{
  "A1": [
    {
      "character": "愛",
      "zhuyin": "ㄞˋ",
      "pinyin": "ài",
      "english": "to love, to be fond of, to like, affection, to be inclined (to do sth), to tend to (happen)"
    },
    {
      "character": "吧",
      "zhuyin": "˙ㄅㄚ",
      "pinyin": "ba",
      "english": "(modal particle indicating suggestion or surmise), ...right?, ...OK?, ...I presume."
    },
    {
      "character": "八",
      "zhuyin": "ㄅㄚ",
      "pinyin": "bā",
      "english": "eight, 8"
    },
    {
      "character": "百",
      "zhuyin": "ㄅㄞˇ",
      "pinyin": "bǎi",
      "english": "hundred, numerous, all kinds of"
    },
    {
      "character": "半",
      "zhuyin": "ㄅㄢˋ",
      "pinyin": "bàn",
      "english": "half, semi-, incomplete, (after a number) and a half"
    },
    {
      "character": "本",
      "zhuyin": "ㄅㄣˇ",
      "pinyin": "běn",
      "english": "root, stem, origin, source, this, the current, original, inherent, originally, classifier for books,"
    },
    {
      "character": "不",
      "zhuyin": "ㄅㄨˋ",
      "pinyin": "bù",
      "english": "no, not so, (bound form) not, un-"
    },
    {
      "character": "茶",
      "zhuyin": "ㄔㄚˊ",
      "pinyin": "chá",
      "english": "tea, tea plant, CL:杯[bei1], 壺|壶[hu2]"
    },
    {
      "character": "吃",
      "zhuyin": "ㄔ",
      "pinyin": "chī",
      "english": "to eat, to consume, to eat at (a cafeteria etc), to eradicate, to destroy, to absorb, to suffer (sho"
    },
    {
      "character": "打",
      "zhuyin": "ㄉㄚˇ",
      "pinyin": "dǎ",
      "english": "to beat, to strike, to hit, to break, to type, to mix up, to build, to fight, to fetch, to make, to "
    },
    {
      "character": "大",
      "zhuyin": "ㄉㄚˋ",
      "pinyin": "dà",
      "english": "big, large, great, older (than another person), eldest (as in 大姐[da4 jie3]), greatly, freely, fully,"
    },
    {
      "character": "帶",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dài",
      "english": "band, belt, girdle, ribbon, tire, area, zone, region, CL:條|条[tiao2], to wear, to carry, to take alon"
    },
    {
      "character": "到",
      "zhuyin": "ㄉㄠˋ",
      "pinyin": "dào",
      "english": "to reach, to arrive, to leave for, to go to, to (a place), until (a time), up to (a point), (verb co"
    },
    {
      "character": "的",
      "zhuyin": "ㄉㄜ˙",
      "pinyin": "de",
      "english": "of, ~'s (possessive particle), (used after an attribute), (used to form a nominal expression), (used"
    },
    {
      "character": "點",
      "zhuyin": "ㄉㄧㄢˇ",
      "pinyin": "diǎn",
      "english": "point, dot, drop, speck, o'clock, point (in space or time), to draw a dot, to check on a list, to ch"
    },
    {
      "character": "都",
      "zhuyin": "ㄉㄡ",
      "pinyin": "dōu",
      "english": "all, both, entirely, (used for emphasis) even, already, (not) at all"
    },
    {
      "character": "對",
      "zhuyin": "ㄉㄨㄟˋ",
      "pinyin": "duì",
      "english": "right, correct, towards, at, for, concerning, regarding, to treat (sb a certain way), to face, (boun"
    },
    {
      "character": "多",
      "zhuyin": "ㄉㄨㄛ",
      "pinyin": "duō",
      "english": "many, much, too many, in excess, (after a numeral) ... odd, how (to what extent) (Taiwan pr. [duo2])"
    },
    {
      "character": "二",
      "zhuyin": "ㄦˋ",
      "pinyin": "èr",
      "english": "two, 2, (Beijing dialect) stupid"
    },
    {
      "character": "分",
      "zhuyin": "ㄈㄣ",
      "pinyin": "fēn",
      "english": "to divide, to separate, to distribute, to allocate, to distinguish (good and bad), (bound form) bran"
    },
    {
      "character": "高",
      "zhuyin": "ㄍㄠ",
      "pinyin": "gāo",
      "english": "high, tall, above average, loud, your (honorific)"
    },
    {
      "character": "個",
      "zhuyin": "˙ㄍㄜ",
      "pinyin": "ge",
      "english": "(classifier used before a noun that has no specific classifier), (bound form) individual"
    },
    {
      "character": "給",
      "zhuyin": "ㄍㄟˇ",
      "pinyin": "gěi",
      "english": "to, for, for the benefit of, to give, to allow, to do sth (for sb), (grammatical equivalent of 被), ("
    },
    {
      "character": "國",
      "zhuyin": "ㄍㄨㄛˊ",
      "pinyin": "guó",
      "english": "country, nation, state (CL:個|个[ge4]), (bound form) national"
    },
    {
      "character": "喝",
      "zhuyin": "ㄏㄜ",
      "pinyin": "hē",
      "english": "to drink, variant of 嗬[he1]"
    },
    {
      "character": "很",
      "zhuyin": "ㄏㄣˇ",
      "pinyin": "hěn",
      "english": "(adverb of degree), quite, very, awfully"
    },
    {
      "character": "後",
      "zhuyin": "ㄏㄡˋ",
      "pinyin": "hòu",
      "english": "back, behind, rear, afterwards, after, later, post-"
    },
    {
      "character": "話",
      "zhuyin": "ㄏㄨㄚˋ",
      "pinyin": "huà",
      "english": "dialect, language, spoken words, speech, talk, words, conversation, what sb said, CL:種|种[zhong3], 席["
    },
    {
      "character": "幾",
      "zhuyin": "ㄐㄧˇ",
      "pinyin": "jǐ",
      "english": "how much, how many, several, a few"
    },
    {
      "character": "家",
      "zhuyin": "ㄐㄧㄚ",
      "pinyin": "jiā",
      "english": "home, family, (polite) my (sister, uncle etc), classifier for families or businesses, refers to the "
    },
    {
      "character": "叫",
      "zhuyin": "ㄐㄧㄠˋ",
      "pinyin": "jiào",
      "english": "to shout, to call, to order, to ask, to be called, by (indicates agent in the passive mood)"
    },
    {
      "character": "腳",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎo",
      "english": "foot, leg (of an animal or an object), base (of an object), CL:雙|双[shuang1], 隻|只[zhi1], classifier f"
    },
    {
      "character": "就",
      "zhuyin": "ㄐㄧㄡˋ",
      "pinyin": "jiù",
      "english": "(after a suppositional clause) in that case, then, (after a clause of action) as soon as, immediatel"
    },
    {
      "character": "久",
      "zhuyin": "ㄐㄧㄡˇ",
      "pinyin": "jiǔ",
      "english": "(long) time, (long) duration of time"
    },
    {
      "character": "九",
      "zhuyin": "ㄐㄧㄡˇ",
      "pinyin": "jiǔ",
      "english": "nine, 9"
    },
    {
      "character": "塊",
      "zhuyin": "ㄎㄨㄞˋ",
      "pinyin": "kuài",
      "english": "lump, chunk, piece, classifier for pieces of cloth, cake, soap etc, (coll.) classifier for money and"
    },
    {
      "character": "來",
      "zhuyin": "ㄌㄞˊ",
      "pinyin": "lái",
      "english": "to come, (used as a substitute for a more specific verb), hither (directional complement for motion "
    },
    {
      "character": "老",
      "zhuyin": "ㄌㄠˇ",
      "pinyin": "lǎo",
      "english": "prefix used before the surname of a person or a numeral indicating the order of birth of the childre"
    },
    {
      "character": "冷",
      "zhuyin": "ㄌㄥˇ",
      "pinyin": "lěng",
      "english": "cold"
    },
    {
      "character": "兩",
      "zhuyin": "ㄌㄧㄤˇ",
      "pinyin": "liǎng",
      "english": "two, both, some, a few, tael, unit of weight equal to 50 grams (modern) or 1⁄16 of a catty 斤[jin1] ("
    },
    {
      "character": "六",
      "zhuyin": "ㄌㄧㄡˋ",
      "pinyin": "liù",
      "english": "six, 6"
    },
    {
      "character": "路",
      "zhuyin": "ㄌㄨˋ",
      "pinyin": "lù",
      "english": "road, CL:條|条[tiao2], journey, route, line (bus etc), sort, kind"
    },
    {
      "character": "嗎",
      "zhuyin": "˙ㄇㄚ",
      "pinyin": "ma",
      "english": "(question particle for \"yes-no\" questions)"
    },
    {
      "character": "買",
      "zhuyin": "ㄇㄞˇ",
      "pinyin": "mǎi",
      "english": "to buy, to purchase"
    },
    {
      "character": "沒",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "méi",
      "english": "(negative prefix for verbs) have not, not"
    },
    {
      "character": "們",
      "zhuyin": "˙ㄇㄣ",
      "pinyin": "men",
      "english": "plural marker for pronouns, and nouns referring to individuals"
    },
    {
      "character": "拿",
      "zhuyin": "ㄋㄚˊ",
      "pinyin": "ná",
      "english": "to hold, to seize, to catch, to apprehend, to take, (used in the same way as 把[ba3]: to mark the fol"
    },
    {
      "character": "那",
      "zhuyin": "ㄋㄚˋ",
      "pinyin": "nà",
      "english": "(specifier) that, the, those (colloquial pr. [nei4]), (pronoun) that (referring to persons, things o"
    },
    {
      "character": "呢",
      "zhuyin": "˙ㄋㄜ",
      "pinyin": "ne",
      "english": "particle indicating that a previously asked question is to be applied to the preceding word (\"What a"
    },
    {
      "character": "你",
      "zhuyin": "ㄋㄧˇ",
      "pinyin": "nǐ",
      "english": "you (informal, as opposed to courteous 您[nin2])"
    },
    {
      "character": "妳",
      "zhuyin": "ㄋㄧˇ",
      "pinyin": "nǐ",
      "english": "you (Note: In Taiwan, 妳 is used to address females, but in mainland China, it is not commonly used. "
    },
    {
      "character": "年",
      "zhuyin": "ㄋㄧㄢˊ",
      "pinyin": "nián",
      "english": "year, CL:個|个[ge4]"
    },
    {
      "character": "您",
      "zhuyin": "ㄋㄧㄣˊ",
      "pinyin": "nín",
      "english": "you (courteous, as opposed to informal 你[ni3])"
    },
    {
      "character": "七",
      "zhuyin": "ㄑㄧ",
      "pinyin": "qī",
      "english": "seven, 7"
    },
    {
      "character": "前",
      "zhuyin": "ㄑㄧㄢˊ",
      "pinyin": "qián",
      "english": "front, forward, ahead, first, top (followed by a number), future, ago, before, BC (e.g. 前293年), form"
    },
    {
      "character": "錢",
      "zhuyin": "ㄑㄧㄢˊ",
      "pinyin": "qián",
      "english": "coin, money, CL:筆|笔[bi3], unit of weight, one tenth of a tael 兩|两[liang3]"
    },
    {
      "character": "千",
      "zhuyin": "ㄑㄧㄢ",
      "pinyin": "qiān",
      "english": "thousand"
    },
    {
      "character": "請",
      "zhuyin": "ㄑㄧㄥˇ",
      "pinyin": "qǐng",
      "english": "to ask, to invite, please (do sth), to treat (to a meal etc), to request"
    },
    {
      "character": "去",
      "zhuyin": "ㄑㄩˋ",
      "pinyin": "qù",
      "english": "to go, to go to (a place), (of a time etc) last, just passed, to send, to remove, to get rid of, to "
    },
    {
      "character": "熱",
      "zhuyin": "ㄖㄜˋ",
      "pinyin": "rè",
      "english": "to warm up, to heat up, hot (of weather), heat, fervent"
    },
    {
      "character": "人",
      "zhuyin": "ㄖㄣˊ",
      "pinyin": "rén",
      "english": "person, people, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "日",
      "zhuyin": "ㄖˋ",
      "pinyin": "rì",
      "english": "sun, day, date, day of the month"
    },
    {
      "character": "三",
      "zhuyin": "ㄙㄢ",
      "pinyin": "sān",
      "english": "three, 3"
    },
    {
      "character": "上",
      "zhuyin": "ㄕㄤˋ",
      "pinyin": "shàng",
      "english": "(bound form) up, upper, above, previous, first (of multiple parts), to climb, to get onto, to go up,"
    },
    {
      "character": "少",
      "zhuyin": "ㄕㄠˇ",
      "pinyin": "shǎo",
      "english": "few, less, to lack, to be missing, to stop (doing sth), seldom"
    },
    {
      "character": "誰",
      "zhuyin": "ㄕㄟˊ",
      "pinyin": "shéi",
      "english": "who, also pr. [shui2]"
    },
    {
      "character": "十",
      "zhuyin": "ㄕˊ",
      "pinyin": "shí",
      "english": "ten, 10"
    },
    {
      "character": "是",
      "zhuyin": "ㄕˋ",
      "pinyin": "shì",
      "english": "to be (followed by substantives only), correct, right, true, (respectful acknowledgement of a comman"
    },
    {
      "character": "書",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shū",
      "english": "book, letter, document, CL:本[ben3], 冊|册[ce4], 部[bu4], to write"
    },
    {
      "character": "水",
      "zhuyin": "ㄕㄨㄟˇ",
      "pinyin": "shuǐ",
      "english": "water, river, liquid, beverage, additional charges or income, (of clothes) classifier for number of "
    },
    {
      "character": "說",
      "zhuyin": "ㄕㄨㄛ",
      "pinyin": "shuō",
      "english": "to speak, to talk, to say, to explain, to comment, to scold, to tell off, (bound form) theory, doctr"
    },
    {
      "character": "四",
      "zhuyin": "ㄙˋ",
      "pinyin": "sì",
      "english": "four, 4"
    },
    {
      "character": "歲",
      "zhuyin": "ㄙㄨㄟˋ",
      "pinyin": "suì",
      "english": "classifier for years (of age), year, year (of crop harvests)"
    },
    {
      "character": "她",
      "zhuyin": "ㄊㄚ",
      "pinyin": "tā",
      "english": "she"
    },
    {
      "character": "他",
      "zhuyin": "ㄊㄚ",
      "pinyin": "tā",
      "english": "he, him (used for either sex when the sex is unknown or unimportant), (used before sb's name for emp"
    },
    {
      "character": "太",
      "zhuyin": "ㄊㄞˋ",
      "pinyin": "tài",
      "english": "highest, greatest, too (much), very, extremely"
    },
    {
      "character": "天",
      "zhuyin": "ㄊㄧㄢ",
      "pinyin": "tiān",
      "english": "day, sky, heaven"
    },
    {
      "character": "聽",
      "zhuyin": "ㄊㄧㄥ",
      "pinyin": "tīng",
      "english": "to listen to, to hear, to heed, to obey, a can (loanword from English \"tin\"), classifier for canned "
    },
    {
      "character": "外",
      "zhuyin": "ㄨㄞˋ",
      "pinyin": "wài",
      "english": "outside, in addition, foreign, external"
    },
    {
      "character": "位",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "wèi",
      "english": "position, location, place, seat, classifier for people (honorific), classifier for binary bits (e.g."
    },
    {
      "character": "問",
      "zhuyin": "ㄨㄣˋ",
      "pinyin": "wèn",
      "english": "to ask, to inquire"
    },
    {
      "character": "我",
      "zhuyin": "ㄨㄛˇ",
      "pinyin": "wǒ",
      "english": "I, me, my"
    },
    {
      "character": "五",
      "zhuyin": "ㄨˇ",
      "pinyin": "wǔ",
      "english": "five, 5"
    },
    {
      "character": "想",
      "zhuyin": "ㄒㄧㄤˇ",
      "pinyin": "xiǎng",
      "english": "to think (about), to think of, to devise, to think (that), to believe (that), to desire, to want (to"
    },
    {
      "character": "小",
      "zhuyin": "ㄒㄧㄠˇ",
      "pinyin": "xiǎo",
      "english": "small, tiny, few, young"
    },
    {
      "character": "寫",
      "zhuyin": "ㄒㄧㄝˇ",
      "pinyin": "xiě",
      "english": "to write"
    },
    {
      "character": "新",
      "zhuyin": "ㄒㄧㄣ",
      "pinyin": "xīn",
      "english": "new, newly, meso- (chemistry)"
    },
    {
      "character": "學",
      "zhuyin": "ㄒㄩㄝˊ",
      "pinyin": "xué",
      "english": "to learn, to study, to imitate, science, -ology"
    },
    {
      "character": "要",
      "zhuyin": "ㄧㄠˋ",
      "pinyin": "yào",
      "english": "to want, to need, to ask for, will, shall, about to, need to, should, if (same as 要是[yao4 shi5]), (b"
    },
    {
      "character": "也",
      "zhuyin": "ㄧㄝˇ",
      "pinyin": "yě",
      "english": "(adverb) also, both ... and ... (before predicates only), (literary) particle having functions simil"
    },
    {
      "character": "一",
      "zhuyin": "ㄧ",
      "pinyin": "yī",
      "english": "one, single, a (article), as soon as, entire, whole, all, throughout, \"one\" radical in Chinese chara"
    },
    {
      "character": "用",
      "zhuyin": "ㄩㄥˋ",
      "pinyin": "yòng",
      "english": "to use, to employ, to have to, to eat or drink, expense or outlay, usefulness, hence, therefore"
    },
    {
      "character": "有",
      "zhuyin": "ㄧㄡˇ",
      "pinyin": "yǒu",
      "english": "to have, there is, (bound form) having, with, -ful, -ed, -al (as in 有意[you3 yi4] intentional)"
    },
    {
      "character": "元",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "yuán",
      "english": "currency unit (esp. Chinese yuan), first, original, primary, fundamental, constituent, part, era (of"
    },
    {
      "character": "月",
      "zhuyin": "ㄩㄝˋ",
      "pinyin": "yuè",
      "english": "moon, month, monthly, CL:個|个[ge4], 輪|轮[lun2]"
    },
    {
      "character": "早",
      "zhuyin": "ㄗㄠˇ",
      "pinyin": "zǎo",
      "english": "early, morning, Good morning!, long ago, prematurely"
    },
    {
      "character": "找",
      "zhuyin": "ㄓㄠˇ",
      "pinyin": "zhǎo",
      "english": "to try to find, to look for, to call on sb, to find, to seek, to return, to give change"
    },
    {
      "character": "這",
      "zhuyin": "ㄓㄜˋ",
      "pinyin": "zhè",
      "english": "(pronoun) this, these, (bound form) this, the (followed by a noun), (bound form) this, these (follow"
    },
    {
      "character": "字",
      "zhuyin": "ㄗˋ",
      "pinyin": "zì",
      "english": "letter, symbol, character, word, CL:個|个[ge4], courtesy or style name traditionally given to males ag"
    },
    {
      "character": "走",
      "zhuyin": "ㄗㄡˇ",
      "pinyin": "zǒu",
      "english": "to walk, to go, to run, to move (of vehicle), to visit, to leave, to go away, to die (euph.), from, "
    },
    {
      "character": "做",
      "zhuyin": "ㄗㄨㄛˋ",
      "pinyin": "zuò",
      "english": "to make, to produce, to write, to compose, to do, to engage in, to hold (a party etc), (of a person)"
    },
    {
      "character": "坐",
      "zhuyin": "ㄗㄨㄛˋ",
      "pinyin": "zuò",
      "english": "to sit, to take a seat, to take (a bus, airplane etc), to bear fruit, variant of 座[zuo4]"
    },
    {
      "character": "矮",
      "zhuyin": "ㄞˇ",
      "pinyin": "ǎi",
      "english": "low, short (in length)"
    },
    {
      "character": "白",
      "zhuyin": "ㄅㄞˊ",
      "pinyin": "bái",
      "english": "white, snowy, pure, bright, empty, blank, plain, clear, to make clear, in vain, gratuitous, free of "
    },
    {
      "character": "飽",
      "zhuyin": "ㄅㄠˇ",
      "pinyin": "bǎo",
      "english": "to eat till full, satisfied"
    },
    {
      "character": "筆",
      "zhuyin": "ㄅㄧˇ",
      "pinyin": "bǐ",
      "english": "pen, pencil, writing brush, to write or compose, the strokes of Chinese characters, classifier for s"
    },
    {
      "character": "比",
      "zhuyin": "ㄅㄧˇ",
      "pinyin": "bǐ",
      "english": "to compare, (followed by a noun and adjective) more {adj.} than {noun}, ratio, to gesture, (Taiwan p"
    },
    {
      "character": "邊",
      "zhuyin": "ㄅㄧㄢ",
      "pinyin": "biān",
      "english": "side, edge, margin, border, boundary, CL:個|个[ge4], simultaneously, suffix of a noun of locality"
    },
    {
      "character": "別",
      "zhuyin": "ㄅㄧㄝˊ",
      "pinyin": "bié",
      "english": "to leave, to part (from), (literary) to differentiate, to distinguish, (bound form) other, another, "
    },
    {
      "character": "冰",
      "zhuyin": "ㄅㄧㄥ",
      "pinyin": "bīng",
      "english": "ice, CL:塊|块[kuai4], to chill sth, (of an object or substance) to feel cold, (of a person) cold, unfr"
    },
    {
      "character": "病",
      "zhuyin": "ㄅㄧㄥˋ",
      "pinyin": "bìng",
      "english": "illness, CL:場|场[chang2], disease, to fall ill, defect"
    },
    {
      "character": "菜",
      "zhuyin": "ㄘㄞˋ",
      "pinyin": "cài",
      "english": "vegetable, greens (CL:棵[ke1]), dish (of food) (CL:樣|样[yang4], 道[dao4], 盤|盘[pan2]), (of one's skills "
    },
    {
      "character": "唱",
      "zhuyin": "ㄔㄤˋ",
      "pinyin": "chàng",
      "english": "to sing, to call loudly, to chant"
    },
    {
      "character": "出",
      "zhuyin": "ㄔㄨ",
      "pinyin": "chū",
      "english": "to go out, to come out, to occur, to produce, to go beyond, to rise, to put forth, to happen, (used "
    },
    {
      "character": "穿",
      "zhuyin": "ㄔㄨㄢ",
      "pinyin": "chuān",
      "english": "to wear, to put on, to dress, to bore through, to pierce, to perforate, to penetrate, to pass throug"
    },
    {
      "character": "床",
      "zhuyin": "ㄔㄨㄤˊ",
      "pinyin": "chuáng",
      "english": "bed, couch, classifier for beds, CL:張|张[zhang1]"
    },
    {
      "character": "從",
      "zhuyin": "ㄘㄨㄥˊ",
      "pinyin": "cóng",
      "english": "from, through, via, to follow, to obey, to engage in (an activity), never (in negative sentence), (T"
    },
    {
      "character": "錯",
      "zhuyin": "ㄘㄨㄛˋ",
      "pinyin": "cuò",
      "english": "mistake, wrong, bad, interlocking, complex, to grind, to polish, to alternate, to stagger, to miss, "
    },
    {
      "character": "蛋",
      "zhuyin": "ㄉㄢˋ",
      "pinyin": "dàn",
      "english": "egg, CL:個|个[ge4], 打[da2], oval-shaped thing"
    },
    {
      "character": "低",
      "zhuyin": "ㄉㄧ",
      "pinyin": "dī",
      "english": "low, beneath, to lower (one's head), to let droop, to hang down, to incline"
    },
    {
      "character": "店",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "diàn",
      "english": "inn, old-style hotel (CL:家[jia1]), (bound form) shop, store"
    },
    {
      "character": "懂",
      "zhuyin": "ㄉㄨㄥˇ",
      "pinyin": "dǒng",
      "english": "to understand, to comprehend"
    },
    {
      "character": "讀",
      "zhuyin": "ㄉㄨˊ",
      "pinyin": "dú",
      "english": "to read out, to read aloud, to read, to attend (school), to study (a subject in school), to pronounc"
    },
    {
      "character": "短",
      "zhuyin": "ㄉㄨㄢˇ",
      "pinyin": "duǎn",
      "english": "short, brief, to lack, weak point, fault"
    },
    {
      "character": "餓",
      "zhuyin": "ㄜˋ",
      "pinyin": "è",
      "english": "to be hungry, hungry, to starve (sb)"
    },
    {
      "character": "飯",
      "zhuyin": "ㄈㄢˋ",
      "pinyin": "fàn",
      "english": "cooked rice, CL:碗[wan3], meal, CL:頓|顿[dun4], (loanword) fan, devotee"
    },
    {
      "character": "風",
      "zhuyin": "ㄈㄥ",
      "pinyin": "fēng",
      "english": "wind, news, style, custom, manner, CL:陣|阵[zhen4], 絲|丝[si1]"
    },
    {
      "character": "歌",
      "zhuyin": "ㄍㄜ",
      "pinyin": "gē",
      "english": "song, CL:支[zhi1], 首[shou3], to sing"
    },
    {
      "character": "跟",
      "zhuyin": "ㄍㄣ",
      "pinyin": "gēn",
      "english": "heel, to follow closely, to go with, (of a woman) to marry sb, with, compared with, to, towards, and"
    },
    {
      "character": "夠",
      "zhuyin": "ㄍㄡˋ",
      "pinyin": "gòu",
      "english": "enough (sufficient), enough (too much), (coll.) (before adj.) really, (coll.) to reach by stretching"
    },
    {
      "character": "貴",
      "zhuyin": "ㄍㄨㄟˋ",
      "pinyin": "guì",
      "english": "expensive, noble, precious, (honorific) your"
    },
    {
      "character": "過",
      "zhuyin": "ㄍㄨㄛˋ",
      "pinyin": "guò",
      "english": "to cross, to go over, to pass (time), to celebrate (a holiday), to live, to get along, excessively, "
    },
    {
      "character": "黑",
      "zhuyin": "ㄏㄟ",
      "pinyin": "hēi",
      "english": "black, dark, sinister, secret, shady, illegal, to hide (sth) away, to vilify, (loanword) to hack (co"
    },
    {
      "character": "紅",
      "zhuyin": "ㄏㄨㄥˊ",
      "pinyin": "hóng",
      "english": "red, popular, revolutionary, bonus"
    },
    {
      "character": "畫",
      "zhuyin": "ㄏㄨㄚˋ",
      "pinyin": "huà",
      "english": "to draw, to paint, picture, painting (CL:幅[fu2], 張|张[zhang1]), to draw (a line) (variant of 劃|划[hua4"
    },
    {
      "character": "會",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "huì",
      "english": "can, to have the skill, to know how to, to be likely to, to be sure to, to meet, to get together, me"
    },
    {
      "character": "雞",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jī",
      "english": "fowl, chicken, CL:隻|只[zhi1], (slang) prostitute"
    },
    {
      "character": "見",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiàn",
      "english": "to see, to meet, to appear (to be sth), to interview, opinion, view"
    },
    {
      "character": "件",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiàn",
      "english": "item, component, classifier for events, things, clothes etc"
    },
    {
      "character": "教",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "jiāo",
      "english": "to teach"
    },
    {
      "character": "進",
      "zhuyin": "ㄐㄧㄣˋ",
      "pinyin": "jìn",
      "english": "to go forward, to advance, to go in, to enter, to put in, to submit, to take in, to admit, (math.) b"
    },
    {
      "character": "酒",
      "zhuyin": "ㄐㄧㄡˇ",
      "pinyin": "jiǔ",
      "english": "wine (esp. rice wine), liquor, spirits, alcoholic beverage, CL:杯[bei1], 瓶[ping2], 罐[guan4], 桶[tong3]"
    },
    {
      "character": "舊",
      "zhuyin": "ㄐㄧㄡˋ",
      "pinyin": "jiù",
      "english": "old, opposite: new 新, former, worn (with age)"
    },
    {
      "character": "開",
      "zhuyin": "ㄎㄞ",
      "pinyin": "kāi",
      "english": "to open (transitive or intransitive), (of ships, vehicles, troops etc) to start, to turn on, to put "
    },
    {
      "character": "課",
      "zhuyin": "ㄎㄜˋ",
      "pinyin": "kè",
      "english": "subject, course, CL:門|门[men2], class, lesson, CL:堂[tang2], 節|节[jie2], to levy, tax, form of divinati"
    },
    {
      "character": "快",
      "zhuyin": "ㄎㄨㄞˋ",
      "pinyin": "kuài",
      "english": "rapid, quick, speed, rate, soon, almost, to make haste, clever, sharp (of knives or wits), forthrigh"
    },
    {
      "character": "裡",
      "zhuyin": "ㄌㄧˇ",
      "pinyin": "lǐ",
      "english": "lining, interior, inside, internal, also written 裏|里[li3]"
    },
    {
      "character": "輛",
      "zhuyin": "ㄌㄧㄤˋ",
      "pinyin": "liàng",
      "english": "classifier for vehicles"
    },
    {
      "character": "樓",
      "zhuyin": "ㄌㄡˊ",
      "pinyin": "lóu",
      "english": "house with more than 1 story, storied building, floor, CL:層|层[ceng2], 座[zuo4], 棟|栋[dong4]"
    },
    {
      "character": "慢",
      "zhuyin": "ㄇㄢˋ",
      "pinyin": "màn",
      "english": "slow"
    },
    {
      "character": "忙",
      "zhuyin": "ㄇㄤˊ",
      "pinyin": "máng",
      "english": "busy, hurriedly, to hurry, to rush"
    },
    {
      "character": "美",
      "zhuyin": "ㄇㄟˇ",
      "pinyin": "měi",
      "english": "beautiful, very satisfactory, good, to beautify, to be pleased with oneself"
    },
    {
      "character": "每",
      "zhuyin": "ㄇㄟˇ",
      "pinyin": "měi",
      "english": "each, every"
    },
    {
      "character": "門",
      "zhuyin": "ㄇㄣˊ",
      "pinyin": "mén",
      "english": "gate, door, CL:扇[shan4], gateway, doorway, CL:個|个[ge4], opening, valve, switch, way to do something,"
    },
    {
      "character": "麵",
      "zhuyin": "ㄇㄧㄢˋ",
      "pinyin": "miàn",
      "english": "flour, noodles, (of food) soft (not crunchy), (slang) (of a person) ineffectual, spineless"
    },
    {
      "character": "男",
      "zhuyin": "ㄋㄢˊ",
      "pinyin": "nán",
      "english": "male, Baron, lowest of five orders of nobility 五等爵位[wu3 deng3 jue2 wei4]"
    },
    {
      "character": "能",
      "zhuyin": "ㄋㄥˊ",
      "pinyin": "néng",
      "english": "can, to be able to, might possibly, ability, (physics) energy"
    },
    {
      "character": "唸",
      "zhuyin": "ㄋㄧㄢˋ",
      "pinyin": "niàn",
      "english": "to read, to study (a subject), to attend (a school), to read aloud, to give (sb) a tongue-lashing (C"
    },
    {
      "character": "牛",
      "zhuyin": "ㄋㄧㄡˊ",
      "pinyin": "niú",
      "english": "ox, cow, bull, CL:條|条[tiao2], 頭|头[tou2], newton (abbr. for 牛頓|牛顿[niu2 dun4]), (slang) awesome"
    },
    {
      "character": "女",
      "zhuyin": "ㄋㄩˇ",
      "pinyin": "nǚ",
      "english": "female, woman, daughter"
    },
    {
      "character": "怕",
      "zhuyin": "ㄆㄚˋ",
      "pinyin": "pà",
      "english": "to be afraid, to fear, to dread, to be unable to endure, perhaps"
    },
    {
      "character": "胖",
      "zhuyin": "ㄆㄤˋ",
      "pinyin": "pàng",
      "english": "fat, plump"
    },
    {
      "character": "球",
      "zhuyin": "ㄑㄧㄡˊ",
      "pinyin": "qiú",
      "english": "ball, sphere, globe, CL:個|个[ge4], ball game, match, CL:場|场[chang3]"
    },
    {
      "character": "肉",
      "zhuyin": "ㄖㄡˋ",
      "pinyin": "ròu",
      "english": "meat, flesh, pulp (of a fruit), (coll.) (of a fruit) squashy, (of a person) flabby, irresolute, Kang"
    },
    {
      "character": "山",
      "zhuyin": "ㄕㄢ",
      "pinyin": "shān",
      "english": "mountain, hill (CL:座[zuo4]), (coll.) small bundle of straw for silkworms to spin cocoons on"
    },
    {
      "character": "事",
      "zhuyin": "ㄕˋ",
      "pinyin": "shì",
      "english": "matter, thing, item, work, affair, CL:件[jian4], 樁|桩[zhuang1], 回[hui2]"
    },
    {
      "character": "手",
      "zhuyin": "ㄕㄡˇ",
      "pinyin": "shǒu",
      "english": "hand, (formal) to hold, person engaged in certain types of work, person skilled in certain types of "
    },
    {
      "character": "瘦",
      "zhuyin": "ㄕㄡˋ",
      "pinyin": "shòu",
      "english": "thin, to lose weight, (of clothing) tight, (of meat) lean, (of land) unproductive"
    },
    {
      "character": "它",
      "zhuyin": "ㄊㄚ",
      "pinyin": "tā",
      "english": "it"
    },
    {
      "character": "湯",
      "zhuyin": "ㄊㄤ",
      "pinyin": "tāng",
      "english": "soup, hot or boiling water, decoction of medicinal herbs, water in which sth has been boiled"
    },
    {
      "character": "甜",
      "zhuyin": "ㄊㄧㄢˊ",
      "pinyin": "tián",
      "english": "sweet"
    },
    {
      "character": "跳",
      "zhuyin": "ㄊㄧㄠˋ",
      "pinyin": "tiào",
      "english": "to jump, to hop, to skip over, to bounce, to palpitate"
    },
    {
      "character": "痛",
      "zhuyin": "ㄊㄨㄥˋ",
      "pinyin": "tòng",
      "english": "ache, pain, sorrow, deeply, thoroughly"
    },
    {
      "character": "頭",
      "zhuyin": "ㄊㄡˊ",
      "pinyin": "tóu",
      "english": "head, hair style, the top, end, beginning or end, a stub, remnant, chief, boss, side, aspect, first,"
    },
    {
      "character": "玩",
      "zhuyin": "ㄨㄢˊ",
      "pinyin": "wán",
      "english": "to play, to have fun, to trifle with, toy, sth used for amusement, curio or antique (Taiwan pr. [wan"
    },
    {
      "character": "晚",
      "zhuyin": "ㄨㄢˇ",
      "pinyin": "wǎn",
      "english": "evening, night, late"
    },
    {
      "character": "碗",
      "zhuyin": "ㄨㄢˇ",
      "pinyin": "wǎn",
      "english": "bowl, cup, CL:隻|只[zhi1], 個|个[ge4]"
    },
    {
      "character": "萬",
      "zhuyin": "ㄨㄢˋ",
      "pinyin": "wàn",
      "english": "ten thousand, a great number"
    },
    {
      "character": "下",
      "zhuyin": "ㄒㄧㄚˋ",
      "pinyin": "xià",
      "english": "down, downwards, below, lower, later, next (week etc), second (of two parts), to decline, to go down"
    },
    {
      "character": "先",
      "zhuyin": "ㄒㄧㄢ",
      "pinyin": "xiān",
      "english": "early, prior, former, in advance, first"
    },
    {
      "character": "像",
      "zhuyin": "ㄒㄧㄤˋ",
      "pinyin": "xiàng",
      "english": "to resemble, to be like, to look as if, such as, appearance, image, portrait, image under a mapping "
    },
    {
      "character": "姓",
      "zhuyin": "ㄒㄧㄥˋ",
      "pinyin": "xìng",
      "english": "family name, surname, CL:個|个[ge4], to be surnamed"
    },
    {
      "character": "藥",
      "zhuyin": "ㄧㄠˋ",
      "pinyin": "yào",
      "english": "medicine, drug, substance used for a specific purpose (e.g. poisoning, explosion, fermenting), CL:種|"
    },
    {
      "character": "右",
      "zhuyin": "ㄧㄡˋ",
      "pinyin": "yòu",
      "english": "(bound form) right, right-hand side, (bound form) (politics) right of center, (bound form) (old) wes"
    },
    {
      "character": "又",
      "zhuyin": "ㄧㄡˋ",
      "pinyin": "yòu",
      "english": "(once) again, also, both... and..., and yet, (used for emphasis) anyway"
    },
    {
      "character": "魚",
      "zhuyin": "ㄩˊ",
      "pinyin": "yú",
      "english": "fish, CL:條|条[tiao2], 尾[wei3]"
    },
    {
      "character": "雨",
      "zhuyin": "ㄩˇ",
      "pinyin": "yǔ",
      "english": "rain, CL:陣|阵[zhen4], 場|场[chang2]"
    },
    {
      "character": "再",
      "zhuyin": "ㄗㄞˋ",
      "pinyin": "zài",
      "english": "again, once more, re-, second, another, then (after sth, and not until then), no matter how ... (fol"
    },
    {
      "character": "在",
      "zhuyin": "ㄗㄞˋ",
      "pinyin": "zài",
      "english": "to exist, to be alive, (of sb or sth) to be (located) at, (used before a verb to indicate an action "
    },
    {
      "character": "站",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "zhàn",
      "english": "station, to stand, to halt, to stop, branch of a company or organization, website"
    },
    {
      "character": "張",
      "zhuyin": "ㄓㄤ",
      "pinyin": "zhāng",
      "english": "to open up, to spread, sheet of paper, classifier for flat objects, sheet, classifier for votes"
    },
    {
      "character": "真",
      "zhuyin": "ㄓㄣ",
      "pinyin": "zhēn",
      "english": "really, truly, indeed, real, true, genuine"
    },
    {
      "character": "枝",
      "zhuyin": "ㄓ",
      "pinyin": "zhī",
      "english": "branch, classifier for sticks, rods, pencils etc"
    },
    {
      "character": "紙",
      "zhuyin": "ㄓˇ",
      "pinyin": "zhǐ",
      "english": "paper, CL:張|张[zhang1], 沓[da2], classifier for documents, letter etc"
    },
    {
      "character": "只",
      "zhuyin": "ㄓˇ",
      "pinyin": "zhǐ",
      "english": "only, merely, just, but"
    },
    {
      "character": "住",
      "zhuyin": "ㄓㄨˋ",
      "pinyin": "zhù",
      "english": "to live, to dwell, to stay, to reside, to stop, (suffix indicating firmness, steadiness, or coming t"
    },
    {
      "character": "豬",
      "zhuyin": "ㄓㄨ",
      "pinyin": "zhū",
      "english": "hog, pig, swine, CL:口[kou3], 頭|头[tou2]"
    },
    {
      "character": "最",
      "zhuyin": "ㄗㄨㄟˋ",
      "pinyin": "zuì",
      "english": "most, the most, -est (superlative suffix)"
    },
    {
      "character": "左",
      "zhuyin": "ㄗㄨㄛˇ",
      "pinyin": "zuǒ",
      "english": "left, the Left (politics), east, unorthodox, queer, wrong, differing, opposite, variant of 佐[zuo3]"
    },
    {
      "character": "爸",
      "zhuyin": "ㄅㄚˋ",
      "pinyin": "bàba",
      "english": "(coll.) father, dad, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "車",
      "zhuyin": "ㄔㄜ",
      "pinyin": "chēzi",
      "english": "car or other vehicle (bicycle, truck etc)"
    },
    {
      "character": "弟",
      "zhuyin": "ㄉㄧˋ",
      "pinyin": "dìdi",
      "english": "younger brother, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "兒",
      "zhuyin": "ㄦˊ",
      "pinyin": "érzi",
      "english": "son"
    },
    {
      "character": "哥",
      "zhuyin": "ㄍㄜ",
      "pinyin": "gēge",
      "english": "older brother, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "工",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "gōngzuò",
      "english": "to work, (of a machine) to operate, job, work, task, CL:個|个[ge4], 份[fen4], 項|项[xiang4]"
    },
    {
      "character": "作",
      "zhuyin": "ㄗㄨㄛˋ",
      "pinyin": "gōngzuò",
      "english": "to work, (of a machine) to operate, job, work, task, CL:個|个[ge4], 份[fen4], 項|项[xiang4]"
    },
    {
      "character": "孩",
      "zhuyin": "ㄏㄞˊ",
      "pinyin": "háizi",
      "english": "child"
    },
    {
      "character": "姊",
      "zhuyin": "ㄐㄧㄝˇ",
      "pinyin": "jiějie",
      "english": "older sister, Taiwan pr. [jie3 jie5]"
    },
    {
      "character": "今",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "jīnnián",
      "english": "this year"
    },
    {
      "character": "咖",
      "zhuyin": "ㄎㄚ",
      "pinyin": "kāfēi",
      "english": "coffee (loanword), CL:杯[bei1]"
    },
    {
      "character": "啡",
      "zhuyin": "ㄈㄟ",
      "pinyin": "kāfēi",
      "english": "coffee (loanword), CL:杯[bei1]"
    },
    {
      "character": "師",
      "zhuyin": "ㄕ",
      "pinyin": "lǎoshī",
      "english": "teacher, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "媽",
      "zhuyin": "ㄇㄚ",
      "pinyin": "māma",
      "english": "mama, mommy, mother, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "妹",
      "zhuyin": "ㄇㄟˋ",
      "pinyin": "mèimei",
      "english": "younger sister, young woman, CL:個|个[ge4]"
    },
    {
      "character": "明",
      "zhuyin": "ㄇㄧㄥˊ",
      "pinyin": "míngtiān",
      "english": "tomorrow"
    },
    {
      "character": "朋",
      "zhuyin": "ㄆㄥˊ",
      "pinyin": "péngyǒu",
      "english": "friend, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "友",
      "zhuyin": "ㄧㄡˇ",
      "pinyin": "péngyǒu",
      "english": "friend, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "容",
      "zhuyin": "ㄖㄨㄥˊ",
      "pinyin": "róngyì",
      "english": "easy, straightforward, likely, liable to, apt to"
    },
    {
      "character": "午",
      "zhuyin": "ㄨˇ",
      "pinyin": "shàngwǔ",
      "english": "morning, CL:個|个[ge4]"
    },
    {
      "character": "什",
      "zhuyin": "ㄕㄣˊ",
      "pinyin": "shénme",
      "english": "what?, something, anything"
    },
    {
      "character": "麼",
      "zhuyin": "˙ㄇㄜ",
      "pinyin": "shénme",
      "english": "what?, something, anything"
    },
    {
      "character": "候",
      "zhuyin": "ㄏㄡˋ",
      "pinyin": "shíhòu",
      "english": "time, length of time, moment, period"
    },
    {
      "character": "機",
      "zhuyin": "ㄐㄧ",
      "pinyin": "shǒujī",
      "english": "cell phone, mobile phone, CL:部[bu4], 支[zhi1]"
    },
    {
      "character": "睡",
      "zhuyin": "ㄕㄨㄟˋ",
      "pinyin": "shuìjiào",
      "english": "to go to bed, to sleep"
    },
    {
      "character": "覺",
      "zhuyin": "ㄐㄧㄠˋ",
      "pinyin": "shuìjiào",
      "english": "to go to bed, to sleep"
    },
    {
      "character": "灣",
      "zhuyin": "ㄨㄢ",
      "pinyin": "táiwān",
      "english": "Taiwan"
    },
    {
      "character": "臺",
      "zhuyin": "ㄊㄞˊ",
      "pinyin": "táiwānrén",
      "english": "Taiwanese"
    },
    {
      "character": "同",
      "zhuyin": "ㄊㄨㄥˊ",
      "pinyin": "tóngxué",
      "english": "to study at the same school, fellow student, classmate, CL:位[wei4], 個|个[ge4]"
    },
    {
      "character": "安",
      "zhuyin": "ㄢ",
      "pinyin": "wǎnān",
      "english": "Good night!, Good evening!"
    },
    {
      "character": "現",
      "zhuyin": "ㄒㄧㄢˋ",
      "pinyin": "xiànzài",
      "english": "now, at present, at the moment, modern, current, nowadays"
    },
    {
      "character": "姐",
      "zhuyin": "ㄐㄧㄝˇ",
      "pinyin": "xiǎojiě",
      "english": "young lady, miss, (slang) prostitute, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "喜",
      "zhuyin": "ㄒㄧˇ",
      "pinyin": "xǐhuān",
      "english": "to like, to be fond of"
    },
    {
      "character": "歡",
      "zhuyin": "ㄏㄨㄢ",
      "pinyin": "xǐhuān",
      "english": "to like, to be fond of"
    },
    {
      "character": "星",
      "zhuyin": "ㄒㄧㄥ",
      "pinyin": "xīngqítiān",
      "english": "Sunday, CL:個|个[ge4]"
    },
    {
      "character": "期",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "xīngqítiān",
      "english": "Sunday, CL:個|个[ge4]"
    },
    {
      "character": "校",
      "zhuyin": "ㄒㄧㄠˋ",
      "pinyin": "xuéxiào",
      "english": "school, CL:所[suo3]"
    },
    {
      "character": "英",
      "zhuyin": "ㄧㄥ",
      "pinyin": "yīngwén",
      "english": "English (language)"
    },
    {
      "character": "文",
      "zhuyin": "ㄨㄣˊ",
      "pinyin": "yīngwén",
      "english": "English (language)"
    },
    {
      "character": "怎",
      "zhuyin": "ㄗㄣˇ",
      "pinyin": "zěnme",
      "english": "how?, what?, why?"
    },
    {
      "character": "知",
      "zhuyin": "ㄓ",
      "pinyin": "zhīdào",
      "english": "to know, to become aware of, also pr. [zhi1 dao5]"
    },
    {
      "character": "昨",
      "zhuyin": "ㄗㄨㄛˊ",
      "pinyin": "zuótiān",
      "english": "yesterday"
    },
    {
      "character": "杯",
      "zhuyin": "ㄅㄟ",
      "pinyin": "bēizi",
      "english": "cup, glass, CL:個|个[ge4], 隻|只[zhi1]"
    },
    {
      "character": "鼻",
      "zhuyin": "ㄅㄧˊ",
      "pinyin": "bízi",
      "english": "nose, CL:個|个[ge4], 隻|只[zhi1]"
    },
    {
      "character": "常",
      "zhuyin": "ㄔㄤˊ",
      "pinyin": "chángcháng",
      "english": "frequently, often"
    },
    {
      "character": "腦",
      "zhuyin": "ㄋㄠˇ",
      "pinyin": "diànnǎo",
      "english": "computer, CL:臺|台[tai2]"
    },
    {
      "character": "影",
      "zhuyin": "ㄧㄥˇ",
      "pinyin": "diànyǐng",
      "english": "movie, film, CL:部[bu4], 片[pian4], 幕[mu4], 場|场[chang3]"
    },
    {
      "character": "附",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fùjìn",
      "english": "nearby, neighboring, (in the) vicinity (of), neighborhood"
    },
    {
      "character": "感",
      "zhuyin": "ㄍㄢˇ",
      "pinyin": "gǎnmào",
      "english": "to catch cold, (common) cold, CL:場|场[chang2], 次[ci4], (coll.) to be interested in (often used in the"
    },
    {
      "character": "訴",
      "zhuyin": "ㄙㄨˋ",
      "pinyin": "gàosù",
      "english": "to press charges, to file a complaint, to tell, to inform, to let know"
    },
    {
      "character": "園",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "gōngyuán",
      "english": "park (for public recreation), CL:個|个[ge4], 座[zuo4]"
    },
    {
      "character": "功",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "gōngkè",
      "english": "homework, assignment, task, classwork, lesson, study, CL:門|门[men2]"
    },
    {
      "character": "室",
      "zhuyin": "ㄕˋ",
      "pinyin": "jiàoshì",
      "english": "classroom, CL:間|间[jian1]"
    },
    {
      "character": "紹",
      "zhuyin": "ㄕㄠˋ",
      "pinyin": "jièshào",
      "english": "to introduce (sb to sb), to give a presentation, to present (sb for a job etc), introduction"
    },
    {
      "character": "氣",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "kōngqì",
      "english": "air, atmosphere"
    },
    {
      "character": "樂",
      "zhuyin": "ㄌㄜˋ",
      "pinyin": "kuàilè",
      "english": "happy, joyful"
    },
    {
      "character": "筷",
      "zhuyin": "ㄎㄨㄞˋ",
      "pinyin": "kuàizi",
      "english": "chopsticks, CL:對|对[dui4], 根[gen1], 把[ba3], 雙|双[shuang1]"
    },
    {
      "character": "禮",
      "zhuyin": "ㄌㄧˇ",
      "pinyin": "lǐbàitiān",
      "english": "Sunday"
    },
    {
      "character": "奶",
      "zhuyin": "ㄋㄞˇ",
      "pinyin": "niúnǎi",
      "english": "cow's milk, CL:瓶[ping2], 杯[bei1]"
    },
    {
      "character": "旁",
      "zhuyin": "ㄆㄤˊ",
      "pinyin": "pángbiān",
      "english": "side, adjacent place"
    },
    {
      "character": "宜",
      "zhuyin": "ㄧˊ",
      "pinyin": "piányí",
      "english": "cheap, inexpensive, a petty advantage, to let sb off lightly"
    },
    {
      "character": "然",
      "zhuyin": "ㄖㄢˊ",
      "pinyin": "ránhòu",
      "english": "then, after that, afterwards"
    },
    {
      "character": "體",
      "zhuyin": "ㄊㄧˇ",
      "pinyin": "shēntǐ",
      "english": "the body, one's health"
    },
    {
      "character": "舒",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shūfu",
      "english": "comfortable, feeling well"
    },
    {
      "character": "服",
      "zhuyin": "˙ㄈㄨ",
      "pinyin": "shūfu",
      "english": "comfortable, feeling well"
    },
    {
      "character": "果",
      "zhuyin": "ㄍㄨㄛˇ",
      "pinyin": "shuǐguǒ",
      "english": "fruit, CL:個|个[ge4]"
    },
    {
      "character": "鞋",
      "zhuyin": "ㄒㄧㄝˊ",
      "pinyin": "xiézi",
      "english": "shoe"
    },
    {
      "character": "息",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "xiūxí",
      "english": "rest, to rest"
    },
    {
      "character": "睛",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "yǎnjīng",
      "english": "eye, CL:隻|只[zhi1], 雙|双[shuang1]"
    },
    {
      "character": "衣",
      "zhuyin": "ㄧ",
      "pinyin": "yīfú",
      "english": "clothes, CL:件[jian4], 套[tao4]"
    },
    {
      "character": "定",
      "zhuyin": "ㄉㄧㄥˋ",
      "pinyin": "yídìng",
      "english": "surely, certainly, necessarily, fixed, a certain (extent etc), given, particular, must"
    },
    {
      "character": "共",
      "zhuyin": "ㄍㄨㄥˋ",
      "pinyin": "yígòng",
      "english": "altogether"
    },
    {
      "character": "些",
      "zhuyin": "ㄒㄧㄝ",
      "pinyin": "yìxiē",
      "english": "some, a few, a little, (following an adjective) slightly ...er"
    },
    {
      "character": "椅",
      "zhuyin": "ㄧˇ",
      "pinyin": "yǐzi",
      "english": "chair, CL:把[ba3], 套[tao4]"
    },
    {
      "character": "意",
      "zhuyin": "ㄧˋ",
      "pinyin": "yìsi",
      "english": "idea, opinion, meaning, wish, desire, interest, fun, token of appreciation, affection etc, CL:個|个[ge"
    },
    {
      "character": "思",
      "zhuyin": "˙ㄙ",
      "pinyin": "yìsi",
      "english": "idea, opinion, meaning, wish, desire, interest, fun, token of appreciation, affection etc, CL:個|个[ge"
    },
    {
      "character": "因",
      "zhuyin": "ㄧㄣ",
      "pinyin": "yīnwèi",
      "english": "because, owing to, on account of"
    },
    {
      "character": "運",
      "zhuyin": "ㄩㄣˋ",
      "pinyin": "yùndòng",
      "english": "to move, to exercise, sports, exercise, motion, movement, campaign, CL:場|场[chang3]"
    },
    {
      "character": "桌",
      "zhuyin": "ㄓㄨㄛ",
      "pinyin": "zhuōzi",
      "english": "table, desk, CL:張|张[zhang1], 套[tao4]"
    },
    {
      "character": "己",
      "zhuyin": "ㄐㄧˇ",
      "pinyin": "zìjǐ",
      "english": "oneself, one's own"
    },
    {
      "character": "嘴",
      "zhuyin": "ㄗㄨㄟˇ",
      "pinyin": "zuǐba",
      "english": "mouth (CL:張|张[zhang1]), slap in the face (CL:個|个[ge4])"
    },
    {
      "character": "巴",
      "zhuyin": "˙ㄅㄚ",
      "pinyin": "zuǐba",
      "english": "mouth (CL:張|张[zhang1]), slap in the face (CL:個|个[ge4])"
    }
  ],
  "A2": [
    {
      "character": "哪",
      "zhuyin": "˙ㄋㄚ",
      "pinyin": "na",
      "english": "(emphatic sentence-final particle, used instead of 啊[a5] after a word ending in \"n\")"
    },
    {
      "character": "長",
      "zhuyin": "ㄓㄤˇ",
      "pinyin": "zhǎng",
      "english": "chief, head, elder, to grow, to develop, to increase, to enhance"
    },
    {
      "character": "還",
      "zhuyin": "ㄏㄨㄢˊ",
      "pinyin": "huán",
      "english": "to pay back, to return"
    },
    {
      "character": "啊",
      "zhuyin": "˙ㄚ",
      "pinyin": "a",
      "english": "modal particle ending sentence, showing affirmation, approval, or consent"
    },
    {
      "character": "把",
      "zhuyin": "ㄅㄚˇ",
      "pinyin": "bǎ",
      "english": "to hold, to grasp, to hold a baby in position to help it urinate or defecate, handlebar, classifier:"
    },
    {
      "character": "班",
      "zhuyin": "ㄅㄢ",
      "pinyin": "bān",
      "english": "team, class, grade, (military) squad, work shift, CL:個|个[ge4], classifier for groups of people and s"
    },
    {
      "character": "幫",
      "zhuyin": "ㄅㄤ",
      "pinyin": "bāng",
      "english": "to help, to assist, to support, for sb (i.e. as a help), hired (as worker), side (of pail, boat etc)"
    },
    {
      "character": "棒",
      "zhuyin": "ㄅㄤˋ",
      "pinyin": "bàng",
      "english": "stick, club, cudgel, smart, capable, strong, wonderful, classifier for legs of a relay race"
    },
    {
      "character": "包",
      "zhuyin": "ㄅㄠ",
      "pinyin": "bāo",
      "english": "to cover, to wrap, to hold, to include, to take charge of, to contract (to or for), package, wrapper"
    },
    {
      "character": "北",
      "zhuyin": "ㄅㄟˇ",
      "pinyin": "běi",
      "english": "north, (classical) to be defeated"
    },
    {
      "character": "被",
      "zhuyin": "ㄅㄟˋ",
      "pinyin": "bèi",
      "english": "quilt, to cover (with), (literary) to suffer (a misfortune), used to indicate passive voice (placed "
    },
    {
      "character": "變",
      "zhuyin": "ㄅㄧㄢˋ",
      "pinyin": "biàn",
      "english": "to change, to become different, to transform, to vary, rebellion"
    },
    {
      "character": "部",
      "zhuyin": "ㄅㄨˋ",
      "pinyin": "bù",
      "english": "ministry, department, section, part, division, troops, board, classifier for works of literature, fi"
    },
    {
      "character": "才",
      "zhuyin": "ㄘㄞˊ",
      "pinyin": "cái",
      "english": "ability, talent, sb of a certain type, a capable individual, then and only then, just now, (before a"
    },
    {
      "character": "場",
      "zhuyin": "ㄔㄤˇ",
      "pinyin": "chǎng",
      "english": "large place used for a specific purpose, stage, scene (of a play), classifier for sporting or recrea"
    },
    {
      "character": "次",
      "zhuyin": "ㄘˋ",
      "pinyin": "cì",
      "english": "next in sequence, second, the second (day, time etc), secondary, vice-, sub-, infra-, inferior quali"
    },
    {
      "character": "戴",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dài",
      "english": "to put on or wear (glasses, hat, gloves etc), to respect, to bear, to support"
    },
    {
      "character": "地",
      "zhuyin": "ㄉㄧˋ",
      "pinyin": "dì",
      "english": "earth, ground, field, place, land, CL:片[pian4]"
    },
    {
      "character": "電",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "diàn",
      "english": "lightning, electricity, electric (bound form), to get (or give) an electric shock, phone call or tel"
    },
    {
      "character": "放",
      "zhuyin": "ㄈㄤˋ",
      "pinyin": "fàng",
      "english": "to put, to place, to release, to free, to let go, to let out, to set off (fireworks)"
    },
    {
      "character": "份",
      "zhuyin": "ㄈㄣˋ",
      "pinyin": "fèn",
      "english": "classifier for gifts, newspaper, magazine, papers, reports, contracts etc, variant of 分[fen4]"
    },
    {
      "character": "敢",
      "zhuyin": "ㄍㄢˇ",
      "pinyin": "gǎn",
      "english": "to dare, daring, (polite) may I venture"
    },
    {
      "character": "各",
      "zhuyin": "ㄍㄜˋ",
      "pinyin": "gè",
      "english": "each, every"
    },
    {
      "character": "狗",
      "zhuyin": "ㄍㄡˇ",
      "pinyin": "gǒu",
      "english": "dog, CL:隻|只[zhi1], 條|条[tiao2]"
    },
    {
      "character": "海",
      "zhuyin": "ㄏㄞˇ",
      "pinyin": "hǎi",
      "english": "ocean, sea, CL:個|个[ge4], 片[pian4], great number of people or things, (dialect) numerous"
    },
    {
      "character": "行",
      "zhuyin": "ㄒㄧㄥˊ",
      "pinyin": "xíng",
      "english": "to walk, to go, to travel, a visit, temporary, makeshift, current, in circulation, to do, to perform"
    },
    {
      "character": "黃",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "huáng",
      "english": "yellow, pornographic, to fall through"
    },
    {
      "character": "回",
      "zhuyin": "ㄏㄨㄟˊ",
      "pinyin": "huí",
      "english": "to circle, to go back, to turn around, to answer, to return, to revolve, Hui ethnic group (Chinese M"
    },
    {
      "character": "火",
      "zhuyin": "ㄏㄨㄛˇ",
      "pinyin": "huǒ",
      "english": "fire, urgent, ammunition, fiery or flaming, internal heat (Chinese medicine), hot (popular), classif"
    },
    {
      "character": "加",
      "zhuyin": "ㄐㄧㄚ",
      "pinyin": "jiā",
      "english": "to add, plus, (used after an adverb such as 不, 大, 稍 etc, and before a disyllabic verb, to indicate t"
    },
    {
      "character": "講",
      "zhuyin": "ㄐㄧㄤˇ",
      "pinyin": "jiǎng",
      "english": "to speak, to explain, to negotiate, to emphasize, to be particular about, as far as sth is concerned"
    },
    {
      "character": "接",
      "zhuyin": "ㄐㄧㄝ",
      "pinyin": "jiē",
      "english": "to receive, to answer (the phone), to meet or welcome sb, to connect, to catch, to join, to extend, "
    },
    {
      "character": "近",
      "zhuyin": "ㄐㄧㄣˋ",
      "pinyin": "jìn",
      "english": "near, close to, approximately"
    },
    {
      "character": "句",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jù",
      "english": "sentence, clause, phrase, classifier for phrases or lines of verse"
    },
    {
      "character": "哭",
      "zhuyin": "ㄎㄨ",
      "pinyin": "kū",
      "english": "to cry, to weep"
    },
    {
      "character": "苦",
      "zhuyin": "ㄎㄨˇ",
      "pinyin": "kǔ",
      "english": "bitter, hardship, pain, to suffer, to bring suffering to, painstakingly"
    },
    {
      "character": "啦",
      "zhuyin": "˙ㄌㄚ",
      "pinyin": "la",
      "english": "sentence-final particle, contraction of 了啊, indicating exclamation, particle placed after each item "
    },
    {
      "character": "拉",
      "zhuyin": "ㄌㄚ",
      "pinyin": "lā",
      "english": "to pull, to play (a bowed instrument), to drag, to draw, to chat, (coll.) to empty one's bowels"
    },
    {
      "character": "離",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "lí",
      "english": "to leave, to part from, to be away from, (in giving distances) from, without (sth), independent of, "
    },
    {
      "character": "臉",
      "zhuyin": "ㄌㄧㄢˇ",
      "pinyin": "liǎn",
      "english": "face, CL:張|张[zhang1], 個|个[ge4]"
    },
    {
      "character": "綠",
      "zhuyin": "ㄌㄩˋ",
      "pinyin": "lǜ",
      "english": "green, (slang) (derived from 綠帽子|绿帽子[lu:4 mao4 zi5]) to cheat on (one's spouse or boyfriend or girlf"
    },
    {
      "character": "馬",
      "zhuyin": "ㄇㄚˇ",
      "pinyin": "mǎ",
      "english": "horse, CL:匹[pi3], horse or cavalry piece in Chinese chess, knight in Western chess"
    },
    {
      "character": "賣",
      "zhuyin": "ㄇㄞˋ",
      "pinyin": "mài",
      "english": "to sell, to betray, to spare no effort, to show off or flaunt"
    },
    {
      "character": "貓",
      "zhuyin": "ㄇㄠ",
      "pinyin": "māo",
      "english": "cat, CL:隻|只[zhi1], (dialect) to hide oneself, (coll.) modem"
    },
    {
      "character": "名",
      "zhuyin": "ㄇㄧㄥˊ",
      "pinyin": "míng",
      "english": "name, noun (part of speech), place (e.g. among winners), famous, classifier for people"
    },
    {
      "character": "南",
      "zhuyin": "ㄋㄢˊ",
      "pinyin": "nán",
      "english": "south"
    },
    {
      "character": "鳥",
      "zhuyin": "ㄋㄧㄠˇ",
      "pinyin": "niǎo",
      "english": "bird, CL:隻|只[zhi1], 群[qun2], \"bird\" radical in Chinese characters (Kangxi radical 196), (dialect) to"
    },
    {
      "character": "跑",
      "zhuyin": "ㄆㄠˇ",
      "pinyin": "pǎo",
      "english": "to run, to run away, to escape, to run around (on errands etc), (of a gas or liquid) to leak or evap"
    },
    {
      "character": "片",
      "zhuyin": "ㄆㄧㄢˋ",
      "pinyin": "piàn",
      "english": "thin piece, flake, a slice, film, TV play, to slice, to carve thin, partial, incomplete, one-sided, "
    },
    {
      "character": "票",
      "zhuyin": "ㄆㄧㄠˋ",
      "pinyin": "piào",
      "english": "ticket, ballot, banknote, CL:張|张[zhang1], person held for ransom, amateur performance of Chinese ope"
    },
    {
      "character": "騎",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qí",
      "english": "to sit astride, to ride (a horse, bike etc), classifier for saddle horses"
    },
    {
      "character": "全",
      "zhuyin": "ㄑㄩㄢˊ",
      "pinyin": "quán",
      "english": "all, whole, entire, every, complete"
    },
    {
      "character": "讓",
      "zhuyin": "ㄖㄤˋ",
      "pinyin": "ràng",
      "english": "to yield, to permit, to let sb do sth, to have sb do sth, to make sb (feel sad etc), by (indicates t"
    },
    {
      "character": "聲",
      "zhuyin": "ㄕㄥ",
      "pinyin": "shēng",
      "english": "sound, voice, tone, noise, reputation, classifier for sounds"
    },
    {
      "character": "試",
      "zhuyin": "ㄕˋ",
      "pinyin": "shì",
      "english": "to test, to try, experiment, examination, test"
    },
    {
      "character": "樹",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "shù",
      "english": "tree, CL:棵[ke1], to cultivate, to set up"
    },
    {
      "character": "雙",
      "zhuyin": "ㄕㄨㄤ",
      "pinyin": "shuāng",
      "english": "two, double, pair, both, even (number)"
    },
    {
      "character": "送",
      "zhuyin": "ㄙㄨㄥˋ",
      "pinyin": "sòng",
      "english": "to send, to deliver, to transmit, to give (as a present), to see (sb) off, to accompany, to go along"
    },
    {
      "character": "算",
      "zhuyin": "ㄙㄨㄢˋ",
      "pinyin": "suàn",
      "english": "to regard as, to figure, to calculate, to compute"
    },
    {
      "character": "所",
      "zhuyin": "ㄙㄨㄛˇ",
      "pinyin": "suǒ",
      "english": "actually, place, classifier for houses, small buildings, institutions etc, that which, particle intr"
    },
    {
      "character": "台",
      "zhuyin": "ㄊㄞˊ",
      "pinyin": "tái",
      "english": "platform, stage, terrace, stand, support, station, broadcasting station, classifier for vehicles or "
    },
    {
      "character": "替",
      "zhuyin": "ㄊㄧˋ",
      "pinyin": "tì",
      "english": "to substitute for, to take the place of, to replace, for, on behalf of, to stand in for"
    },
    {
      "character": "條",
      "zhuyin": "ㄊㄧㄠˊ",
      "pinyin": "tiáo",
      "english": "strip, item, article, clause (of law or treaty), classifier for long thin things (ribbon, river, roa"
    },
    {
      "character": "圖",
      "zhuyin": "ㄊㄨˊ",
      "pinyin": "tú",
      "english": "diagram, picture, drawing, chart, map, CL:張|张[zhang1], to plan, to scheme, to attempt, to pursue, to"
    },
    {
      "character": "往",
      "zhuyin": "ㄨㄤˇ",
      "pinyin": "wǎng",
      "english": "to go (in a direction), to, towards, (of a train) bound for, past, previous"
    },
    {
      "character": "西",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xī",
      "english": "west"
    },
    {
      "character": "洗",
      "zhuyin": "ㄒㄧˇ",
      "pinyin": "xǐ",
      "english": "to wash, to bathe, to develop (photographs), to shuffle (cards etc), to erase (a recording)"
    },
    {
      "character": "香",
      "zhuyin": "ㄒㄧㄤ",
      "pinyin": "xiāng",
      "english": "fragrant, sweet smelling, aromatic, savory or appetizing, (to eat) with relish, (of sleep) sound, pe"
    },
    {
      "character": "向",
      "zhuyin": "ㄒㄧㄤˋ",
      "pinyin": "xiàng",
      "english": "towards, to face, to turn towards, direction, to support, to side with, shortly before, formerly, al"
    },
    {
      "character": "笑",
      "zhuyin": "ㄒㄧㄠˋ",
      "pinyin": "xiào",
      "english": "to laugh, to smile, to laugh at"
    },
    {
      "character": "心",
      "zhuyin": "ㄒㄧㄣ",
      "pinyin": "xīn",
      "english": "heart, mind, intention, center, core, CL:顆|颗[ke1], 個|个[ge4]"
    },
    {
      "character": "信",
      "zhuyin": "ㄒㄧㄣˋ",
      "pinyin": "xìn",
      "english": "letter, mail, CL:封[feng1], to trust, to believe, to profess faith in, truthful, confidence, trust, a"
    },
    {
      "character": "呀",
      "zhuyin": "˙ㄧㄚ",
      "pinyin": "ya",
      "english": "(particle equivalent to 啊 after a vowel, expressing surprise or doubt)"
    },
    {
      "character": "遠",
      "zhuyin": "ㄩㄢˇ",
      "pinyin": "yuǎn",
      "english": "far, distant, remote, (intensifier in a comparison) by far, much (lower etc)"
    },
    {
      "character": "支",
      "zhuyin": "ㄓ",
      "pinyin": "zhī",
      "english": "to support, to sustain, to erect, to raise, branch, division, to draw money, classifier for rods suc"
    },
    {
      "character": "隻",
      "zhuyin": "ㄓ",
      "pinyin": "zhī",
      "english": "classifier for birds and certain animals, one of a pair, some utensils, vessels etc"
    },
    {
      "character": "搬",
      "zhuyin": "ㄅㄢ",
      "pinyin": "bān",
      "english": "to move (i.e. relocate oneself), to move (sth relatively heavy or bulky), to shift, to copy indiscri"
    },
    {
      "character": "笨",
      "zhuyin": "ㄅㄣˋ",
      "pinyin": "bèn",
      "english": "stupid, foolish, silly, slow-witted, clumsy"
    },
    {
      "character": "餐",
      "zhuyin": "ㄘㄢ",
      "pinyin": "cān",
      "english": "meal, to eat, classifier for meals"
    },
    {
      "character": "草",
      "zhuyin": "ㄘㄠˇ",
      "pinyin": "cǎo",
      "english": "grass, straw, manuscript, draft (of a document), careless, rough, CL:棵[ke1], 撮[zuo3], 株[zhu1], 根[gen"
    },
    {
      "character": "炒",
      "zhuyin": "ㄔㄠˇ",
      "pinyin": "chǎo",
      "english": "to sauté, to stir-fry, to speculate (in real estate etc), to scalp, to hype up, to sack, to fire (sb"
    },
    {
      "character": "臭",
      "zhuyin": "ㄔㄡˋ",
      "pinyin": "chòu",
      "english": "stench, smelly, to smell (bad), repulsive, loathsome, terrible, bad, severely, ruthlessly, dud (ammu"
    },
    {
      "character": "窗",
      "zhuyin": "ㄔㄨㄤ",
      "pinyin": "chuāng",
      "english": "window, CL:扇[shan4]"
    },
    {
      "character": "袋",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dài",
      "english": "pouch, bag, sack, pocket"
    },
    {
      "character": "燈",
      "zhuyin": "ㄉㄥ",
      "pinyin": "dēng",
      "english": "lamp, light, lantern, CL:盞|盏[zhan3]"
    },
    {
      "character": "掉",
      "zhuyin": "ㄉㄧㄠˋ",
      "pinyin": "diào",
      "english": "to fall, to drop, to lag behind, to lose, to go missing, to reduce, fall (in prices), to lose (value"
    },
    {
      "character": "東",
      "zhuyin": "ㄉㄨㄥ",
      "pinyin": "dōng",
      "english": "east, host (i.e. sitting on east side of guest), landlord"
    },
    {
      "character": "飛",
      "zhuyin": "ㄈㄟ",
      "pinyin": "fēi",
      "english": "to fly"
    },
    {
      "character": "付",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fù",
      "english": "to pay, to hand over to, classifier for pairs or sets of things"
    },
    {
      "character": "掛",
      "zhuyin": "ㄍㄨㄚˋ",
      "pinyin": "guà",
      "english": "to hang or suspend (from a hook etc), to hang up (the phone), (of a line) to be dead, to be worried "
    },
    {
      "character": "關",
      "zhuyin": "ㄍㄨㄢ",
      "pinyin": "guān",
      "english": "mountain pass, to close, to shut, to turn off, to confine, to lock (sb) up, to shut (sb in a room, a"
    },
    {
      "character": "河",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "hé",
      "english": "river, CL:條|条[tiao2], 道[dao4]"
    },
    {
      "character": "壞",
      "zhuyin": "ㄏㄨㄞˋ",
      "pinyin": "huài",
      "english": "bad, spoiled, broken, to break down, (suffix) to the utmost"
    },
    {
      "character": "寄",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "to send, to mail, to entrust, to depend on, to attach oneself to, to live (in a house), to lodge, fo"
    },
    {
      "character": "交",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "jiāo",
      "english": "to hand over, to deliver, to pay (money), to turn over, to make friends, to intersect (lines), varia"
    },
    {
      "character": "街",
      "zhuyin": "ㄐㄧㄝ",
      "pinyin": "jiē",
      "english": "street, CL:條|条[tiao2]"
    },
    {
      "character": "借",
      "zhuyin": "ㄐㄧㄝˋ",
      "pinyin": "jiè",
      "english": "to lend, to borrow, by means of, to take (an opportunity)"
    },
    {
      "character": "考",
      "zhuyin": "ㄎㄠˇ",
      "pinyin": "kǎo",
      "english": "to check, to verify, to test, to examine, to take an exam, to take an entrance exam for, deceased fa"
    },
    {
      "character": "烤",
      "zhuyin": "ㄎㄠˇ",
      "pinyin": "kǎo",
      "english": "to roast, to bake, to broil"
    },
    {
      "character": "渴",
      "zhuyin": "ㄎㄜˇ",
      "pinyin": "kě",
      "english": "thirsty"
    },
    {
      "character": "辣",
      "zhuyin": "ㄌㄚˋ",
      "pinyin": "là",
      "english": "hot (spicy), pungent, (of chili pepper, raw onions etc) to sting, to burn"
    },
    {
      "character": "藍",
      "zhuyin": "ㄌㄢˊ",
      "pinyin": "lán",
      "english": "blue, indigo plant"
    },
    {
      "character": "零",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "líng",
      "english": "zero, nought, zero sign, fractional, fragmentary, odd (of numbers), (placed between two numbers to i"
    },
    {
      "character": "輕",
      "zhuyin": "ㄑㄧㄥ",
      "pinyin": "qīng",
      "english": "light, easy, gentle, soft, reckless, unimportant, frivolous, small in number, unstressed, neutral, t"
    },
    {
      "character": "色",
      "zhuyin": "ㄙㄜˋ",
      "pinyin": "sè",
      "english": "color, CL:種|种[zhong3], look, appearance, sex"
    },
    {
      "character": "市",
      "zhuyin": "ㄕˋ",
      "pinyin": "shì",
      "english": "market, city, CL:個|个[ge4]"
    },
    {
      "character": "酸",
      "zhuyin": "ㄙㄨㄢ",
      "pinyin": "suān",
      "english": "sour, tart, sick at heart, grieved, sore, aching, pedantic, impractical, to make sarcastic remarks a"
    },
    {
      "character": "糖",
      "zhuyin": "ㄊㄤˊ",
      "pinyin": "táng",
      "english": "sugar, sweets, candy, CL:顆|颗[ke1], 塊|块[kuai4]"
    },
    {
      "character": "踢",
      "zhuyin": "ㄊㄧ",
      "pinyin": "tī",
      "english": "to kick, to play (e.g. soccer), (slang) butch (in a lesbian relationship)"
    },
    {
      "character": "脫",
      "zhuyin": "ㄊㄨㄛ",
      "pinyin": "tuō",
      "english": "to shed, to take off, to escape, to get away from"
    },
    {
      "character": "忘",
      "zhuyin": "ㄨㄤˋ",
      "pinyin": "wàng",
      "english": "to forget, to overlook, to neglect"
    },
    {
      "character": "喂",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéi",
      "english": "hello (when answering the phone)"
    },
    {
      "character": "鹹",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "xián",
      "english": "salted, salty, stingy, miserly"
    },
    {
      "character": "雪",
      "zhuyin": "ㄒㄩㄝˇ",
      "pinyin": "xuě",
      "english": "snow, CL:場|场[chang2], (literary) to wipe away (a humiliation etc)"
    },
    {
      "character": "游",
      "zhuyin": "ㄧㄡˊ",
      "pinyin": "yóu",
      "english": "to swim, variant of 遊|游[you2]"
    },
    {
      "character": "祝",
      "zhuyin": "ㄓㄨˋ",
      "pinyin": "zhù",
      "english": "to pray for, to wish (sb bon voyage, happy birthday etc), person who invokes the spirits during sacr"
    },
    {
      "character": "租",
      "zhuyin": "ㄗㄨ",
      "pinyin": "zū",
      "english": "to hire, to rent, to charter, to rent out, to lease out, rent, land tax"
    },
    {
      "character": "法",
      "zhuyin": "ㄈㄚˇ",
      "pinyin": "bànfǎ",
      "english": "means, method, way (of doing sth), CL:條|条[tiao2], 個|个[ge4]"
    },
    {
      "character": "助",
      "zhuyin": "ㄓㄨˋ",
      "pinyin": "bāngzhù",
      "english": "assistance, aid, to help, to assist"
    },
    {
      "character": "較",
      "zhuyin": "ㄐㄧㄠˋ",
      "pinyin": "bǐjiào",
      "english": "to compare, to contrast, comparatively, relatively, quite, comparison"
    },
    {
      "character": "賽",
      "zhuyin": "ㄙㄞˋ",
      "pinyin": "bǐsài",
      "english": "competition (sports etc), match, CL:場|场[chang3], 次[ci4], to compete"
    },
    {
      "character": "績",
      "zhuyin": "ㄐㄧ",
      "pinyin": "chéngjī",
      "english": "achievement, performance records, grades, CL:項|项[xiang4], 個|个[ge4]"
    },
    {
      "character": "春",
      "zhuyin": "ㄔㄨㄣ",
      "pinyin": "chūntiān",
      "english": "spring (season), CL:個|个[ge4]"
    },
    {
      "character": "但",
      "zhuyin": "ㄉㄢˋ",
      "pinyin": "dànshì",
      "english": "but, however"
    },
    {
      "character": "第",
      "zhuyin": "ㄉㄧˋ",
      "pinyin": "dìyī",
      "english": "first, number one, primary"
    },
    {
      "character": "冬",
      "zhuyin": "ㄉㄨㄥ",
      "pinyin": "dōngtiān",
      "english": "winter, CL:個|个[ge4]"
    },
    {
      "character": "淨",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "gānjìng",
      "english": "clean, neat"
    },
    {
      "character": "剛",
      "zhuyin": "ㄍㄤ",
      "pinyin": "gānggāng",
      "english": "just recently, just a moment ago"
    },
    {
      "character": "興",
      "zhuyin": "ㄒㄧㄥˋ",
      "pinyin": "gāoxìng",
      "english": "happy, glad, willing (to do sth), in a cheerful mood"
    },
    {
      "character": "司",
      "zhuyin": "ㄙ",
      "pinyin": "gōngsī",
      "english": "company, firm, corporation, CL:家[jia1]"
    },
    {
      "character": "迎",
      "zhuyin": "ㄧㄥˊ",
      "pinyin": "huānyíng",
      "english": "to welcome, welcome"
    },
    {
      "character": "或",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "huòshì",
      "english": "or, either one or the other"
    },
    {
      "character": "簡",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "jiǎndān",
      "english": "simple, not complicated"
    },
    {
      "character": "健",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiànkāng",
      "english": "health, healthy"
    },
    {
      "character": "康",
      "zhuyin": "ㄎㄤ",
      "pinyin": "jiànkāng",
      "english": "health, healthy"
    },
    {
      "character": "庭",
      "zhuyin": "ㄊㄧㄥˊ",
      "pinyin": "jiātíng",
      "english": "family, household, CL:戶|户[hu4], 個|个[ge4]"
    },
    {
      "character": "經",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jīngguò",
      "english": "to pass, to go through, process, course, CL:個|个[ge4]"
    },
    {
      "character": "驗",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "jīngyàn",
      "english": "experience, to experience"
    },
    {
      "character": "決",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "juédìng",
      "english": "to decide (to do something), to resolve, decision, CL:個|个[ge4], 項|项[xiang4], certainly"
    },
    {
      "character": "始",
      "zhuyin": "ㄕˇ",
      "pinyin": "kāishǐ",
      "english": "to begin, beginning, to start, initial, CL:個|个[ge4]"
    },
    {
      "character": "闆",
      "zhuyin": "ㄅㄢˇ",
      "pinyin": "lǎobǎn",
      "english": "boss, business proprietor, CL:個|个[ge4]"
    },
    {
      "character": "習",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "liànxí",
      "english": "to practice, exercise, drill, practice, CL:個|个[ge4]"
    },
    {
      "character": "聊",
      "zhuyin": "ㄌㄧㄠˊ",
      "pinyin": "liáotiān",
      "english": "to chat, to gossip"
    },
    {
      "character": "旅",
      "zhuyin": "ㄌㄩˇ",
      "pinyin": "lǚxíng",
      "english": "to travel, journey, trip, CL:趟[tang4], 次[ci4]"
    },
    {
      "character": "力",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "nénglì",
      "english": "capability, ability, CL:個|个[ge4]"
    },
    {
      "character": "努",
      "zhuyin": "ㄋㄨˇ",
      "pinyin": "nǔlì",
      "english": "to make an effort, to try hard, to strive, hard-working, conscientious"
    },
    {
      "character": "奇",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qíguài",
      "english": "strange, odd, to marvel, to be baffled"
    },
    {
      "character": "汽",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "qìchē",
      "english": "car, automobile, bus, CL:輛|辆[liang4]"
    },
    {
      "character": "楚",
      "zhuyin": "ㄔㄨˇ",
      "pinyin": "qīngchǔ",
      "english": "clear, distinct, to understand thoroughly, to be clear about"
    },
    {
      "character": "認",
      "zhuyin": "ㄖㄣˋ",
      "pinyin": "rènshì",
      "english": "to know, to recognize, to be familiar with, to get acquainted with sb, knowledge, understanding, awa"
    },
    {
      "character": "識",
      "zhuyin": "ㄕˋ",
      "pinyin": "rènshì",
      "english": "to know, to recognize, to be familiar with, to get acquainted with sb, knowledge, understanding, awa"
    },
    {
      "character": "如",
      "zhuyin": "ㄖㄨˊ",
      "pinyin": "rúguǒ",
      "english": "if, in case, in the event that"
    },
    {
      "character": "音",
      "zhuyin": "ㄧㄣ",
      "pinyin": "shēngyīn",
      "english": "voice, sound, CL:個|个[ge4]"
    },
    {
      "character": "世",
      "zhuyin": "ㄕˋ",
      "pinyin": "shìjiè",
      "english": "world (CL:個|个[ge4])"
    },
    {
      "character": "界",
      "zhuyin": "ㄐㄧㄝˋ",
      "pinyin": "shìjiè",
      "english": "world (CL:個|个[ge4])"
    },
    {
      "character": "情",
      "zhuyin": "ㄑㄧㄥˊ",
      "pinyin": "shìqíng",
      "english": "affair, matter, thing, business, CL:件[jian4], 樁|桩[zhuang1]"
    },
    {
      "character": "雖",
      "zhuyin": "ㄙㄨㄟ",
      "pinyin": "suīrán",
      "english": "although, even though (often used correlatively with 可是[ke3 shi4] or 但是[dan4 shi4] etc)"
    },
    {
      "character": "特",
      "zhuyin": "ㄊㄜˋ",
      "pinyin": "tèbié",
      "english": "unusual, special, very, especially, particularly, expressly, for a specific purpose, (often followed"
    },
    {
      "character": "味",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "wèidào",
      "english": "flavor, taste, (fig.) feeling (of ...), sense (of ...), hint (of ...), (fig.) interest, delight, (di"
    },
    {
      "character": "化",
      "zhuyin": "ㄏㄨㄚˋ",
      "pinyin": "wénhuà",
      "english": "culture, civilization, cultural, CL:個|个[ge4], 種|种[zhong3]"
    },
    {
      "character": "屋",
      "zhuyin": "ㄨ",
      "pinyin": "wūzi",
      "english": "house, room, CL:間|间[jian1]"
    },
    {
      "character": "相",
      "zhuyin": "ㄒㄧㄤˋ",
      "pinyin": "xiàngpiàn",
      "english": "image, photograph, CL:張|张[zhang1]"
    },
    {
      "character": "夏",
      "zhuyin": "ㄒㄧㄚˋ",
      "pinyin": "xiàtiān",
      "english": "summer, CL:個|个[ge4]"
    },
    {
      "character": "辛",
      "zhuyin": "ㄒㄧㄣ",
      "pinyin": "xīnkǔ",
      "english": "exhausting, hard, tough, arduous, to work hard, to go to a lot of trouble, hardship(s)"
    },
    {
      "character": "希",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xīwàng",
      "english": "to hope, a hope, a wish (CL:個|个[ge4])"
    },
    {
      "character": "望",
      "zhuyin": "ㄨㄤˋ",
      "pinyin": "xīwàng",
      "english": "to hope, a hope, a wish (CL:個|个[ge4])"
    },
    {
      "character": "需",
      "zhuyin": "ㄒㄩ",
      "pinyin": "xūyào",
      "english": "to need, to want, to demand, to require, needs"
    },
    {
      "character": "顏",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "yánsè",
      "english": "color, countenance, appearance, facial expression, pigment, dyestuff"
    },
    {
      "character": "院",
      "zhuyin": "ㄩㄢˋ",
      "pinyin": "yīyuàn",
      "english": "hospital, CL:所[suo3], 家[jia1], 座[zuo4]"
    },
    {
      "character": "語",
      "zhuyin": "ㄩˇ",
      "pinyin": "yǔyán",
      "english": "language, CL:門|门[men2], 種|种[zhong3]"
    },
    {
      "character": "言",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "yǔyán",
      "english": "language, CL:門|门[men2], 種|种[zhong3]"
    },
    {
      "character": "備",
      "zhuyin": "ㄅㄟˋ",
      "pinyin": "zhǔnbèi",
      "english": "preparation, to prepare, to intend, to be about to, reserve (fund)"
    },
    {
      "character": "注",
      "zhuyin": "ㄓㄨˋ",
      "pinyin": "zhùyì",
      "english": "to take note of, to pay attention to"
    },
    {
      "character": "總",
      "zhuyin": "ㄗㄨㄥˇ",
      "pinyin": "zǒngshì",
      "english": "always"
    },
    {
      "character": "業",
      "zhuyin": "ㄧㄝˋ",
      "pinyin": "zuòyè",
      "english": "school assignment, homework, work, task, operation, CL:個|个[ge4], to operate"
    },
    {
      "character": "阿",
      "zhuyin": "ㄚ",
      "pinyin": "āyí",
      "english": "maternal aunt, step-mother, childcare worker, nursemaid, woman of similar age to one's parents (term"
    },
    {
      "character": "姨",
      "zhuyin": "ㄧˊ",
      "pinyin": "āyí",
      "english": "maternal aunt, step-mother, childcare worker, nursemaid, woman of similar age to one's parents (term"
    },
    {
      "character": "報",
      "zhuyin": "ㄅㄠˋ",
      "pinyin": "bàozhǐ",
      "english": "newspaper, newsprint, CL:份[fen4], 期[qi1], 張|张[zhang1]"
    },
    {
      "character": "士",
      "zhuyin": "ㄕˋ",
      "pinyin": "bāshì",
      "english": "bus (loanword), motor coach"
    },
    {
      "character": "商",
      "zhuyin": "ㄕㄤ",
      "pinyin": "biànlìshāngdiàn",
      "english": "convenience store (Tw)"
    },
    {
      "character": "淇",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "bīngqílín",
      "english": "ice cream"
    },
    {
      "character": "箱",
      "zhuyin": "ㄒㄧㄤ",
      "pinyin": "bīngxiāng",
      "english": "refrigerator, (old) icebox"
    },
    {
      "character": "伯",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "bóbo",
      "english": "father's elder brother, uncle"
    },
    {
      "character": "了",
      "zhuyin": "˙ㄌㄜ",
      "pinyin": "bújiànle",
      "english": "to have disappeared, to be missing, nowhere to be found"
    },
    {
      "character": "館",
      "zhuyin": "ㄍㄨㄢˇ",
      "pinyin": "cháguǎn",
      "english": "teahouse, CL:家[jia1]"
    },
    {
      "character": "超",
      "zhuyin": "ㄔㄠ",
      "pinyin": "chāoshāng",
      "english": "convenience store, supermarket"
    },
    {
      "character": "叉",
      "zhuyin": "ㄔㄚ",
      "pinyin": "chāzi",
      "english": "fork, CL:把[ba3]"
    },
    {
      "character": "聰",
      "zhuyin": "ㄘㄨㄥ",
      "pinyin": "cōngmíng",
      "english": "intelligent, clever, bright, smart, acute (of sight and hearing)"
    },
    {
      "character": "糕",
      "zhuyin": "ㄍㄠ",
      "pinyin": "dàngāo",
      "english": "cake, CL:塊|块[kuai4], 個|个[ge4]"
    },
    {
      "character": "刀",
      "zhuyin": "ㄉㄠ",
      "pinyin": "dāozi",
      "english": "knife, CL:把[ba3]"
    },
    {
      "character": "德",
      "zhuyin": "ㄉㄜˊ",
      "pinyin": "déwén",
      "english": "German (language)"
    },
    {
      "character": "梯",
      "zhuyin": "ㄊㄧ",
      "pinyin": "diàntī",
      "english": "elevator, escalator, CL:臺|台[tai2], 部[bu4]"
    },
    {
      "character": "址",
      "zhuyin": "ㄓˇ",
      "pinyin": "dìzhǐ",
      "english": "address, CL:個|个[ge4]"
    },
    {
      "character": "肚",
      "zhuyin": "ㄉㄨˋ",
      "pinyin": "dùzi",
      "english": "belly, abdomen, stomach, CL:個|个[ge4]"
    },
    {
      "character": "景",
      "zhuyin": "ㄐㄧㄥˇ",
      "pinyin": "fēngjǐng",
      "english": "scenery, landscape, CL:個|个[ge4]"
    },
    {
      "character": "罐",
      "zhuyin": "ㄍㄨㄢˋ",
      "pinyin": "guànzi",
      "english": "jar, pitcher, pot"
    },
    {
      "character": "漢",
      "zhuyin": "ㄏㄢˋ",
      "pinyin": "hànbǎo",
      "english": "hamburger (loanword)"
    },
    {
      "character": "堡",
      "zhuyin": "ㄅㄠˇ",
      "pinyin": "hànbǎo",
      "english": "hamburger (loanword)"
    },
    {
      "character": "盒",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "hézi",
      "english": "box, case"
    },
    {
      "character": "護",
      "zhuyin": "ㄏㄨˋ",
      "pinyin": "hùshì",
      "english": "nurse, CL:個|个[ge4]"
    },
    {
      "character": "餃",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎozi",
      "english": "dumpling, pot-sticker, CL:個|个[ge4], 隻|只[zhi1]"
    },
    {
      "character": "褲",
      "zhuyin": "ㄎㄨˋ",
      "pinyin": "kùzi",
      "english": "trousers, pants, CL:條|条[tiao2]"
    },
    {
      "character": "籃",
      "zhuyin": "ㄌㄢˊ",
      "pinyin": "lánqiú",
      "english": "basketball, CL:個|个[ge4], 隻|只[zhi1]"
    },
    {
      "character": "饅",
      "zhuyin": "ㄇㄢˊ",
      "pinyin": "mántou",
      "english": "steamed bun"
    },
    {
      "character": "帽",
      "zhuyin": "ㄇㄠˋ",
      "pinyin": "màozi",
      "english": "hat, cap, (fig.) label, bad name, CL:頂|顶[ding3]"
    },
    {
      "character": "念",
      "zhuyin": "ㄋㄧㄢˋ",
      "pinyin": "niànshū",
      "english": "to read, to study"
    },
    {
      "character": "盤",
      "zhuyin": "ㄆㄢˊ",
      "pinyin": "pánzi",
      "english": "tray, plate, dish, CL:個|个[ge4]"
    },
    {
      "character": "啤",
      "zhuyin": "ㄆㄧˊ",
      "pinyin": "píjiǔ",
      "english": "beer (loanword), CL:杯[bei1], 瓶[ping2], 罐[guan4], 桶[tong3], 缸[gang1]"
    },
    {
      "character": "蘋",
      "zhuyin": "ㄆㄧㄥˊ",
      "pinyin": "píngguǒ",
      "english": "apple, CL:個|个[ge4], 顆|颗[ke1]"
    },
    {
      "character": "瓶",
      "zhuyin": "ㄆㄧㄥˊ",
      "pinyin": "píngzi",
      "english": "bottle, CL:個|个[ge4]"
    },
    {
      "character": "秋",
      "zhuyin": "ㄑㄧㄡ",
      "pinyin": "qiūtiān",
      "english": "autumn, CL:個|个[ge4]"
    },
    {
      "character": "裙",
      "zhuyin": "ㄑㄩㄣˊ",
      "pinyin": "qúnzi",
      "english": "skirt, CL:條|条[tiao2]"
    },
    {
      "character": "治",
      "zhuyin": "ㄓˋ",
      "pinyin": "sānmíngzhì",
      "english": "sandwich (loanword), CL:個|个[ge4]"
    },
    {
      "character": "錶",
      "zhuyin": "ㄅㄧㄠˇ",
      "pinyin": "shǒubiǎo",
      "english": "wristwatch, CL:塊|块[kuai4], 隻|只[zhi1], 個|个[ge4]"
    },
    {
      "character": "叔",
      "zhuyin": "ㄕㄨˊ",
      "pinyin": "shúshu",
      "english": "father's younger brother, uncle, Taiwan pr. [shu2 shu5], CL:個|个[ge4]"
    },
    {
      "character": "舍",
      "zhuyin": "ㄕㄜˋ",
      "pinyin": "sùshè",
      "english": "dormitory, dorm room, living quarters, hostel, CL:間|间[jian1]"
    },
    {
      "character": "匙",
      "zhuyin": "ㄔˊ",
      "pinyin": "tāngchí",
      "english": "soup spoon, tablespoon, CL:把[ba3]"
    },
    {
      "character": "髮",
      "zhuyin": "ㄈㄚˇ",
      "pinyin": "tóufǎ",
      "english": "hair (on the head)"
    },
    {
      "character": "蕉",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "xiāngjiāo",
      "english": "banana, CL:枝[zhi1], 根[gen1], 個|个[ge4], 把[ba3]"
    },
    {
      "character": "瓜",
      "zhuyin": "ㄍㄨㄚ",
      "pinyin": "xīguā",
      "english": "watermelon, CL:顆|颗[ke1], 個|个[ge5]"
    },
    {
      "character": "澡",
      "zhuyin": "ㄗㄠˇ",
      "pinyin": "xǐzǎo",
      "english": "to bathe, to take a shower"
    },
    {
      "character": "鏡",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "yǎnjìng",
      "english": "spectacles, eyeglasses, CL:副[fu4]"
    },
    {
      "character": "爺",
      "zhuyin": "ㄧㄝˊ",
      "pinyin": "yéye",
      "english": "(coll.) father's father, paternal grandfather, CL:個|个[ge4]"
    },
    {
      "character": "郵",
      "zhuyin": "ㄧㄡˊ",
      "pinyin": "yóujú",
      "english": "post office, CL:家[jia1], 個|个[ge4]"
    },
    {
      "character": "泳",
      "zhuyin": "ㄩㄥˇ",
      "pinyin": "yóuyǒng",
      "english": "swimming, to swim"
    },
    {
      "character": "池",
      "zhuyin": "ㄔˊ",
      "pinyin": "yóuyǒngchí",
      "english": "swimming pool, CL:場|场[chang3]"
    },
    {
      "character": "照",
      "zhuyin": "ㄓㄠˋ",
      "pinyin": "zhàoxiàng",
      "english": "to take a photograph"
    },
    {
      "character": "典",
      "zhuyin": "ㄉㄧㄢˇ",
      "pinyin": "zìdiǎn",
      "english": "Chinese character dictionary (containing entries for single characters, contrasted with a 詞典|词典[ci2 "
    },
    {
      "character": "足",
      "zhuyin": "ㄗㄨˊ",
      "pinyin": "zúqiú",
      "english": "soccer ball, a football, CL:個|个[ge4], soccer, football"
    }
  ],
  "B1": [
    {
      "character": "等",
      "zhuyin": "ㄉㄥˇ",
      "pinyin": "děng",
      "english": "to wait for, to await, by the time, when, till, and so on, etc., et al., (bound form) class, rank, g"
    },
    {
      "character": "花",
      "zhuyin": "ㄏㄨㄚ",
      "pinyin": "huā",
      "english": "flower, blossom, CL:朵[duo3], 支[zhi1], 束[shu4], 把[ba3], 盆[pen2], 簇[cu4], fancy pattern, florid, to sp"
    },
    {
      "character": "空",
      "zhuyin": "ㄎㄨㄥ",
      "pinyin": "kōng",
      "english": "empty, air, sky, in vain"
    },
    {
      "character": "背",
      "zhuyin": "ㄅㄟ",
      "pinyin": "bēi",
      "english": "to be burdened, to carry on the back or shoulder"
    },
    {
      "character": "遍",
      "zhuyin": "ㄅㄧㄢˋ",
      "pinyin": "biàn",
      "english": "everywhere, all over, classifier for actions: one time"
    },
    {
      "character": "查",
      "zhuyin": "ㄔㄚˊ",
      "pinyin": "chá",
      "english": "to research, to check, to investigate, to examine, to refer to, to look up (e.g. a word in a diction"
    },
    {
      "character": "船",
      "zhuyin": "ㄔㄨㄢˊ",
      "pinyin": "chuán",
      "english": "boat, vessel, ship, CL:條|条[tiao2], 艘[sou1], 隻|只[zhi1]"
    },
    {
      "character": "詞",
      "zhuyin": "ㄘˊ",
      "pinyin": "cí",
      "english": "word, statement, speech, lyrics, CL:組|组[zu3], 個|个[ge4], a form of lyric poetry, flourishing in the S"
    },
    {
      "character": "搭",
      "zhuyin": "ㄉㄚ",
      "pinyin": "dā",
      "english": "to put up, to build (scaffolding), to hang (clothes on a pole), to connect, to join, to arrange in p"
    },
    {
      "character": "訂",
      "zhuyin": "ㄉㄧㄥˋ",
      "pinyin": "dìng",
      "english": "to agree, to conclude, to draw up, to subscribe to (a newspaper etc), to order"
    },
    {
      "character": "丟",
      "zhuyin": "ㄉㄧㄡ",
      "pinyin": "diū",
      "english": "to lose, to put aside, to throw"
    },
    {
      "character": "度",
      "zhuyin": "ㄉㄨˋ",
      "pinyin": "dù",
      "english": "to pass, to spend (time), measure, limit, extent, degree of intensity, degree (angles, temperature e"
    },
    {
      "character": "封",
      "zhuyin": "ㄈㄥ",
      "pinyin": "fēng",
      "english": "to confer, to grant, to bestow a title, to seal, classifier for sealed objects, esp. letters"
    },
    {
      "character": "逛",
      "zhuyin": "ㄍㄨㄤˋ",
      "pinyin": "guàng",
      "english": "to stroll, to visit"
    },
    {
      "character": "換",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "huàn",
      "english": "to exchange, to change (clothes etc), to substitute, to switch, to convert (currency)"
    },
    {
      "character": "急",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jí",
      "english": "urgent, pressing, rapid, hurried, worried, to make (sb) anxious"
    },
    {
      "character": "醬",
      "zhuyin": "ㄐㄧㄤˋ",
      "pinyin": "jiàng",
      "english": "thick paste of fermented soybean, marinated in soy paste, paste, jam"
    },
    {
      "character": "顆",
      "zhuyin": "ㄎㄜ",
      "pinyin": "kē",
      "english": "classifier for small spheres, pearls, corn grains, teeth, hearts, satellites etc"
    },
    {
      "character": "口",
      "zhuyin": "ㄎㄡˇ",
      "pinyin": "kǒu",
      "english": "mouth, classifier for things with mouths (people, domestic animals, cannons, wells etc), classifier "
    },
    {
      "character": "留",
      "zhuyin": "ㄌㄧㄡˊ",
      "pinyin": "liú",
      "english": "to leave (a message etc), to retain, to stay, to remain, to keep, to preserve"
    },
    {
      "character": "亂",
      "zhuyin": "ㄌㄨㄢˋ",
      "pinyin": "luàn",
      "english": "in confusion or disorder, in a confused state of mind, disorder, upheaval, riot, illicit sexual rela"
    },
    {
      "character": "滿",
      "zhuyin": "ㄇㄢˇ",
      "pinyin": "mǎn",
      "english": "to fill, full, filled, packed, fully, completely, quite, to reach the limit, to satisfy, satisfied, "
    },
    {
      "character": "夢",
      "zhuyin": "ㄇㄥˋ",
      "pinyin": "mèng",
      "english": "dream (CL:場|场[chang2], 個|个[ge4]), (bound form) to dream"
    },
    {
      "character": "內",
      "zhuyin": "ㄋㄟˋ",
      "pinyin": "nèi",
      "english": "inside, inner, internal, within, interior"
    },
    {
      "character": "拍",
      "zhuyin": "ㄆㄞ",
      "pinyin": "pāi",
      "english": "to pat, to clap, to slap, to swat, to take (a photo), to shoot (a film), racket (sports), beat (musi"
    },
    {
      "character": "泡",
      "zhuyin": "ㄆㄠˋ",
      "pinyin": "pào",
      "english": "bubble, foam, blister, to soak, to steep, to infuse, to dawdle, to loiter, to pick up (a girl), to g"
    },
    {
      "character": "陪",
      "zhuyin": "ㄆㄟˊ",
      "pinyin": "péi",
      "english": "to accompany, to keep sb company, to assist, old variant of 賠|赔[pei2]"
    },
    {
      "character": "破",
      "zhuyin": "ㄆㄛˋ",
      "pinyin": "pò",
      "english": "broken, damaged, worn out, lousy, rotten, to break, split or cleave, to get rid of, to destroy, to b"
    },
    {
      "character": "傘",
      "zhuyin": "ㄙㄢˇ",
      "pinyin": "sǎn",
      "english": "umbrella, parasol, CL:把[ba3]"
    },
    {
      "character": "溼",
      "zhuyin": "ㄕ",
      "pinyin": "shī",
      "english": "moist, wet"
    },
    {
      "character": "收",
      "zhuyin": "ㄕㄡ",
      "pinyin": "shōu",
      "english": "to receive, to accept, to collect, to put away, to restrain, to stop, in care of (used on address li"
    },
    {
      "character": "帥",
      "zhuyin": "ㄕㄨㄞˋ",
      "pinyin": "shuài",
      "english": "(bound form) commander-in-chief, (bound form) to lead, to command, handsome, graceful, dashing, eleg"
    },
    {
      "character": "死",
      "zhuyin": "ㄙˇ",
      "pinyin": "sǐ",
      "english": "to die, impassable, uncrossable, inflexible, rigid, extremely, damned"
    },
    {
      "character": "套",
      "zhuyin": "ㄊㄠˋ",
      "pinyin": "tào",
      "english": "to cover, to encase, cover, sheath, to overlap, to interleave, to model after, to copy, formula, har"
    },
    {
      "character": "提",
      "zhuyin": "ㄊㄧˊ",
      "pinyin": "tí",
      "english": "to carry (hanging down from the hand), to lift, to put forward, to mention, to raise (an issue), upw"
    },
    {
      "character": "停",
      "zhuyin": "ㄊㄧㄥˊ",
      "pinyin": "tíng",
      "english": "to stop, to halt, to park (a car)"
    },
    {
      "character": "腿",
      "zhuyin": "ㄊㄨㄟˇ",
      "pinyin": "tuǐ",
      "english": "leg, CL:條|条[tiao2]"
    },
    {
      "character": "哇",
      "zhuyin": "˙ㄨㄚ",
      "pinyin": "wɑ",
      "english": "replaces 啊[a5] when following the vowel \"u\" or \"ao\""
    },
    {
      "character": "聞",
      "zhuyin": "ㄨㄣˊ",
      "pinyin": "wén",
      "english": "to hear, news, well-known, famous, reputation, fame, to smell, to sniff at"
    },
    {
      "character": "舞",
      "zhuyin": "ㄨˇ",
      "pinyin": "wǔ",
      "english": "to dance, to wield, to brandish"
    },
    {
      "character": "選",
      "zhuyin": "ㄒㄩㄢˇ",
      "pinyin": "xuǎn",
      "english": "to choose, to pick, to select, to elect"
    },
    {
      "character": "鹽",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "yán",
      "english": "salt, CL:粒[li4]"
    },
    {
      "character": "樣",
      "zhuyin": "ㄧㄤˋ",
      "pinyin": "yàng",
      "english": "manner, pattern, way, appearance, shape, classifier: kind, type"
    },
    {
      "character": "已",
      "zhuyin": "ㄧˇ",
      "pinyin": "yǐ",
      "english": "already, to stop, then, afterwards"
    },
    {
      "character": "油",
      "zhuyin": "ㄧㄡˊ",
      "pinyin": "yóu",
      "english": "oil, fat, grease, petroleum, to apply tung oil, paint or varnish, oily, greasy, glib, cunning"
    },
    {
      "character": "越",
      "zhuyin": "ㄩㄝˋ",
      "pinyin": "yuè",
      "english": "to exceed, to climb over, to surpass, the more... the more"
    },
    {
      "character": "髒",
      "zhuyin": "ㄗㄤ",
      "pinyin": "zāng",
      "english": "dirty, filthy, to get (sth) dirty"
    },
    {
      "character": "週",
      "zhuyin": "ㄓㄡ",
      "pinyin": "zhōu",
      "english": "week, weekly, variant of 周[zhou1]"
    },
    {
      "character": "裝",
      "zhuyin": "ㄓㄨㄤ",
      "pinyin": "zhuāng",
      "english": "adornment, to adorn, dress, clothing, costume (of an actor in a play), to play a role, to pretend, t"
    },
    {
      "character": "辦",
      "zhuyin": "ㄅㄢˋ",
      "pinyin": "bàn",
      "english": "to do, to manage, to handle, to go about, to run, to set up, to deal with"
    },
    {
      "character": "倍",
      "zhuyin": "ㄅㄟˋ",
      "pinyin": "bèi",
      "english": "(two, three etc) -fold, times (multiplier), double, to increase or multiply"
    },
    {
      "character": "步",
      "zhuyin": "ㄅㄨˋ",
      "pinyin": "bù",
      "english": "a step, a pace, walk, march, stages in a process, situation"
    },
    {
      "character": "層",
      "zhuyin": "ㄘㄥˊ",
      "pinyin": "céng",
      "english": "to pile on top of one another, layer, stratum, floor (of a building), story, (math.) sheaf, classifi"
    },
    {
      "character": "吵",
      "zhuyin": "ㄔㄠˇ",
      "pinyin": "chǎo",
      "english": "to quarrel, to make a noise, noisy, to disturb by making a noise"
    },
    {
      "character": "乘",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéng",
      "english": "to ride, to mount, to make use of, to avail oneself of, to take advantage of, to multiply (math.), B"
    },
    {
      "character": "除",
      "zhuyin": "ㄔㄨˊ",
      "pinyin": "chú",
      "english": "to get rid of, to remove, to exclude, to eliminate, to wipe out, to divide, except, not including"
    },
    {
      "character": "傳",
      "zhuyin": "ㄔㄨㄢˊ",
      "pinyin": "chuán",
      "english": "to pass on, to spread, to transmit, to infect, to transfer, to circulate, to conduct (electricity)"
    },
    {
      "character": "存",
      "zhuyin": "ㄘㄨㄣˊ",
      "pinyin": "cún",
      "english": "to exist, to deposit, to store, to keep, to survive"
    },
    {
      "character": "底",
      "zhuyin": "ㄉㄧˇ",
      "pinyin": "dǐ",
      "english": "background, bottom, base, end (of the month, year etc), remnants, (math.) radix, base"
    },
    {
      "character": "動",
      "zhuyin": "ㄉㄨㄥˋ",
      "pinyin": "dòng",
      "english": "(of sth) to move, to set in movement, to displace, to touch, to make use of, to stir (emotions), to "
    },
    {
      "character": "豆",
      "zhuyin": "ㄉㄡˋ",
      "pinyin": "dòu",
      "english": "legume, pulse, bean, pea (CL:棵[ke1], 粒[li4]), stemmed sacrificial vessel"
    },
    {
      "character": "朵",
      "zhuyin": "ㄉㄨㄛˇ",
      "pinyin": "duǒ",
      "english": "flower, earlobe, fig. item on both sides, classifier for flowers, clouds etc"
    },
    {
      "character": "煩",
      "zhuyin": "ㄈㄢˊ",
      "pinyin": "fán",
      "english": "to feel vexed, to bother, to trouble, superfluous and confusing, edgy"
    },
    {
      "character": "方",
      "zhuyin": "ㄈㄤ",
      "pinyin": "fāng",
      "english": "square, power or involution (math.), upright, honest, fair and square, direction, side, party (to a "
    },
    {
      "character": "房",
      "zhuyin": "ㄈㄤˊ",
      "pinyin": "fáng",
      "english": "house, room, CL:間|间[jian1], branch of an extended family, classifier for family members (or concubin"
    },
    {
      "character": "改",
      "zhuyin": "ㄍㄞˇ",
      "pinyin": "gǎi",
      "english": "to change, to alter, to transform, to correct"
    },
    {
      "character": "光",
      "zhuyin": "ㄍㄨㄤ",
      "pinyin": "guāng",
      "english": "light, ray (CL:道[dao4]), bright, shiny, only, merely, used up, finished, to leave (a part of the bod"
    },
    {
      "character": "汗",
      "zhuyin": "ㄏㄢˋ",
      "pinyin": "hàn",
      "english": "perspiration, sweat, CL:滴[di1], 頭|头[tou2], 身[shen1], to be speechless (out of helplessness, embarras"
    },
    {
      "character": "極",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jí",
      "english": "extremely, pole (geography, physics), utmost, top"
    },
    {
      "character": "減",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "jiǎn",
      "english": "to lower, to decrease, to reduce, to subtract, to diminish"
    },
    {
      "character": "咳",
      "zhuyin": "ㄎㄜˊ",
      "pinyin": "ké",
      "english": "cough"
    },
    {
      "character": "類",
      "zhuyin": "ㄌㄟˋ",
      "pinyin": "lèi",
      "english": "kind, type, class, category, similar, like, to resemble"
    },
    {
      "character": "連",
      "zhuyin": "ㄌㄧㄢˊ",
      "pinyin": "lián",
      "english": "to link, to join, to connect, continuously, in succession, including, (used with 也[ye3], 都[dou1] etc"
    },
    {
      "character": "涼",
      "zhuyin": "ㄌㄧㄤˊ",
      "pinyin": "liáng",
      "english": "cool, cold"
    },
    {
      "character": "流",
      "zhuyin": "ㄌㄧㄡˊ",
      "pinyin": "liú",
      "english": "to flow, to disseminate, to circulate or spread, to move or drift, to degenerate, to banish or send "
    },
    {
      "character": "毛",
      "zhuyin": "ㄇㄠˊ",
      "pinyin": "máo",
      "english": "hair, feather, down, wool, mildew, mold, coarse or semifinished, young, raw, careless, unthinking, n"
    },
    {
      "character": "米",
      "zhuyin": "ㄇㄧˇ",
      "pinyin": "mǐ",
      "english": "rice, CL:粒[li4], meter (classifier)"
    },
    {
      "character": "爬",
      "zhuyin": "ㄆㄚˊ",
      "pinyin": "pá",
      "english": "to crawl, to climb, to get up or sit up"
    },
    {
      "character": "起",
      "zhuyin": "ㄑㄧˇ",
      "pinyin": "qǐ",
      "english": "to rise, to raise, to get up, to set out, to start, to appear, to launch, to initiate (action), to d"
    },
    {
      "character": "淺",
      "zhuyin": "ㄑㄧㄢˇ",
      "pinyin": "qiǎn",
      "english": "shallow, light (color)"
    },
    {
      "character": "深",
      "zhuyin": "ㄕㄣ",
      "pinyin": "shēn",
      "english": "deep (lit. and fig.)"
    },
    {
      "character": "時",
      "zhuyin": "ㄕˊ",
      "pinyin": "shí",
      "english": "o'clock, time, when, hour, season, period"
    },
    {
      "character": "熟",
      "zhuyin": "ㄕㄡˊ",
      "pinyin": "shóu",
      "english": "ripe, mature, thoroughly cooked, done, familiar, acquainted, experienced, skilled, (of sleep etc) de"
    },
    {
      "character": "數",
      "zhuyin": "ㄕㄨˇ",
      "pinyin": "shǔ",
      "english": "to count, to count as, to regard as, to enumerate, to list"
    },
    {
      "character": "刷",
      "zhuyin": "ㄕㄨㄚ",
      "pinyin": "shuā",
      "english": "to brush, to paint, to daub, to paste up, to skip class (of students), to fire from a job"
    },
    {
      "character": "鎖",
      "zhuyin": "ㄙㄨㄛˇ",
      "pinyin": "suǒ",
      "english": "to lock, to lock up, a lock (CL:把[ba3])"
    },
    {
      "character": "談",
      "zhuyin": "ㄊㄢˊ",
      "pinyin": "tán",
      "english": "to speak, to talk, to converse, to chat, to discuss"
    },
    {
      "character": "題",
      "zhuyin": "ㄊㄧˊ",
      "pinyin": "tí",
      "english": "topic, problem for discussion, exam question, subject, to inscribe, to mention, CL:個|个[ge4], 道[dao4]"
    },
    {
      "character": "廳",
      "zhuyin": "ㄊㄧㄥ",
      "pinyin": "tīng",
      "english": "(reception) hall, living room, office, provincial government department"
    },
    {
      "character": "偷",
      "zhuyin": "ㄊㄡ",
      "pinyin": "tōu",
      "english": "to steal, to pilfer, to snatch, thief, stealthily"
    },
    {
      "character": "完",
      "zhuyin": "ㄨㄢˊ",
      "pinyin": "wán",
      "english": "to finish, to be over, whole, complete, entire"
    },
    {
      "character": "眼",
      "zhuyin": "ㄧㄢˇ",
      "pinyin": "yǎn",
      "english": "eye, small hole, crux (of a matter), CL:隻|只[zhi1], 雙|双[shuang1], classifier for big hollow things (w"
    },
    {
      "character": "夜",
      "zhuyin": "ㄧㄝˋ",
      "pinyin": "yè",
      "english": "night"
    },
    {
      "character": "圓",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "yuán",
      "english": "circle, round, circular, spherical, (of the moon) full, unit of Chinese currency (yuan), tactful, to"
    },
    {
      "character": "約",
      "zhuyin": "ㄩㄝ",
      "pinyin": "yuē",
      "english": "to make an appointment, to invite, approximately, pact, treaty, to economize, to restrict, to reduce"
    },
    {
      "character": "整",
      "zhuyin": "ㄓㄥˇ",
      "pinyin": "zhěng",
      "english": "exactly, in good order, whole, complete, entire, in order, orderly, to repair, to mend, to renovate,"
    },
    {
      "character": "正",
      "zhuyin": "ㄓㄥˋ",
      "pinyin": "zhèng",
      "english": "straight, upright, proper, main, principal, to correct, to rectify, exactly, just (at that time), ri"
    },
    {
      "character": "汁",
      "zhuyin": "ㄓ",
      "pinyin": "zhī",
      "english": "juice"
    },
    {
      "character": "鐘",
      "zhuyin": "ㄓㄨㄥ",
      "pinyin": "zhōng",
      "english": "clock, o'clock, time as measured in hours and minutes, bell, CL:架[jia4], 座[zuo4]"
    },
    {
      "character": "抓",
      "zhuyin": "ㄓㄨㄚ",
      "pinyin": "zhuā",
      "english": "to grab, to catch, to arrest, to snatch, to scratch"
    },
    {
      "character": "子",
      "zhuyin": "ㄗˇ",
      "pinyin": "zǐ",
      "english": "son, child, seed, egg, small thing, 1st earthly branch: 11 p.m.-1 a.m., midnight, 11th solar month ("
    },
    {
      "character": "座",
      "zhuyin": "ㄗㄨㄛˋ",
      "pinyin": "zuò",
      "english": "seat, base, stand, (archaic) suffix used in a respectful form of address, e.g. 师座|师座[shi1 zuo4], CL:"
    },
    {
      "character": "餅",
      "zhuyin": "ㄅㄧㄥˇ",
      "pinyin": "bǐnggān",
      "english": "biscuit, cracker, cookie, CL:片[pian4], 塊|块[kuai4]"
    },
    {
      "character": "必",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bìxū",
      "english": "to have to, must, compulsory, necessarily"
    },
    {
      "character": "須",
      "zhuyin": "ㄒㄩ",
      "pinyin": "bìxū",
      "english": "to have to, must, compulsory, necessarily"
    },
    {
      "character": "畢",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bìyè",
      "english": "graduation, to graduate, to finish school"
    },
    {
      "character": "莓",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "cǎoméi",
      "english": "strawberry, CL:顆|颗[ke1], (Tw) hickey, love bite"
    },
    {
      "character": "廁",
      "zhuyin": "ㄘㄜˋ",
      "pinyin": "cèsuǒ",
      "english": "toilet, lavatory, CL:間|间[jian1], 處|处[chu4]"
    },
    {
      "character": "城",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéngshì",
      "english": "city, town, CL:座[zuo4]"
    },
    {
      "character": "統",
      "zhuyin": "ㄊㄨㄥˇ",
      "pinyin": "chuántǒng",
      "english": "tradition, traditional, convention, conventional, CL:個|个[ge4]"
    },
    {
      "character": "廚",
      "zhuyin": "ㄔㄨˊ",
      "pinyin": "chúfáng",
      "english": "kitchen, CL:間|间[jian1]"
    },
    {
      "character": "概",
      "zhuyin": "ㄍㄞˋ",
      "pinyin": "dàgài",
      "english": "roughly, probably, rough, approximate, about, general idea"
    },
    {
      "character": "腐",
      "zhuyin": "ㄈㄨˇ",
      "pinyin": "dòufǔ",
      "english": "tofu, bean curd"
    },
    {
      "character": "漿",
      "zhuyin": "ㄐㄧㄤ",
      "pinyin": "dòujiāng",
      "english": "soy milk"
    },
    {
      "character": "且",
      "zhuyin": "ㄑㄧㄝˇ",
      "pinyin": "érqiě",
      "english": "(not only ...) but also, moreover, in addition, furthermore"
    },
    {
      "character": "茄",
      "zhuyin": "ㄑㄧㄝˊ",
      "pinyin": "fānqié",
      "english": "tomato"
    },
    {
      "character": "皂",
      "zhuyin": "ㄗㄠˋ",
      "pinyin": "féizào",
      "english": "soap, CL:塊|块[kuai4], 條|条[tiao2]"
    },
    {
      "character": "務",
      "zhuyin": "ㄨˋ",
      "pinyin": "fúwù",
      "english": "to serve, service, CL:項|项[xiang4]"
    },
    {
      "character": "父",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fùmǔ",
      "english": "father and mother, parents"
    },
    {
      "character": "母",
      "zhuyin": "ㄇㄨˇ",
      "pinyin": "fùmǔ",
      "english": "father and mother, parents"
    },
    {
      "character": "寒",
      "zhuyin": "ㄏㄢˊ",
      "pinyin": "hánjià",
      "english": "winter vacation"
    },
    {
      "character": "境",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "huánjìng",
      "english": "environment, circumstances, surroundings, CL:個|个[ge4], ambient"
    },
    {
      "character": "華",
      "zhuyin": "ㄏㄨㄚˊ",
      "pinyin": "huáyǔ",
      "english": "Chinese language"
    },
    {
      "character": "答",
      "zhuyin": "ㄉㄚˊ",
      "pinyin": "huídá",
      "english": "to reply, to answer, reply, answer"
    },
    {
      "character": "者",
      "zhuyin": "ㄓㄜˇ",
      "pinyin": "huòzhě",
      "english": "or, possibly, maybe, perhaps"
    },
    {
      "character": "訊",
      "zhuyin": "ㄒㄩㄣˋ",
      "pinyin": "jiǎnxùn",
      "english": "newsletter, the news in brief, (Tw) SMS message"
    },
    {
      "character": "育",
      "zhuyin": "ㄩˋ",
      "pinyin": "jiàoyù",
      "english": "to educate, to teach, education"
    },
    {
      "character": "季",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jìjié",
      "english": "time, season, period, CL:個|个[ge4]"
    },
    {
      "character": "婚",
      "zhuyin": "ㄏㄨㄣ",
      "pinyin": "jiéhūn",
      "english": "to marry, to get married, CL:次[ci4]"
    },
    {
      "character": "捷",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jiéyùn",
      "english": "(Tw) mass rapid transit (MRT), subway"
    },
    {
      "character": "橘",
      "zhuyin": "ㄐㄩˊ",
      "pinyin": "jú",
      "english": "tangerine, CL:個|个[ge4], 瓣[ban4]"
    },
    {
      "character": "垃",
      "zhuyin": "ㄌㄜˋ",
      "pinyin": "lèsè",
      "english": "trash, refuse, garbage, (coll.) of poor quality, Taiwan pr. [le4 se4]"
    },
    {
      "character": "圾",
      "zhuyin": "ㄙㄜˋ",
      "pinyin": "lèsè",
      "english": "trash, refuse, garbage, (coll.) of poor quality, Taiwan pr. [le4 se4]"
    },
    {
      "character": "立",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lìkè",
      "english": "forthwith, immediate, prompt, promptly, straightway, thereupon, at once"
    },
    {
      "character": "另",
      "zhuyin": "ㄌㄧㄥˋ",
      "pinyin": "lìngwài",
      "english": "additional, in addition, besides, separate, other, moreover, furthermore"
    },
    {
      "character": "居",
      "zhuyin": "ㄐㄩ",
      "pinyin": "línjū",
      "english": "neighbor, next door, CL:個|个[ge4]"
    },
    {
      "character": "歷",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lìshǐ",
      "english": "history, CL:門|门[men2], 段[duan4]"
    },
    {
      "character": "史",
      "zhuyin": "ㄕˇ",
      "pinyin": "lìshǐ",
      "english": "history, CL:門|门[men2], 段[duan4]"
    },
    {
      "character": "物",
      "zhuyin": "ㄨˋ",
      "pinyin": "lǐwù",
      "english": "gift, present, CL:件[jian4], 個|个[ge4], 份[fen4]"
    },
    {
      "character": "例",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lìzi",
      "english": "case, (for) instance, example, CL:個|个[ge4]"
    },
    {
      "character": "芒",
      "zhuyin": "ㄇㄤˊ",
      "pinyin": "mángguǒ",
      "english": "mango (loanword)"
    },
    {
      "character": "巾",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "máojīn",
      "english": "towel, CL:條|条[tiao2]"
    },
    {
      "character": "摩",
      "zhuyin": "ㄇㄛˊ",
      "pinyin": "mótuōchē",
      "english": "(loanword) motorbike, motorcycle, CL:輛|辆[liang4], 部[bu4]"
    },
    {
      "character": "沐",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "mùyùrǔ",
      "english": "body wash (liquid soap), shower gel"
    },
    {
      "character": "浴",
      "zhuyin": "ㄩˋ",
      "pinyin": "mùyùrǔ",
      "english": "body wash (liquid soap), shower gel"
    },
    {
      "character": "乳",
      "zhuyin": "ㄖㄨˇ",
      "pinyin": "mùyùrǔ",
      "english": "body wash (liquid soap), shower gel"
    },
    {
      "character": "紀",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "niánjì",
      "english": "age, CL:把[ba3], 個|个[ge4]"
    },
    {
      "character": "葡",
      "zhuyin": "ㄆㄨˊ",
      "pinyin": "pútáo",
      "english": "grape"
    },
    {
      "character": "萄",
      "zhuyin": "ㄊㄠˊ",
      "pinyin": "pútáo",
      "english": "grape"
    },
    {
      "character": "簽",
      "zhuyin": "ㄑㄧㄢ",
      "pinyin": "qiānzhèng",
      "english": "visa, to issue a visa"
    },
    {
      "character": "證",
      "zhuyin": "ㄓㄥˋ",
      "pinyin": "qiānzhèng",
      "english": "visa, to issue a visa"
    },
    {
      "character": "克",
      "zhuyin": "ㄎㄜˋ",
      "pinyin": "qiǎokèlì",
      "english": "chocolate (loanword), CL:塊|块[kuai4]"
    },
    {
      "character": "食",
      "zhuyin": "ㄕˊ",
      "pinyin": "shíwù",
      "english": "food, CL:種|种[zhong3]"
    },
    {
      "character": "適",
      "zhuyin": "ㄕˋ",
      "pinyin": "shìhé",
      "english": "to fit, to suit"
    },
    {
      "character": "暑",
      "zhuyin": "ㄕㄨˇ",
      "pinyin": "shǔjià",
      "english": "summer vacation, CL:個|个[ge4]"
    },
    {
      "character": "速",
      "zhuyin": "ㄙㄨˋ",
      "pinyin": "sùshí",
      "english": "fast food (Tw)"
    },
    {
      "character": "颱",
      "zhuyin": "ㄊㄞˊ",
      "pinyin": "táifēng",
      "english": "typhoon"
    },
    {
      "character": "陽",
      "zhuyin": "ㄧㄤˊ",
      "pinyin": "tàiyáng",
      "english": "sun, CL:個|个[ge4], abbr. for 太陽穴|太阳穴[tai4 yang2 xue2]"
    },
    {
      "character": "襪",
      "zhuyin": "ㄨㄚˋ",
      "pinyin": "wàzi",
      "english": "socks, stockings, CL:隻|只[zhi1], 對|对[dui4], 雙|双[shuang1]"
    },
    {
      "character": "危",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéixiǎn",
      "english": "danger, dangerous"
    },
    {
      "character": "衛",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "wèishēngzhǐ",
      "english": "toilet paper, bathroom tissue"
    },
    {
      "character": "泉",
      "zhuyin": "ㄑㄩㄢˊ",
      "pinyin": "wēnquán",
      "english": "hot spring, spa, onsen"
    },
    {
      "character": "烏",
      "zhuyin": "ㄨ",
      "pinyin": "wūlóngchá",
      "english": "oolong tea"
    },
    {
      "character": "消",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "xiāoxí",
      "english": "news, information, CL:條|条[tiao2]"
    },
    {
      "character": "李",
      "zhuyin": "ㄌㄧˇ",
      "pinyin": "xínglǐ",
      "english": "luggage, CL:件[jian4]"
    },
    {
      "character": "趣",
      "zhuyin": "ㄑㄩˋ",
      "pinyin": "xìngqù",
      "english": "interest (desire to know about sth), interest (thing in which one is interested), hobby, CL:個|个[ge4]"
    },
    {
      "character": "牙",
      "zhuyin": "ㄧㄚˊ",
      "pinyin": "yágāo",
      "english": "toothpaste, CL:管[guan3]"
    },
    {
      "character": "膏",
      "zhuyin": "ㄍㄠ",
      "pinyin": "yágāo",
      "english": "toothpaste, CL:管[guan3]"
    },
    {
      "character": "洋",
      "zhuyin": "ㄧㄤˊ",
      "pinyin": "yángcōng",
      "english": "onion (Allium cepa), bulb onion"
    },
    {
      "character": "蔥",
      "zhuyin": "ㄘㄨㄥ",
      "pinyin": "yángcōng",
      "english": "onion (Allium cepa), bulb onion"
    },
    {
      "character": "研",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "yánjiù",
      "english": "research, a study, CL:項|项[xiang4], to research, to look into"
    },
    {
      "character": "究",
      "zhuyin": "ㄐㄧㄡˋ",
      "pinyin": "yánjiù",
      "english": "research, a study, CL:項|项[xiang4], to research, to look into"
    },
    {
      "character": "鑰",
      "zhuyin": "ㄧㄠˋ",
      "pinyin": "yàoshi",
      "english": "key, CL:把[ba3]"
    },
    {
      "character": "飲",
      "zhuyin": "ㄧㄣˇ",
      "pinyin": "yǐnliào",
      "english": "drink, beverage"
    },
    {
      "character": "料",
      "zhuyin": "ㄌㄧㄠˋ",
      "pinyin": "yǐnliào",
      "english": "drink, beverage"
    },
    {
      "character": "遊",
      "zhuyin": "ㄧㄡˊ",
      "pinyin": "yóuxì",
      "english": "game, CL:場|场[chang3], to play"
    },
    {
      "character": "戲",
      "zhuyin": "ㄒㄧˋ",
      "pinyin": "yóuxì",
      "english": "game, CL:場|场[chang3], to play"
    },
    {
      "character": "顧",
      "zhuyin": "ㄍㄨˋ",
      "pinyin": "zhàogù",
      "english": "to take care of, to show consideration, to attend to, to look after"
    },
    {
      "character": "資",
      "zhuyin": "ㄗ",
      "pinyin": "zīliào",
      "english": "material, resources, data, information, profile (Internet), CL:份[fen4], 個|个[ge4]"
    },
    {
      "character": "括",
      "zhuyin": "ㄎㄨㄛˋ",
      "pinyin": "bāokuò",
      "english": "to comprise, to include, to involve, to incorporate, to consist of"
    },
    {
      "character": "保",
      "zhuyin": "ㄅㄠˇ",
      "pinyin": "bǎohù",
      "english": "to protect, to defend, to safeguard, protection, CL:種|种[zhong3]"
    },
    {
      "character": "標",
      "zhuyin": "ㄅㄧㄠ",
      "pinyin": "biāozhǔn",
      "english": "standard, norm, criterion, (adjective) standard, good, correct, conforming to a standard"
    },
    {
      "character": "案",
      "zhuyin": "ㄢˋ",
      "pinyin": "dáàn",
      "english": "answer, solution, CL:個|个[ge4]"
    },
    {
      "character": "律",
      "zhuyin": "ㄌㄩˋ",
      "pinyin": "fǎlǜ",
      "english": "law, CL:條|条[tiao2], 套[tao4], 個|个[ge4]"
    },
    {
      "character": "姑",
      "zhuyin": "ㄍㄨ",
      "pinyin": "gūgu",
      "english": "paternal aunt, CL:個|个[ge4]"
    },
    {
      "character": "櫃",
      "zhuyin": "ㄍㄨㄟˋ",
      "pinyin": "guìzi",
      "english": "cupboard, cabinet"
    },
    {
      "character": "建",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiànyì",
      "english": "to propose, to suggest, to recommend, proposal, suggestion, recommendation, CL:個|个[ge4], 點|点[dian3]"
    },
    {
      "character": "議",
      "zhuyin": "ㄧˋ",
      "pinyin": "jiànyì",
      "english": "to propose, to suggest, to recommend, proposal, suggestion, recommendation, CL:個|个[ge4], 點|点[dian3]"
    },
    {
      "character": "授",
      "zhuyin": "ㄕㄡˋ",
      "pinyin": "jiàoshòu",
      "english": "professor, to instruct, to lecture on, CL:個|个[ge4], 位[wei4]"
    },
    {
      "character": "金",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "jīnsè",
      "english": "golden, gold (color)"
    },
    {
      "character": "嗽",
      "zhuyin": "ㄙㄡˋ",
      "pinyin": "késòu",
      "english": "to cough, CL:陣|阵[zhen4]"
    },
    {
      "character": "惜",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "kěxí",
      "english": "it is a pity, what a pity, unfortunately"
    },
    {
      "character": "解",
      "zhuyin": "ㄐㄧㄝˇ",
      "pinyin": "liǎojiě",
      "english": "to understand, to realize, to find out"
    },
    {
      "character": "貌",
      "zhuyin": "ㄇㄠˋ",
      "pinyin": "lǐmào",
      "english": "courtesy, politeness, manners, courteous, polite"
    },
    {
      "character": "麗",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "měilì",
      "english": "beautiful"
    },
    {
      "character": "目",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "mùdì",
      "english": "purpose, aim, goal, target, objective, CL:個|个[ge4]"
    },
    {
      "character": "實",
      "zhuyin": "ㄕˊ",
      "pinyin": "qíshí",
      "english": "actually, in fact, really"
    },
    {
      "character": "晴",
      "zhuyin": "ㄑㄧㄥˊ",
      "pinyin": "qíngtiān",
      "english": "clear sky, sunny day"
    },
    {
      "character": "形",
      "zhuyin": "ㄒㄧㄥˊ",
      "pinyin": "qíngxíng",
      "english": "circumstances, situation, CL:個|个[ge4]"
    },
    {
      "character": "社",
      "zhuyin": "ㄕㄜˋ",
      "pinyin": "shèhuì",
      "english": "society, CL:個|个[ge4]"
    },
    {
      "character": "聖",
      "zhuyin": "ㄕㄥˋ",
      "pinyin": "shèngdànlǎorén",
      "english": "Father Christmas, Santa Claus"
    },
    {
      "character": "誕",
      "zhuyin": "ㄉㄢˋ",
      "pinyin": "shèngdànlǎorén",
      "english": "Father Christmas, Santa Claus"
    },
    {
      "character": "孫",
      "zhuyin": "ㄙㄨㄣ",
      "pinyin": "sūnnǚ",
      "english": "son's daughter, granddaughter"
    },
    {
      "character": "論",
      "zhuyin": "ㄌㄨㄣˋ",
      "pinyin": "tǎolùn",
      "english": "to discuss, to talk over"
    },
    {
      "character": "婆",
      "zhuyin": "ㄆㄛˊ",
      "pinyin": "wàipó",
      "english": "(coll.) mother's mother, maternal grandmother"
    },
    {
      "character": "蚊",
      "zhuyin": "ㄨㄣˊ",
      "pinyin": "wénzi",
      "english": "mosquito"
    },
    {
      "character": "污",
      "zhuyin": "ㄨ",
      "pinyin": "wūrǎn",
      "english": "to pollute, to contaminate (lit. and fig.)"
    },
    {
      "character": "擇",
      "zhuyin": "ㄗㄜˊ",
      "pinyin": "xuǎnzé",
      "english": "to select, to pick, choice, option, alternative"
    },
    {
      "character": "嚴",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "yánzhòng",
      "english": "grave, serious, severe, critical"
    },
    {
      "character": "尤",
      "zhuyin": "ㄧㄡˊ",
      "pinyin": "yóuqí",
      "english": "especially, particularly"
    },
    {
      "character": "原",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "yuánlái",
      "english": "original, former, originally, formerly, at first, so, actually, as it turns out"
    },
    {
      "character": "誌",
      "zhuyin": "ㄓˋ",
      "pinyin": "zázhì",
      "english": "magazine, CL:本[ben3], 份[fen4], 期[qi1]"
    },
    {
      "character": "式",
      "zhuyin": "ㄕˋ",
      "pinyin": "zhèngshì",
      "english": "formal, official"
    },
    {
      "character": "主",
      "zhuyin": "ㄓㄨˇ",
      "pinyin": "zhǔrén",
      "english": "master, host, owner, CL:個|个[ge4]"
    }
  ],
  "B2": [
    {
      "character": "好",
      "zhuyin": "ㄏㄠˋ",
      "pinyin": "hào",
      "english": "to be fond of, to have a tendency to, to be prone to"
    },
    {
      "character": "中",
      "zhuyin": "ㄓㄨㄥˋ",
      "pinyin": "zhòng",
      "english": "to hit (the mark), to be hit by, to suffer, to win (a prize, a lottery)"
    },
    {
      "character": "種",
      "zhuyin": "ㄓㄨㄥˋ",
      "pinyin": "zhòng",
      "english": "to plant, to grow, to cultivate"
    },
    {
      "character": "重",
      "zhuyin": "ㄔㄨㄥˊ",
      "pinyin": "chóng",
      "english": "to repeat, repetition, again, re-, classifier: layer"
    },
    {
      "character": "假",
      "zhuyin": "ㄐㄧㄚˇ",
      "pinyin": "jiǎ",
      "english": "fake, false, artificial, to borrow, if, suppose"
    },
    {
      "character": "按",
      "zhuyin": "ㄢˋ",
      "pinyin": "àn",
      "english": "to press, to push, to leave aside or shelve, to control, to restrain, to keep one's hand on, to chec"
    },
    {
      "character": "擺",
      "zhuyin": "ㄅㄞˇ",
      "pinyin": "bǎi",
      "english": "to arrange, to exhibit, to move to and fro, a pendulum"
    },
    {
      "character": "抱",
      "zhuyin": "ㄅㄠˋ",
      "pinyin": "bào",
      "english": "to hold, to carry (in one's arms), to hug, to embrace, to surround, to cherish, (coll.) (of clothes)"
    },
    {
      "character": "表",
      "zhuyin": "ㄅㄧㄠˇ",
      "pinyin": "biǎo",
      "english": "exterior surface, family relationship via females, to show (one's opinion), a model, a table (listin"
    },
    {
      "character": "擦",
      "zhuyin": "ㄘㄚ",
      "pinyin": "cā",
      "english": "to rub, to scratch, to wipe, to polish, to apply (lipstick, lotion etc), to brush (past), to shred ("
    },
    {
      "character": "猜",
      "zhuyin": "ㄘㄞ",
      "pinyin": "cāi",
      "english": "to guess"
    },
    {
      "character": "趁",
      "zhuyin": "ㄔㄣˋ",
      "pinyin": "chèn",
      "english": "to avail oneself of, to take advantage of"
    },
    {
      "character": "醜",
      "zhuyin": "ㄔㄡˇ",
      "pinyin": "chǒu",
      "english": "shameful, ugly, disgraceful"
    },
    {
      "character": "初",
      "zhuyin": "ㄔㄨ",
      "pinyin": "chū",
      "english": "at first, (at the) beginning, first, junior, basic"
    },
    {
      "character": "吹",
      "zhuyin": "ㄔㄨㄟ",
      "pinyin": "chuī",
      "english": "to blow, to play a wind instrument, to blast, to puff, to boast, to brag, to end in failure, to fall"
    },
    {
      "character": "粗",
      "zhuyin": "ㄘㄨ",
      "pinyin": "cū",
      "english": "coarse, rough, thick (for cylindrical objects), unfinished, vulgar, rude, crude"
    },
    {
      "character": "代",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dài",
      "english": "to substitute, to act on behalf of others, to replace, generation, dynasty, age, period, (historical"
    },
    {
      "character": "淡",
      "zhuyin": "ㄉㄢˋ",
      "pinyin": "dàn",
      "english": "insipid, diluted, weak, mild, light in color, tasteless, indifferent, (variant of 氮[dan4]) nitrogen"
    },
    {
      "character": "倒",
      "zhuyin": "ㄉㄠˇ",
      "pinyin": "dǎo",
      "english": "to fall, to collapse, to lie horizontally, to fail, to go bankrupt, to overthrow, to change (trains "
    },
    {
      "character": "棟",
      "zhuyin": "ㄉㄨㄥˋ",
      "pinyin": "dòng",
      "english": "classifier for houses or buildings, ridgepole (old)"
    },
    {
      "character": "洞",
      "zhuyin": "ㄉㄨㄥˋ",
      "pinyin": "dòng",
      "english": "cave, hole, zero (unambiguous spoken form when spelling out numbers), CL:個|个[ge4]"
    },
    {
      "character": "段",
      "zhuyin": "ㄉㄨㄢˋ",
      "pinyin": "duàn",
      "english": "paragraph, section, segment, stage (of a process), classifier for stories, periods of time, lengths "
    },
    {
      "character": "堆",
      "zhuyin": "ㄉㄨㄟ",
      "pinyin": "duī",
      "english": "to pile up, to heap up, a mass, pile, heap, stack, large amount"
    },
    {
      "character": "頓",
      "zhuyin": "ㄉㄨㄣˋ",
      "pinyin": "dùn",
      "english": "to stop, to pause, to arrange, to lay out, to kowtow, to stamp (one's foot), at once, classifier for"
    },
    {
      "character": "躲",
      "zhuyin": "ㄉㄨㄛˇ",
      "pinyin": "duǒ",
      "english": "to hide, to dodge, to avoid"
    },
    {
      "character": "嗯",
      "zhuyin": "˙ㄣ",
      "pinyin": "en",
      "english": "interjection indicating approval, appreciation or agreement"
    },
    {
      "character": "發",
      "zhuyin": "ㄈㄚ",
      "pinyin": "fā",
      "english": "to send out, to show (one's feeling), to issue, to develop, to make a bundle of money, classifier fo"
    },
    {
      "character": "翻",
      "zhuyin": "ㄈㄢ",
      "pinyin": "fān",
      "english": "to turn over, to flip over, to overturn, to rummage through, to translate, to decode, to double, to "
    },
    {
      "character": "根",
      "zhuyin": "ㄍㄣ",
      "pinyin": "gēn",
      "english": "root, basis, classifier for long slender objects, e.g. cigarettes, guitar strings, CL:條|条[tiao2], ra"
    },
    {
      "character": "乖",
      "zhuyin": "ㄍㄨㄞ",
      "pinyin": "guāi",
      "english": "(of a child) obedient, well-behaved, clever, shrewd, alert, perverse, contrary to reason, irregular,"
    },
    {
      "character": "怪",
      "zhuyin": "ㄍㄨㄞˋ",
      "pinyin": "guài",
      "english": "bewildering, odd, strange, uncanny, devil, monster, to wonder at, to blame, quite, rather"
    },
    {
      "character": "管",
      "zhuyin": "ㄍㄨㄢˇ",
      "pinyin": "guǎn",
      "english": "to take care (of), to control, to manage, to be in charge of, to look after, to run, to care about, "
    },
    {
      "character": "哈",
      "zhuyin": "ㄏㄚ",
      "pinyin": "hā",
      "english": "(interj.) ha!, (onom. for laughter), (slang) to be infatuated with, to adore, abbr. for 哈士奇[ha1 shi4"
    },
    {
      "character": "害",
      "zhuyin": "ㄏㄞˋ",
      "pinyin": "hài",
      "english": "to do harm to, to cause trouble to, harm, evil, calamity"
    },
    {
      "character": "嗨",
      "zhuyin": "ㄏㄞ",
      "pinyin": "hāi",
      "english": "oh alas, hey!, hi! (loanword), a high (natural or drug-induced) (loanword)"
    },
    {
      "character": "喊",
      "zhuyin": "ㄏㄢˇ",
      "pinyin": "hǎn",
      "english": "to yell, to shout, to call out for (a person)"
    },
    {
      "character": "厚",
      "zhuyin": "ㄏㄡˋ",
      "pinyin": "hòu",
      "english": "thick, deep or profound, kind, generous, rich or strong in flavor, to favor, to stress"
    },
    {
      "character": "滑",
      "zhuyin": "ㄏㄨㄚˊ",
      "pinyin": "huá",
      "english": "to slip, to slide, slippery, smooth, sly, slippery, not to be trusted"
    },
    {
      "character": "擠",
      "zhuyin": "ㄐㄧˇ",
      "pinyin": "jǐ",
      "english": "to crowd in, to cram in, to force others aside, to press, to squeeze, to find (time in one's busy sc"
    },
    {
      "character": "記",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "to record, to note, to memorize, to remember, mark, sign, classifier for blows, kicks, shots"
    },
    {
      "character": "架",
      "zhuyin": "ㄐㄧㄚˋ",
      "pinyin": "jià",
      "english": "to support, frame, rack, framework, classifier for planes, large vehicles, radios etc"
    },
    {
      "character": "剪",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "jiǎn",
      "english": "scissors, shears, clippers, CL:把[ba3], to cut with scissors, to trim, to wipe out or exterminate"
    },
    {
      "character": "緊",
      "zhuyin": "ㄐㄧㄣˇ",
      "pinyin": "jǐn",
      "english": "tight, strict, close at hand, near, urgent, tense, hard up, short of money, to tighten"
    },
    {
      "character": "舉",
      "zhuyin": "ㄐㄩˇ",
      "pinyin": "jǔ",
      "english": "to lift, to hold up, to cite, to enumerate, to act, to raise, to choose, to elect, act, move, deed"
    },
    {
      "character": "靠",
      "zhuyin": "ㄎㄠˋ",
      "pinyin": "kào",
      "english": "to lean against or on, to stand by the side of, to come near to, to depend on, to trust, to fuck (vu"
    },
    {
      "character": "棵",
      "zhuyin": "ㄎㄜ",
      "pinyin": "kē",
      "english": "classifier for trees, cabbages, plants etc"
    },
    {
      "character": "寬",
      "zhuyin": "ㄎㄨㄢ",
      "pinyin": "kuān",
      "english": "wide, broad, loose, relaxed, lenient"
    },
    {
      "character": "懶",
      "zhuyin": "ㄌㄢˇ",
      "pinyin": "lǎn",
      "english": "lazy"
    },
    {
      "character": "亮",
      "zhuyin": "ㄌㄧㄤˋ",
      "pinyin": "liàng",
      "english": "bright, clear, resonant, to shine, to show, to reveal"
    },
    {
      "character": "領",
      "zhuyin": "ㄌㄧㄥˇ",
      "pinyin": "lǐng",
      "english": "neck, collar, to lead, to receive, classifier for clothes, mats, screens etc"
    },
    {
      "character": "罵",
      "zhuyin": "ㄇㄚˋ",
      "pinyin": "mà",
      "english": "to scold, to abuse, to curse, CL:通[tong4], 頓|顿[dun4]"
    },
    {
      "character": "秒",
      "zhuyin": "ㄇㄧㄠˇ",
      "pinyin": "miǎo",
      "english": "second (unit of time), arc second (angular measurement unit), (coll.) instantly"
    },
    {
      "character": "摸",
      "zhuyin": "ㄇㄛ",
      "pinyin": "mō",
      "english": "to feel with the hand, to touch, to stroke, to grope, to steal, to abstract"
    },
    {
      "character": "濃",
      "zhuyin": "ㄋㄨㄥˊ",
      "pinyin": "nóng",
      "english": "concentrated, dense, strong (smell etc)"
    },
    {
      "character": "哦",
      "zhuyin": "ㄛˊ",
      "pinyin": "ó",
      "english": "oh (interjection indicating doubt or surprise)"
    },
    {
      "character": "喔",
      "zhuyin": "ㄛ",
      "pinyin": "ō",
      "english": "(interjection) oh, I see (used to indicate realization, understanding)"
    },
    {
      "character": "排",
      "zhuyin": "ㄆㄞˊ",
      "pinyin": "pái",
      "english": "a row, a line, to set in order, to arrange, to line up, to eliminate, to drain, to push open, platoo"
    },
    {
      "character": "碰",
      "zhuyin": "ㄆㄥˋ",
      "pinyin": "pèng",
      "english": "to touch, to meet with, to bump"
    },
    {
      "character": "篇",
      "zhuyin": "ㄆㄧㄢ",
      "pinyin": "piān",
      "english": "sheet, piece of writing, bound set of bamboo slips used for record keeping (old), classifier for wri"
    },
    {
      "character": "窮",
      "zhuyin": "ㄑㄩㄥˊ",
      "pinyin": "qióng",
      "english": "poor, destitute, to use up, to exhaust, thoroughly, extremely, (coll.) persistently and pointlessly"
    },
    {
      "character": "卻",
      "zhuyin": "ㄑㄩㄝˋ",
      "pinyin": "què",
      "english": "but, yet, however, while, to go back, to decline, to retreat, nevertheless, even though"
    },
    {
      "character": "群",
      "zhuyin": "ㄑㄩㄣˊ",
      "pinyin": "qún",
      "english": "group, crowd, flock, herd, pack etc"
    },
    {
      "character": "軟",
      "zhuyin": "ㄖㄨㄢˇ",
      "pinyin": "ruǎn",
      "english": "soft, flexible"
    },
    {
      "character": "燒",
      "zhuyin": "ㄕㄠ",
      "pinyin": "shāo",
      "english": "to burn, to cook, to stew, to bake, to roast, to heat, to boil (tea, water etc), fever, to run a tem"
    },
    {
      "character": "剩",
      "zhuyin": "ㄕㄥˋ",
      "pinyin": "shèng",
      "english": "to remain, to be left, to have as remainder"
    },
    {
      "character": "省",
      "zhuyin": "ㄕㄥˇ",
      "pinyin": "shěng",
      "english": "to save, to economize, to be frugal, to omit, to delete, to leave out, province, provincial capital,"
    },
    {
      "character": "受",
      "zhuyin": "ㄕㄡˋ",
      "pinyin": "shòu",
      "english": "to receive, to accept, to suffer, subjected to, to bear, to stand, pleasant, (passive marker)"
    },
    {
      "character": "鬆",
      "zhuyin": "ㄙㄨㄥ",
      "pinyin": "sōng",
      "english": "loose, to loosen, to relax, floss (dry, fluffy food product made from shredded, seasoned meat or fis"
    },
    {
      "character": "牠",
      "zhuyin": "ㄊㄚ",
      "pinyin": "tā",
      "english": "it (used for animals)"
    },
    {
      "character": "躺",
      "zhuyin": "ㄊㄤˇ",
      "pinyin": "tǎng",
      "english": "to recline, to lie down"
    },
    {
      "character": "填",
      "zhuyin": "ㄊㄧㄢˊ",
      "pinyin": "tián",
      "english": "to fill or stuff, (of a form etc) to fill in"
    },
    {
      "character": "貼",
      "zhuyin": "ㄊㄧㄝ",
      "pinyin": "tiē",
      "english": "to stick, to paste, to post (e.g. on a blog), to keep close to, to fit snugly, to subsidize, allowan"
    },
    {
      "character": "投",
      "zhuyin": "ㄊㄡˊ",
      "pinyin": "tóu",
      "english": "to cast, to send, to throw oneself (into the river etc), to seek refuge, to place oneself into the h"
    },
    {
      "character": "土",
      "zhuyin": "ㄊㄨˇ",
      "pinyin": "tǔ",
      "english": "earth, dust, clay, local, indigenous, crude opium, unsophisticated, one of the eight categories of a"
    },
    {
      "character": "推",
      "zhuyin": "ㄊㄨㄟ",
      "pinyin": "tuī",
      "english": "to push, to cut, to refuse, to reject, to decline, to shirk (responsibility), to put off, to delay, "
    },
    {
      "character": "網",
      "zhuyin": "ㄨㄤˇ",
      "pinyin": "wǎng",
      "english": "net, network"
    },
    {
      "character": "細",
      "zhuyin": "ㄒㄧˋ",
      "pinyin": "xì",
      "english": "thin or slender, finely particulate, thin and soft, fine, delicate, trifling, (of a sound) quiet, fr"
    },
    {
      "character": "嚇",
      "zhuyin": "ㄒㄧㄚˋ",
      "pinyin": "xià",
      "english": "to frighten, to scare"
    },
    {
      "character": "血",
      "zhuyin": "ㄒㄧㄝˇ",
      "pinyin": "xiě",
      "english": "blood, colloquial pr. [xie3], CL:滴[di1], 片[pian4]"
    },
    {
      "character": "咬",
      "zhuyin": "ㄧㄠˇ",
      "pinyin": "yǎo",
      "english": "to bite, to nip"
    },
    {
      "character": "頁",
      "zhuyin": "ㄧㄝˋ",
      "pinyin": "yè",
      "english": "page, leaf"
    },
    {
      "character": "硬",
      "zhuyin": "ㄧㄥˋ",
      "pinyin": "yìng",
      "english": "hard, stiff, solid, (fig.) strong, firm, resolutely, uncompromisingly, laboriously, with great diffi"
    },
    {
      "character": "噢",
      "zhuyin": "ㄩˇ",
      "pinyin": "yǔ",
      "english": "oh, ah (used to indicate realization), also pr. [ou4]"
    },
    {
      "character": "陣",
      "zhuyin": "ㄓㄣˋ",
      "pinyin": "zhèn",
      "english": "disposition of troops, wave, spate, burst, spell, short period of time, classifier for events or sta"
    },
    {
      "character": "直",
      "zhuyin": "ㄓˊ",
      "pinyin": "zhí",
      "english": "straight, to straighten, fair and reasonable, frank, straightforward, (indicates continuing motion o"
    },
    {
      "character": "指",
      "zhuyin": "ㄓˇ",
      "pinyin": "zhǐ",
      "english": "finger, to point at or to, to indicate or refer to, to depend on, to count on, (of hair) to stand on"
    },
    {
      "character": "追",
      "zhuyin": "ㄓㄨㄟ",
      "pinyin": "zhuī",
      "english": "to chase, to pursue, to look into, to investigate, to reminisce, to recall, to court (one's beloved)"
    },
    {
      "character": "龍",
      "zhuyin": "ㄌㄨㄥˊ",
      "pinyin": "lóng",
      "english": "dragon, CL:條|条[tiao2], imperial"
    },
    {
      "character": "生",
      "zhuyin": "ㄕㄥ",
      "pinyin": "shēng",
      "english": "to be born, to give birth, life, to grow, raw, uncooked, student"
    },
    {
      "character": "羊",
      "zhuyin": "ㄧㄤˊ",
      "pinyin": "yáng",
      "english": "sheep, goat, CL:頭|头[tou2], 隻|只[zhi1]"
    },
    {
      "character": "區",
      "zhuyin": "ㄑㄩ",
      "pinyin": "qū",
      "english": "area, region, district, small, distinguish, CL:個|个[ge4]"
    },
    {
      "character": "掃",
      "zhuyin": "ㄙㄠˇ",
      "pinyin": "sǎo",
      "english": "to sweep"
    },
    {
      "character": "巷",
      "zhuyin": "ㄒㄧㄤˋ",
      "pinyin": "xiàng",
      "english": "lane, alley"
    },
    {
      "character": "醒",
      "zhuyin": "ㄒㄧㄥˇ",
      "pinyin": "xǐng",
      "english": "to wake up, to be awake, to become aware, to sober up, to come to"
    },
    {
      "character": "派",
      "zhuyin": "ㄆㄞˋ",
      "pinyin": "pài",
      "english": "clique, school, group, faction, to dispatch, to send, to assign, to appoint, pi (Greek letter Ππ), t"
    },
    {
      "character": "賺",
      "zhuyin": "ㄓㄨㄢˋ",
      "pinyin": "zhuàn",
      "english": "to earn, to make a profit"
    },
    {
      "character": "隊",
      "zhuyin": "ㄉㄨㄟˋ",
      "pinyin": "duì",
      "english": "squadron, team, group, CL:個|个[ge4]"
    },
    {
      "character": "獎",
      "zhuyin": "ㄐㄧㄤˇ",
      "pinyin": "jiǎng",
      "english": "prize, award, encouragement, CL:個|个[ge4]"
    },
    {
      "character": "輸",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shū",
      "english": "to lose, to be beaten, (bound form) to transport, (literary) to donate, to contribute, (coll.) to en"
    },
    {
      "character": "養",
      "zhuyin": "ㄧㄤˇ",
      "pinyin": "yǎng",
      "english": "to raise (animals), to bring up (children), to keep (pets), to support, to give birth"
    },
    {
      "character": "贏",
      "zhuyin": "ㄧㄥˊ",
      "pinyin": "yíng",
      "english": "to beat, to win, to profit"
    },
    {
      "character": "島",
      "zhuyin": "ㄉㄠˇ",
      "pinyin": "dǎo",
      "english": "island, CL:個|个[ge4], 座[zuo4]"
    },
    {
      "character": "橋",
      "zhuyin": "ㄑㄧㄠˊ",
      "pinyin": "qiáo",
      "english": "bridge, CL:座[zuo4]"
    },
    {
      "character": "趟",
      "zhuyin": "ㄊㄤˋ",
      "pinyin": "tàng",
      "english": "classifier for times, round trips or rows, a time, a trip"
    },
    {
      "character": "線",
      "zhuyin": "ㄒㄧㄢˋ",
      "pinyin": "xiàn",
      "english": "thread, string, wire, line, CL:條|条[tiao2], 股[gu3], 根[gen1], (after a number) tier (unofficial rankin"
    },
    {
      "character": "耳",
      "zhuyin": "ㄦˇ",
      "pinyin": "ěr",
      "english": "ear, handle (archaeology), and that is all (Classical Chinese)"
    },
    {
      "character": "活",
      "zhuyin": "ㄏㄨㄛˊ",
      "pinyin": "huó",
      "english": "to live, alive, living, work, workmanship"
    },
    {
      "character": "救",
      "zhuyin": "ㄐㄧㄡˋ",
      "pinyin": "jiù",
      "english": "to save, to assist, to rescue"
    },
    {
      "character": "傷",
      "zhuyin": "ㄕㄤ",
      "pinyin": "shāng",
      "english": "to injure, injury, wound"
    },
    {
      "character": "醉",
      "zhuyin": "ㄗㄨㄟˋ",
      "pinyin": "zuì",
      "english": "intoxicated"
    },
    {
      "character": "級",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jí",
      "english": "level, grade, rank, step (of stairs), CL:個|个[ge4], classifier: step, level"
    },
    {
      "character": "節",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jié",
      "english": "joint, node, (bound form) section, segment, solar term (one of the 24 divisions of the year in the t"
    },
    {
      "character": "練",
      "zhuyin": "ㄌㄧㄢˋ",
      "pinyin": "liàn",
      "english": "to practice, to train, to drill, to perfect (one's skill), exercise, (literary) white silk, to boil "
    },
    {
      "character": "系",
      "zhuyin": "ㄒㄧˋ",
      "pinyin": "xì",
      "english": "system, department, faculty"
    },
    {
      "character": "修",
      "zhuyin": "ㄒㄧㄡ",
      "pinyin": "xiū",
      "english": "to decorate, to embellish, to repair, to build, to write, to cultivate, to study, to take (a class)"
    },
    {
      "character": "醋",
      "zhuyin": "ㄘㄨˋ",
      "pinyin": "cù",
      "english": "vinegar, jealousy (in love rivalry)"
    },
    {
      "character": "蓋",
      "zhuyin": "ㄍㄞˋ",
      "pinyin": "gài",
      "english": "lid, top, cover, canopy, to cover, to conceal, to build"
    },
    {
      "character": "皮",
      "zhuyin": "ㄆㄧˊ",
      "pinyin": "pí",
      "english": "leather, skin, fur, CL:張|张[zhang1], pico- (one trillionth), naughty"
    },
    {
      "character": "切",
      "zhuyin": "ㄑㄧㄝ",
      "pinyin": "qiē",
      "english": "to cut, to slice, to carve, (math) tangential"
    },
    {
      "character": "燙",
      "zhuyin": "ㄊㄤˋ",
      "pinyin": "tàng",
      "english": "to scald, to burn (by scalding), to blanch (cooking), to heat (sth) up in hot water, to perm, to iro"
    },
    {
      "character": "煮",
      "zhuyin": "ㄓㄨˇ",
      "pinyin": "zhǔ",
      "english": "to cook, to boil"
    },
    {
      "character": "騙",
      "zhuyin": "ㄆㄧㄢˋ",
      "pinyin": "piàn",
      "english": "to cheat, to swindle, to deceive, to get on (a horse etc) by swinging one leg over"
    },
    {
      "character": "搶",
      "zhuyin": "ㄑㄧㄤˇ",
      "pinyin": "qiǎng",
      "english": "to fight over, to rush, to scramble, to grab, to rob, to snatch"
    },
    {
      "character": "槍",
      "zhuyin": "ㄑㄧㄤ",
      "pinyin": "qiāng",
      "english": "gun, firearm, rifle, spear, thing with shape or function similar to a gun, CL:支[zhi1], 把[ba3], 桿|杆[g"
    },
    {
      "character": "殺",
      "zhuyin": "ㄕㄚ",
      "pinyin": "shā",
      "english": "to kill, to murder, to attack, to weaken or reduce, to smart (dialect), (used after a verb) extremel"
    },
    {
      "character": "雲",
      "zhuyin": "ㄩㄣˊ",
      "pinyin": "yún",
      "english": "cloud, CL:朵[duo3]"
    },
    {
      "character": "神",
      "zhuyin": "ㄕㄣˊ",
      "pinyin": "shén",
      "english": "god, deity, supernatural, magical, mysterious, spirit, mind, energy, lively, expressive, look, expre"
    },
    {
      "character": "唉",
      "zhuyin": "ㄞ",
      "pinyin": "āi",
      "english": "interjection or grunt of agreement or recognition (e.g. yes, it's me!), to sigh"
    },
    {
      "character": "岸",
      "zhuyin": "ㄢˋ",
      "pinyin": "àn",
      "english": "bank, shore, beach, coast, CL:個|个[ge4]"
    },
    {
      "character": "暗",
      "zhuyin": "ㄢˋ",
      "pinyin": "àn",
      "english": "dark, to turn dark, secret, hidden, (literary) confused, ignorant"
    },
    {
      "character": "寶",
      "zhuyin": "ㄅㄠˇ",
      "pinyin": "bǎo",
      "english": "jewel, gem, treasure, precious"
    },
    {
      "character": "編",
      "zhuyin": "ㄅㄧㄢ",
      "pinyin": "biān",
      "english": "to weave, to plait, to organize, to group, to arrange, to edit, to compile, to write, to compose, to"
    },
    {
      "character": "並",
      "zhuyin": "ㄅㄧㄥˋ",
      "pinyin": "bìng",
      "english": "and, furthermore, also, together with, (not) at all, simultaneously, to combine, to join, to merge"
    },
    {
      "character": "布",
      "zhuyin": "ㄅㄨˋ",
      "pinyin": "bù",
      "english": "cloth, to declare, to announce, to spread, to make known"
    },
    {
      "character": "採",
      "zhuyin": "ㄘㄞˇ",
      "pinyin": "cǎi",
      "english": "to pick, to pluck, to collect, to select, to choose, to gather"
    },
    {
      "character": "藏",
      "zhuyin": "ㄘㄤˊ",
      "pinyin": "cáng",
      "english": "to conceal, to hide away, to harbor, to store, to collect"
    },
    {
      "character": "成",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéng",
      "english": "to succeed, to finish, to complete, to accomplish, to become, to turn into, to be all right, OK!, on"
    },
    {
      "character": "尺",
      "zhuyin": "ㄔˇ",
      "pinyin": "chǐ",
      "english": "a Chinese foot, one-third of a meter, a ruler, a tape-measure, one of the three acupoints for measur"
    },
    {
      "character": "毒",
      "zhuyin": "ㄉㄨˊ",
      "pinyin": "dú",
      "english": "poison, to poison, poisonous, malicious, cruel, fierce, narcotics"
    },
    {
      "character": "端",
      "zhuyin": "ㄉㄨㄢ",
      "pinyin": "duān",
      "english": "end, extremity, item, port, to hold sth level with both hands, to carry, regular"
    },
    {
      "character": "犯",
      "zhuyin": "ㄈㄢˋ",
      "pinyin": "fàn",
      "english": "to violate, to offend, to assault, criminal, crime, to make a mistake, recurrence (of mistake or sth"
    },
    {
      "character": "反",
      "zhuyin": "ㄈㄢˇ",
      "pinyin": "fǎn",
      "english": "contrary, in reverse, inside out or upside down, to reverse, to return, to oppose, opposite, against"
    },
    {
      "character": "費",
      "zhuyin": "ㄈㄟˋ",
      "pinyin": "fèi",
      "english": "to cost, to spend, fee, wasteful, expenses"
    },
    {
      "character": "粉",
      "zhuyin": "ㄈㄣˇ",
      "pinyin": "fěn",
      "english": "powder, cosmetic face powder, food prepared from starch, noodles or pasta made from any kind of flou"
    },
    {
      "character": "瘋",
      "zhuyin": "ㄈㄥ",
      "pinyin": "fēng",
      "english": "insane, mad, wild"
    },
    {
      "character": "幅",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "fú",
      "english": "width, roll, classifier for textiles or pictures"
    },
    {
      "character": "該",
      "zhuyin": "ㄍㄞ",
      "pinyin": "gāi",
      "english": "should, ought to, probably, must be, to deserve, to owe, to be sb's turn to do sth, that, the above-"
    },
    {
      "character": "趕",
      "zhuyin": "ㄍㄢˇ",
      "pinyin": "gǎn",
      "english": "to overtake, to catch up with, to hurry, to rush, to try to catch (the bus etc), to drive (cattle et"
    },
    {
      "character": "颳",
      "zhuyin": "ㄍㄨㄚ",
      "pinyin": "guā",
      "english": "to blow (of the wind)"
    },
    {
      "character": "鬼",
      "zhuyin": "ㄍㄨㄟˇ",
      "pinyin": "guǐ",
      "english": "disembodied spirit, ghost, devil, (suffix) person with a certain vice or addiction etc, sly, crafty,"
    },
    {
      "character": "恨",
      "zhuyin": "ㄏㄣˋ",
      "pinyin": "hèn",
      "english": "to hate, to regret"
    },
    {
      "character": "湖",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "hú",
      "english": "lake, CL:個|个[ge4], 片[pian4]"
    },
    {
      "character": "貨",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "huò",
      "english": "goods, money, commodity, CL:個|个[ge4]"
    },
    {
      "character": "嫁",
      "zhuyin": "ㄐㄧㄚˋ",
      "pinyin": "jià",
      "english": "(of a woman) to marry, to marry off a daughter, to shift (blame etc)"
    },
    {
      "character": "煎",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiān",
      "english": "to pan fry, to sauté"
    },
    {
      "character": "尖",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiān",
      "english": "pointed, tapering, sharp, (of a sound) shrill, piercing, (of one's hearing, sight etc) sharp, acute,"
    },
    {
      "character": "江",
      "zhuyin": "ㄐㄧㄤ",
      "pinyin": "jiāng",
      "english": "river, CL:條|条[tiao2], 道[dao4]"
    },
    {
      "character": "斤",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "jīn",
      "english": "catty, (PRC) weight equal to 500 g, (Tw) weight equal to 600 g, (HK, Malaysia, Singapore) slightly o"
    },
    {
      "character": "靜",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "jìng",
      "english": "still, calm, quiet, not moving"
    },
    {
      "character": "聚",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jù",
      "english": "to congregate, to assemble, to mass, to gather together, to amass, to polymerize"
    },
    {
      "character": "砍",
      "zhuyin": "ㄎㄢˇ",
      "pinyin": "kǎn",
      "english": "to chop, to cut down, to throw sth at sb"
    },
    {
      "character": "可",
      "zhuyin": "ㄎㄜˇ",
      "pinyin": "kě",
      "english": "(prefix) can, may, able to, -able, to approve, to permit, to suit, (particle used for emphasis) cert"
    },
    {
      "character": "肯",
      "zhuyin": "ㄎㄣˇ",
      "pinyin": "kěn",
      "english": "to agree, to consent, to be willing to"
    },
    {
      "character": "林",
      "zhuyin": "ㄌㄧㄣˊ",
      "pinyin": "lín",
      "english": "(bound form) woods, forest, (bound form) circle(s) (i.e. specific group of people), (bound form) a c"
    },
    {
      "character": "麥",
      "zhuyin": "ㄇㄞˋ",
      "pinyin": "mài",
      "english": "wheat, barley, oats"
    },
    {
      "character": "面",
      "zhuyin": "ㄇㄧㄢˋ",
      "pinyin": "miàn",
      "english": "face, side, surface, aspect, top, classifier for objects with flat surfaces such as drums, mirrors, "
    },
    {
      "character": "末",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "mò",
      "english": "tip, end, final stage, latter part, inessential detail, powder, dust, opera role of old man"
    },
    {
      "character": "木",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "mù",
      "english": "(bound form) tree, (bound form) wood, unresponsive, numb, wooden"
    },
    {
      "character": "膩",
      "zhuyin": "ㄋㄧˋ",
      "pinyin": "nì",
      "english": "greasy, soft, unctuous, intimate, tired of"
    },
    {
      "character": "平",
      "zhuyin": "ㄆㄧㄥˊ",
      "pinyin": "píng",
      "english": "flat, level, equal, to tie (make the same score), to draw (score), calm, peaceful, abbr. for 平聲|平声[p"
    },
    {
      "character": "敲",
      "zhuyin": "ㄑㄧㄠ",
      "pinyin": "qiāo",
      "english": "to hit, to strike, to tap, to rap, to knock, to rip sb off, to overcharge"
    },
    {
      "character": "清",
      "zhuyin": "ㄑㄧㄥ",
      "pinyin": "qīng",
      "english": "(of water etc) clear, clean, quiet, still, pure, uncorrupted, clear, distinct, to clear, to settle ("
    },
    {
      "character": "求",
      "zhuyin": "ㄑㄧㄡˊ",
      "pinyin": "qiú",
      "english": "to seek, to look for, to request, to demand, to beseech"
    },
    {
      "character": "取",
      "zhuyin": "ㄑㄩˇ",
      "pinyin": "qǔ",
      "english": "to take, to get, to choose, to fetch"
    },
    {
      "character": "勸",
      "zhuyin": "ㄑㄩㄢˋ",
      "pinyin": "quàn",
      "english": "to advise, to urge, to try to persuade, to exhort, to console, to soothe"
    },
    {
      "character": "忍",
      "zhuyin": "ㄖㄣˇ",
      "pinyin": "rěn",
      "english": "to bear, to endure, to tolerate, to restrain oneself"
    },
    {
      "character": "扔",
      "zhuyin": "ㄖㄥ",
      "pinyin": "rēng",
      "english": "to throw, to throw away"
    },
    {
      "character": "入",
      "zhuyin": "ㄖㄨˋ",
      "pinyin": "rù",
      "english": "to enter, to go into, to join, to become a member of, to confirm or agree with, abbr. for 入聲|入声[ru4 "
    },
    {
      "character": "弱",
      "zhuyin": "ㄖㄨㄛˋ",
      "pinyin": "ruò",
      "english": "weak, feeble, young, inferior, not as good as, (following a decimal or fraction) slightly less than"
    },
    {
      "character": "沙",
      "zhuyin": "ㄕㄚ",
      "pinyin": "shā",
      "english": "granule, hoarse, raspy, sand, powder, CL:粒[li4], abbr. for Tsar or Tsarist Russia"
    },
    {
      "character": "身",
      "zhuyin": "ㄕㄣ",
      "pinyin": "shēn",
      "english": "body, life, oneself, personally, one's morality and conduct, the main part of a structure or body, p"
    },
    {
      "character": "伸",
      "zhuyin": "ㄕㄣ",
      "pinyin": "shēn",
      "english": "to stretch, to extend"
    },
    {
      "character": "首",
      "zhuyin": "ㄕㄡˇ",
      "pinyin": "shǒu",
      "english": "head, chief, first (occasion, thing etc), classifier for poems, songs etc"
    },
    {
      "character": "絲",
      "zhuyin": "ㄙ",
      "pinyin": "sī",
      "english": "silk, thread, trace, (cuisine) shreds or julienne strips, CL:條|条[tiao2], classifier: a thread (of cl"
    },
    {
      "character": "蒜",
      "zhuyin": "ㄙㄨㄢˋ",
      "pinyin": "suàn",
      "english": "garlic, CL:頭|头[tou2], 瓣[ban4]"
    },
    {
      "character": "抬",
      "zhuyin": "ㄊㄞˊ",
      "pinyin": "tái",
      "english": "to lift, to raise, (of two or more persons) to carry"
    },
    {
      "character": "彈",
      "zhuyin": "ㄊㄢˊ",
      "pinyin": "tán",
      "english": "to pluck (a string), to play (a string instrument), to spring or leap, to shoot (e.g. with a catapul"
    },
    {
      "character": "逃",
      "zhuyin": "ㄊㄠˊ",
      "pinyin": "táo",
      "english": "to escape, to run away, to flee"
    },
    {
      "character": "疼",
      "zhuyin": "ㄊㄥˊ",
      "pinyin": "téng",
      "english": "(it) hurts, sore, to love dearly"
    },
    {
      "character": "田",
      "zhuyin": "ㄊㄧㄢˊ",
      "pinyin": "tián",
      "english": "field, farm, CL:片[pian4]"
    },
    {
      "character": "鐵",
      "zhuyin": "ㄊㄧㄝˇ",
      "pinyin": "tiě",
      "english": "iron (metal), arms, weapons, hard, strong, violent, unshakeable, determined, close, tight (slang)"
    },
    {
      "character": "通",
      "zhuyin": "ㄊㄨㄥ",
      "pinyin": "tōng",
      "english": "to go through, to know well, (suffix) expert, to connect, to communicate, open, to clear, classifier"
    },
    {
      "character": "吐",
      "zhuyin": "ㄊㄨˇ",
      "pinyin": "tǔ",
      "english": "to spit, to send out (silk from a silkworm, bolls from cotton flowers etc), to say, to pour out (one"
    },
    {
      "character": "團",
      "zhuyin": "ㄊㄨㄢˊ",
      "pinyin": "tuán",
      "english": "round, lump, ball, to roll into a ball, to gather, regiment, group, society, classifier for a lump o"
    },
    {
      "character": "退",
      "zhuyin": "ㄊㄨㄟˋ",
      "pinyin": "tuì",
      "english": "to retreat, to withdraw, to reject, to return (sth), to decline"
    },
    {
      "character": "挖",
      "zhuyin": "ㄨㄚ",
      "pinyin": "wā",
      "english": "to dig, to excavate, to scoop out"
    },
    {
      "character": "王",
      "zhuyin": "ㄨㄤˊ",
      "pinyin": "wáng",
      "english": "king or monarch, best or strongest of its type, grand, great"
    },
    {
      "character": "餵",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "wèi",
      "english": "to feed"
    },
    {
      "character": "溫",
      "zhuyin": "ㄨㄣ",
      "pinyin": "wēn",
      "english": "warm, lukewarm, temperature, to warm up, mild, soft, tender, to review (a lesson etc), fever (TCM), "
    },
    {
      "character": "握",
      "zhuyin": "ㄨㄛˋ",
      "pinyin": "wò",
      "english": "to hold, to grasp, to clench (one's fist), (bound form) to have in one's control, classifier: a hand"
    },
    {
      "character": "吸",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xī",
      "english": "to breathe, to suck in, to absorb, to inhale"
    },
    {
      "character": "響",
      "zhuyin": "ㄒㄧㄤˇ",
      "pinyin": "xiǎng",
      "english": "echo, sound, noise, to make a sound, to sound, to ring, loud, classifier for noises"
    },
    {
      "character": "熊",
      "zhuyin": "ㄒㄩㄥˊ",
      "pinyin": "xióng",
      "english": "bear, (coll.) to scold, to rebuke, (coll.) weak, incapable"
    },
    {
      "character": "兄",
      "zhuyin": "ㄒㄩㄥ",
      "pinyin": "xiōng",
      "english": "elder brother"
    },
    {
      "character": "壓",
      "zhuyin": "ㄧㄚ",
      "pinyin": "yā",
      "english": "to press, to push down, to keep under (control), pressure"
    },
    {
      "character": "煙",
      "zhuyin": "ㄧㄢ",
      "pinyin": "yān",
      "english": "cigarette or pipe tobacco, CL:根[gen1], smoke, mist, vapour, CL:縷|缕[lu:3], tobacco plant, (of the eye"
    },
    {
      "character": "搖",
      "zhuyin": "ㄧㄠˊ",
      "pinyin": "yáo",
      "english": "to shake, to rock, to row, to crank"
    },
    {
      "character": "腰",
      "zhuyin": "ㄧㄠ",
      "pinyin": "yāo",
      "english": "waist, lower back, pocket, middle, loins"
    },
    {
      "character": "醫",
      "zhuyin": "ㄧ",
      "pinyin": "yī",
      "english": "medical, medicine, doctor, to cure, to treat"
    },
    {
      "character": "銀",
      "zhuyin": "ㄧㄣˊ",
      "pinyin": "yín",
      "english": "silver, silver-colored, relating to money or currency"
    },
    {
      "character": "由",
      "zhuyin": "ㄧㄡˊ",
      "pinyin": "yóu",
      "english": "to follow, from, because of, due to, by, via, through, (before a noun and a verb) it is for ... to ."
    },
    {
      "character": "與",
      "zhuyin": "ㄩˇ",
      "pinyin": "yǔ",
      "english": "and, to give, together with"
    },
    {
      "character": "糟",
      "zhuyin": "ㄗㄠ",
      "pinyin": "zāo",
      "english": "dregs, draff, pickled in wine, rotten, messy, ruined"
    },
    {
      "character": "章",
      "zhuyin": "ㄓㄤ",
      "pinyin": "zhāng",
      "english": "chapter, section, clause, movement (of symphony), seal, badge, regulation, order"
    },
    {
      "character": "爭",
      "zhuyin": "ㄓㄥ",
      "pinyin": "zhēng",
      "english": "to strive for, to vie for, to argue or debate, deficient or lacking (dialect), how or what (literary"
    },
    {
      "character": "止",
      "zhuyin": "ㄓˇ",
      "pinyin": "zhǐ",
      "english": "to stop, to prohibit, until, only"
    },
    {
      "character": "準",
      "zhuyin": "ㄓㄨㄣˇ",
      "pinyin": "zhǔn",
      "english": "accurate, standard, definitely, certainly, about to become (bride, son-in-law etc), quasi-, para-"
    },
    {
      "character": "紫",
      "zhuyin": "ㄗˇ",
      "pinyin": "zǐ",
      "english": "purple, violet"
    },
    {
      "character": "組",
      "zhuyin": "ㄗㄨˇ",
      "pinyin": "zǔ",
      "english": "to form, to organize, group, team, classifier for sets, series, groups of people, batteries"
    },
    {
      "character": "怨",
      "zhuyin": "ㄩㄢˋ",
      "pinyin": "bàoyuàn",
      "english": "to complain, to grumble, to harbor a complaint, to feel dissatisfied"
    },
    {
      "character": "曾",
      "zhuyin": "ㄘㄥˊ",
      "pinyin": "céngjīng",
      "english": "once, already, former, previously, ever, (past tense marker used before verb or clause)"
    },
    {
      "character": "充",
      "zhuyin": "ㄔㄨㄥ",
      "pinyin": "chōngdiàn",
      "english": "to recharge (a battery), (fig.) to recharge one's batteries (through leisure), to update one's skill"
    },
    {
      "character": "菸",
      "zhuyin": "ㄧㄢ",
      "pinyin": "chōuyān",
      "english": "to smoke (a cigarette, tobacco)"
    },
    {
      "character": "誤",
      "zhuyin": "ㄨˋ",
      "pinyin": "cuòwù",
      "english": "mistaken, false, wrong, error, mistake, CL:個|个[ge4]"
    },
    {
      "character": "獨",
      "zhuyin": "ㄉㄨˊ",
      "pinyin": "dúlì",
      "english": "independent, independence, to stand alone"
    },
    {
      "character": "象",
      "zhuyin": "ㄒㄧㄤˋ",
      "pinyin": "duìxiàng",
      "english": "target, object, partner, boyfriend, girlfriend, CL:個|个[ge4]"
    },
    {
      "character": "童",
      "zhuyin": "ㄊㄨㄥˊ",
      "pinyin": "értóng",
      "english": "child, CL:個|个[ge4]"
    },
    {
      "character": "惱",
      "zhuyin": "ㄋㄠˇ",
      "pinyin": "fánnǎo",
      "english": "to be worried, to be distressed, worries"
    },
    {
      "character": "棄",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "fàngqì",
      "english": "to renounce, to abandon, to give up"
    },
    {
      "character": "豐",
      "zhuyin": "ㄈㄥ",
      "pinyin": "fēngfù",
      "english": "to enrich, rich, plentiful, abundant"
    },
    {
      "character": "富",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fēngfù",
      "english": "to enrich, rich, plentiful, abundant"
    },
    {
      "character": "婦",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fùnǚ",
      "english": "woman"
    },
    {
      "character": "複",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fùzá",
      "english": "complicated, complex"
    },
    {
      "character": "溝",
      "zhuyin": "ㄍㄡ",
      "pinyin": "gōutōng",
      "english": "to join, to connect, to link up, to communicate"
    },
    {
      "character": "勵",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "gǔlì",
      "english": "to encourage"
    },
    {
      "character": "規",
      "zhuyin": "ㄍㄨㄟ",
      "pinyin": "guīdìng",
      "english": "to stipulate, to specify, to prescribe, to fix (a price), to set (a quota), regulations, rules, prov"
    },
    {
      "character": "忽",
      "zhuyin": "ㄏㄨ",
      "pinyin": "hūrán",
      "english": "suddenly, all of a sudden"
    },
    {
      "character": "糊",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "hútú",
      "english": "muddled, silly, confused"
    },
    {
      "character": "互",
      "zhuyin": "ㄏㄨˋ",
      "pinyin": "hùxiāng",
      "english": "each other, mutually, mutual"
    },
    {
      "character": "乎",
      "zhuyin": "ㄏㄨ",
      "pinyin": "jīhū",
      "english": "almost, nearly, practically"
    },
    {
      "character": "激",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jīliè",
      "english": "(of competition or fighting) intense, fierce, (of pain) acute, (of an expression of opinion) impassi"
    },
    {
      "character": "器",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "jīqì",
      "english": "machine, CL:臺|台[tai2], 部[bu4], 個|个[ge4]"
    },
    {
      "character": "續",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "jìxù",
      "english": "to continue, to proceed with, to go on with"
    },
    {
      "character": "價",
      "zhuyin": "ㄐㄧㄚˋ",
      "pinyin": "jiàqián",
      "english": "price"
    },
    {
      "character": "檢",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "jiǎnchá",
      "english": "inspection, to examine, to inspect, CL:次[ci4]"
    },
    {
      "character": "釋",
      "zhuyin": "ㄕˋ",
      "pinyin": "jiěshì",
      "english": "explanation, to explain, to interpret, to resolve, CL:個|个[ge4]"
    },
    {
      "character": "拒",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jùjué",
      "english": "to refuse, to decline, to reject"
    },
    {
      "character": "距",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jùlí",
      "english": "distance, CL:個|个[ge4], to be apart from"
    },
    {
      "character": "慮",
      "zhuyin": "ㄌㄩˋ",
      "pinyin": "kǎolǜ",
      "english": "to think over, to consider, consideration"
    },
    {
      "character": "憐",
      "zhuyin": "ㄌㄧㄢˊ",
      "pinyin": "kělián",
      "english": "pitiful, pathetic, to have pity on"
    },
    {
      "character": "恐",
      "zhuyin": "ㄎㄨㄥˇ",
      "pinyin": "kǒngpà",
      "english": "fear, to dread, I'm afraid that..., perhaps, maybe"
    },
    {
      "character": "及",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "láibùjí",
      "english": "there's not enough time (to do sth), it's too late (to do sth)"
    },
    {
      "character": "浪",
      "zhuyin": "ㄌㄤˋ",
      "pinyin": "làngfèi",
      "english": "to waste, to squander"
    },
    {
      "character": "理",
      "zhuyin": "ㄌㄧˇ",
      "pinyin": "lǐyóu",
      "english": "reason, grounds, justification, CL:個|个[ge4]"
    },
    {
      "character": "厲",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lìhài",
      "english": "(used to describe sb or sth that makes a very strong impression, whether favorable or unfavorable) t"
    },
    {
      "character": "迷",
      "zhuyin": "ㄇㄧˊ",
      "pinyin": "mílù",
      "english": "to lose the way, lost, labyrinth, labyrinthus vestibularis (of the inner ear)"
    },
    {
      "character": "普",
      "zhuyin": "ㄆㄨˇ",
      "pinyin": "pǔbiàn",
      "english": "universal, general, widespread, common"
    },
    {
      "character": "況",
      "zhuyin": "ㄎㄨㄤˋ",
      "pinyin": "qíngkuàng",
      "english": "circumstances, state of affairs, situation, CL:個|个[ge4], 種|种[zhong3]"
    },
    {
      "character": "確",
      "zhuyin": "ㄑㄩㄝˋ",
      "pinyin": "quèdìng",
      "english": "definite, certain, fixed, to fix (on sth), to determine, to be sure, to ensure, to make certain, to "
    },
    {
      "character": "仍",
      "zhuyin": "ㄖㄥˊ",
      "pinyin": "réngrán",
      "english": "still, as before, yet"
    },
    {
      "character": "申",
      "zhuyin": "ㄕㄣ",
      "pinyin": "shēnqǐng",
      "english": "to apply for sth, application form (CL:份[fen4])"
    },
    {
      "character": "隨",
      "zhuyin": "ㄙㄨㄟˊ",
      "pinyin": "suíbiàn",
      "english": "as one wishes, as one pleases, at random, negligent, casual, wanton"
    },
    {
      "character": "態",
      "zhuyin": "ㄊㄞˋ",
      "pinyin": "tàidù",
      "english": "manner, bearing, attitude, approach, CL:個|个[ge4]"
    },
    {
      "character": "厭",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "tǎoyàn",
      "english": "to dislike, to loathe, disagreeable, troublesome, annoying"
    },
    {
      "character": "突",
      "zhuyin": "ㄊㄨˊ",
      "pinyin": "túrán",
      "english": "sudden, abrupt, unexpected"
    },
    {
      "character": "奮",
      "zhuyin": "ㄈㄣˋ",
      "pinyin": "xīngfèn",
      "english": "excited, excitement, (physiology) excitation"
    },
    {
      "character": "幸",
      "zhuyin": "ㄒㄧㄥˋ",
      "pinyin": "xìngyùn",
      "english": "fortunate, lucky, fortune, luck"
    },
    {
      "character": "葉",
      "zhuyin": "ㄧㄝˋ",
      "pinyin": "yèzi",
      "english": "leaf (CL:片[pian4]), (slang) marijuana"
    },
    {
      "character": "永",
      "zhuyin": "ㄩㄥˇ",
      "pinyin": "yǒngyuǎn",
      "english": "forever, eternal"
    },
    {
      "character": "遇",
      "zhuyin": "ㄩˋ",
      "pinyin": "yùdào",
      "english": "to meet, to run into, to come across"
    },
    {
      "character": "增",
      "zhuyin": "ㄗㄥ",
      "pinyin": "zēngjiā",
      "english": "to raise, to increase"
    },
    {
      "character": "終",
      "zhuyin": "ㄓㄨㄥ",
      "pinyin": "zhōngyú",
      "english": "at last, in the end, finally, eventually"
    },
    {
      "character": "竹",
      "zhuyin": "ㄓㄨˊ",
      "pinyin": "zhúzi",
      "english": "bamboo, CL:棵[ke1], 支[zhi1], 根[gen1]"
    },
    {
      "character": "嬤",
      "zhuyin": "˙ㄇㄚ",
      "pinyin": "āma",
      "english": "grandma (Tw)"
    },
    {
      "character": "夫",
      "zhuyin": "ㄈㄨ",
      "pinyin": "fūqī",
      "english": "husband and wife, married couple"
    },
    {
      "character": "妻",
      "zhuyin": "ㄑㄧ",
      "pinyin": "fūqī",
      "english": "husband and wife, married couple"
    },
    {
      "character": "性",
      "zhuyin": "ㄒㄧㄥˋ",
      "pinyin": "gèxìng",
      "english": "individuality, personality"
    },
    {
      "character": "猴",
      "zhuyin": "ㄏㄡˊ",
      "pinyin": "hóuzi",
      "english": "monkey, CL:隻|只[zhi1]"
    },
    {
      "character": "鼠",
      "zhuyin": "ㄕㄨˇ",
      "pinyin": "lǎoshǔ",
      "english": "rat, mouse, CL:隻|只[zhi1]"
    },
    {
      "character": "齡",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "niánlíng",
      "english": "(a person's) age, CL:把[ba3], 個|个[ge4]"
    },
    {
      "character": "農",
      "zhuyin": "ㄋㄨㄥˊ",
      "pinyin": "nónglì",
      "english": "the traditional Chinese calendar, the lunar calendar"
    },
    {
      "character": "曆",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "nónglì",
      "english": "the traditional Chinese calendar, the lunar calendar"
    },
    {
      "character": "戚",
      "zhuyin": "ㄑㄧ",
      "pinyin": "qīnqī",
      "english": "a relative (i.e. family relation), CL:門|门[men2], 個|个[ge4], 位[wei4]"
    },
    {
      "character": "移",
      "zhuyin": "ㄧˊ",
      "pinyin": "yímín",
      "english": "to immigrate, to migrate, emigrant, immigrant"
    },
    {
      "character": "民",
      "zhuyin": "ㄇㄧㄣˊ",
      "pinyin": "yímín",
      "english": "to immigrate, to migrate, emigrant, immigrant"
    },
    {
      "character": "職",
      "zhuyin": "ㄓˊ",
      "pinyin": "zhíyè",
      "english": "occupation, profession, vocation, professional"
    },
    {
      "character": "祖",
      "zhuyin": "ㄗㄨˇ",
      "pinyin": "zǔfù",
      "english": "father's father, paternal grandfather"
    },
    {
      "character": "玻",
      "zhuyin": "ㄅㄛ",
      "pinyin": "bōlí",
      "english": "glass, CL:張|张[zhang1], 塊|块[kuai4], (slang) male homosexual"
    },
    {
      "character": "璃",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "bōlí",
      "english": "glass, CL:張|张[zhang1], 塊|块[kuai4], (slang) male homosexual"
    },
    {
      "character": "寓",
      "zhuyin": "ㄩˋ",
      "pinyin": "gōngyù",
      "english": "apartment building, block of flats, CL:套[tao4]"
    },
    {
      "character": "郊",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "jiāoqū",
      "english": "suburban district, outskirts, suburbs, CL:個|个[ge4]"
    },
    {
      "character": "暖",
      "zhuyin": "ㄋㄨㄢˇ",
      "pinyin": "nuǎnqì",
      "english": "central heating, heater, warm air"
    },
    {
      "character": "設",
      "zhuyin": "ㄕㄜˋ",
      "pinyin": "shèbèi",
      "english": "equipment, facilities, installations, CL:個|个[ge4]"
    },
    {
      "character": "斯",
      "zhuyin": "ㄙ",
      "pinyin": "wǎsī",
      "english": "gas (loanword)"
    },
    {
      "character": "展",
      "zhuyin": "ㄓㄢˇ",
      "pinyin": "fāzhǎn",
      "english": "development, growth, to develop, to grow, to expand"
    },
    {
      "character": "廠",
      "zhuyin": "ㄔㄤˇ",
      "pinyin": "gōngchǎng",
      "english": "factory, CL:家[jia1], 座[zuo4]"
    },
    {
      "character": "技",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jìshù",
      "english": "technology, technique, skill, CL:門|门[men2], 種|种[zhong3], 項|项[xiang4]"
    },
    {
      "character": "術",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "jìshù",
      "english": "technology, technique, skill, CL:門|门[men2], 種|种[zhong3], 項|项[xiang4]"
    },
    {
      "character": "競",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "jìngzhēng",
      "english": "to compete, competition"
    },
    {
      "character": "族",
      "zhuyin": "ㄗㄨˊ",
      "pinyin": "shàngbānzú",
      "english": "office workers (as social group)"
    },
    {
      "character": "薪",
      "zhuyin": "ㄒㄧㄣ",
      "pinyin": "xīnshuǐ",
      "english": "salary, wage"
    },
    {
      "character": "訓",
      "zhuyin": "ㄒㄩㄣˋ",
      "pinyin": "xùnliàn",
      "english": "to train, to drill, training, CL:個|个[ge4]"
    },
    {
      "character": "專",
      "zhuyin": "ㄓㄨㄢ",
      "pinyin": "zhuānyè",
      "english": "specialty, specialized field, main field of study (at university), major, CL:門|门[men2], 個|个[ge4], pr"
    },
    {
      "character": "源",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "zīyuán",
      "english": "natural resource (such as water or minerals), resource (such as manpower or tourism)"
    },
    {
      "character": "演",
      "zhuyin": "ㄧㄢˇ",
      "pinyin": "biǎoyǎn",
      "english": "play, show, performance, exhibition, to perform, to act, to demonstrate, CL:場|场[chang3]"
    },
    {
      "character": "博",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "bówùguǎn",
      "english": "museum"
    },
    {
      "character": "導",
      "zhuyin": "ㄉㄠˇ",
      "pinyin": "dǎoyǎn",
      "english": "to direct, director (film etc)"
    },
    {
      "character": "眾",
      "zhuyin": "ㄓㄨㄥˋ",
      "pinyin": "guānzhòng",
      "english": "spectators, audience, visitors (to an exhibition etc)"
    },
    {
      "character": "媒",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "méitǐ",
      "english": "media, esp. news media"
    },
    {
      "character": "享",
      "zhuyin": "ㄒㄧㄤˇ",
      "pinyin": "xiǎngshòu",
      "english": "to enjoy, to live it up, pleasure, CL:種|种[zhong3]"
    },
    {
      "character": "藝",
      "zhuyin": "ㄧˋ",
      "pinyin": "yìshù",
      "english": "art"
    },
    {
      "character": "覽",
      "zhuyin": "ㄌㄢˇ",
      "pinyin": "zhǎnlǎn",
      "english": "to put on display, to exhibit, exhibition, show, CL:個|个[ge4], 次[ci4]"
    },
    {
      "character": "潮",
      "zhuyin": "ㄔㄠˊ",
      "pinyin": "cháoshī",
      "english": "damp, moist"
    },
    {
      "character": "震",
      "zhuyin": "ㄓㄣˋ",
      "pinyin": "dìzhèn",
      "english": "earthquake"
    },
    {
      "character": "森",
      "zhuyin": "ㄙㄣ",
      "pinyin": "sēnlín",
      "english": "forest, CL:片[pian4]"
    },
    {
      "character": "石",
      "zhuyin": "ㄕˊ",
      "pinyin": "shítou",
      "english": "stone, CL:塊|块[kuai4]"
    },
    {
      "character": "歉",
      "zhuyin": "ㄑㄧㄢˋ",
      "pinyin": "bàoqiàn",
      "english": "to be sorry, to feel apologetic, sorry!"
    },
    {
      "character": "呼",
      "zhuyin": "ㄏㄨ",
      "pinyin": "dǎzhāohū",
      "english": "to greet sb by word or action, to give prior notice"
    },
    {
      "character": "恭",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "gōngxǐ",
      "english": "to congratulate, (interj.) congratulations!"
    },
    {
      "character": "聯",
      "zhuyin": "ㄌㄧㄢˊ",
      "pinyin": "liánluò",
      "english": "to get in touch with, to contact, to stay in contact (with), liaison, (math.) connection"
    },
    {
      "character": "絡",
      "zhuyin": "ㄌㄨㄛˋ",
      "pinyin": "liánluò",
      "english": "to get in touch with, to contact, to stay in contact (with), liaison, (math.) connection"
    },
    {
      "character": "慶",
      "zhuyin": "ㄑㄧㄥˋ",
      "pinyin": "qìngzhù",
      "english": "to celebrate"
    },
    {
      "character": "郎",
      "zhuyin": "ㄌㄤˊ",
      "pinyin": "xīnláng",
      "english": "bridegroom, groom"
    },
    {
      "character": "邀",
      "zhuyin": "ㄧㄠ",
      "pinyin": "yāoqǐng",
      "english": "to invite, invitation, CL:個|个[ge4]"
    },
    {
      "character": "喉",
      "zhuyin": "ㄏㄡˊ",
      "pinyin": "hóulóng",
      "english": "the throat"
    },
    {
      "character": "嚨",
      "zhuyin": "ㄌㄨㄥˊ",
      "pinyin": "hóulóng",
      "english": "the throat"
    },
    {
      "character": "恢",
      "zhuyin": "ㄏㄨㄟ",
      "pinyin": "huīfù",
      "english": "to reinstate, to resume, to restore, to recover, to regain, to rehabilitate"
    },
    {
      "character": "復",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "huīfù",
      "english": "to reinstate, to resume, to restore, to recover, to regain, to rehabilitate"
    },
    {
      "character": "膚",
      "zhuyin": "ㄈㄨ",
      "pinyin": "pífū",
      "english": "skin, CL:層|层[ceng2], 塊|块[kuai4]"
    },
    {
      "character": "齒",
      "zhuyin": "ㄔˇ",
      "pinyin": "yáchǐ",
      "english": "tooth, dental, CL:顆|颗[ke1]"
    },
    {
      "character": "淚",
      "zhuyin": "ㄌㄟˋ",
      "pinyin": "yǎnlèi",
      "english": "tears, crying, CL:滴[di1]"
    },
    {
      "character": "補",
      "zhuyin": "ㄅㄨˇ",
      "pinyin": "bǔxíbān",
      "english": "cram class, cram school, evening classes"
    },
    {
      "character": "譯",
      "zhuyin": "ㄧˋ",
      "pinyin": "fānyì",
      "english": "to translate, to interpret, translator, interpreter, translation, interpretation, CL:個|个[ge4], 位[wei"
    },
    {
      "character": "訪",
      "zhuyin": "ㄈㄤˇ",
      "pinyin": "fǎngwèn",
      "english": "to visit, to call on, to interview, CL:次[ci4]"
    },
    {
      "character": "失",
      "zhuyin": "ㄕ",
      "pinyin": "shībài",
      "english": "to be defeated, to lose, to fail (e.g. experiments), failure, defeat, CL:次[ci4]"
    },
    {
      "character": "敗",
      "zhuyin": "ㄅㄞˋ",
      "pinyin": "shībài",
      "english": "to be defeated, to lose, to fail (e.g. experiments), failure, defeat, CL:次[ci4]"
    },
    {
      "character": "薦",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "tuījiàn",
      "english": "to recommend, recommendation"
    },
    {
      "character": "預",
      "zhuyin": "ㄩˋ",
      "pinyin": "yùxí",
      "english": "to prepare a lesson"
    },
    {
      "character": "閱",
      "zhuyin": "ㄩㄝˋ",
      "pinyin": "yuèdú",
      "english": "to read, reading"
    },
    {
      "character": "政",
      "zhuyin": "ㄓㄥˋ",
      "pinyin": "zhèngzhì",
      "english": "politics, political"
    },
    {
      "character": "襯",
      "zhuyin": "ㄔㄣˋ",
      "pinyin": "chènshān",
      "english": "shirt, blouse, CL:件[jian4]"
    },
    {
      "character": "衫",
      "zhuyin": "ㄕㄢ",
      "pinyin": "chènshān",
      "english": "shirt, blouse, CL:件[jian4]"
    },
    {
      "character": "購",
      "zhuyin": "ㄍㄡˋ",
      "pinyin": "gòumǎi",
      "english": "to purchase, to buy"
    },
    {
      "character": "檯",
      "zhuyin": "ㄊㄞˊ",
      "pinyin": "guìtái",
      "english": "sales counter, front desk, bar, (of markets, medicines etc) OTC (over-the-counter)"
    },
    {
      "character": "仔",
      "zhuyin": "ㄗˇ",
      "pinyin": "niúzǐkù",
      "english": "jeans, CL:條|条[tiao2]"
    },
    {
      "character": "牌",
      "zhuyin": "ㄆㄞˊ",
      "pinyin": "páizi",
      "english": "sign, trademark, brand"
    },
    {
      "character": "質",
      "zhuyin": "ㄓˊ",
      "pinyin": "pǐnzhí",
      "english": "character, intrinsic quality (of a person), quality (of a product or service, or as in \"quality of l"
    },
    {
      "character": "鉛",
      "zhuyin": "ㄑㄧㄢ",
      "pinyin": "qiānbǐ",
      "english": "(lead) pencil, CL:支[zhi1], 枝[zhi1], 桿|杆[gan3]"
    },
    {
      "character": "塑",
      "zhuyin": "ㄙㄨˋ",
      "pinyin": "sùjiāo",
      "english": "synthetic resin, plastic cement, (Tw) plastic"
    },
    {
      "character": "膠",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "sùjiāo",
      "english": "synthetic resin, plastic cement, (Tw) plastic"
    },
    {
      "character": "材",
      "zhuyin": "ㄘㄞˊ",
      "pinyin": "cáiliào",
      "english": "(raw) material, data, (fig.) person who has the potential to do the job"
    },
    {
      "character": "鍋",
      "zhuyin": "ㄍㄨㄛ",
      "pinyin": "guōzi",
      "english": "pot, pan, wok, cauldron, pot-shaped thing, hotpot"
    },
    {
      "character": "胡",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "hújiāo",
      "english": "pepper"
    },
    {
      "character": "椒",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "hújiāo",
      "english": "pepper"
    },
    {
      "character": "蔬",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shūcài",
      "english": "vegetables, CL:種|种[zhong3]"
    },
    {
      "character": "素",
      "zhuyin": "ㄙㄨˋ",
      "pinyin": "sùshí",
      "english": "vegetarian food, to eat a vegetarian diet"
    },
    {
      "character": "蝦",
      "zhuyin": "ㄒㄧㄚ",
      "pinyin": "xiāzi",
      "english": "shrimp"
    },
    {
      "character": "粽",
      "zhuyin": "ㄗㄨㄥˋ",
      "pinyin": "zòngzi",
      "english": "glutinous rice and choice of filling wrapped in leaves and steamed or boiled"
    },
    {
      "character": "歐",
      "zhuyin": "ㄡ",
      "pinyin": "ōuyuán",
      "english": "euro (currency)"
    },
    {
      "character": "幣",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "xīntáibì",
      "english": "New Taiwan dollar (NTD)"
    },
    {
      "character": "禍",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "chēhuò",
      "english": "traffic accident, car crash, CL:場|场[chang2]"
    },
    {
      "character": "警",
      "zhuyin": "ㄐㄧㄥˇ",
      "pinyin": "jǐngchá",
      "english": "police, police officer, CL:個|个[ge4]"
    },
    {
      "character": "察",
      "zhuyin": "ㄔㄚˊ",
      "pinyin": "jǐngchá",
      "english": "police, police officer, CL:個|个[ge4]"
    },
    {
      "character": "怖",
      "zhuyin": "ㄅㄨˋ",
      "pinyin": "kǒngbù",
      "english": "terrible, frightful, frightening, terror, terrorist"
    },
    {
      "character": "虎",
      "zhuyin": "ㄏㄨˇ",
      "pinyin": "lǎohǔ",
      "english": "tiger, CL:隻|只[zhi1]"
    },
    {
      "character": "濟",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jīngjì",
      "english": "economy, economic"
    },
    {
      "character": "權",
      "zhuyin": "ㄑㄩㄢˊ",
      "pinyin": "quánlì",
      "english": "right (i.e. an entitlement to sth), (classical) power and wealth"
    },
    {
      "character": "責",
      "zhuyin": "ㄗㄜˊ",
      "pinyin": "zérèn",
      "english": "responsibility, blame, duty, CL:個|个[ge4]"
    },
    {
      "character": "府",
      "zhuyin": "ㄈㄨˇ",
      "pinyin": "zhèngfǔ",
      "english": "government, CL:個|个[ge4]"
    },
    {
      "character": "制",
      "zhuyin": "ㄓˋ",
      "pinyin": "zhìdù",
      "english": "system (e.g. political, adminstrative etc), institution, CL:個|个[ge4]"
    },
    {
      "character": "偉",
      "zhuyin": "ㄨㄟˇ",
      "pinyin": "wěidà",
      "english": "huge, great, grand, worthy of the greatest admiration, important (contribution etc)"
    },
    {
      "character": "引",
      "zhuyin": "ㄧㄣˇ",
      "pinyin": "xīyǐn",
      "english": "to attract, to appeal to, to fascinate"
    },
    {
      "character": "勇",
      "zhuyin": "ㄩㄥˇ",
      "pinyin": "yǒnggǎn",
      "english": "brave, courageous"
    },
    {
      "character": "扮",
      "zhuyin": "ㄅㄢˋ",
      "pinyin": "bànyǎn",
      "english": "to play the role of, to act"
    },
    {
      "character": "避",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bìmiǎn",
      "english": "to avert, to prevent, to avoid, to refrain from"
    },
    {
      "character": "涕",
      "zhuyin": "ㄊㄧˋ",
      "pinyin": "bítì",
      "english": "nasal mucus, snivel, snot"
    },
    {
      "character": "達",
      "zhuyin": "ㄉㄚˊ",
      "pinyin": "biǎodá",
      "english": "to express, to convey"
    },
    {
      "character": "示",
      "zhuyin": "ㄕˋ",
      "pinyin": "biǎoshì",
      "english": "(of sb) to express, to state, to show, (of sth) to indicate, to signify, to show, expression, manife"
    },
    {
      "character": "脖",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "bózi",
      "english": "neck, CL:個|个[ge4]"
    },
    {
      "character": "測",
      "zhuyin": "ㄘㄜˋ",
      "pinyin": "cèyàn",
      "english": "test, to test, CL:次[ci4], 個|个[ge4]"
    },
    {
      "character": "異",
      "zhuyin": "ㄧˋ",
      "pinyin": "chāyì",
      "english": "difference, discrepancy"
    },
    {
      "character": "產",
      "zhuyin": "ㄔㄢˇ",
      "pinyin": "chǎnshēng",
      "english": "to arise, to come into being, to come about, to give rise to, to bring into being, to bring about, t"
    },
    {
      "character": "承",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéngrèn",
      "english": "to admit, to concede, to recognize, recognition (diplomatic, artistic etc), to acknowledge"
    },
    {
      "character": "創",
      "zhuyin": "ㄔㄨㄤˋ",
      "pinyin": "chuàngxīn",
      "english": "to bring forth new ideas, to blaze new trails, innovation"
    },
    {
      "character": "造",
      "zhuyin": "ㄗㄠˋ",
      "pinyin": "chuàngzào",
      "english": "to create, to bring about, to produce, to set (a record)"
    },
    {
      "character": "嚏",
      "zhuyin": "ㄊㄧˋ",
      "pinyin": "dǎpēntì",
      "english": "to sneeze"
    },
    {
      "character": "劇",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "diànshìjù",
      "english": "TV series, TV drama, CL:部[bu4]"
    },
    {
      "character": "型",
      "zhuyin": "ㄒㄧㄥˊ",
      "pinyin": "diǎnxíng",
      "english": "model, typical case, archetype, typical, representative"
    },
    {
      "character": "財",
      "zhuyin": "ㄘㄞˊ",
      "pinyin": "fācái",
      "english": "to get rich"
    },
    {
      "character": "炎",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "fāyán",
      "english": "to become inflamed, inflammation"
    },
    {
      "character": "範",
      "zhuyin": "ㄈㄢˋ",
      "pinyin": "fànwéi",
      "english": "range, scope, limit, extent, CL:個|个[ge4]"
    },
    {
      "character": "否",
      "zhuyin": "ㄈㄡˇ",
      "pinyin": "fǒuzé",
      "english": "otherwise, if not, or (else)"
    },
    {
      "character": "善",
      "zhuyin": "ㄕㄢˋ",
      "pinyin": "gǎishàn",
      "english": "to make better, to improve, CL:個|个[ge4]"
    },
    {
      "character": "壁",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "gébì",
      "english": "next door, neighbor"
    },
    {
      "character": "據",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "gēnjù",
      "english": "according to, based on, basis, foundation, CL:個|个[ge4]"
    },
    {
      "character": "古",
      "zhuyin": "ㄍㄨˇ",
      "pinyin": "gǔdài",
      "english": "ancient times"
    },
    {
      "character": "固",
      "zhuyin": "ㄍㄨˋ",
      "pinyin": "gùdìng",
      "english": "to fix, to fasten, to set rigidly in place, fixed, set, regular"
    },
    {
      "character": "模",
      "zhuyin": "ㄇㄛˊ",
      "pinyin": "guīmó",
      "english": "scale, scope, extent, CL:個|个[ge4]"
    },
    {
      "character": "敏",
      "zhuyin": "ㄇㄧㄣˇ",
      "pinyin": "guòmǐn",
      "english": "oversensitive, allergic, allergy"
    },
    {
      "character": "鬍",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "húzi",
      "english": "beard, mustache or whiskers, facial hair, CL:撮[zuo3], 根[gen1], (coll.) bandit"
    },
    {
      "character": "懷",
      "zhuyin": "ㄏㄨㄞˊ",
      "pinyin": "huáiyí",
      "english": "to doubt (sth), to be skeptical of, to have one's doubts, to harbor suspicions, to suspect that"
    },
    {
      "character": "疑",
      "zhuyin": "ㄧˊ",
      "pinyin": "huáiyí",
      "english": "to doubt (sth), to be skeptical of, to have one's doubts, to harbor suspicions, to suspect that"
    },
    {
      "character": "姻",
      "zhuyin": "ㄧㄣ",
      "pinyin": "hūnyīn",
      "english": "matrimony, wedding, marriage, CL:樁|桩[zhuang1], 次[ci4]"
    },
    {
      "character": "基",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jīchǔ",
      "english": "base, foundation, basis, basic, fundamental"
    },
    {
      "character": "礎",
      "zhuyin": "ㄔㄨˇ",
      "pinyin": "jīchǔ",
      "english": "base, foundation, basis, basic, fundamental"
    },
    {
      "character": "積",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jījí",
      "english": "active, energetic, vigorous, positive (outlook), proactive"
    },
    {
      "character": "既",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jìrán",
      "english": "since, as, this being the case"
    },
    {
      "character": "吉",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jítā",
      "english": "guitar (loanword), CL:把[ba3]"
    },
    {
      "character": "憶",
      "zhuyin": "ㄧˋ",
      "pinyin": "jìyì",
      "english": "to remember, to recall, memory, CL:個|个[ge4]"
    },
    {
      "character": "診",
      "zhuyin": "ㄓㄣˇ",
      "pinyin": "jízhěn",
      "english": "to give or receive urgent medical treatment, emergency treatment (at a hospital emergency department"
    },
    {
      "character": "漸",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiànjiàn",
      "english": "gradually"
    },
    {
      "character": "築",
      "zhuyin": "ㄓㄨˊ",
      "pinyin": "jiànzhú",
      "english": "to construct, building, CL:個|个[ge4]"
    },
    {
      "character": "觸",
      "zhuyin": "ㄔㄨˋ",
      "pinyin": "jiēchù",
      "english": "to touch, to contact, access, in touch with"
    },
    {
      "character": "竟",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "jìngrán",
      "english": "unexpectedly, to one's surprise, in spite of everything, in that crazy way, actually, to go as far a"
    },
    {
      "character": "驚",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jīngyà",
      "english": "amazed, astonished, to surprise, amazing, astonishment, awe"
    },
    {
      "character": "訝",
      "zhuyin": "ㄧㄚˋ",
      "pinyin": "jīngyà",
      "english": "amazed, astonished, to surprise, amazing, astonishment, awe"
    },
    {
      "character": "舅",
      "zhuyin": "ㄐㄧㄡˋ",
      "pinyin": "jiùjiu",
      "english": "mother's brother, maternal uncle (informal), CL:個|个[ge4]"
    },
    {
      "character": "鍊",
      "zhuyin": "ㄌㄧㄢˋ",
      "pinyin": "lāliàn",
      "english": "zipper"
    },
    {
      "character": "漫",
      "zhuyin": "ㄇㄢˋ",
      "pinyin": "làngmàn",
      "english": "romantic"
    },
    {
      "character": "戀",
      "zhuyin": "ㄌㄧㄢˋ",
      "pinyin": "liànài",
      "english": "(romantic) love, CL:個|个[ge4], 場|场[chang3], in love, to have an affair"
    },
    {
      "character": "良",
      "zhuyin": "ㄌㄧㄤˊ",
      "pinyin": "liánghǎo",
      "english": "good, favorable, well, fine"
    },
    {
      "character": "貿",
      "zhuyin": "ㄇㄠˋ",
      "pinyin": "màoyì",
      "english": "(commercial) trade, CL:個|个[ge4]"
    },
    {
      "character": "命",
      "zhuyin": "ㄇㄧㄥˋ",
      "pinyin": "mìnglìng",
      "english": "order, command, CL:道[dao4], 個|个[ge4]"
    },
    {
      "character": "寧",
      "zhuyin": "ㄋㄧㄥˊ",
      "pinyin": "níngkě",
      "english": "preferably, one would prefer to...(or not to...), would rather, (would) be better to, (to pick) the "
    },
    {
      "character": "檸",
      "zhuyin": "ㄋㄧㄥˊ",
      "pinyin": "níngméng",
      "english": "lemon"
    },
    {
      "character": "檬",
      "zhuyin": "ㄇㄥˊ",
      "pinyin": "níngméng",
      "english": "lemon"
    },
    {
      "character": "偶",
      "zhuyin": "ㄡˇ",
      "pinyin": "ǒuěr",
      "english": "occasionally, once in a while, sometimes"
    },
    {
      "character": "爾",
      "zhuyin": "ㄦˇ",
      "pinyin": "ǒuěr",
      "english": "occasionally, once in a while, sometimes"
    },
    {
      "character": "評",
      "zhuyin": "ㄆㄧㄥˊ",
      "pinyin": "pīpíng",
      "english": "to criticize, criticism, CL:次[ci4], 番[fan1]"
    },
    {
      "character": "脾",
      "zhuyin": "ㄆㄧˊ",
      "pinyin": "píqì",
      "english": "character, temperament, disposition, bad temper, CL:股[gu3]"
    },
    {
      "character": "乒",
      "zhuyin": "ㄆㄧㄥ",
      "pinyin": "pīngpāngqiú",
      "english": "table tennis, ping-pong, table tennis ball, CL:個|个[ge4]"
    },
    {
      "character": "乓",
      "zhuyin": "ㄆㄤ",
      "pinyin": "pīngpāngqiú",
      "english": "table tennis, ping-pong, table tennis ball, CL:個|个[ge4]"
    },
    {
      "character": "氛",
      "zhuyin": "ㄈㄣ",
      "pinyin": "qìfēn",
      "english": "atmosphere, mood"
    },
    {
      "character": "企",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "qìyè",
      "english": "company, firm, enterprise, corporation, CL:家[jia1]"
    },
    {
      "character": "旗",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qízi",
      "english": "flag, banner, CL:面[mian4]"
    },
    {
      "character": "域",
      "zhuyin": "ㄩˋ",
      "pinyin": "qūyù",
      "english": "area, region, district"
    },
    {
      "character": "缺",
      "zhuyin": "ㄑㄩㄝ",
      "pinyin": "quēdiǎn",
      "english": "weak point, fault, shortcoming, disadvantage, CL:個|个[ge4]"
    },
    {
      "character": "何",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "rènhé",
      "english": "any, whatever, whichever, whatsoever"
    },
    {
      "character": "若",
      "zhuyin": "ㄖㄨㄛˋ",
      "pinyin": "ruòshì",
      "english": "if"
    },
    {
      "character": "嫂",
      "zhuyin": "ㄙㄠˇ",
      "pinyin": "sǎosao",
      "english": "older brother's wife, sister-in-law, (polite address to a younger married woman) sister"
    },
    {
      "character": "彩",
      "zhuyin": "ㄘㄞˇ",
      "pinyin": "sècǎi",
      "english": "tint, coloring, coloration, (fig.) flavor, character"
    },
    {
      "character": "帝",
      "zhuyin": "ㄉㄧˋ",
      "pinyin": "shàngdì",
      "english": "God"
    },
    {
      "character": "勝",
      "zhuyin": "ㄕㄥˋ",
      "pinyin": "shènglì",
      "english": "victory, CL:個|个[ge4]"
    },
    {
      "character": "肖",
      "zhuyin": "ㄒㄧㄠˋ",
      "pinyin": "shēngxiào",
      "english": "one of the twelve animals symbolic of the earthly branches 地支[di4 zhi1], animal from the Chinese zod"
    },
    {
      "character": "悉",
      "zhuyin": "ㄒㄧ",
      "pinyin": "shóuxī",
      "english": "to be familiar with, to know well"
    },
    {
      "character": "眠",
      "zhuyin": "ㄇㄧㄢˊ",
      "pinyin": "shuìmián",
      "english": "sleep, to sleep, (computing) to enter sleep mode"
    },
    {
      "character": "亡",
      "zhuyin": "ㄨㄤˊ",
      "pinyin": "sǐwáng",
      "english": "to die, death"
    },
    {
      "character": "販",
      "zhuyin": "ㄈㄢˋ",
      "pinyin": "tānfàn",
      "english": "stallkeeper, peddler"
    },
    {
      "character": "供",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "tígōng",
      "english": "to offer, to supply, to provide, to furnish"
    },
    {
      "character": "兔",
      "zhuyin": "ㄊㄨˋ",
      "pinyin": "tùzi",
      "english": "hare, rabbit, CL:隻|只[zhi1]"
    },
    {
      "character": "娃",
      "zhuyin": "ㄨㄚˊ",
      "pinyin": "wáwa",
      "english": "baby, small child, doll"
    },
    {
      "character": "微",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéixiào",
      "english": "smile, CL:個|个[ge4], 絲|丝[si1], to smile"
    },
    {
      "character": "置",
      "zhuyin": "ㄓˋ",
      "pinyin": "wèizhì",
      "english": "position, place, seat, CL:個|个[ge4]"
    },
    {
      "character": "限",
      "zhuyin": "ㄒㄧㄢˋ",
      "pinyin": "xiànzhì",
      "english": "to restrict, to limit, to confine, restriction, limit, CL:個|个[ge4]"
    },
    {
      "character": "村",
      "zhuyin": "ㄘㄨㄣ",
      "pinyin": "xiāngcūn",
      "english": "rustic, village, countryside"
    },
    {
      "character": "詳",
      "zhuyin": "ㄒㄧㄤˊ",
      "pinyin": "xiángxì",
      "english": "detailed, in detail, minute"
    },
    {
      "character": "曉",
      "zhuyin": "ㄒㄧㄠˇ",
      "pinyin": "xiǎode",
      "english": "to know"
    },
    {
      "character": "效",
      "zhuyin": "ㄒㄧㄠˋ",
      "pinyin": "xiàoguǒ",
      "english": "result, effect, efficacy, (theater) sound or visual effects"
    },
    {
      "character": "協",
      "zhuyin": "ㄒㄧㄝˊ",
      "pinyin": "xiézhù",
      "english": "to provide assistance, to aid"
    },
    {
      "character": "欣",
      "zhuyin": "ㄒㄧㄣ",
      "pinyin": "xīnshǎng",
      "english": "to appreciate, to enjoy, to admire"
    },
    {
      "character": "福",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "xìngfú",
      "english": "happiness, happy, blessed"
    },
    {
      "character": "宣",
      "zhuyin": "ㄒㄩㄢ",
      "pinyin": "xuānbù",
      "english": "to declare, to announce, to proclaim"
    },
    {
      "character": "迅",
      "zhuyin": "ㄒㄩㄣˋ",
      "pinyin": "xùnsù",
      "english": "rapid, speedy, fast"
    },
    {
      "character": "鴨",
      "zhuyin": "ㄧㄚ",
      "pinyin": "yāzi",
      "english": "duck, male prostitute (slang)"
    },
    {
      "character": "嬰",
      "zhuyin": "ㄧㄥ",
      "pinyin": "yīngér",
      "english": "infant, baby, CL:個|个[ge4], lead (Pb)"
    },
    {
      "character": "優",
      "zhuyin": "ㄧㄡ",
      "pinyin": "yōudiǎn",
      "english": "merit, benefit, strong point, advantage, CL:個|个[ge4], 項|项[xiang4]"
    },
    {
      "character": "幼",
      "zhuyin": "ㄧㄡˋ",
      "pinyin": "yòuzhìyuán",
      "english": "kindergarten (Tw)"
    },
    {
      "character": "稚",
      "zhuyin": "ㄓˋ",
      "pinyin": "yòuzhìyuán",
      "english": "kindergarten (Tw)"
    },
    {
      "character": "愉",
      "zhuyin": "ㄩˊ",
      "pinyin": "yúkuài",
      "english": "cheerful, cheerily, delightful, pleasant, pleasantly, pleasing, happy, delighted"
    },
    {
      "character": "旦",
      "zhuyin": "ㄉㄢˋ",
      "pinyin": "yuándàn",
      "english": "New Year's Day"
    },
    {
      "character": "諒",
      "zhuyin": "ㄌㄧㄤˋ",
      "pinyin": "yuánliàng",
      "english": "to excuse, to forgive, to pardon"
    },
    {
      "character": "宵",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "yuánxiāo",
      "english": "Lantern Festival, night of the 15th of the first lunar month, see also 元夜[yuan2 ye4], sticky rice du"
    },
    {
      "character": "晨",
      "zhuyin": "ㄔㄣˊ",
      "pinyin": "zǎochén",
      "english": "early morning, CL:個|个[ge4], also pr. [zao3 chen5]"
    },
    {
      "character": "暫",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "zhànshí",
      "english": "temporary, provisional, for the time being"
    },
    {
      "character": "帳",
      "zhuyin": "ㄓㄤˋ",
      "pinyin": "zhàngdān",
      "english": "bill, check"
    },
    {
      "character": "哲",
      "zhuyin": "ㄓㄜˊ",
      "pinyin": "zhéxué",
      "english": "philosophy, CL:個|个[ge4]"
    },
    {
      "character": "策",
      "zhuyin": "ㄘㄜˋ",
      "pinyin": "zhèngcè",
      "english": "policy, CL:個|个[ge4]"
    },
    {
      "character": "製",
      "zhuyin": "ㄓˋ",
      "pinyin": "zhìzào",
      "english": "to manufacture, to make"
    }
  ],
  "C1": [
    {
      "character": "和",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "huò",
      "english": "to mix (ingredients) together, to blend, classifier for rinses of clothes, classifier for boilings o"
    },
    {
      "character": "號",
      "zhuyin": "ㄏㄠˊ",
      "pinyin": "háo",
      "english": "roar, cry, CL:個|个[ge4]"
    },
    {
      "character": "看",
      "zhuyin": "ㄎㄢ",
      "pinyin": "kān",
      "english": "to look after, to take care of, to watch, to guard"
    },
    {
      "character": "難",
      "zhuyin": "ㄋㄢˋ",
      "pinyin": "nàn",
      "english": "disaster, distress, to scold"
    },
    {
      "character": "得",
      "zhuyin": "ㄉㄜˊ",
      "pinyin": "dé",
      "english": "to obtain, to get, to gain, to catch (a disease), proper, suitable, proud, contented, to allow, to p"
    },
    {
      "character": "累",
      "zhuyin": "ㄌㄟˇ",
      "pinyin": "lěi",
      "english": "to accumulate, to involve or implicate (Taiwan pr. [lei4]), continuous, repeated"
    },
    {
      "character": "當",
      "zhuyin": "ㄉㄤˋ",
      "pinyin": "dàng",
      "english": "at or in the very same..., suitable, adequate, fitting, proper, to replace, to regard as, to think, "
    },
    {
      "character": "道",
      "zhuyin": "ㄉㄠˋ",
      "pinyin": "dào",
      "english": "road, path, CL:條|条[tiao2], 股[gu3], principle, truth, morality, reason, skill, method, Dao (of Daoism"
    },
    {
      "character": "更",
      "zhuyin": "ㄍㄥ",
      "pinyin": "gēng",
      "english": "to change or replace, to experience, one of the five two-hour periods into which the night was forme"
    },
    {
      "character": "間",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiàn",
      "english": "gap, to separate, to thin out (seedlings), to sow discontent"
    },
    {
      "character": "轉",
      "zhuyin": "ㄓㄨㄢˋ",
      "pinyin": "zhuàn",
      "english": "to revolve, to turn, to circle about, to walk about, classifier for revolutions (per minute etc): re"
    },
    {
      "character": "炸",
      "zhuyin": "ㄓㄚˋ",
      "pinyin": "zhà",
      "english": "to burst, to explode, to blow up, (fig.) to fly into a rage"
    },
    {
      "character": "乾",
      "zhuyin": "ㄑㄧㄢˊ",
      "pinyin": "qián",
      "english": "one of the Eight Trigrams 八卦[ba1 gua4], symbolizing heaven, male principle, ☰, ancient Chinese compa"
    },
    {
      "character": "弄",
      "zhuyin": "ㄌㄨㄥˋ",
      "pinyin": "lòng",
      "english": "lane, alley"
    },
    {
      "character": "差",
      "zhuyin": "ㄔㄞ",
      "pinyin": "chāi",
      "english": "to send (on an errand), (archaic) person sent on such an errand, job, official post"
    },
    {
      "character": "量",
      "zhuyin": "ㄌㄧㄤˊ",
      "pinyin": "liáng",
      "english": "to measure"
    },
    {
      "character": "強",
      "zhuyin": "ㄐㄧㄤˋ",
      "pinyin": "jiàng",
      "english": "stubborn, unyielding"
    },
    {
      "character": "挑",
      "zhuyin": "ㄊㄧㄠˇ",
      "pinyin": "tiǎo",
      "english": "to raise, to dig up, to poke, to prick, to incite, to stir up"
    },
    {
      "character": "載",
      "zhuyin": "ㄗㄞˇ",
      "pinyin": "zǎi",
      "english": "to record in writing, to carry (i.e. publish in a newspaper etc), Taiwan pr. [zai4], year"
    },
    {
      "character": "衝",
      "zhuyin": "ㄔㄨㄥˋ",
      "pinyin": "chòng",
      "english": "powerful, vigorous, pungent, towards, in view of"
    },
    {
      "character": "處",
      "zhuyin": "ㄔㄨˇ",
      "pinyin": "chǔ",
      "english": "to reside, to live, to dwell, to be in, to be situated at, to stay, to get along with, to be in a po"
    },
    {
      "character": "匹",
      "zhuyin": "ㄆㄧˇ",
      "pinyin": "pǐ",
      "english": "classifier for horses, mules etc, Taiwan pr. [pi1], ordinary person, classifier for cloth: bolt, hor"
    },
    {
      "character": "為",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéi",
      "english": "as (in the capacity of), to take sth as, to act as, to serve as, to behave as, to become, to be, to "
    },
    {
      "character": "哎",
      "zhuyin": "ㄞ",
      "pinyin": "āi",
      "english": "hey!, (interjection used to attract attention or to express surprise or disapprobation)"
    },
    {
      "character": "拔",
      "zhuyin": "ㄅㄚˊ",
      "pinyin": "bá",
      "english": "to pull up, to pull out, to draw out by suction, to select, to pick, to stand out (above level), to "
    },
    {
      "character": "拜",
      "zhuyin": "ㄅㄞˋ",
      "pinyin": "bài",
      "english": "to pay respect, worship, visit, salute"
    },
    {
      "character": "拌",
      "zhuyin": "ㄅㄢˋ",
      "pinyin": "bàn",
      "english": "to mix, to mix in, to toss (a salad)"
    },
    {
      "character": "版",
      "zhuyin": "ㄅㄢˇ",
      "pinyin": "bǎn",
      "english": "a register, block of printing, edition, version, page"
    },
    {
      "character": "綁",
      "zhuyin": "ㄅㄤˇ",
      "pinyin": "bǎng",
      "english": "to tie, bind or fasten together, to kidnap"
    },
    {
      "character": "輩",
      "zhuyin": "ㄅㄟˋ",
      "pinyin": "bèi",
      "english": "lifetime, generation, group of people, class, classifier for generations, (literary) classifier for "
    },
    {
      "character": "閉",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bì",
      "english": "to close, to stop up, to shut, to obstruct"
    },
    {
      "character": "逼",
      "zhuyin": "ㄅㄧ",
      "pinyin": "bī",
      "english": "to force (sb to do sth), to compel, to press for, to extort, to press on towards, to press up to, to"
    },
    {
      "character": "扁",
      "zhuyin": "ㄅㄧㄢˇ",
      "pinyin": "biǎn",
      "english": "flat, (coll.) to beat (sb) up, old variant of 匾[bian3]"
    },
    {
      "character": "兵",
      "zhuyin": "ㄅㄧㄥ",
      "pinyin": "bīng",
      "english": "soldiers, a force, an army, weapons, arms, military, warlike, CL:個|个[ge4]"
    },
    {
      "character": "薄",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "bó",
      "english": "meager, slight, weak, ungenerous or unkind, frivolous, to despise, to belittle, to look down on, to "
    },
    {
      "character": "撥",
      "zhuyin": "ㄅㄛ",
      "pinyin": "bō",
      "english": "to push aside with the hand, foot, a stick etc, to dial, to allocate, to set aside (money), to poke "
    },
    {
      "character": "波",
      "zhuyin": "ㄅㄛ",
      "pinyin": "bō",
      "english": "wave, ripple, storm, surge"
    },
    {
      "character": "踩",
      "zhuyin": "ㄘㄞˇ",
      "pinyin": "cǎi",
      "english": "to step on, to tread, to stamp, to press a pedal, to pedal (a bike), (online) to downvote"
    },
    {
      "character": "慘",
      "zhuyin": "ㄘㄢˇ",
      "pinyin": "cǎn",
      "english": "miserable, wretched, cruel, inhuman, disastrous, tragic, dim, gloomy"
    },
    {
      "character": "冊",
      "zhuyin": "ㄘㄜˋ",
      "pinyin": "cè",
      "english": "book, booklet, classifier for books"
    },
    {
      "character": "插",
      "zhuyin": "ㄔㄚ",
      "pinyin": "chā",
      "english": "to insert, stick in, pierce, to take part in, to interfere, to interpose"
    },
    {
      "character": "拆",
      "zhuyin": "ㄔㄞ",
      "pinyin": "chāi",
      "english": "to tear open, to tear down, to tear apart, to open"
    },
    {
      "character": "嘗",
      "zhuyin": "ㄔㄤˊ",
      "pinyin": "cháng",
      "english": "to taste, to try (food), to experience, (literary) ever, once"
    },
    {
      "character": "抄",
      "zhuyin": "ㄔㄠ",
      "pinyin": "chāo",
      "english": "to make a copy, to plagiarize, to search and seize, to raid, to grab, to go off with, to take a shor"
    },
    {
      "character": "沉",
      "zhuyin": "ㄔㄣˊ",
      "pinyin": "chén",
      "english": "to submerge, to immerse, to sink, to keep down, to lower, to drop, deep, profound, heavy"
    },
    {
      "character": "撐",
      "zhuyin": "ㄔㄥ",
      "pinyin": "chēng",
      "english": "to support, to prop up, to push or move with a pole, to maintain, to open or unfurl, to fill to burs"
    },
    {
      "character": "稱",
      "zhuyin": "ㄔㄥ",
      "pinyin": "chēng",
      "english": "to weigh, to state, to name, name, appellation, to praise"
    },
    {
      "character": "持",
      "zhuyin": "ㄔˊ",
      "pinyin": "chí",
      "english": "to hold, to grasp, to support, to maintain, to persevere, to manage, to run (i.e. administer), to co"
    },
    {
      "character": "寵",
      "zhuyin": "ㄔㄨㄥˇ",
      "pinyin": "chǒng",
      "english": "to love, to pamper, to spoil, to favor"
    },
    {
      "character": "沖",
      "zhuyin": "ㄔㄨㄥ",
      "pinyin": "chōng",
      "english": "(of water) to dash against, to mix with water, to infuse, to rinse, to flush, to develop (a film), t"
    },
    {
      "character": "抽",
      "zhuyin": "ㄔㄡ",
      "pinyin": "chōu",
      "english": "to draw out, to pull out from in between, to remove part of the whole, (of certain plants) to sprout"
    },
    {
      "character": "串",
      "zhuyin": "ㄔㄨㄢˋ",
      "pinyin": "chuàn",
      "english": "to string together, to skewer, to connect wrongly, to gang up, to rove, string, bunch, skewer, class"
    },
    {
      "character": "喘",
      "zhuyin": "ㄔㄨㄢˇ",
      "pinyin": "chuǎn",
      "english": "to gasp, to pant, asthma"
    },
    {
      "character": "闖",
      "zhuyin": "ㄔㄨㄤˇ",
      "pinyin": "chuǎng",
      "english": "to rush, to charge, to dash, to break through, to temper oneself (through battling hardships)"
    },
    {
      "character": "純",
      "zhuyin": "ㄔㄨㄣˊ",
      "pinyin": "chún",
      "english": "pure, simple, unmixed, genuine"
    },
    {
      "character": "刺",
      "zhuyin": "ㄘˋ",
      "pinyin": "cì",
      "english": "thorn, sting, thrust, to prick, to pierce, to stab, to assassinate, to murder"
    },
    {
      "character": "此",
      "zhuyin": "ㄘˇ",
      "pinyin": "cǐ",
      "english": "this, these"
    },
    {
      "character": "催",
      "zhuyin": "ㄘㄨㄟ",
      "pinyin": "cuī",
      "english": "to urge, to press, to prompt, to rush sb, to hasten sth, to expedite"
    },
    {
      "character": "吋",
      "zhuyin": "ㄘㄨㄣˋ",
      "pinyin": "cùn",
      "english": "inch (English)"
    },
    {
      "character": "寸",
      "zhuyin": "ㄘㄨㄣˋ",
      "pinyin": "cùn",
      "english": "a unit of length, inch, thumb"
    },
    {
      "character": "待",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dài",
      "english": "to wait, to treat, to deal with, to need, going to (do sth), about to, intending to"
    },
    {
      "character": "呆",
      "zhuyin": "ㄉㄞ",
      "pinyin": "dāi",
      "english": "foolish, stupid, expressionless, blank, to stay"
    },
    {
      "character": "膽",
      "zhuyin": "ㄉㄢˇ",
      "pinyin": "dǎn",
      "english": "gall bladder, courage, guts, gall, inner container (e.g. bladder of a football, inner container of a"
    },
    {
      "character": "單",
      "zhuyin": "ㄉㄢ",
      "pinyin": "dān",
      "english": "bill, list, form, single, only, sole, odd number, CL:個|个[ge4]"
    },
    {
      "character": "擋",
      "zhuyin": "ㄉㄤˇ",
      "pinyin": "dǎng",
      "english": "to resist, to obstruct, to hinder, to keep off, to block (a blow), to get in the way of, cover, gear"
    },
    {
      "character": "瞪",
      "zhuyin": "ㄉㄥˋ",
      "pinyin": "dèng",
      "english": "to open (one's eyes) wide, to stare at, to glare at"
    },
    {
      "character": "遞",
      "zhuyin": "ㄉㄧˋ",
      "pinyin": "dì",
      "english": "to hand over, to pass on, to deliver, (bound form) progressively, in the proper order"
    },
    {
      "character": "滴",
      "zhuyin": "ㄉㄧ",
      "pinyin": "dī",
      "english": "a drop, to drip"
    },
    {
      "character": "調",
      "zhuyin": "ㄊㄧㄠˊ",
      "pinyin": "tiáo",
      "english": "to harmonize, to reconcile, to blend, to suit well, to adjust, to regulate, to season (food), to pro"
    },
    {
      "character": "釣",
      "zhuyin": "ㄉㄧㄠˋ",
      "pinyin": "diào",
      "english": "to fish with a hook and bait"
    },
    {
      "character": "碟",
      "zhuyin": "ㄉㄧㄝˊ",
      "pinyin": "dié",
      "english": "dish, plate"
    },
    {
      "character": "跌",
      "zhuyin": "ㄉㄧㄝˊ",
      "pinyin": "dié",
      "english": "to fall, to tumble, to trip, (of prices etc) to drop, Taiwan pr. [die2]"
    },
    {
      "character": "頂",
      "zhuyin": "ㄉㄧㄥˇ",
      "pinyin": "dǐng",
      "english": "apex, crown of the head, top, roof, most, to carry on the head, to push to the top, to go against, t"
    },
    {
      "character": "叮",
      "zhuyin": "ㄉㄧㄥ",
      "pinyin": "dīng",
      "english": "to sting or bite (of mosquito, bee etc), to say repeatedly, to urge insistently, to ask repeatedly, "
    },
    {
      "character": "盯",
      "zhuyin": "ㄉㄧㄥ",
      "pinyin": "dīng",
      "english": "to watch attentively, to fix one's attention on, to stare at, to gaze at"
    },
    {
      "character": "凍",
      "zhuyin": "ㄉㄨㄥˋ",
      "pinyin": "dòng",
      "english": "to freeze, to feel very cold, aspic or jelly"
    },
    {
      "character": "賭",
      "zhuyin": "ㄉㄨˇ",
      "pinyin": "dǔ",
      "english": "to bet, to gamble"
    },
    {
      "character": "斷",
      "zhuyin": "ㄉㄨㄢˋ",
      "pinyin": "duàn",
      "english": "to break, to snap, to cut off, to give up or abstain from sth, to judge, (usu. used in the negative)"
    },
    {
      "character": "蹲",
      "zhuyin": "ㄉㄨㄣ",
      "pinyin": "dūn",
      "english": "to crouch, to squat, to stay (somewhere)"
    },
    {
      "character": "鵝",
      "zhuyin": "ㄜˊ",
      "pinyin": "é",
      "english": "goose, CL:隻|只[zhi1]"
    },
    {
      "character": "而",
      "zhuyin": "ㄦˊ",
      "pinyin": "ér",
      "english": "and, as well as, and so, but (not), yet (not), (indicates causal relation), (indicates change of sta"
    },
    {
      "character": "罰",
      "zhuyin": "ㄈㄚˊ",
      "pinyin": "fá",
      "english": "to punish, to penalize"
    },
    {
      "character": "番",
      "zhuyin": "ㄈㄢ",
      "pinyin": "fān",
      "english": "foreign (non-Chinese), barbarian, classifier for occurrences (of an event, action or speech utteranc"
    },
    {
      "character": "肥",
      "zhuyin": "ㄈㄟˊ",
      "pinyin": "féi",
      "english": "fat, fertile, loose-fitting or large, to fertilize, to become rich by illegal means, fertilizer, man"
    },
    {
      "character": "肺",
      "zhuyin": "ㄈㄟˋ",
      "pinyin": "fèi",
      "english": "lung, CL:個|个[ge4]"
    },
    {
      "character": "非",
      "zhuyin": "ㄈㄟ",
      "pinyin": "fēi",
      "english": "to not be, not, wrong, incorrect, non-, un-, in-, de-, to reproach, to blame, (coll.) to insist on, "
    },
    {
      "character": "縫",
      "zhuyin": "ㄈㄥˋ",
      "pinyin": "fèng",
      "english": "seam, crack, narrow slit, CL:道[dao4]"
    },
    {
      "character": "逢",
      "zhuyin": "ㄈㄥˊ",
      "pinyin": "féng",
      "english": "to meet by chance, to come across, (of a calendar event) to come along, (of an event) to fall on (a "
    },
    {
      "character": "佛",
      "zhuyin": "ㄈㄛˊ",
      "pinyin": "fó",
      "english": "Buddha, Buddhism (abbr. for 佛陀[Fo2 tuo2])"
    },
    {
      "character": "扶",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "fú",
      "english": "to support with the hand, to help sb up, to support oneself by holding onto something, to help"
    },
    {
      "character": "浮",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "fú",
      "english": "to float, superficial, floating, unstable, movable, provisional, temporary, transient, impetuous, ho"
    },
    {
      "character": "副",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fù",
      "english": "secondary, auxiliary, deputy, assistant, vice-, abbr. for 副詞|副词 adverb, classifier for pairs, sets o"
    },
    {
      "character": "腹",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fù",
      "english": "abdomen, stomach, belly"
    },
    {
      "character": "負",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fù",
      "english": "to bear, to carry (on one's back), to turn one's back on, to be defeated, negative (math. etc)"
    },
    {
      "character": "幹",
      "zhuyin": "ㄍㄢˋ",
      "pinyin": "gàn",
      "english": "tree trunk, main part of sth, to manage, to work, to do, capable, cadre, to kill (slang), to fuck (v"
    },
    {
      "character": "肝",
      "zhuyin": "ㄍㄢ",
      "pinyin": "gān",
      "english": "liver, CL:葉|叶[ye4], 個|个[ge4], (slang) to put in long hours, typically late into the night, playing ("
    },
    {
      "character": "告",
      "zhuyin": "ㄍㄠˋ",
      "pinyin": "gào",
      "english": "to say, to tell, to announce, to report, to denounce, to file a lawsuit, to sue"
    },
    {
      "character": "搞",
      "zhuyin": "ㄍㄠˇ",
      "pinyin": "gǎo",
      "english": "to do, to make, to go in for, to set up, to get hold of, to take care of"
    },
    {
      "character": "格",
      "zhuyin": "ㄍㄜˊ",
      "pinyin": "gé",
      "english": "square, frame, rule, (legal) case, style, character, standard, pattern, (grammar) case, (classical) "
    },
    {
      "character": "隔",
      "zhuyin": "ㄍㄜˊ",
      "pinyin": "gé",
      "english": "to separate, to partition, to stand or lie between, at a distance from, after or at an interval of"
    },
    {
      "character": "割",
      "zhuyin": "ㄍㄜ",
      "pinyin": "gē",
      "english": "to cut, to cut apart"
    },
    {
      "character": "鼓",
      "zhuyin": "ㄍㄨˇ",
      "pinyin": "gǔ",
      "english": "drum, CL:通[tong4], 面[mian4], to drum, to strike, to rouse, to bulge, to swell"
    },
    {
      "character": "刮",
      "zhuyin": "ㄍㄨㄚ",
      "pinyin": "guā",
      "english": "to scrape, to blow, to shave, to plunder, to extort"
    },
    {
      "character": "廣",
      "zhuyin": "ㄍㄨㄤˇ",
      "pinyin": "guǎng",
      "english": "wide, numerous, to spread"
    },
    {
      "character": "跪",
      "zhuyin": "ㄍㄨㄟˋ",
      "pinyin": "guì",
      "english": "to kneel"
    },
    {
      "character": "滾",
      "zhuyin": "ㄍㄨㄣˇ",
      "pinyin": "gǔn",
      "english": "to boil, to roll, to take a hike, Get lost!"
    },
    {
      "character": "含",
      "zhuyin": "ㄏㄢˊ",
      "pinyin": "hán",
      "english": "to keep in the mouth, to contain"
    },
    {
      "character": "合",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "hé",
      "english": "to close, to join, to fit, to be equal to, whole, together, round (in battle), conjunction (astronom"
    },
    {
      "character": "嘿",
      "zhuyin": "ㄏㄟ",
      "pinyin": "hēi",
      "english": "hey"
    },
    {
      "character": "橫",
      "zhuyin": "ㄏㄥˋ",
      "pinyin": "hèng",
      "english": "harsh and unreasonable, unexpected"
    },
    {
      "character": "哼",
      "zhuyin": "ㄏㄥ",
      "pinyin": "hēng",
      "english": "to groan, to snort, to hum, to croon, humph!"
    },
    {
      "character": "壺",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "hú",
      "english": "pot, classifier for bottled liquid"
    },
    {
      "character": "戶",
      "zhuyin": "ㄏㄨˋ",
      "pinyin": "hù",
      "english": "a household, door, family"
    },
    {
      "character": "划",
      "zhuyin": "ㄏㄨㄚˊ",
      "pinyin": "huá",
      "english": "to row, to paddle, profitable, worth (the effort), it pays (to do sth)"
    },
    {
      "character": "劃",
      "zhuyin": "ㄏㄨㄚˋ",
      "pinyin": "huà",
      "english": "to delimit, to transfer, to assign, to plan, to draw (a line), stroke of a Chinese character"
    },
    {
      "character": "揮",
      "zhuyin": "ㄏㄨㄟ",
      "pinyin": "huī",
      "english": "to wave, to brandish, to command, to conduct, to scatter, to disperse"
    },
    {
      "character": "灰",
      "zhuyin": "ㄏㄨㄟ",
      "pinyin": "huī",
      "english": "ash, dust, lime, gray, discouraged, dejected"
    },
    {
      "character": "混",
      "zhuyin": "ㄏㄨㄣˋ",
      "pinyin": "hùn",
      "english": "to mix, to mingle, muddled, to drift along, to muddle along, to pass for, to get along with sb, thou"
    },
    {
      "character": "昏",
      "zhuyin": "ㄏㄨㄣ",
      "pinyin": "hūn",
      "english": "muddle-headed, twilight, to faint, to lose consciousness"
    },
    {
      "character": "葷",
      "zhuyin": "ㄏㄨㄣ",
      "pinyin": "hūn",
      "english": "strong-smelling vegetable (garlic etc), non-vegetarian food (meat, fish etc), vulgar, obscene"
    },
    {
      "character": "計",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "to calculate, to compute, to count, to regard as important, to plan, ruse, meter, gauge"
    },
    {
      "character": "繫",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "to tie, to fasten, to button up"
    },
    {
      "character": "夾",
      "zhuyin": "ㄐㄧㄚˊ",
      "pinyin": "jiá",
      "english": "to press from either side, to place in between, to sandwich, to carry sth under armpit, wedged betwe"
    },
    {
      "character": "佳",
      "zhuyin": "ㄐㄧㄚ",
      "pinyin": "jiā",
      "english": "beautiful, fine, good"
    },
    {
      "character": "劍",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiàn",
      "english": "double-edged sword, CL:口[kou3], 把[ba3], classifier for blows of a sword"
    },
    {
      "character": "箭",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiàn",
      "english": "arrow, CL:支[zhi1]"
    },
    {
      "character": "撿",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "jiǎn",
      "english": "to pick up, to collect, to gather"
    },
    {
      "character": "降",
      "zhuyin": "ㄒㄧㄤˊ",
      "pinyin": "xiáng",
      "english": "to surrender, to capitulate, to subdue, to tame"
    },
    {
      "character": "薑",
      "zhuyin": "ㄐㄧㄤ",
      "pinyin": "jiāng",
      "english": "ginger"
    },
    {
      "character": "將",
      "zhuyin": "ㄐㄧㄤ",
      "pinyin": "jiāng",
      "english": "will, shall, to use, to take, to checkmate, just a short while ago, (introduces object of main verb,"
    },
    {
      "character": "攪",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎo",
      "english": "to disturb, to annoy, to mix, to stir"
    },
    {
      "character": "角",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎo",
      "english": "angle, corner, horn, horn-shaped, unit of money equal to 0.1 yuan, or 10 cents (a dime), CL:個|个[ge4]"
    },
    {
      "character": "結",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jié",
      "english": "knot, sturdy, bond, to tie, to bind, to check out (of a hotel)"
    },
    {
      "character": "屆",
      "zhuyin": "ㄐㄧㄝˋ",
      "pinyin": "jiè",
      "english": "to arrive at (place or time), period, to become due, classifier for events, meetings, elections, spo"
    },
    {
      "character": "戒",
      "zhuyin": "ㄐㄧㄝˋ",
      "pinyin": "jiè",
      "english": "to guard against, to exhort, to admonish or warn, to give up or stop doing sth, Buddhist monastic di"
    },
    {
      "character": "皆",
      "zhuyin": "ㄐㄧㄝ",
      "pinyin": "jiē",
      "english": "all, each and every, in all cases"
    },
    {
      "character": "盡",
      "zhuyin": "ㄐㄧㄣˋ",
      "pinyin": "jìn",
      "english": "to use up, to exhaust, to end, to finish, to the utmost, exhausted, finished, to the limit (of sth),"
    },
    {
      "character": "井",
      "zhuyin": "ㄐㄧㄥˇ",
      "pinyin": "jǐng",
      "english": "a well, CL:口[kou3], neat, orderly"
    },
    {
      "character": "局",
      "zhuyin": "ㄐㄩˊ",
      "pinyin": "jú",
      "english": "office, situation, classifier for games: match, set, round etc"
    },
    {
      "character": "捲",
      "zhuyin": "ㄐㄩㄢˇ",
      "pinyin": "juǎn",
      "english": "to roll up, to sweep up, to carry along, a roll, classifier for rolls, spools etc"
    },
    {
      "character": "捐",
      "zhuyin": "ㄐㄩㄢ",
      "pinyin": "juān",
      "english": "to relinquish, to abandon, to contribute, to donate, (bound form) tax, levy"
    },
    {
      "character": "卷",
      "zhuyin": "ㄐㄩㄢˇ",
      "pinyin": "juǎn",
      "english": "to roll up, roll, classifier for small rolled things (wad of paper money, movie reel etc)"
    },
    {
      "character": "軍",
      "zhuyin": "ㄐㄩㄣ",
      "pinyin": "jūn",
      "english": "(bound form) army, military"
    },
    {
      "character": "卡",
      "zhuyin": "ㄎㄚˇ",
      "pinyin": "kǎ",
      "english": "to stop, to block, (computing) (coll.) slow, (loanword) card, CL:張|张[zhang1], 片[pian4], truck (from "
    },
    {
      "character": "刻",
      "zhuyin": "ㄎㄜˋ",
      "pinyin": "kè",
      "english": "quarter (hour), moment, to carve, to engrave, to cut, oppressive, classifier for short time interval"
    },
    {
      "character": "客",
      "zhuyin": "ㄎㄜˋ",
      "pinyin": "kè",
      "english": "customer, visitor, guest"
    },
    {
      "character": "科",
      "zhuyin": "ㄎㄜ",
      "pinyin": "kē",
      "english": "branch of study, administrative section, division, field, branch, stage directions, family (taxonomy"
    },
    {
      "character": "跨",
      "zhuyin": "ㄎㄨㄚˋ",
      "pinyin": "kuà",
      "english": "to step across, to stride over, to straddle, to span"
    },
    {
      "character": "垮",
      "zhuyin": "ㄎㄨㄚˇ",
      "pinyin": "kuǎ",
      "english": "to collapse (lit. or fig.)"
    },
    {
      "character": "狂",
      "zhuyin": "ㄎㄨㄤˊ",
      "pinyin": "kuáng",
      "english": "mad, wild, violent"
    },
    {
      "character": "困",
      "zhuyin": "ㄎㄨㄣˋ",
      "pinyin": "kùn",
      "english": "to trap, to surround, hard-pressed, stranded, destitute"
    },
    {
      "character": "攔",
      "zhuyin": "ㄌㄢˊ",
      "pinyin": "lán",
      "english": "to block sb's path, to obstruct, to flag down (a taxi)"
    },
    {
      "character": "爛",
      "zhuyin": "ㄌㄢˋ",
      "pinyin": "làn",
      "english": "soft, mushy, well-cooked and soft, to rot, to decompose, rotten, worn out, chaotic, messy, utterly, "
    },
    {
      "character": "狼",
      "zhuyin": "ㄌㄤˊ",
      "pinyin": "láng",
      "english": "wolf, CL:匹[pi3], 隻|只[zhi1], 條|条[tiao2]"
    },
    {
      "character": "雷",
      "zhuyin": "ㄌㄟˊ",
      "pinyin": "léi",
      "english": "thunder, (bound form) (military) mine, as in 地雷[di4 lei2] land mine, (coll.) to shock, to stun, to a"
    },
    {
      "character": "梨",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "lí",
      "english": "pear, CL:個|个[ge4]"
    },
    {
      "character": "利",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lì",
      "english": "sharp, favorable, advantage, benefit, profit, interest, to do good to, to benefit"
    },
    {
      "character": "粒",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lì",
      "english": "grain, granule, classifier for small round things (peas, bullets, peanuts, pills, grains etc)"
    },
    {
      "character": "哩",
      "zhuyin": "ㄌㄧ",
      "pinyin": "lī",
      "english": "(modal final particle similar to 呢[ne5] or 啦[la5])"
    },
    {
      "character": "裂",
      "zhuyin": "ㄌㄧㄝˋ",
      "pinyin": "liè",
      "english": "to split, to crack, to break open, to rend"
    },
    {
      "character": "淋",
      "zhuyin": "ㄌㄧㄣˊ",
      "pinyin": "lín",
      "english": "to sprinkle, to drip, to pour, to drench"
    },
    {
      "character": "令",
      "zhuyin": "ㄌㄧㄥˋ",
      "pinyin": "lìng",
      "english": "to order, to command, an order, warrant, writ, to cause, to make sth happen, virtuous, honorific tit"
    },
    {
      "character": "籠",
      "zhuyin": "ㄌㄨㄥˊ",
      "pinyin": "lóng",
      "english": "enclosing frame made of bamboo, wire etc, cage, basket, steamer basket, to cover, to cage, to embrac"
    },
    {
      "character": "露",
      "zhuyin": "ㄌㄡˋ",
      "pinyin": "lòu",
      "english": "to show, to reveal, to betray, to expose"
    },
    {
      "character": "錄",
      "zhuyin": "ㄌㄨˋ",
      "pinyin": "lù",
      "english": "diary, record, to hit, to copy"
    },
    {
      "character": "鹿",
      "zhuyin": "ㄌㄨˋ",
      "pinyin": "lù",
      "english": "deer"
    },
    {
      "character": "滷",
      "zhuyin": "ㄌㄨˇ",
      "pinyin": "lǔ",
      "english": "to stew in soy sauce and spices"
    },
    {
      "character": "輪",
      "zhuyin": "ㄌㄨㄣˊ",
      "pinyin": "lún",
      "english": "wheel, disk, ring, steamship, to take turns, to rotate, classifier for big round objects: disk, or r"
    },
    {
      "character": "落",
      "zhuyin": "ㄌㄨㄛˋ",
      "pinyin": "luò",
      "english": "to fall or drop, (of the sun) to set, (of a tide) to go out, to lower, to decline or sink, to lag or"
    },
    {
      "character": "埋",
      "zhuyin": "ㄇㄞˊ",
      "pinyin": "mái",
      "english": "to bury"
    },
    {
      "character": "冒",
      "zhuyin": "ㄇㄠˋ",
      "pinyin": "mào",
      "english": "to emit, to give off, to send out (or up, forth), to brave, to face, reckless, to falsely adopt (sb'"
    },
    {
      "character": "梅",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "méi",
      "english": "plum, plum flower, Japanese apricot (Prunus mume)"
    },
    {
      "character": "悶",
      "zhuyin": "ㄇㄣˋ",
      "pinyin": "mèn",
      "english": "bored, depressed, melancholy, sealed, airtight, tightly closed"
    },
    {
      "character": "猛",
      "zhuyin": "ㄇㄥˇ",
      "pinyin": "měng",
      "english": "ferocious, fierce, violent, brave, suddenly, abrupt, (slang) awesome"
    },
    {
      "character": "謎",
      "zhuyin": "ㄇㄧˊ",
      "pinyin": "mí",
      "english": "riddle"
    },
    {
      "character": "免",
      "zhuyin": "ㄇㄧㄢˇ",
      "pinyin": "miǎn",
      "english": "to excuse sb, to exempt, to remove or dismiss from office, to avoid, to avert, to escape, to be proh"
    },
    {
      "character": "妙",
      "zhuyin": "ㄇㄧㄠˋ",
      "pinyin": "miào",
      "english": "clever, wonderful"
    },
    {
      "character": "廟",
      "zhuyin": "ㄇㄧㄠˋ",
      "pinyin": "miào",
      "english": "temple, ancestral shrine, CL:座[zuo4], temple fair, great imperial hall, imperial"
    },
    {
      "character": "墨",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "mò",
      "english": "ink stick, China ink, CL:塊|块[kuai4], corporal punishment consisting of tattooing characters on the v"
    },
    {
      "character": "抹",
      "zhuyin": "ㄇㄛˇ",
      "pinyin": "mǒ",
      "english": "to smear, to wipe, to erase, classifier for wisps of cloud, light-beams etc"
    },
    {
      "character": "磨",
      "zhuyin": "ㄇㄛˊ",
      "pinyin": "mó",
      "english": "to rub, to grind, to polish, to sharpen, to wear down, to die out, to waste time, to pester, to insi"
    },
    {
      "character": "某",
      "zhuyin": "ㄇㄡˇ",
      "pinyin": "mǒu",
      "english": "some, a certain, sb or sth indefinite, such-and-such"
    },
    {
      "character": "耐",
      "zhuyin": "ㄋㄞˋ",
      "pinyin": "nài",
      "english": "(bound form) to bear, to endure, to withstand"
    },
    {
      "character": "鬧",
      "zhuyin": "ㄋㄠˋ",
      "pinyin": "nào",
      "english": "noisy, cacophonous, to make noise, to disturb, to vent (feelings), to fall ill, to have an attack (o"
    },
    {
      "character": "黏",
      "zhuyin": "ㄋㄧㄢˊ",
      "pinyin": "nián",
      "english": "sticky, glutinous, (Tw) to adhere, to stick on, to glue"
    },
    {
      "character": "尿",
      "zhuyin": "ㄋㄧㄠˋ",
      "pinyin": "niào",
      "english": "to urinate, urine, CL:泡[pao1]"
    },
    {
      "character": "趴",
      "zhuyin": "ㄆㄚ",
      "pinyin": "pā",
      "english": "to lie on one's stomach, to lean forward, resting one's upper body (on a desktop etc), (Tw) percent"
    },
    {
      "character": "賠",
      "zhuyin": "ㄆㄟˊ",
      "pinyin": "péi",
      "english": "to compensate for loss, to indemnify, to suffer a financial loss"
    },
    {
      "character": "配",
      "zhuyin": "ㄆㄟˋ",
      "pinyin": "pèi",
      "english": "to join, to fit, to mate, to mix, to match, to deserve, to make up (a prescription), to allocate"
    },
    {
      "character": "盆",
      "zhuyin": "ㄆㄣˊ",
      "pinyin": "pén",
      "english": "basin, flower pot, unit of volume equal to 12 斗[dou3] and 8 升[sheng1], approx 128 liters, CL:個|个[ge4"
    },
    {
      "character": "噴",
      "zhuyin": "ㄆㄣ",
      "pinyin": "pēn",
      "english": "to spout, to spurt, to spray, to puff, (slang) to criticize scathingly (esp. online)"
    },
    {
      "character": "屁",
      "zhuyin": "ㄆㄧˋ",
      "pinyin": "pì",
      "english": "fart, flatulence, nonsense, (usu. in the negative) what, (not) a damn thing"
    },
    {
      "character": "批",
      "zhuyin": "ㄆㄧ",
      "pinyin": "pī",
      "english": "to ascertain, to act on, to criticize, to pass on, classifier for batches, lots, military flights, t"
    },
    {
      "character": "披",
      "zhuyin": "ㄆㄧ",
      "pinyin": "pī",
      "english": "to drape over one's shoulders, to open, to unroll, to split open, to spread out"
    },
    {
      "character": "偏",
      "zhuyin": "ㄆㄧㄢ",
      "pinyin": "piān",
      "english": "to lean, to slant, oblique, prejudiced, to deviate from average, to stray from the intended line, st"
    },
    {
      "character": "飄",
      "zhuyin": "ㄆㄧㄠ",
      "pinyin": "piāo",
      "english": "to float (in the air), to flutter, to waft, complacent, frivolous, weak, shaky, wobbly"
    },
    {
      "character": "坪",
      "zhuyin": "ㄆㄧㄥˊ",
      "pinyin": "píng",
      "english": "a plain, ping, unit of area equal to approx. 3.3058 square meters (used in Japan and Taiwan)"
    },
    {
      "character": "憑",
      "zhuyin": "ㄆㄧㄥˊ",
      "pinyin": "píng",
      "english": "to lean against, to rely on, on the basis of, no matter (how, what etc), proof"
    },
    {
      "character": "潑",
      "zhuyin": "ㄆㄛ",
      "pinyin": "pō",
      "english": "to splash, to spill, rough and coarse, brutish"
    },
    {
      "character": "棋",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qí",
      "english": "chess, chess-like game, a game of chess, CL:盤|盘[pan2], chess piece, CL:個|个[ge4], 顆|颗[ke1]"
    },
    {
      "character": "欠",
      "zhuyin": "ㄑㄧㄢˋ",
      "pinyin": "qiàn",
      "english": "to owe, to lack, (literary) to be deficient in, (bound form) yawn, to raise slightly (a part of one'"
    },
    {
      "character": "牽",
      "zhuyin": "ㄑㄧㄢ",
      "pinyin": "qiān",
      "english": "to lead along, to pull (an animal on a tether), (bound form) to involve, to draw in"
    },
    {
      "character": "瞧",
      "zhuyin": "ㄑㄧㄠˊ",
      "pinyin": "qiáo",
      "english": "to look at, to see, to see (a doctor), to visit"
    },
    {
      "character": "巧",
      "zhuyin": "ㄑㄧㄠˇ",
      "pinyin": "qiǎo",
      "english": "opportunely, coincidentally, as it happens, skillful, timely"
    },
    {
      "character": "琴",
      "zhuyin": "ㄑㄧㄣˊ",
      "pinyin": "qín",
      "english": "guqin 古琴[gu3 qin2] (a type of zither), musical instrument in general"
    },
    {
      "character": "親",
      "zhuyin": "ㄑㄧㄣ",
      "pinyin": "qīn",
      "english": "parent, one's own (flesh and blood), relative, related, marriage, bride, close, intimate, in person,"
    },
    {
      "character": "娶",
      "zhuyin": "ㄑㄩˇ",
      "pinyin": "qǔ",
      "english": "to take a wife, to marry (a woman)"
    },
    {
      "character": "曲",
      "zhuyin": "ㄑㄩ",
      "pinyin": "qū",
      "english": "bent, crooked, wrong"
    },
    {
      "character": "拳",
      "zhuyin": "ㄑㄩㄢˊ",
      "pinyin": "quán",
      "english": "fist, boxing"
    },
    {
      "character": "圈",
      "zhuyin": "ㄐㄩㄢˋ",
      "pinyin": "juàn",
      "english": "livestock enclosure, pen, fold, sty"
    },
    {
      "character": "染",
      "zhuyin": "ㄖㄢˇ",
      "pinyin": "rǎn",
      "english": "to dye, to catch (a disease), to acquire (bad habits etc), to contaminate, to add color washes to a "
    },
    {
      "character": "繞",
      "zhuyin": "ㄖㄠˋ",
      "pinyin": "rào",
      "english": "to wind, to coil (thread), to rotate around, to spiral, to move around, to go round (an obstacle), t"
    },
    {
      "character": "任",
      "zhuyin": "ㄖㄣˋ",
      "pinyin": "rèn",
      "english": "to assign, to appoint, to take up a post, office, responsibility, to let, to allow, to give free rei"
    },
    {
      "character": "揉",
      "zhuyin": "ㄖㄡˊ",
      "pinyin": "róu",
      "english": "to knead, to massage, to rub"
    },
    {
      "character": "塞",
      "zhuyin": "ㄙㄞ",
      "pinyin": "sāi",
      "english": "to stop up, to squeeze in, to stuff, cork, stopper"
    },
    {
      "character": "散",
      "zhuyin": "ㄙㄢˇ",
      "pinyin": "sǎn",
      "english": "scattered, loose, to come loose, to fall apart, leisurely, powdered medicine"
    },
    {
      "character": "艘",
      "zhuyin": "ㄙㄠ",
      "pinyin": "sāo",
      "english": "classifier for ships, Taiwan pr. [sao1]"
    },
    {
      "character": "傻",
      "zhuyin": "ㄕㄚˇ",
      "pinyin": "shǎ",
      "english": "foolish"
    },
    {
      "character": "晒",
      "zhuyin": "ㄕㄞˋ",
      "pinyin": "shài",
      "english": "(of the sun) to shine on, to bask in (the sunshine), to dry (clothes, grain etc) in the sun, (fig.) "
    },
    {
      "character": "閃",
      "zhuyin": "ㄕㄢˇ",
      "pinyin": "shǎn",
      "english": "to dodge, to duck out of the way, to beat it, shaken (by a fall), to sprain, to pull a muscle, light"
    },
    {
      "character": "扇",
      "zhuyin": "ㄕㄢ",
      "pinyin": "shān",
      "english": "to fan, to slap sb on the face"
    },
    {
      "character": "賞",
      "zhuyin": "ㄕㄤˇ",
      "pinyin": "shǎng",
      "english": "to bestow (a reward), to give (to an inferior), to hand down, a reward (bestowed by a superior), to "
    },
    {
      "character": "蛇",
      "zhuyin": "ㄕㄜˊ",
      "pinyin": "shé",
      "english": "snake, serpent, CL:條|条[tiao2]"
    },
    {
      "character": "射",
      "zhuyin": "ㄕㄜˋ",
      "pinyin": "shè",
      "english": "to shoot, to launch, to allude to, radio- (chemistry)"
    },
    {
      "character": "升",
      "zhuyin": "ㄕㄥ",
      "pinyin": "shēng",
      "english": "to ascend, to rise to the rank of, to promote, to hoist, liter, measure for dry grain equal to one-t"
    },
    {
      "character": "使",
      "zhuyin": "ㄕˇ",
      "pinyin": "shǐ",
      "english": "to make, to cause, to enable, to use, to employ, to send, to instruct sb to do sth, envoy, messenger"
    },
    {
      "character": "詩",
      "zhuyin": "ㄕ",
      "pinyin": "shī",
      "english": "poem, CL:首[shou3], poetry, verse"
    },
    {
      "character": "售",
      "zhuyin": "ㄕㄡˋ",
      "pinyin": "shòu",
      "english": "to sell, to make or carry out (a plan or intrigue etc)"
    },
    {
      "character": "束",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "shù",
      "english": "to bind, bunch, bundle, classifier for bunches, bundles, beams of light etc, to control"
    },
    {
      "character": "屬",
      "zhuyin": "ㄕㄨˇ",
      "pinyin": "shǔ",
      "english": "category, genus (taxonomy), family members, dependents, to belong to, subordinate to, affiliated wit"
    },
    {
      "character": "梳",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shū",
      "english": "to comb, (bound form) a comb"
    },
    {
      "character": "摔",
      "zhuyin": "ㄕㄨㄞ",
      "pinyin": "shuāi",
      "english": "to throw down, to fall, to drop and break"
    },
    {
      "character": "稅",
      "zhuyin": "ㄕㄨㄟˋ",
      "pinyin": "shuì",
      "english": "taxes, duties"
    },
    {
      "character": "順",
      "zhuyin": "ㄕㄨㄣˋ",
      "pinyin": "shùn",
      "english": "to obey, to follow, to arrange, to make reasonable, along, favorable"
    },
    {
      "character": "寺",
      "zhuyin": "ㄙˋ",
      "pinyin": "sì",
      "english": "Buddhist temple, mosque, government office (old)"
    },
    {
      "character": "碎",
      "zhuyin": "ㄙㄨㄟˋ",
      "pinyin": "suì",
      "english": "(transitive or intransitive verb) to break into pieces, to shatter, to crumble, broken, fragmentary,"
    },
    {
      "character": "踏",
      "zhuyin": "ㄊㄚˋ",
      "pinyin": "tà",
      "english": "to tread, to stamp, to step on, to press a pedal, to investigate on the spot"
    },
    {
      "character": "塔",
      "zhuyin": "ㄊㄚˇ",
      "pinyin": "tǎ",
      "english": "pagoda, tower, minaret, stupa (abbr. loanword from Sanskrit tapo), CL:座[zuo4]"
    },
    {
      "character": "塌",
      "zhuyin": "ㄊㄚ",
      "pinyin": "tā",
      "english": "to collapse, to droop, to settle down"
    },
    {
      "character": "嘆",
      "zhuyin": "ㄊㄢˋ",
      "pinyin": "tàn",
      "english": "to sigh, to exclaim"
    },
    {
      "character": "炭",
      "zhuyin": "ㄊㄢˋ",
      "pinyin": "tàn",
      "english": "wood charcoal, coal"
    },
    {
      "character": "貪",
      "zhuyin": "ㄊㄢ",
      "pinyin": "tān",
      "english": "to have a voracious desire for, to covet, greedy, corrupt"
    },
    {
      "character": "堂",
      "zhuyin": "ㄊㄤˊ",
      "pinyin": "táng",
      "english": "(main) hall, large room for a specific purpose, CL:間|间[jian1], relationship between cousins etc on t"
    },
    {
      "character": "討",
      "zhuyin": "ㄊㄠˇ",
      "pinyin": "tǎo",
      "english": "to invite, to provoke, to demand or ask for, to send armed forces to suppress, to denounce or condem"
    },
    {
      "character": "添",
      "zhuyin": "ㄊㄧㄢ",
      "pinyin": "tiān",
      "english": "to add, to increase, to replenish"
    },
    {
      "character": "挺",
      "zhuyin": "ㄊㄧㄥˇ",
      "pinyin": "tǐng",
      "english": "straight, erect, to stick out (a part of the body), to (physically) straighten up, to support, to wi"
    },
    {
      "character": "銅",
      "zhuyin": "ㄊㄨㄥˊ",
      "pinyin": "tóng",
      "english": "copper (chemistry), see also 紅銅|红铜[hong2 tong2], CL:塊|块[kuai4]"
    },
    {
      "character": "桶",
      "zhuyin": "ㄊㄨㄥˇ",
      "pinyin": "tǒng",
      "english": "bucket, (trash) can, barrel (of oil etc), CL:個|个[ge4], 隻|只[zhi1]"
    },
    {
      "character": "透",
      "zhuyin": "ㄊㄡˋ",
      "pinyin": "tòu",
      "english": "(bound form) to penetrate, to seep through, to tell secretly, to leak, thoroughly, through and throu"
    },
    {
      "character": "塗",
      "zhuyin": "ㄊㄨˊ",
      "pinyin": "tú",
      "english": "to apply (paint etc), to smear, to daub, to blot out, to scribble, to scrawl, (literary) mud, street"
    },
    {
      "character": "吞",
      "zhuyin": "ㄊㄨㄣ",
      "pinyin": "tūn",
      "english": "to swallow, to take"
    },
    {
      "character": "拖",
      "zhuyin": "ㄊㄨㄛ",
      "pinyin": "tuō",
      "english": "to drag, to tow, to trail, to hang down, to mop (the floor), to delay, to drag on"
    },
    {
      "character": "彎",
      "zhuyin": "ㄨㄢ",
      "pinyin": "wān",
      "english": "to bend, bent, a bend, a turn (in a road etc), CL:道[dao4]"
    },
    {
      "character": "圍",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéi",
      "english": "to encircle, to surround, all around, to wear by wrapping around (scarf, shawl)"
    },
    {
      "character": "未",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "wèi",
      "english": "not yet, did not, have not, not, 8th earthly branch: 1-3 p.m., 6th solar month (7th July-6th August)"
    },
    {
      "character": "胃",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "wèi",
      "english": "stomach, CL:個|个[ge4]"
    },
    {
      "character": "吻",
      "zhuyin": "ㄨㄣˇ",
      "pinyin": "wěn",
      "english": "kiss, to kiss, mouth"
    },
    {
      "character": "穩",
      "zhuyin": "ㄨㄣˇ",
      "pinyin": "wěn",
      "english": "settled, steady, stable"
    },
    {
      "character": "窩",
      "zhuyin": "ㄨㄛ",
      "pinyin": "wō",
      "english": "nest, pit or hollow on the human body, lair, den, place, to harbor or shelter, to hold in check, to "
    },
    {
      "character": "無",
      "zhuyin": "ㄨˊ",
      "pinyin": "wú",
      "english": "not to have, no, none, not, to lack, un-, -less"
    },
    {
      "character": "勿",
      "zhuyin": "ㄨˋ",
      "pinyin": "wù",
      "english": "do not"
    },
    {
      "character": "霧",
      "zhuyin": "ㄨˋ",
      "pinyin": "wù",
      "english": "fog, mist, CL:場|场[chang2], 陣|阵[zhen4]"
    },
    {
      "character": "溪",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xī",
      "english": "creek, rivulet"
    },
    {
      "character": "嫌",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "xián",
      "english": "to dislike, suspicion, resentment, enmity, abbr. for 嫌犯[xian2 fan4], criminal suspect"
    },
    {
      "character": "閒",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "xián",
      "english": "idle, unoccupied, leisure"
    },
    {
      "character": "縣",
      "zhuyin": "ㄒㄧㄢˋ",
      "pinyin": "xiàn",
      "english": "county"
    },
    {
      "character": "項",
      "zhuyin": "ㄒㄧㄤˋ",
      "pinyin": "xiàng",
      "english": "back of neck, item, thing, term (in a mathematical formula), sum (of money), classifier for principl"
    },
    {
      "character": "鄉",
      "zhuyin": "ㄒㄧㄤ",
      "pinyin": "xiāng",
      "english": "country or countryside, native place, home village or town, township (PRC administrative unit)"
    },
    {
      "character": "斜",
      "zhuyin": "ㄒㄧㄝˊ",
      "pinyin": "xié",
      "english": "inclined, slanting, oblique, tilting"
    },
    {
      "character": "雄",
      "zhuyin": "ㄒㄩㄥˊ",
      "pinyin": "xióng",
      "english": "male, staminate, grand, imposing, powerful, mighty, person or state having great power and influence"
    },
    {
      "character": "胸",
      "zhuyin": "ㄒㄩㄥ",
      "pinyin": "xiōng",
      "english": "chest, bosom, heart, mind, thorax"
    },
    {
      "character": "噓",
      "zhuyin": "ㄒㄩ",
      "pinyin": "xū",
      "english": "to exhale slowly, to hiss, hush!"
    },
    {
      "character": "沿",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "yán",
      "english": "along, to follow (a line, tradition etc), to carry on, to trim (a border with braid, tape etc), bord"
    },
    {
      "character": "癢",
      "zhuyin": "ㄧㄤˇ",
      "pinyin": "yǎng",
      "english": "to itch, to tickle"
    },
    {
      "character": "喲",
      "zhuyin": "ㄧㄠ",
      "pinyin": "yāo",
      "english": "(sentence-final particle expressing exhortation), (syllable filler in a song)"
    },
    {
      "character": "咦",
      "zhuyin": "ㄧˊ",
      "pinyin": "yí",
      "english": "expression of surprise"
    },
    {
      "character": "以",
      "zhuyin": "ㄧˇ",
      "pinyin": "yǐ",
      "english": "to use, by means of, according to, in order to, because of, at (a certain date or place)"
    },
    {
      "character": "印",
      "zhuyin": "ㄧㄣˋ",
      "pinyin": "yìn",
      "english": "to print, to mark, to engrave, a seal, a print, a stamp, a mark, a trace, image"
    },
    {
      "character": "癮",
      "zhuyin": "ㄧㄣˇ",
      "pinyin": "yǐn",
      "english": "addiction, craving"
    },
    {
      "character": "陰",
      "zhuyin": "ㄧㄣ",
      "pinyin": "yīn",
      "english": "overcast (weather), cloudy, shady, Yin (the negative principle of Yin and Yang), negative (electric."
    },
    {
      "character": "於",
      "zhuyin": "ㄩˊ",
      "pinyin": "yú",
      "english": "(of time or place) in, at, on, (indicating any indirect relation) to, toward, vis-à-vis, with regard"
    },
    {
      "character": "餘",
      "zhuyin": "ㄩˊ",
      "pinyin": "yú",
      "english": "extra, surplus, remaining, remainder after division, (following numerical value) or more, in excess "
    },
    {
      "character": "玉",
      "zhuyin": "ㄩˋ",
      "pinyin": "yù",
      "english": "jade"
    },
    {
      "character": "願",
      "zhuyin": "ㄩㄢˋ",
      "pinyin": "yuàn",
      "english": "to hope, to wish, to desire, hoped-for, ready, willing"
    },
    {
      "character": "暈",
      "zhuyin": "ㄩㄣˋ",
      "pinyin": "yùn",
      "english": "dizzy, halo, ring around moon or sun"
    },
    {
      "character": "雜",
      "zhuyin": "ㄗㄚˊ",
      "pinyin": "zá",
      "english": "mixed, miscellaneous, various, to mix"
    },
    {
      "character": "讚",
      "zhuyin": "ㄗㄢˋ",
      "pinyin": "zàn",
      "english": "to patronize, to support, to praise, (Internet slang) to like (an online post on Facebook etc)"
    },
    {
      "character": "則",
      "zhuyin": "ㄗㄜˊ",
      "pinyin": "zé",
      "english": "(literary) (conjunction used to express contrast with a previous clause) but, then, (bound form) sta"
    },
    {
      "character": "賊",
      "zhuyin": "ㄗㄟˊ",
      "pinyin": "zéi",
      "english": "thief, traitor, wily, deceitful, evil, extremely"
    },
    {
      "character": "窄",
      "zhuyin": "ㄓㄞˇ",
      "pinyin": "zhǎi",
      "english": "narrow, narrow-minded, badly off"
    },
    {
      "character": "摘",
      "zhuyin": "ㄓㄞ",
      "pinyin": "zhāi",
      "english": "to take, to pick (flowers, fruit etc), to pluck, to remove, to take off (glasses, hat etc), to selec"
    },
    {
      "character": "占",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "zhàn",
      "english": "to take possession of, to occupy, to take up"
    },
    {
      "character": "沾",
      "zhuyin": "ㄓㄢ",
      "pinyin": "zhān",
      "english": "to moisten, to be infected by, to receive benefit or advantage through a contact, to touch"
    },
    {
      "character": "丈",
      "zhuyin": "ㄓㄤˋ",
      "pinyin": "zhàng",
      "english": "measure of length, ten Chinese feet (3.3 m), to measure, husband, polite appellation for an older ma"
    },
    {
      "character": "漲",
      "zhuyin": "ㄓㄤˇ",
      "pinyin": "zhǎng",
      "english": "to rise (of prices, rivers)"
    },
    {
      "character": "折",
      "zhuyin": "ㄓㄜˊ",
      "pinyin": "zhé",
      "english": "to break, to fracture, to snap, to suffer loss, to bend, to twist, to turn, to change direction, con"
    },
    {
      "character": "鎮",
      "zhuyin": "ㄓㄣˋ",
      "pinyin": "zhèn",
      "english": "to press down, to calm, to subdue, to suppress, to guard, garrison, small town, to cool or chill (fo"
    },
    {
      "character": "針",
      "zhuyin": "ㄓㄣ",
      "pinyin": "zhēn",
      "english": "needle, pin, injection, stitch, CL:根[gen1], 支[zhi1]"
    },
    {
      "character": "蒸",
      "zhuyin": "ㄓㄥ",
      "pinyin": "zhēng",
      "english": "to evaporate, (of cooking) to steam, torch made from hemp stalks or bamboo (old), finely chopped fir"
    },
    {
      "character": "至",
      "zhuyin": "ㄓˋ",
      "pinyin": "zhì",
      "english": "to arrive, most, to, until"
    },
    {
      "character": "之",
      "zhuyin": "ㄓ",
      "pinyin": "zhī",
      "english": "(possessive particle, literary equivalent of 的[de5]), him, her, it"
    },
    {
      "character": "腫",
      "zhuyin": "ㄓㄨㄥˇ",
      "pinyin": "zhǒng",
      "english": "to swell, swelling, swollen"
    },
    {
      "character": "皺",
      "zhuyin": "ㄓㄡˋ",
      "pinyin": "zhòu",
      "english": "to wrinkle, wrinkled, to crease"
    },
    {
      "character": "周",
      "zhuyin": "ㄓㄡ",
      "pinyin": "zhōu",
      "english": "to make a circuit, to circle, circle, circumference, lap, cycle, complete, all, all over, thorough, "
    },
    {
      "character": "州",
      "zhuyin": "ㄓㄡ",
      "pinyin": "zhōu",
      "english": "prefecture, (old) province, (old) administrative division, state (e.g. of US), oblast (Russia), cant"
    },
    {
      "character": "粥",
      "zhuyin": "ㄓㄡ",
      "pinyin": "zhōu",
      "english": "congee, gruel, porridge, CL:碗[wan3]"
    },
    {
      "character": "壯",
      "zhuyin": "ㄓㄨㄤˋ",
      "pinyin": "zhuàng",
      "english": "to strengthen, strong, robust"
    },
    {
      "character": "撞",
      "zhuyin": "ㄓㄨㄤˋ",
      "pinyin": "zhuàng",
      "english": "to knock against, to bump into, to run into, to meet by accident"
    },
    {
      "character": "妝",
      "zhuyin": "ㄓㄨㄤ",
      "pinyin": "zhuāng",
      "english": "(of a woman) to adorn oneself, makeup, adornment, trousseau, stage makeup and costume"
    },
    {
      "character": "准",
      "zhuyin": "ㄓㄨㄣˇ",
      "pinyin": "zhǔn",
      "english": "to allow, to grant, in accordance with, in the light of"
    },
    {
      "character": "捉",
      "zhuyin": "ㄓㄨㄛ",
      "pinyin": "zhuō",
      "english": "to clutch, to grab, to capture"
    },
    {
      "character": "自",
      "zhuyin": "ㄗˋ",
      "pinyin": "zì",
      "english": "(bound form) self, oneself, from, since, naturally, as a matter of course"
    },
    {
      "character": "鑽",
      "zhuyin": "ㄗㄨㄢˋ",
      "pinyin": "zuàn",
      "english": "an auger, diamond"
    },
    {
      "character": "罪",
      "zhuyin": "ㄗㄨㄟˋ",
      "pinyin": "zuì",
      "english": "guilt, crime, fault, blame, sin"
    },
    {
      "character": "熬",
      "zhuyin": "ㄠˊ",
      "pinyin": "áo",
      "english": "to cook on a slow fire, to extract by heating, to decoct, to endure"
    },
    {
      "character": "板",
      "zhuyin": "ㄅㄢˇ",
      "pinyin": "bǎn",
      "english": "board, plank, plate, shutter, table tennis bat, clappers (music), CL:塊|块[kuai4], accented beat in Ch"
    },
    {
      "character": "斑",
      "zhuyin": "ㄅㄢ",
      "pinyin": "bān",
      "english": "spot, colored patch, stripe, spotted, striped, variegated"
    },
    {
      "character": "般",
      "zhuyin": "ㄅㄢ",
      "pinyin": "bān",
      "english": "sort, kind, class, way, manner"
    },
    {
      "character": "磅",
      "zhuyin": "ㄅㄤˋ",
      "pinyin": "bàng",
      "english": "scale (instrument for weighing), to weigh, (loanword) pound (unit of weight, about 454 grams), (prin"
    },
    {
      "character": "豹",
      "zhuyin": "ㄅㄠˋ",
      "pinyin": "bào",
      "english": "leopard, panther"
    },
    {
      "character": "崩",
      "zhuyin": "ㄅㄥ",
      "pinyin": "bēng",
      "english": "to collapse, to fall into ruins, death of king or emperor, demise"
    },
    {
      "character": "彼",
      "zhuyin": "ㄅㄧˇ",
      "pinyin": "bǐ",
      "english": "that, those, (one) another"
    },
    {
      "character": "便",
      "zhuyin": "ㄅㄧㄢˋ",
      "pinyin": "biàn",
      "english": "plain, informal, suitable, convenient, opportune, to urinate or defecate, equivalent to 就[jiu4]: the"
    },
    {
      "character": "憋",
      "zhuyin": "ㄅㄧㄝ",
      "pinyin": "biē",
      "english": "to choke, to stifle, to restrain, to hold back, to hold in (urine), to hold (one's breath)"
    },
    {
      "character": "丙",
      "zhuyin": "ㄅㄧㄥˇ",
      "pinyin": "bǐng",
      "english": "third of the ten Heavenly Stems 十天干[shi2 tian1 gan1], third in order, letter \"C\" or Roman \"III\" in l"
    },
    {
      "character": "柄",
      "zhuyin": "ㄅㄧㄥˇ",
      "pinyin": "bǐng",
      "english": "handle or shaft (of an axe etc), (of a flower, leaf or fruit) stem, sth that affords an advantage to"
    },
    {
      "character": "柏",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "bó",
      "english": "(used for transcribing names)"
    },
    {
      "character": "剝",
      "zhuyin": "ㄅㄛ",
      "pinyin": "bō",
      "english": "to peel, to skin, to flay, to shuck"
    },
    {
      "character": "操",
      "zhuyin": "ㄘㄠ",
      "pinyin": "cāo",
      "english": "to grasp, to hold, to operate, to manage, to control, to steer, to exercise, to drill (practice), to"
    },
    {
      "character": "側",
      "zhuyin": "ㄘㄜˋ",
      "pinyin": "cè",
      "english": "the side, to incline towards, to lean, inclined, lateral, side"
    },
    {
      "character": "纏",
      "zhuyin": "ㄔㄢˊ",
      "pinyin": "chán",
      "english": "to wind around, to wrap round, to coil, tangle, to involve, to bother, to annoy"
    },
    {
      "character": "禪",
      "zhuyin": "ㄔㄢˊ",
      "pinyin": "chán",
      "english": "dhyana (Sanskrit), Zen, meditation (Buddhism)"
    },
    {
      "character": "巢",
      "zhuyin": "ㄔㄠˊ",
      "pinyin": "cháo",
      "english": "nest"
    },
    {
      "character": "扯",
      "zhuyin": "ㄔㄜˇ",
      "pinyin": "chě",
      "english": "to pull, to tear, (of cloth, thread etc) to buy, to chat, to gossip, (coll.) (Tw) ridiculous, hokey"
    },
    {
      "character": "呈",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéng",
      "english": "to present to a superior, memorial, petition, to present (a certain appearance), to assume (a shape)"
    },
    {
      "character": "程",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéng",
      "english": "rule, order, regulations, formula, journey, procedure, sequence"
    },
    {
      "character": "盛",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéng",
      "english": "to hold, to contain, to ladle, to pick up with a utensil"
    },
    {
      "character": "遲",
      "zhuyin": "ㄔˊ",
      "pinyin": "chí",
      "english": "late, delayed, slow"
    },
    {
      "character": "癡",
      "zhuyin": "ㄔ",
      "pinyin": "chī",
      "english": "imbecile, sentimental, stupid, foolish, silly"
    },
    {
      "character": "仇",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "chóu",
      "english": "hatred, animosity, enmity, foe, enemy, to feel animosity toward (the wealthy, foreigners etc)"
    },
    {
      "character": "愁",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "chóu",
      "english": "to worry about"
    },
    {
      "character": "齣",
      "zhuyin": "ㄔㄨ",
      "pinyin": "chū",
      "english": "to go out, to come out, to occur, to produce, to go beyond, to rise, to put forth, to happen, (used "
    },
    {
      "character": "瘡",
      "zhuyin": "ㄔㄨㄤ",
      "pinyin": "chuāng",
      "english": "sore, skin ulcer"
    },
    {
      "character": "垂",
      "zhuyin": "ㄔㄨㄟˊ",
      "pinyin": "chuí",
      "english": "to hang (down), droop, dangle, bend down, hand down, bequeath, nearly, almost, to approach"
    },
    {
      "character": "捶",
      "zhuyin": "ㄔㄨㄟˊ",
      "pinyin": "chuí",
      "english": "to beat (with a stick or one's fist), to thump, to pound"
    },
    {
      "character": "蠢",
      "zhuyin": "ㄔㄨㄣˇ",
      "pinyin": "chǔn",
      "english": "stupid, sluggish, clumsy, to wiggle (of worms), to move in a disorderly fashion"
    },
    {
      "character": "戳",
      "zhuyin": "ㄔㄨㄛ",
      "pinyin": "chuō",
      "english": "to jab, to poke, to stab, (coll.) to sprain, to blunt, to fuck (vulgar), to stand, to stand (sth) up"
    },
    {
      "character": "雌",
      "zhuyin": "ㄘ",
      "pinyin": "cī",
      "english": "female, Taiwan pr. [ci1]"
    },
    {
      "character": "叢",
      "zhuyin": "ㄘㄨㄥˊ",
      "pinyin": "cóng",
      "english": "cluster, collection, collection of books, thicket"
    },
    {
      "character": "湊",
      "zhuyin": "ㄘㄡˋ",
      "pinyin": "còu",
      "english": "to gather together, pool or collect, to happen by chance, to move close to, to exploit an opportunit"
    },
    {
      "character": "脆",
      "zhuyin": "ㄘㄨㄟˋ",
      "pinyin": "cuì",
      "english": "brittle, fragile, crisp, crunchy, clear and loud voice, neat"
    },
    {
      "character": "搓",
      "zhuyin": "ㄘㄨㄛ",
      "pinyin": "cuō",
      "english": "to rub or roll between the hands or fingers, to twist"
    },
    {
      "character": "擔",
      "zhuyin": "ㄉㄢ",
      "pinyin": "dān",
      "english": "to undertake, to carry, to shoulder, to take responsibility"
    },
    {
      "character": "檔",
      "zhuyin": "ㄉㄤˇ",
      "pinyin": "dǎng",
      "english": "(Tw) variant of 擋|挡[dang3], gear"
    },
    {
      "character": "盜",
      "zhuyin": "ㄉㄠˋ",
      "pinyin": "dào",
      "english": "to steal, to rob, to plunder, thief, bandit, robber"
    },
    {
      "character": "抵",
      "zhuyin": "ㄉㄧˇ",
      "pinyin": "dǐ",
      "english": "to press against, to support, to prop up, to resist, to equal, to balance, to make up for, to mortga"
    },
    {
      "character": "吊",
      "zhuyin": "ㄉㄧㄠˋ",
      "pinyin": "diào",
      "english": "to suspend, to hang up, to hang a person"
    },
    {
      "character": "雕",
      "zhuyin": "ㄉㄧㄠ",
      "pinyin": "diāo",
      "english": "to carve, to engrave, shrewd, bird of prey"
    },
    {
      "character": "疊",
      "zhuyin": "ㄉㄧㄝˊ",
      "pinyin": "dié",
      "english": "to fold, to fold over in layers, to furl, to layer, to pile up, to repeat, to duplicate"
    },
    {
      "character": "釘",
      "zhuyin": "ㄉㄧㄥ",
      "pinyin": "dīng",
      "english": "nail, to follow closely, to keep at sb (to do sth), variant of 盯[ding1]"
    },
    {
      "character": "丁",
      "zhuyin": "ㄉㄧㄥ",
      "pinyin": "dīng",
      "english": "male adult, the 4th of the 10 Heavenly Stems 天干[tian1 gan1], fourth (used like \"4\" or \"D\"), small cu"
    },
    {
      "character": "逗",
      "zhuyin": "ㄉㄡˋ",
      "pinyin": "dòu",
      "english": "to tease (playfully), to entice, (coll.) to joke, (coll.) funny, amusing, to stay, to sojourn, brief"
    },
    {
      "character": "抖",
      "zhuyin": "ㄉㄡˇ",
      "pinyin": "dǒu",
      "english": "to tremble, to shake out, to reveal, to make it in the world"
    },
    {
      "character": "陡",
      "zhuyin": "ㄉㄡˇ",
      "pinyin": "dǒu",
      "english": "steep, precipitous, abrubtly, suddenly, unexpectedly"
    },
    {
      "character": "渡",
      "zhuyin": "ㄉㄨˋ",
      "pinyin": "dù",
      "english": "to cross, to pass through, to ferry"
    },
    {
      "character": "堵",
      "zhuyin": "ㄉㄨˇ",
      "pinyin": "dǔ",
      "english": "to block up (a road, pipe etc), to stop up (a hole), (fig.) (of a person) choked up with anxiety or "
    },
    {
      "character": "噸",
      "zhuyin": "ㄉㄨㄣˋ",
      "pinyin": "dùn",
      "english": "ton (loanword), Taiwan pr. [dun4]"
    },
    {
      "character": "燉",
      "zhuyin": "ㄉㄨㄣˋ",
      "pinyin": "dùn",
      "english": "to stew"
    },
    {
      "character": "呃",
      "zhuyin": "ㄜˋ",
      "pinyin": "è",
      "english": "(exclamation), to hiccup"
    },
    {
      "character": "泛",
      "zhuyin": "ㄈㄢˋ",
      "pinyin": "fàn",
      "english": "(bound form) general, non-specific, extensive, pan-, to flood, (literary) to float about, to be suff"
    },
    {
      "character": "糞",
      "zhuyin": "ㄈㄣˋ",
      "pinyin": "fèn",
      "english": "manure, dung"
    },
    {
      "character": "鳳",
      "zhuyin": "ㄈㄥˋ",
      "pinyin": "fèng",
      "english": "phoenix"
    },
    {
      "character": "赴",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fù",
      "english": "to go, to visit (e.g. another country), to attend (a banquet etc)"
    },
    {
      "character": "敷",
      "zhuyin": "ㄈㄨ",
      "pinyin": "fū",
      "english": "to spread, to lay out, to apply (powder, ointment etc), sufficient (to cover), enough"
    },
    {
      "character": "桿",
      "zhuyin": "ㄍㄢˇ",
      "pinyin": "gǎn",
      "english": "stick, pole, lever, classifier for long objects such as guns"
    },
    {
      "character": "甘",
      "zhuyin": "ㄍㄢ",
      "pinyin": "gān",
      "english": "sweet, willing"
    },
    {
      "character": "缸",
      "zhuyin": "ㄍㄤ",
      "pinyin": "gāng",
      "english": "jar, vat, classifier for loads of laundry, CL:口[kou3]"
    },
    {
      "character": "鋼",
      "zhuyin": "ㄍㄤ",
      "pinyin": "gāng",
      "english": "steel"
    },
    {
      "character": "擱",
      "zhuyin": "ㄍㄜ",
      "pinyin": "gē",
      "english": "to place, to put aside, to shelve"
    },
    {
      "character": "公",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "gōng",
      "english": "public, collectively owned, common, international (e.g. high seas, metric system, calendar), make pu"
    },
    {
      "character": "弓",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "gōng",
      "english": "a bow (weapon), CL:張|张[zhang1], to bend, to arch (one's back etc)"
    },
    {
      "character": "勾",
      "zhuyin": "ㄍㄡ",
      "pinyin": "gōu",
      "english": "to attract, to arouse, to tick, to strike out, to delineate, to collude, variant of 鉤|钩[gou1], hook"
    },
    {
      "character": "故",
      "zhuyin": "ㄍㄨˋ",
      "pinyin": "gù",
      "english": "happening, instance, reason, cause, intentional, former, old, friend, therefore, hence, (of people) "
    },
    {
      "character": "穀",
      "zhuyin": "ㄍㄨˇ",
      "pinyin": "gǔ",
      "english": "grain, corn"
    },
    {
      "character": "股",
      "zhuyin": "ㄍㄨˇ",
      "pinyin": "gǔ",
      "english": "thigh, part of a whole, portion of a sum, (stock) share, strand of a thread, low-level administrativ"
    },
    {
      "character": "谷",
      "zhuyin": "ㄍㄨˇ",
      "pinyin": "gǔ",
      "english": "valley"
    },
    {
      "character": "寡",
      "zhuyin": "ㄍㄨㄚˇ",
      "pinyin": "guǎ",
      "english": "few, scant, widowed"
    },
    {
      "character": "拐",
      "zhuyin": "ㄍㄨㄞˇ",
      "pinyin": "guǎi",
      "english": "to turn (a corner etc), to kidnap, to swindle, to misappropriate, seven (used as a substitute for 七["
    },
    {
      "character": "灌",
      "zhuyin": "ㄍㄨㄢˋ",
      "pinyin": "guàn",
      "english": "to irrigate, to pour, to install (software), to record (music)"
    },
    {
      "character": "官",
      "zhuyin": "ㄍㄨㄢ",
      "pinyin": "guān",
      "english": "government official, governmental, official, public, organ of the body, CL:個|个[ge4]"
    },
    {
      "character": "觀",
      "zhuyin": "ㄍㄨㄢ",
      "pinyin": "guān",
      "english": "to look at, to watch, to observe, to behold, to advise, concept, point of view, outlook"
    },
    {
      "character": "歸",
      "zhuyin": "ㄍㄨㄟ",
      "pinyin": "guī",
      "english": "to return, to go back to, to give back to, (of a responsibility) to be taken care of by, to belong t"
    },
    {
      "character": "裹",
      "zhuyin": "ㄍㄨㄛˇ",
      "pinyin": "guǒ",
      "english": "to wrap around, bundle, parcel, package, to press into service, to pressgang, to make off with (sth)"
    },
    {
      "character": "核",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "hé",
      "english": "pit, stone, nucleus, nuclear, to examine, to check, to verify"
    },
    {
      "character": "哄",
      "zhuyin": "ㄏㄨㄥ",
      "pinyin": "hōng",
      "english": "roar of laughter (onom.), hubbub, to roar (as a crowd)"
    },
    {
      "character": "吼",
      "zhuyin": "ㄏㄡˇ",
      "pinyin": "hǒu",
      "english": "to roar, to howl, to shriek, roar or howl of an animal, bellow of rage"
    },
    {
      "character": "環",
      "zhuyin": "ㄏㄨㄢˊ",
      "pinyin": "huán",
      "english": "ring, hoop, loop, (chain) link, classifier for scores in archery etc, to surround, to encircle, to h"
    },
    {
      "character": "晃",
      "zhuyin": "ㄏㄨㄤˇ",
      "pinyin": "huǎng",
      "english": "to dazzle, to flash past"
    },
    {
      "character": "慌",
      "zhuyin": "ㄏㄨㄤ",
      "pinyin": "huāng",
      "english": "to get panicky, to lose one's head, (coll.) (after 得) unbearably, terribly"
    },
    {
      "character": "匯",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "huì",
      "english": "to remit, to converge (of rivers), to exchange"
    },
    {
      "character": "魂",
      "zhuyin": "ㄏㄨㄣˊ",
      "pinyin": "hún",
      "english": "soul, spirit, immortal soul (that can be detached from the body)"
    },
    {
      "character": "夥",
      "zhuyin": "ㄏㄨㄛˇ",
      "pinyin": "huǒ",
      "english": "companion, partner, group, classifier for groups of people, to combine, together"
    },
    {
      "character": "即",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jí",
      "english": "namely, that is, i.e., prompt, at once, at present, even if, prompted (by the occasion), to approach"
    },
    {
      "character": "疾",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jí",
      "english": "(bound form) disease, ailment, (bound form) swift, (literary) to hate, to abhor"
    },
    {
      "character": "集",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jí",
      "english": "to gather, to collect, collected works, classifier for sections of a TV series etc: episode"
    },
    {
      "character": "劑",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "dose (medicine)"
    },
    {
      "character": "忌",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "to be jealous of, fear, dread, scruple, to avoid or abstain from, to quit, to give up sth"
    },
    {
      "character": "暨",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "and, to reach to, the limits"
    },
    {
      "character": "祭",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "to offer a sacrifice to (gods or ancestors), memorial ceremony, (in classical novels) to recite an i"
    },
    {
      "character": "繼",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "to continue, to follow after, to go on with, to succeed, to inherit, then, afterwards"
    },
    {
      "character": "際",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jì",
      "english": "border, edge, boundary, interval, between, inter-, to meet, time, occasion, to meet with (circumstan"
    },
    {
      "character": "甲",
      "zhuyin": "ㄐㄧㄚˇ",
      "pinyin": "jiǎ",
      "english": "first of the ten Heavenly Stems 十天干[shi2 tian1 gan1], (used for an unspecified person or thing), fir"
    },
    {
      "character": "賤",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiàn",
      "english": "inexpensive, lowly, despicable, (bound form) (humble) my"
    },
    {
      "character": "揀",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "jiǎn",
      "english": "to choose, to pick, to sort out, to pick up"
    },
    {
      "character": "兼",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiān",
      "english": "double, twice, simultaneous, holding two or more (official) posts at the same time"
    },
    {
      "character": "奸",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiān",
      "english": "wicked, crafty, traitor, variant of 姦|奸[jian1]"
    },
    {
      "character": "僵",
      "zhuyin": "ㄐㄧㄤ",
      "pinyin": "jiāng",
      "english": "rigid, deadlock, stiff (corpse)"
    },
    {
      "character": "絞",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎo",
      "english": "to twist (strands into a thread), to entangle, to wring, to hang (by the neck), to turn, to wind, cl"
    },
    {
      "character": "繳",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎo",
      "english": "to hand in, to hand over, to seize"
    },
    {
      "character": "澆",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "jiāo",
      "english": "to pour liquid, to irrigate (using waterwheel), to water, to cast (molten metal), to mold"
    },
    {
      "character": "焦",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "jiāo",
      "english": "burnt, scorched, charred, worried, anxious, coke, joule (abbr. for 焦耳[jiao1 er3])"
    },
    {
      "character": "嚼",
      "zhuyin": "ㄐㄧㄠˊ",
      "pinyin": "jiáo",
      "english": "to chew, also pr. [jue2]"
    },
    {
      "character": "劫",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jié",
      "english": "to rob, to plunder, to seize by force, to coerce, calamity, abbr. for kalpa 劫波[jie2 bo1]"
    },
    {
      "character": "截",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jié",
      "english": "to cut off (a length), to stop, to intercept, section, chunk, length"
    },
    {
      "character": "階",
      "zhuyin": "ㄐㄧㄝ",
      "pinyin": "jiē",
      "english": "rank or step, stairs"
    },
    {
      "character": "藉",
      "zhuyin": "ㄐㄧㄝˋ",
      "pinyin": "jiè",
      "english": "to lend, to borrow, by means of, to take (an opportunity)"
    },
    {
      "character": "筋",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "jīn",
      "english": "muscle, tendon, veins visible under the skin, sth resembling tendons or veins (e.g. fiber in a veget"
    },
    {
      "character": "精",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jīng",
      "english": "essence, extract, vitality, energy, semen, sperm, mythical goblin spirit, highly perfected, elite, t"
    },
    {
      "character": "頸",
      "zhuyin": "ㄐㄧㄥˇ",
      "pinyin": "jǐng",
      "english": "neck"
    },
    {
      "character": "勁",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "jìng",
      "english": "stalwart, sturdy, strong, powerful"
    },
    {
      "character": "俱",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jù",
      "english": "(literary) all, both, entirely, without exception, (literary) to be together, (literary) to be alike"
    },
    {
      "character": "具",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jù",
      "english": "tool, device, utensil, equipment, instrument, talent, ability, to possess, to have, to provide, to f"
    },
    {
      "character": "絕",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "jué",
      "english": "to cut short, extinct, to disappear, to vanish, absolutely, by no means"
    },
    {
      "character": "均",
      "zhuyin": "ㄐㄩㄣ",
      "pinyin": "jūn",
      "english": "equal, even, all, uniform"
    },
    {
      "character": "扛",
      "zhuyin": "ㄎㄤˊ",
      "pinyin": "káng",
      "english": "to carry on one's shoulder, (fig.) to take on (a burden, duty etc)"
    },
    {
      "character": "殼",
      "zhuyin": "ㄎㄜˊ",
      "pinyin": "ké",
      "english": "shell, carapace, crust (earth's crust etc), also pr. [ke2]"
    },
    {
      "character": "啃",
      "zhuyin": "ㄎㄣˇ",
      "pinyin": "kěn",
      "english": "to gnaw, to nibble, to bite"
    },
    {
      "character": "坑",
      "zhuyin": "ㄎㄥ",
      "pinyin": "kēng",
      "english": "pit, depression, hollow, tunnel, hole in the ground, (archaic) to bury alive, to hoodwink, to cheat "
    },
    {
      "character": "孔",
      "zhuyin": "ㄎㄨㄥˇ",
      "pinyin": "kǒng",
      "english": "hole, CL:個|个[ge4], classifier for cave dwellings"
    },
    {
      "character": "扣",
      "zhuyin": "ㄎㄡˋ",
      "pinyin": "kòu",
      "english": "to fasten, to button, button, buckle, knot, to arrest, to confiscate, to deduct (money), discount, t"
    },
    {
      "character": "酷",
      "zhuyin": "ㄎㄨˋ",
      "pinyin": "kù",
      "english": "ruthless, strong (e.g. of wine), (loanword) cool, hip"
    },
    {
      "character": "款",
      "zhuyin": "ㄎㄨㄢˇ",
      "pinyin": "kuǎn",
      "english": "section, paragraph, funds, CL:筆|笔[bi3], 個|个[ge4], classifier for versions or models (of a product)"
    },
    {
      "character": "框",
      "zhuyin": "ㄎㄨㄤ",
      "pinyin": "kuāng",
      "english": "frame (e.g. door frame), casing, fig. framework, template, to circle (i.e. draw a circle around sth)"
    },
    {
      "character": "虧",
      "zhuyin": "ㄎㄨㄟ",
      "pinyin": "kuī",
      "english": "deficiency, deficit, luckily, it's lucky that..., (often ironically) fancy that..."
    },
    {
      "character": "捆",
      "zhuyin": "ㄎㄨㄣˇ",
      "pinyin": "kǔn",
      "english": "a bunch, to tie together, bundle"
    },
    {
      "character": "蠟",
      "zhuyin": "ㄌㄚˋ",
      "pinyin": "là",
      "english": "candle, wax"
    },
    {
      "character": "賴",
      "zhuyin": "ㄌㄞˋ",
      "pinyin": "lài",
      "english": "to depend on, to hang on in a place, bad, to renege (on promise), to disclaim, to rat (on debts), ra"
    },
    {
      "character": "欄",
      "zhuyin": "ㄌㄢˊ",
      "pinyin": "lán",
      "english": "fence, railing, hurdle, column or box (of text or other data)"
    },
    {
      "character": "牢",
      "zhuyin": "ㄌㄠˊ",
      "pinyin": "láo",
      "english": "firm, sturdy, fold (for animals), sacrifice, prison"
    },
    {
      "character": "撈",
      "zhuyin": "ㄌㄠ",
      "pinyin": "lāo",
      "english": "to fish up, to dredge up"
    },
    {
      "character": "愣",
      "zhuyin": "ㄌㄥˋ",
      "pinyin": "lèng",
      "english": "to look distracted, to stare blankly, distracted, blank, (coll.) unexpectedly, rash, rashly"
    },
    {
      "character": "里",
      "zhuyin": "ㄌㄧˇ",
      "pinyin": "lǐ",
      "english": "li, ancient measure of length, approx. 500 m, neighborhood, ancient administrative unit of 25 famili"
    },
    {
      "character": "列",
      "zhuyin": "ㄌㄧㄝˋ",
      "pinyin": "liè",
      "english": "to arrange, to line up, file, series, (in data tables) column, (Tw) row"
    },
    {
      "character": "烈",
      "zhuyin": "ㄌㄧㄝˋ",
      "pinyin": "liè",
      "english": "ardent, intense, fierce, stern, upright, to give one's life for a noble cause, exploits, achievement"
    },
    {
      "character": "臨",
      "zhuyin": "ㄌㄧㄣˊ",
      "pinyin": "lín",
      "english": "to face, to overlook, to arrive, to be (just) about to, just before"
    },
    {
      "character": "鈴",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "líng",
      "english": "(small) bell, CL:隻|只[zhi1]"
    },
    {
      "character": "靈",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "líng",
      "english": "quick, alert, efficacious, effective, to come true, spirit, departed soul, coffin"
    },
    {
      "character": "拎",
      "zhuyin": "ㄌㄧㄥ",
      "pinyin": "līng",
      "english": "to lift up, to carry in one's hand, Taiwan pr. [ling1]"
    },
    {
      "character": "柳",
      "zhuyin": "ㄌㄧㄡˇ",
      "pinyin": "liǔ",
      "english": "willow"
    },
    {
      "character": "溜",
      "zhuyin": "ㄌㄧㄡ",
      "pinyin": "liū",
      "english": "to slip away, to escape in stealth, to skate"
    },
    {
      "character": "陸",
      "zhuyin": "ㄌㄧㄡˋ",
      "pinyin": "liù",
      "english": "six (banker's anti-fraud numeral)"
    },
    {
      "character": "漏",
      "zhuyin": "ㄌㄡˋ",
      "pinyin": "lòu",
      "english": "to leak, to divulge, to leave out by mistake, waterclock or hourglass (old)"
    },
    {
      "character": "摟",
      "zhuyin": "ㄌㄡ",
      "pinyin": "lōu",
      "english": "to draw towards oneself, to gather, to gather up (one's gown, sleeves etc), to grab (money), to exto"
    },
    {
      "character": "驢",
      "zhuyin": "ㄌㄩˊ",
      "pinyin": "lǘ",
      "english": "donkey, CL:頭|头[tou2]"
    },
    {
      "character": "率",
      "zhuyin": "ㄌㄩˋ",
      "pinyin": "lǜ",
      "english": "rate, frequency"
    },
    {
      "character": "卵",
      "zhuyin": "ㄌㄨㄢˇ",
      "pinyin": "luǎn",
      "english": "egg, ovum, spawn, (coll.) testicles, (old) penis, (expletive) fucking"
    },
    {
      "character": "略",
      "zhuyin": "ㄌㄩㄝˋ",
      "pinyin": "lüè",
      "english": "brief, sketchy, outline, summary, to omit, (bound form before a single-character verb) a bit, somewh"
    },
    {
      "character": "麻",
      "zhuyin": "ㄇㄚˊ",
      "pinyin": "má",
      "english": "generic name for hemp, flax etc, hemp or flax fiber for textile materials, sesame, CL:縷|缕[lu:3], (of"
    },
    {
      "character": "碼",
      "zhuyin": "ㄇㄚˇ",
      "pinyin": "mǎ",
      "english": "weight, number, code, to pile, to stack, classifier for length or distance (yard), happenings etc"
    },
    {
      "character": "瞞",
      "zhuyin": "ㄇㄢˊ",
      "pinyin": "mán",
      "english": "to conceal from, to keep (sb) in the dark"
    },
    {
      "character": "蠻",
      "zhuyin": "ㄇㄢˊ",
      "pinyin": "mán",
      "english": "barbarian, bullying, very, quite, rough, reckless"
    },
    {
      "character": "盲",
      "zhuyin": "ㄇㄤˊ",
      "pinyin": "máng",
      "english": "blind"
    },
    {
      "character": "枚",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "méi",
      "english": "classifier for coins, rings, badges, pearls, sporting medals, rockets, satellites etc, tree trunk, w"
    },
    {
      "character": "煤",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "méi",
      "english": "coal, CL:塊|块[kuai4]"
    },
    {
      "character": "密",
      "zhuyin": "ㄇㄧˋ",
      "pinyin": "mì",
      "english": "secret, confidential, close, thick, dense"
    },
    {
      "character": "瞇",
      "zhuyin": "ㄇㄧ",
      "pinyin": "mī",
      "english": "to narrow one's eyes, to squint, (dialect) to take a nap"
    },
    {
      "character": "瞄",
      "zhuyin": "ㄇㄧㄠˊ",
      "pinyin": "miáo",
      "english": "to take aim, (fig.) to aim one's looks at, to glance at"
    },
    {
      "character": "苗",
      "zhuyin": "ㄇㄧㄠˊ",
      "pinyin": "miáo",
      "english": "sprout"
    },
    {
      "character": "鳴",
      "zhuyin": "ㄇㄧㄥˊ",
      "pinyin": "míng",
      "english": "to cry (of birds, animals and insects), to make a sound, to voice (one's gratitude, grievance etc)"
    },
    {
      "character": "莫",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "mò",
      "english": "do not, there is none who"
    },
    {
      "character": "幕",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "mù",
      "english": "curtain or screen, canopy or tent, headquarters of a general, act (of a play)"
    },
    {
      "character": "嫩",
      "zhuyin": "ㄋㄣˋ",
      "pinyin": "nèn",
      "english": "young and tender, (of food) tender, lightly cooked, (of color) light, (of a person) inexperienced, u"
    },
    {
      "character": "逆",
      "zhuyin": "ㄋㄧˋ",
      "pinyin": "nì",
      "english": "contrary, opposite, backwards, to go against, to oppose, to betray, to rebel"
    },
    {
      "character": "擬",
      "zhuyin": "ㄋㄧˇ",
      "pinyin": "nǐ",
      "english": "to plan to, to draft (a plan), to imitate, to assess, to compare, pseudo-"
    },
    {
      "character": "捏",
      "zhuyin": "ㄋㄧㄝ",
      "pinyin": "niē",
      "english": "to hold between the thumb and fingers, to pinch, to mold (using the fingers), to hold (lit. in one's"
    },
    {
      "character": "扭",
      "zhuyin": "ㄋㄧㄡˇ",
      "pinyin": "niǔ",
      "english": "to turn, to twist, to wring, to sprain, to swing one's hips"
    },
    {
      "character": "挪",
      "zhuyin": "ㄋㄨㄛˊ",
      "pinyin": "nuó",
      "english": "to shift, to move"
    },
    {
      "character": "攀",
      "zhuyin": "ㄆㄢ",
      "pinyin": "pān",
      "english": "to climb (by pulling oneself up), to implicate, to claim connections of higher status"
    },
    {
      "character": "砲",
      "zhuyin": "ㄆㄠˋ",
      "pinyin": "pào",
      "english": "cannon, CL:座[zuo4], firecracker"
    },
    {
      "character": "拋",
      "zhuyin": "ㄆㄠ",
      "pinyin": "pāo",
      "english": "to throw, to toss, to fling, to cast, to abandon"
    },
    {
      "character": "炮",
      "zhuyin": "ㄆㄠˊ",
      "pinyin": "páo",
      "english": "to prepare herbal medicine by roasting or parching (in a pan)"
    },
    {
      "character": "捧",
      "zhuyin": "ㄆㄥˇ",
      "pinyin": "pěng",
      "english": "to clasp, to cup the hands, to hold up with both hands, to offer (esp. in cupped hands), to praise, "
    },
    {
      "character": "砰",
      "zhuyin": "ㄆㄥ",
      "pinyin": "pēng",
      "english": "(onom.) bang, thump"
    },
    {
      "character": "劈",
      "zhuyin": "ㄆㄧ",
      "pinyin": "pī",
      "english": "to hack, to chop, to split open, (of lightning) to strike"
    },
    {
      "character": "漂",
      "zhuyin": "ㄆㄧㄠ",
      "pinyin": "piāo",
      "english": "to float, to drift"
    },
    {
      "character": "品",
      "zhuyin": "ㄆㄧㄣˇ",
      "pinyin": "pǐn",
      "english": "(bound form) article, commodity, product, goods, (bound form) grade, rank, kind, type, variety, char"
    },
    {
      "character": "拼",
      "zhuyin": "ㄆㄧㄣ",
      "pinyin": "pīn",
      "english": "to piece together, to join together, to stake all, adventurous, at the risk of one's life, to spell"
    },
    {
      "character": "頗",
      "zhuyin": "ㄆㄛˇ",
      "pinyin": "pǒ",
      "english": "rather, quite, considerably, oblique, inclined, slanting, Taiwan pr. [po3]"
    },
    {
      "character": "鋪",
      "zhuyin": "ㄆㄨ",
      "pinyin": "pū",
      "english": "to spread, to display, to set up, (old) holder for door-knocker"
    },
    {
      "character": "譜",
      "zhuyin": "ㄆㄨˇ",
      "pinyin": "pǔ",
      "english": "chart, list, table, register, score (music), spectrum (physics), to set to music"
    },
    {
      "character": "撲",
      "zhuyin": "ㄆㄨ",
      "pinyin": "pū",
      "english": "to throw oneself at, to pounce on, to devote one's energies, to flap, to flutter, to dab, to pat, to"
    },
    {
      "character": "其",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qí",
      "english": "his, her, its, their, that, such, it (refers to sth preceding it)"
    },
    {
      "character": "迄",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "qì",
      "english": "as yet, until"
    },
    {
      "character": "豈",
      "zhuyin": "ㄑㄧˇ",
      "pinyin": "qǐ",
      "english": "how? (emphatic question)"
    },
    {
      "character": "漆",
      "zhuyin": "ㄑㄧ",
      "pinyin": "qī",
      "english": "paint, lacquer, CL:道[dao4], to paint (furniture, walls etc)"
    },
    {
      "character": "齊",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qí",
      "english": "neat, even, level with, identical, simultaneous, all together, to even sth out"
    },
    {
      "character": "腔",
      "zhuyin": "ㄑㄧㄤ",
      "pinyin": "qiāng",
      "english": "(bound form) cavity, tune, accent (in one's speech), (old) (classifier for carcasses of slaughtered "
    },
    {
      "character": "翹",
      "zhuyin": "ㄑㄧㄠˊ",
      "pinyin": "qiáo",
      "english": "outstanding, to raise"
    },
    {
      "character": "青",
      "zhuyin": "ㄑㄧㄥ",
      "pinyin": "qīng",
      "english": "green, blue, black, youth, young (of people)"
    },
    {
      "character": "趨",
      "zhuyin": "ㄑㄩ",
      "pinyin": "qū",
      "english": "to hasten, to hurry, to walk fast, to approach, to tend towards, to converge"
    },
    {
      "character": "犬",
      "zhuyin": "ㄑㄩㄢˇ",
      "pinyin": "quǎn",
      "english": "dog, Kangxi radical 94"
    },
    {
      "character": "嚷",
      "zhuyin": "ㄖㄤˇ",
      "pinyin": "rǎng",
      "english": "to shout, to bellow, to make a big deal of sth, to make a fuss about sth"
    },
    {
      "character": "饒",
      "zhuyin": "ㄖㄠˊ",
      "pinyin": "ráo",
      "english": "rich, abundant, exuberant, to add for free, to throw in as bonus, to spare, to forgive, despite, alt"
    },
    {
      "character": "惹",
      "zhuyin": "ㄖㄜˇ",
      "pinyin": "rě",
      "english": "to provoke, to irritate, to vex, to stir up, to anger, to attract (troubles), to cause (problems)"
    },
    {
      "character": "仁",
      "zhuyin": "ㄖㄣˊ",
      "pinyin": "rén",
      "english": "humane, kernel"
    },
    {
      "character": "撒",
      "zhuyin": "ㄙㄚ",
      "pinyin": "sā",
      "english": "to let go, to cast, to let loose, to discharge, to give expression to, (coll.) to pee"
    },
    {
      "character": "灑",
      "zhuyin": "ㄙㄚˇ",
      "pinyin": "sǎ",
      "english": "to sprinkle, to spray, to spill, to shed"
    },
    {
      "character": "啥",
      "zhuyin": "ㄕㄚˊ",
      "pinyin": "shá",
      "english": "dialectal equivalent of 什麼|什么[shen2 me5], also pr. [sha4]"
    },
    {
      "character": "尚",
      "zhuyin": "ㄕㄤˋ",
      "pinyin": "shàng",
      "english": "still, yet, to value, to esteem"
    },
    {
      "character": "甚",
      "zhuyin": "ㄕㄣˊ",
      "pinyin": "shén",
      "english": "ten (used in fractions, writing checks etc), assorted, miscellaneous"
    },
    {
      "character": "拾",
      "zhuyin": "ㄕˊ",
      "pinyin": "shí",
      "english": "to pick up, to collate or arrange, ten (banker's anti-fraud numeral)"
    },
    {
      "character": "視",
      "zhuyin": "ㄕˋ",
      "pinyin": "shì",
      "english": "(bound form) to look at"
    },
    {
      "character": "屎",
      "zhuyin": "ㄕˇ",
      "pinyin": "shǐ",
      "english": "stool, feces, ear wax, nasal mucus"
    },
    {
      "character": "豎",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "shù",
      "english": "to erect, vertical, vertical stroke (in Chinese characters)"
    },
    {
      "character": "耍",
      "zhuyin": "ㄕㄨㄚˇ",
      "pinyin": "shuǎ",
      "english": "to play with, to wield, to act (cool etc), to display (a skill, one's temper etc)"
    },
    {
      "character": "甩",
      "zhuyin": "ㄕㄨㄞˇ",
      "pinyin": "shuǎi",
      "english": "to throw, to fling, to swing, to leave behind, to throw off, to dump (sb)"
    },
    {
      "character": "霜",
      "zhuyin": "ㄕㄨㄤ",
      "pinyin": "shuāng",
      "english": "frost, white powder or cream spread over a surface, frosting, (skin) cream"
    },
    {
      "character": "撕",
      "zhuyin": "ㄙ",
      "pinyin": "sī",
      "english": "to tear"
    },
    {
      "character": "遂",
      "zhuyin": "ㄙㄨㄟˋ",
      "pinyin": "suì",
      "english": "to satisfy, to succeed, then, thereupon, finally, unexpectedly, to proceed, to reach"
    },
    {
      "character": "縮",
      "zhuyin": "ㄙㄨㄛ",
      "pinyin": "suō",
      "english": "to withdraw, to pull back, to contract, to shrink, to reduce, abbreviation, also pr. [su4]"
    },
    {
      "character": "胎",
      "zhuyin": "ㄊㄞ",
      "pinyin": "tāi",
      "english": "fetus, classifier for litters (of puppies etc), padding (in clothing or bedding), womb carrying a fe"
    },
    {
      "character": "潭",
      "zhuyin": "ㄊㄢˊ",
      "pinyin": "tán",
      "english": "deep pool, pond, pit (dialect), depression"
    },
    {
      "character": "攤",
      "zhuyin": "ㄊㄢ",
      "pinyin": "tān",
      "english": "to spread out, vendor's stand"
    },
    {
      "character": "灘",
      "zhuyin": "ㄊㄢ",
      "pinyin": "tān",
      "english": "beach, shoal, rapids, CL:片[pian4], classifier for liquids: pool, puddle"
    },
    {
      "character": "掏",
      "zhuyin": "ㄊㄠ",
      "pinyin": "tāo",
      "english": "to fish out (from pocket), to scoop"
    },
    {
      "character": "蹄",
      "zhuyin": "ㄊㄧˊ",
      "pinyin": "tí",
      "english": "hoof, pig's trotters"
    },
    {
      "character": "舔",
      "zhuyin": "ㄊㄧㄢˇ",
      "pinyin": "tiǎn",
      "english": "to lick, to lap"
    },
    {
      "character": "徒",
      "zhuyin": "ㄊㄨˊ",
      "pinyin": "tú",
      "english": "disciple, apprentice, believer, on foot, bare, empty, to no avail, only, prison sentence"
    },
    {
      "character": "托",
      "zhuyin": "ㄊㄨㄛ",
      "pinyin": "tuō",
      "english": "to hold up in one's hand, to support with one's palm, sth serving as a support: a prop, a rest (e.g."
    },
    {
      "character": "託",
      "zhuyin": "ㄊㄨㄛ",
      "pinyin": "tuō",
      "english": "to trust, to entrust, to be entrusted with, to act as trustee"
    },
    {
      "character": "歪",
      "zhuyin": "ㄨㄞ",
      "pinyin": "wāi",
      "english": "askew, at a crooked angle, devious, noxious, (coll.) to lie on one's side"
    },
    {
      "character": "旺",
      "zhuyin": "ㄨㄤˋ",
      "pinyin": "wàng",
      "english": "prosperous, flourishing, (of flowers) blooming, (of fire) roaring"
    },
    {
      "character": "惟",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéi",
      "english": "-ism, only"
    },
    {
      "character": "偽",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "wèi",
      "english": "false, fake, forged, bogus, (prefix) pseudo-, Taiwan pr. [wei4]"
    },
    {
      "character": "臥",
      "zhuyin": "ㄨㄛˋ",
      "pinyin": "wò",
      "english": "to lie, to crouch"
    },
    {
      "character": "吾",
      "zhuyin": "ㄨˊ",
      "pinyin": "wú",
      "english": "(old) I, my"
    },
    {
      "character": "席",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "xí",
      "english": "woven mat, seat, banquet, place in a democratic assembly, classifier for banquets, conversations etc"
    },
    {
      "character": "係",
      "zhuyin": "ㄒㄧˋ",
      "pinyin": "xì",
      "english": "to connect, to relate to, to tie up, to bind, to be (literary)"
    },
    {
      "character": "夕",
      "zhuyin": "ㄒㄧˋ",
      "pinyin": "xì",
      "english": "dusk, evening, Taiwan pr. [xi4]"
    },
    {
      "character": "瞎",
      "zhuyin": "ㄒㄧㄚ",
      "pinyin": "xiā",
      "english": "blind, groundlessly, foolishly, to no purpose"
    },
    {
      "character": "獻",
      "zhuyin": "ㄒㄧㄢˋ",
      "pinyin": "xiàn",
      "english": "to offer, to present, to dedicate, to donate, to show, to put on display, worthy person (old)"
    },
    {
      "character": "險",
      "zhuyin": "ㄒㄧㄢˇ",
      "pinyin": "xiǎn",
      "english": "danger, dangerous, rugged"
    },
    {
      "character": "鮮",
      "zhuyin": "ㄒㄧㄢ",
      "pinyin": "xiān",
      "english": "fresh, bright (in color), delicious, tasty, delicacy, aquatic foods"
    },
    {
      "character": "削",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "xiāo",
      "english": "to peel with a knife, to pare, to cut (a ball at tennis etc)"
    },
    {
      "character": "邪",
      "zhuyin": "ㄒㄧㄝˊ",
      "pinyin": "xié",
      "english": "demonic, iniquitous, nefarious, evil, unhealthy influences that cause disease (Chinese medicine), (c"
    },
    {
      "character": "瀉",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "xiè",
      "english": "to flow out swiftly, to flood, a torrent, diarrhea, laxative"
    },
    {
      "character": "謝",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "xiè",
      "english": "to thank, to apologize, (of flowers, leaves etc) to wither, to decline"
    },
    {
      "character": "刑",
      "zhuyin": "ㄒㄧㄥˊ",
      "pinyin": "xíng",
      "english": "punishment, penalty, sentence, torture, corporal punishment"
    },
    {
      "character": "凶",
      "zhuyin": "ㄒㄩㄥ",
      "pinyin": "xiōng",
      "english": "vicious, fierce, ominous, inauspicious, famine, variant of 兇|凶[xiong1]"
    },
    {
      "character": "嗅",
      "zhuyin": "ㄒㄧㄡˋ",
      "pinyin": "xiù",
      "english": "to smell, to sniff, to nose"
    },
    {
      "character": "秀",
      "zhuyin": "ㄒㄧㄡˋ",
      "pinyin": "xiù",
      "english": "handsome, refined, elegant, graceful, superior, show (loanword), CL:場|场[chang2], (literary) to grow,"
    },
    {
      "character": "休",
      "zhuyin": "ㄒㄧㄡ",
      "pinyin": "xiū",
      "english": "to rest, to stop doing sth for a period of time, to cease, (imperative) don't"
    },
    {
      "character": "許",
      "zhuyin": "ㄒㄩˇ",
      "pinyin": "xǔ",
      "english": "to allow, to permit, to promise, to praise, somewhat, perhaps"
    },
    {
      "character": "懸",
      "zhuyin": "ㄒㄩㄢˊ",
      "pinyin": "xuán",
      "english": "to hang or suspend, to worry, public announcement, unresolved, baseless, without foundation"
    },
    {
      "character": "啞",
      "zhuyin": "ㄧㄚˇ",
      "pinyin": "yǎ",
      "english": "mute, dumb, incapable of speech, (of a voice) hoarse, husky, (of a bullet, bomb etc) dud"
    },
    {
      "character": "雁",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "yàn",
      "english": "wild goose"
    },
    {
      "character": "掩",
      "zhuyin": "ㄧㄢˇ",
      "pinyin": "yǎn",
      "english": "to cover up, to conceal, to close (a door, book etc), (coll.) to get (one's fingers etc) caught when"
    },
    {
      "character": "淹",
      "zhuyin": "ㄧㄢ",
      "pinyin": "yān",
      "english": "to flood, to submerge, to drown, to irritate the skin (of liquids), to delay"
    },
    {
      "character": "醃",
      "zhuyin": "ㄧㄢ",
      "pinyin": "yān",
      "english": "to salt, to pickle, to cure (meat), to marinate"
    },
    {
      "character": "野",
      "zhuyin": "ㄧㄝˇ",
      "pinyin": "yě",
      "english": "field, plain, open space, limit, boundary, rude, feral"
    },
    {
      "character": "亦",
      "zhuyin": "ㄧˋ",
      "pinyin": "yì",
      "english": "also"
    },
    {
      "character": "役",
      "zhuyin": "ㄧˋ",
      "pinyin": "yì",
      "english": "forced labor, corvée, obligatory task, military service, to use as servant, to enserf, servant (old)"
    },
    {
      "character": "易",
      "zhuyin": "ㄧˋ",
      "pinyin": "yì",
      "english": "easy, amiable, to change, to exchange, prefix corresponding to the English adjective suffix \"-able\" "
    },
    {
      "character": "乙",
      "zhuyin": "ㄧˇ",
      "pinyin": "yǐ",
      "english": "second of the ten Heavenly Stems 十天干[shi2 tian1 gan1], second in order, letter \"B\" or Roman \"II\" in "
    },
    {
      "character": "營",
      "zhuyin": "ㄧㄥˊ",
      "pinyin": "yíng",
      "english": "camp, barracks, battalion, to build, to operate, to manage, to strive for"
    },
    {
      "character": "應",
      "zhuyin": "ㄧㄥˋ",
      "pinyin": "yìng",
      "english": "to answer, to respond, to comply with, to deal or cope with"
    },
    {
      "character": "于",
      "zhuyin": "ㄩˊ",
      "pinyin": "yú",
      "english": "to go, to take, sentence-final interrogative particle, variant of 於|于[yu2]"
    },
    {
      "character": "逾",
      "zhuyin": "ㄩˊ",
      "pinyin": "yú",
      "english": "to exceed, to go beyond, to transcend, to cross over, to jump over"
    },
    {
      "character": "愈",
      "zhuyin": "ㄩˋ",
      "pinyin": "yù",
      "english": "the more...(the more...), to recover, to heal, better"
    },
    {
      "character": "欲",
      "zhuyin": "ㄩˋ",
      "pinyin": "yù",
      "english": "to wish for, to desire, variant of 慾|欲[yu4]"
    },
    {
      "character": "員",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "yuán",
      "english": "person, employee, member"
    },
    {
      "character": "緣",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "yuán",
      "english": "cause, reason, karma, fate, predestined affinity, margin, hem, edge, along"
    },
    {
      "character": "砸",
      "zhuyin": "ㄗㄚˊ",
      "pinyin": "zá",
      "english": "to smash, to pound, to fail, to muck up, to bungle"
    },
    {
      "character": "宰",
      "zhuyin": "ㄗㄞˇ",
      "pinyin": "zǎi",
      "english": "to slaughter, to butcher, to kill (animals etc), (coll.) to fleece, to rip off, to overcharge, (boun"
    },
    {
      "character": "栽",
      "zhuyin": "ㄗㄞ",
      "pinyin": "zāi",
      "english": "to plant, to grow, to insert, to erect (e.g. a bus stop sign), to impose sth on sb, to stumble, to f"
    },
    {
      "character": "詐",
      "zhuyin": "ㄓㄚˋ",
      "pinyin": "zhà",
      "english": "to cheat, to swindle, to pretend, to feign, to draw sb out, to try to extract information by deceit "
    },
    {
      "character": "扎",
      "zhuyin": "ㄓㄚ",
      "pinyin": "zhā",
      "english": "to prick, to run or stick (a needle etc) into, mug or jug used for serving beer (loanword from \"jar\""
    },
    {
      "character": "債",
      "zhuyin": "ㄓㄞˋ",
      "pinyin": "zhài",
      "english": "debt, CL:筆|笔[bi3]"
    },
    {
      "character": "戰",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "zhàn",
      "english": "to fight, fight, war, battle"
    },
    {
      "character": "斬",
      "zhuyin": "ㄓㄢˇ",
      "pinyin": "zhǎn",
      "english": "to behead (as form of capital punishment), to chop"
    },
    {
      "character": "仗",
      "zhuyin": "ㄓㄤˋ",
      "pinyin": "zhàng",
      "english": "weaponry, to hold (a weapon), to wield, to rely on, to depend on, war, battle"
    },
    {
      "character": "脹",
      "zhuyin": "ㄓㄤˋ",
      "pinyin": "zhàng",
      "english": "to swell, dropsical, swollen, bloated"
    },
    {
      "character": "賬",
      "zhuyin": "ㄓㄤˋ",
      "pinyin": "zhàng",
      "english": "account, bill, debt, CL:本[ben3], 筆|笔[bi3]"
    },
    {
      "character": "罩",
      "zhuyin": "ㄓㄠˋ",
      "pinyin": "zhào",
      "english": "cover, fish trap (basket), shade"
    },
    {
      "character": "爪",
      "zhuyin": "ㄓㄠˇ",
      "pinyin": "zhǎo",
      "english": "foot of a bird or animal, paw, claws, talons"
    },
    {
      "character": "招",
      "zhuyin": "ㄓㄠ",
      "pinyin": "zhāo",
      "english": "to recruit, to provoke, to beckon, to incur, to infect, contagious, a move (chess), a maneuver, devi"
    },
    {
      "character": "朝",
      "zhuyin": "ㄓㄠ",
      "pinyin": "zhāo",
      "english": "morning"
    },
    {
      "character": "遮",
      "zhuyin": "ㄓㄜ",
      "pinyin": "zhē",
      "english": "to cover up (a shortcoming), to screen off, to hide, to conceal"
    },
    {
      "character": "執",
      "zhuyin": "ㄓˊ",
      "pinyin": "zhí",
      "english": "to execute (a plan), to grasp"
    },
    {
      "character": "擲",
      "zhuyin": "ㄓˊ",
      "pinyin": "zhí",
      "english": "to toss, to throw dice, Taiwan pr. [zhi2]"
    },
    {
      "character": "致",
      "zhuyin": "ㄓˋ",
      "pinyin": "zhì",
      "english": "to send, to devote, to deliver, to cause, to convey"
    },
    {
      "character": "舟",
      "zhuyin": "ㄓㄡ",
      "pinyin": "zhōu",
      "english": "boat"
    },
    {
      "character": "柱",
      "zhuyin": "ㄓㄨˋ",
      "pinyin": "zhù",
      "english": "pillar, CL:根[gen1]"
    },
    {
      "character": "著",
      "zhuyin": "ㄓㄠˊ",
      "pinyin": "zháo",
      "english": "to touch, to come in contact with, to feel, to be affected by, to catch fire, to burn, (coll.) to fa"
    },
    {
      "character": "駐",
      "zhuyin": "ㄓㄨˋ",
      "pinyin": "zhù",
      "english": "to halt, to stay, to be stationed (of troops, diplomats etc)"
    },
    {
      "character": "株",
      "zhuyin": "ㄓㄨ",
      "pinyin": "zhū",
      "english": "tree trunk, stump (tree root), a plant, classifier for trees or plants, strain (biology), to involve"
    },
    {
      "character": "磚",
      "zhuyin": "ㄓㄨㄢ",
      "pinyin": "zhuān",
      "english": "brick, CL:塊|块[kuai4]"
    },
    {
      "character": "狀",
      "zhuyin": "ㄓㄨㄤˋ",
      "pinyin": "zhuàng",
      "english": "accusation, suit, state, condition, strong, great, -shaped"
    },
    {
      "character": "樁",
      "zhuyin": "ㄓㄨㄤ",
      "pinyin": "zhuāng",
      "english": "stump, stake, pile, classifier for items"
    },
    {
      "character": "縱",
      "zhuyin": "ㄗㄨㄥ",
      "pinyin": "zōng",
      "english": "footprints; traces"
    },
    {
      "character": "宗",
      "zhuyin": "ㄗㄨㄥ",
      "pinyin": "zōng",
      "english": "school, sect, purpose, model, ancestor, clan, to take as one's model (in academic or artistic work),"
    },
    {
      "character": "揍",
      "zhuyin": "ㄗㄡˋ",
      "pinyin": "zòu",
      "english": "to hit, to beat (sb), (coll.) to smash (sth)"
    },
    {
      "character": "尊",
      "zhuyin": "ㄗㄨㄣ",
      "pinyin": "zūn",
      "english": "senior, of a senior generation, to honor, to respect, honorific, classifier for cannons and statues,"
    },
    {
      "character": "諳",
      "zhuyin": "ㄢ",
      "pinyin": "ān",
      "english": "to be versed in, to know well"
    },
    {
      "character": "凹",
      "zhuyin": "ㄠ",
      "pinyin": "āo",
      "english": "depressed, sunken, indented, concave, female (connector etc)"
    },
    {
      "character": "扒",
      "zhuyin": "ㄆㄚˊ",
      "pinyin": "pá",
      "english": "to rake up, to steal, to braise, to crawl"
    },
    {
      "character": "捌",
      "zhuyin": "ㄅㄚ",
      "pinyin": "bā",
      "english": "eight (banker's anti-fraud numeral), split"
    },
    {
      "character": "瓣",
      "zhuyin": "ㄅㄢˋ",
      "pinyin": "bàn",
      "english": "petal, segment, clove (of garlic), piece, section, fragment, valve, lamella, classifier for pieces, "
    },
    {
      "character": "絆",
      "zhuyin": "ㄅㄢˋ",
      "pinyin": "bàn",
      "english": "to trip, to stumble, to hinder"
    },
    {
      "character": "扳",
      "zhuyin": "ㄅㄢ",
      "pinyin": "bān",
      "english": "to pull, to turn (sth) around, to turn around (a situation), to recoup"
    },
    {
      "character": "甭",
      "zhuyin": "ㄅㄥˊ",
      "pinyin": "béng",
      "english": "(contraction of 不用[bu4 yong4]) need not, please don't"
    },
    {
      "character": "蹦",
      "zhuyin": "ㄅㄥˋ",
      "pinyin": "bèng",
      "english": "to jump, to bounce, to hop"
    },
    {
      "character": "敝",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bì",
      "english": "my (polite), poor, ruined, shabby, worn out, defeated"
    },
    {
      "character": "斃",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bì",
      "english": "to die, to shoot dead, to reject, to fall forward, (suffix) to death"
    },
    {
      "character": "貶",
      "zhuyin": "ㄅㄧㄢˇ",
      "pinyin": "biǎn",
      "english": "to diminish, to demote, to reduce or devaluate, to disparage, to censure, to depreciate"
    },
    {
      "character": "鞭",
      "zhuyin": "ㄅㄧㄢ",
      "pinyin": "biān",
      "english": "whip or lash, to flog, to whip, conductor's baton, segmented iron weapon (old), penis (of animal, se"
    },
    {
      "character": "卜",
      "zhuyin": "ㄅㄨˇ",
      "pinyin": "bǔ",
      "english": "(bound form) to divine"
    },
    {
      "character": "參",
      "zhuyin": "ㄘㄢ",
      "pinyin": "cān",
      "english": "to take part in, to participate, to join, to attend, to counsel, unequal, varied, irregular, uneven,"
    },
    {
      "character": "槽",
      "zhuyin": "ㄘㄠˊ",
      "pinyin": "cáo",
      "english": "trough, manger, groove, channel, (Tw) (computing) hard drive"
    },
    {
      "character": "饞",
      "zhuyin": "ㄔㄢˊ",
      "pinyin": "chán",
      "english": "gluttonous, greedy, to have a craving"
    },
    {
      "character": "摻",
      "zhuyin": "ㄔㄢ",
      "pinyin": "chān",
      "english": "to take by the arm and assist, to mix, to blend, to dilute, to adulterate"
    },
    {
      "character": "秤",
      "zhuyin": "ㄔㄥˋ",
      "pinyin": "chèng",
      "english": "steelyard, Roman balance, CL:臺|台[tai2]"
    },
    {
      "character": "逞",
      "zhuyin": "ㄔㄥˇ",
      "pinyin": "chěng",
      "english": "to show off, to flaunt, to carry out or succeed in a scheme, to indulge, to give free rein to"
    },
    {
      "character": "稠",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "chóu",
      "english": "dense, crowded, thick, many"
    },
    {
      "character": "瞅",
      "zhuyin": "ㄔㄡˇ",
      "pinyin": "chǒu",
      "english": "(dialect) to look at"
    },
    {
      "character": "踹",
      "zhuyin": "ㄔㄨㄞˋ",
      "pinyin": "chuài",
      "english": "to kick, to trample, to tread on"
    },
    {
      "character": "幢",
      "zhuyin": "ㄔㄨㄤˊ",
      "pinyin": "chuáng",
      "english": "banner"
    },
    {
      "character": "搥",
      "zhuyin": "ㄔㄨㄟˊ",
      "pinyin": "chuí",
      "english": "to beat (with a stick or one's fist), to thump, to pound"
    },
    {
      "character": "錘",
      "zhuyin": "ㄔㄨㄟˊ",
      "pinyin": "chuí",
      "english": "hammer, to hammer into shape, weight (e.g. of a steelyard or balance), to strike with a hammer"
    },
    {
      "character": "啜",
      "zhuyin": "ㄔㄨㄛˋ",
      "pinyin": "chuò",
      "english": "(literary) to drink, to sip, to sob"
    },
    {
      "character": "蹙",
      "zhuyin": "ㄘㄨˋ",
      "pinyin": "cù",
      "english": "to knit (one's brows), wrinkled (of brows), to hesitate, distressed"
    },
    {
      "character": "竄",
      "zhuyin": "ㄘㄨㄢˋ",
      "pinyin": "cuàn",
      "english": "to flee, to scuttle, to exile or banish, to amend or edit"
    },
    {
      "character": "撮",
      "zhuyin": "ㄘㄨㄛˋ",
      "pinyin": "cuò",
      "english": "classifier for hair or grass: tuft, Taiwan pr. [cuo4]"
    },
    {
      "character": "搗",
      "zhuyin": "ㄉㄠˇ",
      "pinyin": "dǎo",
      "english": "to pound, to beat, to hull, to attack, to disturb, to stir"
    },
    {
      "character": "蹬",
      "zhuyin": "ㄉㄥˋ",
      "pinyin": "dèng",
      "english": "to step on, to tread on, to wear (shoes), (slang) to dump (sb), Taiwan pr. [deng4]"
    },
    {
      "character": "殿",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "diàn",
      "english": "palace hall"
    },
    {
      "character": "踮",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "diàn",
      "english": "to stand on tiptoe, Taiwan pr. [dian4]"
    },
    {
      "character": "爹",
      "zhuyin": "ㄉㄧㄝ",
      "pinyin": "diē",
      "english": "dad"
    },
    {
      "character": "斗",
      "zhuyin": "ㄉㄡˇ",
      "pinyin": "dǒu",
      "english": "dry measure for grain equal to ten 升[sheng1] or one-tenth of a 石[dan4], decaliter, peck, cup or dipp"
    },
    {
      "character": "兜",
      "zhuyin": "ㄉㄡ",
      "pinyin": "dōu",
      "english": "pocket, bag, to wrap up or hold in a bag, to move in a circle, to canvas or solicit, to take respons"
    },
    {
      "character": "鈍",
      "zhuyin": "ㄉㄨㄣˋ",
      "pinyin": "dùn",
      "english": "blunt, stupid"
    },
    {
      "character": "舵",
      "zhuyin": "ㄉㄨㄛˋ",
      "pinyin": "duò",
      "english": "helm, rudder"
    },
    {
      "character": "貳",
      "zhuyin": "ㄦˋ",
      "pinyin": "èr",
      "english": "two (banker's anti-fraud numeral), to betray"
    },
    {
      "character": "餌",
      "zhuyin": "ㄦˇ",
      "pinyin": "ěr",
      "english": "pastry, food, to swallow, to lure, bait, lure"
    },
    {
      "character": "奉",
      "zhuyin": "ㄈㄥˋ",
      "pinyin": "fèng",
      "english": "to offer (tribute), to present respectfully (to superior, ancestor, deity etc), to esteem, to revere"
    },
    {
      "character": "拂",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "fú",
      "english": "to flick, to brush off, (of a breeze) to brush lightly over, (literary) to run counter to"
    },
    {
      "character": "賦",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fù",
      "english": "poetic essay, taxation, to bestow on, to endow with"
    },
    {
      "character": "甫",
      "zhuyin": "ㄈㄨˇ",
      "pinyin": "fǔ",
      "english": "(classical) barely, just, just now"
    },
    {
      "character": "羹",
      "zhuyin": "ㄍㄥ",
      "pinyin": "gēng",
      "english": "soup"
    },
    {
      "character": "拱",
      "zhuyin": "ㄍㄨㄥˇ",
      "pinyin": "gǒng",
      "english": "to cup one's hands in salute, to surround, to arch, to dig earth with the snout, arched"
    },
    {
      "character": "鉤",
      "zhuyin": "ㄍㄡ",
      "pinyin": "gōu",
      "english": "to hook, to sew, to crochet, hook, check mark or tick, window catch"
    },
    {
      "character": "冠",
      "zhuyin": "ㄍㄨㄢˋ",
      "pinyin": "guàn",
      "english": "to put on a hat, to be first, to dub"
    },
    {
      "character": "慣",
      "zhuyin": "ㄍㄨㄢˋ",
      "pinyin": "guàn",
      "english": "accustomed to, used to, indulge, to spoil (a child)"
    },
    {
      "character": "毫",
      "zhuyin": "ㄏㄠˊ",
      "pinyin": "háo",
      "english": "hair, drawing brush, (in the) least, one thousandth, currency unit, 0.1 yuan"
    },
    {
      "character": "荷",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "hé",
      "english": "lotus"
    },
    {
      "character": "鶴",
      "zhuyin": "ㄏㄜˋ",
      "pinyin": "hè",
      "english": "crane"
    },
    {
      "character": "虹",
      "zhuyin": "ㄏㄨㄥˊ",
      "pinyin": "hóng",
      "english": "rainbow"
    },
    {
      "character": "唬",
      "zhuyin": "ㄏㄨˇ",
      "pinyin": "hǔ",
      "english": "a tiger's roar, to scare, to intimidate, (coll.) to fool, to bluff"
    },
    {
      "character": "濺",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiàn",
      "english": "to splash"
    },
    {
      "character": "鑑",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiàn",
      "english": "bronze mirror (used in ancient times), to reflect, to mirror, sth that serves as a warning or a less"
    },
    {
      "character": "鹼",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "jiǎn",
      "english": "(chemistry) base, alkali, soda"
    },
    {
      "character": "嬌",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "jiāo",
      "english": "lovable, pampered, tender, delicate, frail"
    },
    {
      "character": "介",
      "zhuyin": "ㄐㄧㄝˋ",
      "pinyin": "jiè",
      "english": "to introduce, to lie between, between, shell, armor"
    },
    {
      "character": "謹",
      "zhuyin": "ㄐㄧㄣˇ",
      "pinyin": "jǐn",
      "english": "cautious, careful, solemnly, sincerely (formal)"
    },
    {
      "character": "莖",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jīng",
      "english": "stalk, stem, CL:條|条[tiao2]"
    },
    {
      "character": "窘",
      "zhuyin": "ㄐㄩㄥˇ",
      "pinyin": "jiǒng",
      "english": "distressed, embarrassed"
    },
    {
      "character": "玖",
      "zhuyin": "ㄐㄧㄡˇ",
      "pinyin": "jiǔ",
      "english": "black jade, nine (banker's anti-fraud numeral)"
    },
    {
      "character": "揪",
      "zhuyin": "ㄐㄧㄡ",
      "pinyin": "jiū",
      "english": "to seize, to clutch, to grab firmly and pull"
    },
    {
      "character": "菊",
      "zhuyin": "ㄐㄩˊ",
      "pinyin": "jú",
      "english": "chrysanthemum"
    },
    {
      "character": "鉅",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jù",
      "english": "hard iron, hook, variant of 巨[ju4], variant of 詎|讵[ju4]"
    },
    {
      "character": "鋸",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jù",
      "english": "a saw (CL:把[ba3]), to saw"
    },
    {
      "character": "炕",
      "zhuyin": "ㄎㄤˋ",
      "pinyin": "kàng",
      "english": "kang (a heatable brick bed), to bake, to dry by the heat of a fire"
    },
    {
      "character": "叩",
      "zhuyin": "ㄎㄡˋ",
      "pinyin": "kòu",
      "english": "to knock, to kowtow"
    },
    {
      "character": "礦",
      "zhuyin": "ㄎㄨㄤˋ",
      "pinyin": "kuàng",
      "english": "mineral deposit, ore deposit, ore, a mine"
    },
    {
      "character": "濫",
      "zhuyin": "ㄌㄢˋ",
      "pinyin": "làn",
      "english": "overflowing, excessive, indiscriminate"
    },
    {
      "character": "攬",
      "zhuyin": "ㄌㄢˇ",
      "pinyin": "lǎn",
      "english": "to monopolize, to seize, to take into one's arms, to embrace, to fasten (with a rope etc), to take o"
    },
    {
      "character": "廊",
      "zhuyin": "ㄌㄤˊ",
      "pinyin": "láng",
      "english": "corridor, veranda, porch"
    },
    {
      "character": "怔",
      "zhuyin": "ㄌㄥˋ",
      "pinyin": "lèng",
      "english": "stumped for words, to stare blankly"
    },
    {
      "character": "犁",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "lí",
      "english": "plow"
    },
    {
      "character": "樑",
      "zhuyin": "ㄌㄧㄤˊ",
      "pinyin": "liáng",
      "english": "roof beam, beam (structure), bridge"
    },
    {
      "character": "晾",
      "zhuyin": "ㄌㄧㄤˋ",
      "pinyin": "liàng",
      "english": "to dry in the air, (fig.) to cold-shoulder"
    },
    {
      "character": "鄰",
      "zhuyin": "ㄌㄧㄣˊ",
      "pinyin": "lín",
      "english": "neighbor, adjacent, close to"
    },
    {
      "character": "鱗",
      "zhuyin": "ㄌㄧㄣˊ",
      "pinyin": "lín",
      "english": "scales (of fish)"
    },
    {
      "character": "瘤",
      "zhuyin": "ㄌㄧㄡˊ",
      "pinyin": "liú",
      "english": "tumor"
    },
    {
      "character": "簍",
      "zhuyin": "ㄌㄡˇ",
      "pinyin": "lǒu",
      "english": "basket"
    },
    {
      "character": "擄",
      "zhuyin": "ㄌㄨˇ",
      "pinyin": "lǔ",
      "english": "(bound form) to capture (sb)"
    },
    {
      "character": "縷",
      "zhuyin": "ㄌㄩˇ",
      "pinyin": "lǚ",
      "english": "strand, thread, detailed, in detail, classifier for wisps (of smoke, mist or vapor), strands, locks "
    },
    {
      "character": "鑼",
      "zhuyin": "ㄌㄨㄛˊ",
      "pinyin": "luó",
      "english": "gong, CL:面[mian4]"
    },
    {
      "character": "蒙",
      "zhuyin": "ㄇㄥˊ",
      "pinyin": "méng",
      "english": "to cover, ignorant, to suffer (misfortune), to receive (a favor), to cheat"
    },
    {
      "character": "描",
      "zhuyin": "ㄇㄧㄠˊ",
      "pinyin": "miáo",
      "english": "to depict, to trace (a drawing), to copy, to touch up"
    },
    {
      "character": "畝",
      "zhuyin": "ㄇㄨˇ",
      "pinyin": "mǔ",
      "english": "classifier for fields, unit of area equal to one fifteenth of a hectare"
    },
    {
      "character": "拈",
      "zhuyin": "ㄋㄧㄢˊ",
      "pinyin": "nián",
      "english": "to nip, to grasp with the fingers, to fiddle with, Taiwan pr. [nian2]"
    },
    {
      "character": "娘",
      "zhuyin": "ㄋㄧㄤˊ",
      "pinyin": "niáng",
      "english": "mother, young lady, (coll.) effeminate"
    },
    {
      "character": "擰",
      "zhuyin": "ㄋㄧㄥˇ",
      "pinyin": "nǐng",
      "english": "mistake, to twist"
    },
    {
      "character": "畔",
      "zhuyin": "ㄆㄢˋ",
      "pinyin": "pàn",
      "english": "(bound form) side, edge, boundary"
    },
    {
      "character": "袍",
      "zhuyin": "ㄆㄠˊ",
      "pinyin": "páo",
      "english": "gown (lined)"
    },
    {
      "character": "棚",
      "zhuyin": "ㄆㄥˊ",
      "pinyin": "péng",
      "english": "shed, canopy, shack"
    },
    {
      "character": "瓢",
      "zhuyin": "ㄆㄧㄠˊ",
      "pinyin": "piáo",
      "english": "dipper, ladle"
    },
    {
      "character": "瞟",
      "zhuyin": "ㄆㄧㄠˇ",
      "pinyin": "piǎo",
      "english": "to cast a glance"
    },
    {
      "character": "撇",
      "zhuyin": "ㄆㄧㄝ",
      "pinyin": "piē",
      "english": "to cast away, to fling aside"
    },
    {
      "character": "剖",
      "zhuyin": "ㄆㄡˇ",
      "pinyin": "pǒu",
      "english": "to cut open, to analyze, Taiwan pr. [pou3]"
    },
    {
      "character": "噗",
      "zhuyin": "ㄆㄨ",
      "pinyin": "pū",
      "english": "(onom.) pop, plop, pfff, putt-putt of a motor"
    },
    {
      "character": "柒",
      "zhuyin": "ㄑㄧ",
      "pinyin": "qī",
      "english": "seven (banker's anti-fraud numeral)"
    },
    {
      "character": "嵌",
      "zhuyin": "ㄑㄧㄢ",
      "pinyin": "qiān",
      "english": "to inlay, to embed, Taiwan pr. [qian1]"
    },
    {
      "character": "嗆",
      "zhuyin": "ㄑㄧㄤˋ",
      "pinyin": "qiàng",
      "english": "to irritate the nose, to choke (of smoke, smell etc), pungent, (coll.) (Tw) to shout at sb, to scold"
    },
    {
      "character": "妾",
      "zhuyin": "ㄑㄧㄝˋ",
      "pinyin": "qiè",
      "english": "concubine, I, your servant (deprecatory self-reference for women)"
    },
    {
      "character": "擒",
      "zhuyin": "ㄑㄧㄣˊ",
      "pinyin": "qín",
      "english": "to capture"
    },
    {
      "character": "汝",
      "zhuyin": "ㄖㄨˇ",
      "pinyin": "rǔ",
      "english": "thou"
    },
    {
      "character": "腮",
      "zhuyin": "ㄙㄞ",
      "pinyin": "sāi",
      "english": "cheek"
    },
    {
      "character": "搔",
      "zhuyin": "ㄙㄠ",
      "pinyin": "sāo",
      "english": "to scratch, old variant of 騷|骚[sao1]"
    },
    {
      "character": "煞",
      "zhuyin": "ㄕㄚ",
      "pinyin": "shā",
      "english": "to terminate, to cut short, to bring to a stop, to squeeze, to tighten, to damage, variant of 殺|杀[sh"
    },
    {
      "character": "紗",
      "zhuyin": "ㄕㄚ",
      "pinyin": "shā",
      "english": "cotton yarn, muslin"
    },
    {
      "character": "勺",
      "zhuyin": "ㄕㄠˊ",
      "pinyin": "sháo",
      "english": "spoon, ladle, CL:把[ba3], abbr. for 公勺[gong1 shao2], centiliter (unit of volume)"
    },
    {
      "character": "嗜",
      "zhuyin": "ㄕˋ",
      "pinyin": "shì",
      "english": "addicted to, fond of, stem corresponding to -phil or -phile"
    },
    {
      "character": "孰",
      "zhuyin": "ㄕㄨˊ",
      "pinyin": "shú",
      "english": "who, which, what"
    },
    {
      "character": "贖",
      "zhuyin": "ㄕㄨˊ",
      "pinyin": "shú",
      "english": "to redeem, to ransom"
    },
    {
      "character": "拴",
      "zhuyin": "ㄕㄨㄢ",
      "pinyin": "shuān",
      "english": "to tie up"
    },
    {
      "character": "肆",
      "zhuyin": "ㄙˋ",
      "pinyin": "sì",
      "english": "four (banker's anti-fraud numeral), unrestrained, wanton, (literary) shop"
    },
    {
      "character": "粟",
      "zhuyin": "ㄙㄨˋ",
      "pinyin": "sù",
      "english": "millet, (metonym) grain"
    },
    {
      "character": "酥",
      "zhuyin": "ㄙㄨ",
      "pinyin": "sū",
      "english": "flaky pastry, crunchy, limp, soft, silky"
    },
    {
      "character": "祂",
      "zhuyin": "ㄊㄚ",
      "pinyin": "tā",
      "english": "(third person pronoun for a divine being)"
    },
    {
      "character": "碳",
      "zhuyin": "ㄊㄢˋ",
      "pinyin": "tàn",
      "english": "carbon (chemistry)"
    },
    {
      "character": "癱",
      "zhuyin": "ㄊㄢ",
      "pinyin": "tān",
      "english": "paralyzed"
    },
    {
      "character": "啼",
      "zhuyin": "ㄊㄧˊ",
      "pinyin": "tí",
      "english": "(bound form) to cry, to weep loudly, (bound form) (of a bird or animal) to crow, to hoot, to screech"
    },
    {
      "character": "剃",
      "zhuyin": "ㄊㄧˋ",
      "pinyin": "tì",
      "english": "to shave"
    },
    {
      "character": "帖",
      "zhuyin": "ㄊㄧㄝˇ",
      "pinyin": "tiě",
      "english": "invitation card, notice"
    },
    {
      "character": "捅",
      "zhuyin": "ㄊㄨㄥˇ",
      "pinyin": "tǒng",
      "english": "to stab, to poke, to prod, to nudge, to disclose"
    },
    {
      "character": "臀",
      "zhuyin": "ㄊㄨㄣˊ",
      "pinyin": "tún",
      "english": "butt, buttocks"
    },
    {
      "character": "瓦",
      "zhuyin": "ㄨㄚˇ",
      "pinyin": "wǎ",
      "english": "roof tile, abbr. for 瓦特[wa3 te4]"
    },
    {
      "character": "挽",
      "zhuyin": "ㄨㄢˇ",
      "pinyin": "wǎn",
      "english": "to pull, to draw (a cart or a bow), to roll up, to coil, to carry on the arm, to lament the dead, (f"
    },
    {
      "character": "伍",
      "zhuyin": "ㄨˇ",
      "pinyin": "wǔ",
      "english": "squad of five soldiers, to associate with, five (banker's anti-fraud numeral)"
    },
    {
      "character": "襲",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "xí",
      "english": "(bound form) to raid, to attack, (bound form) to continue the pattern, to perpetuate, (literary) cla"
    },
    {
      "character": "錫",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "xí",
      "english": "tin (chemistry), to bestow, to confer, to grant, Taiwan pr. [xi2]"
    },
    {
      "character": "稀",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xī",
      "english": "rare, uncommon, watery, sparse"
    },
    {
      "character": "弦",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "xián",
      "english": "bow string, string of musical instrument, watchspring, chord (segment of curve), hypotenuse, CL:根[ge"
    },
    {
      "character": "銜",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "xián",
      "english": "bit (of a bridle), to hold in the mouth, to harbor (feelings), to link, to accept, rank, title"
    },
    {
      "character": "掀",
      "zhuyin": "ㄒㄧㄢ",
      "pinyin": "xiān",
      "english": "to lift (a lid), to rock, to convulse"
    },
    {
      "character": "鑲",
      "zhuyin": "ㄒㄧㄤ",
      "pinyin": "xiāng",
      "english": "to inlay, to embed, ridge, border"
    },
    {
      "character": "偕",
      "zhuyin": "ㄒㄧㄝˊ",
      "pinyin": "xié",
      "english": "in company with"
    },
    {
      "character": "卸",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "xiè",
      "english": "to unload, to unhitch, to remove or strip, to get rid of"
    },
    {
      "character": "繡",
      "zhuyin": "ㄒㄧㄡˋ",
      "pinyin": "xiù",
      "english": "to embroider, embroidery"
    },
    {
      "character": "宿",
      "zhuyin": "ㄒㄧㄡˇ",
      "pinyin": "xiǔ",
      "english": "night, classifier for nights"
    },
    {
      "character": "序",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "xù",
      "english": "(bound form) order, sequence, (bound form) introductory, initial, preface"
    },
    {
      "character": "蓄",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "xù",
      "english": "to store up, to grow (e.g. a beard), to entertain (ideas)"
    },
    {
      "character": "鬚",
      "zhuyin": "ㄒㄩ",
      "pinyin": "xū",
      "english": "beard, mustache, feeler (of an insect etc), tassel"
    },
    {
      "character": "靴",
      "zhuyin": "ㄒㄩㄝ",
      "pinyin": "xuē",
      "english": "boots"
    },
    {
      "character": "旬",
      "zhuyin": "ㄒㄩㄣˊ",
      "pinyin": "xún",
      "english": "ten days, ten years, full period"
    },
    {
      "character": "薰",
      "zhuyin": "ㄒㄩㄣ",
      "pinyin": "xūn",
      "english": "fragrance, warm, to educate, variant of 熏[xun1], to smoke, to fumigate"
    },
    {
      "character": "芽",
      "zhuyin": "ㄧㄚˊ",
      "pinyin": "yá",
      "english": "bud, sprout"
    },
    {
      "character": "押",
      "zhuyin": "ㄧㄚ",
      "pinyin": "yā",
      "english": "to mortgage, to pawn, to detain in custody, to escort and protect, (literary) to sign"
    },
    {
      "character": "嚥",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "yàn",
      "english": "to swallow"
    },
    {
      "character": "焉",
      "zhuyin": "ㄧㄢ",
      "pinyin": "yān",
      "english": "where, how"
    },
    {
      "character": "舀",
      "zhuyin": "ㄧㄠˇ",
      "pinyin": "yǎo",
      "english": "to ladle out, to scoop up"
    },
    {
      "character": "溢",
      "zhuyin": "ㄧˋ",
      "pinyin": "yì",
      "english": "to overflow, (literary) excessive, old variant of 鎰|镒[yi4]"
    },
    {
      "character": "翼",
      "zhuyin": "ㄧˋ",
      "pinyin": "yì",
      "english": "wing, area surrounding the bullseye of a target, to assist, one of the 28 constellations of Chinese "
    },
    {
      "character": "矣",
      "zhuyin": "ㄧˇ",
      "pinyin": "yǐ",
      "english": "classical final particle, similar to modern 了[le5]"
    },
    {
      "character": "伊",
      "zhuyin": "ㄧ",
      "pinyin": "yī",
      "english": "(old) third person singular pronoun (\"he\" or \"she\"), second person singular pronoun (\"you\"), (May 4t"
    },
    {
      "character": "壹",
      "zhuyin": "ㄧ",
      "pinyin": "yī",
      "english": "one (banker's anti-fraud numeral)"
    },
    {
      "character": "淫",
      "zhuyin": "ㄧㄣˊ",
      "pinyin": "yín",
      "english": "excess, excessive, wanton, lewd, lascivious, obscene, depraved"
    },
    {
      "character": "余",
      "zhuyin": "ㄩˊ",
      "pinyin": "yú",
      "english": "(literary) I, me, variant of 餘|余[yu2]"
    },
    {
      "character": "曰",
      "zhuyin": "ㄩㄝ",
      "pinyin": "yuē",
      "english": "to speak, to say"
    },
    {
      "character": "哉",
      "zhuyin": "ㄗㄞ",
      "pinyin": "zāi",
      "english": "(exclamatory or interrogative particle)"
    },
    {
      "character": "灶",
      "zhuyin": "ㄗㄠˋ",
      "pinyin": "zào",
      "english": "kitchen stove, kitchen, mess, canteen"
    },
    {
      "character": "棗",
      "zhuyin": "ㄗㄠˇ",
      "pinyin": "zǎo",
      "english": "(bound form) jujube, Chinese date (Zizyphus jujuba)"
    },
    {
      "character": "遭",
      "zhuyin": "ㄗㄠ",
      "pinyin": "zāo",
      "english": "to meet by chance (usually with misfortune), classifier for events: time, turn, incident"
    },
    {
      "character": "鑿",
      "zhuyin": "ㄗㄠˊ",
      "pinyin": "záo",
      "english": "chisel, to bore a hole, to chisel or dig, (literary) (bound form) certain, authentic, irrefutable, a"
    },
    {
      "character": "紮",
      "zhuyin": "ㄓㄚˊ",
      "pinyin": "zhá",
      "english": "(of troops) to be stationed (at), Taiwan pr. [zha2]"
    },
    {
      "character": "乍",
      "zhuyin": "ㄓㄚˋ",
      "pinyin": "zhà",
      "english": "at first, suddenly, abruptly, to spread, (of hair) to stand on end, bristling"
    },
    {
      "character": "寨",
      "zhuyin": "ㄓㄞˋ",
      "pinyin": "zhài",
      "english": "stronghold, stockade, camp, (stockaded) village"
    },
    {
      "character": "蘸",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "zhàn",
      "english": "to dip in (ink, sauce etc)"
    },
    {
      "character": "盞",
      "zhuyin": "ㄓㄢˇ",
      "pinyin": "zhǎn",
      "english": "a small cup, classifier for lamps"
    },
    {
      "character": "掌",
      "zhuyin": "ㄓㄤˇ",
      "pinyin": "zhǎng",
      "english": "palm of the hand, sole of the foot, paw, horseshoe, to slap, to hold in one's hand, to wield"
    },
    {
      "character": "朕",
      "zhuyin": "ㄓㄣˋ",
      "pinyin": "zhèn",
      "english": "(used by an emperor or king) I, me, we (royal \"we\"), (literary) omen"
    },
    {
      "character": "枕",
      "zhuyin": "ㄓㄣˇ",
      "pinyin": "zhěn",
      "english": "pillow, to pillow, to rest one's head on (Taiwan pr. [zhen4] for this sense)"
    },
    {
      "character": "斟",
      "zhuyin": "ㄓㄣ",
      "pinyin": "zhēn",
      "english": "to pour, to deliberate"
    },
    {
      "character": "臻",
      "zhuyin": "ㄓㄣ",
      "pinyin": "zhēn",
      "english": "to arrive, to reach (esp. perfection), utmost, (used in commercials)"
    },
    {
      "character": "掙",
      "zhuyin": "ㄓㄥ",
      "pinyin": "zhēng",
      "english": "used in 掙扎|挣扎[zheng1 zha2]"
    },
    {
      "character": "值",
      "zhuyin": "ㄓˊ",
      "pinyin": "zhí",
      "english": "value, (to be) worth, to happen to, to be on duty"
    },
    {
      "character": "盅",
      "zhuyin": "ㄓㄨㄥ",
      "pinyin": "zhōng",
      "english": "handleless cup, goblet"
    },
    {
      "character": "拄",
      "zhuyin": "ㄓㄨˇ",
      "pinyin": "zhǔ",
      "english": "to lean on, to prop on"
    },
    {
      "character": "朱",
      "zhuyin": "ㄓㄨ",
      "pinyin": "zhū",
      "english": "vermilion"
    },
    {
      "character": "啄",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "zhuó",
      "english": "to peck"
    },
    {
      "character": "濁",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "zhuó",
      "english": "turbid, muddy, impure"
    },
    {
      "character": "酌",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "zhuó",
      "english": "to pour wine, to drink wine, to deliberate, to consider"
    },
    {
      "character": "茲",
      "zhuyin": "ㄗ",
      "pinyin": "zī",
      "english": "now, here, this, time, year"
    },
    {
      "character": "卒",
      "zhuyin": "ㄗㄨˊ",
      "pinyin": "zú",
      "english": "soldier, servant, to finish, to die, finally, at last, pawn in Chinese chess"
    },
    {
      "character": "挨",
      "zhuyin": "ㄞ",
      "pinyin": "āidǎ",
      "english": "to take a beating, to get thrashed, to come under attack"
    },
    {
      "character": "癌",
      "zhuyin": "ㄞˊ",
      "pinyin": "áizhèng",
      "english": "cancer"
    },
    {
      "character": "症",
      "zhuyin": "ㄓㄥˋ",
      "pinyin": "áizhèng",
      "english": "cancer"
    },
    {
      "character": "慰",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "ānwèi",
      "english": "to comfort, to console, CL:個|个[ge4]"
    },
    {
      "character": "昂",
      "zhuyin": "ㄤˊ",
      "pinyin": "ángguì",
      "english": "expensive, costly"
    },
    {
      "character": "罷",
      "zhuyin": "ㄅㄚˋ",
      "pinyin": "bàgōng",
      "english": "a strike, to go on strike"
    },
    {
      "character": "伴",
      "zhuyin": "ㄅㄢˋ",
      "pinyin": "bànlǚ",
      "english": "companion, mate, partner"
    },
    {
      "character": "侶",
      "zhuyin": "ㄌㄩˇ",
      "pinyin": "bànlǚ",
      "english": "companion, mate, partner"
    },
    {
      "character": "途",
      "zhuyin": "ㄊㄨˊ",
      "pinyin": "bàntú",
      "english": "halfway, midway"
    },
    {
      "character": "傍",
      "zhuyin": "ㄅㄤ",
      "pinyin": "bāngwǎn",
      "english": "in the evening, when night falls, towards evening, at night fall, at dusk"
    },
    {
      "character": "貝",
      "zhuyin": "ㄅㄟˋ",
      "pinyin": "bǎobèi",
      "english": "treasured object, treasure, darling, baby, cowry, good-for-nothing or queer character"
    },
    {
      "character": "爆",
      "zhuyin": "ㄅㄠˋ",
      "pinyin": "bàofā",
      "english": "to break out, to erupt, to explode, to burst out"
    },
    {
      "character": "刊",
      "zhuyin": "ㄎㄢ",
      "pinyin": "bàokān",
      "english": "newspapers and periodicals, the press"
    },
    {
      "character": "暴",
      "zhuyin": "ㄅㄠˋ",
      "pinyin": "bàolì",
      "english": "violence, force, violent"
    },
    {
      "character": "守",
      "zhuyin": "ㄕㄡˇ",
      "pinyin": "bǎoshǒu",
      "english": "conservative, to guard, to keep"
    },
    {
      "character": "障",
      "zhuyin": "ㄓㄤˋ",
      "pinyin": "bǎozhàng",
      "english": "to ensure, to guarantee, to safeguard"
    },
    {
      "character": "悲",
      "zhuyin": "ㄅㄟ",
      "pinyin": "bēiāi",
      "english": "grieved, sorrowful"
    },
    {
      "character": "哀",
      "zhuyin": "ㄞ",
      "pinyin": "bēiāi",
      "english": "grieved, sorrowful"
    },
    {
      "character": "叛",
      "zhuyin": "ㄆㄢˋ",
      "pinyin": "bèipàn",
      "english": "to betray"
    },
    {
      "character": "港",
      "zhuyin": "ㄍㄤˇ",
      "pinyin": "bìfēnggǎng",
      "english": "haven, refuge, harbor, CL:座[zuo4], 個|个[ge4]"
    },
    {
      "character": "喻",
      "zhuyin": "ㄩˋ",
      "pinyin": "bǐyù",
      "english": "to compare, to liken to, metaphor, analogy, figure of speech, figuratively"
    },
    {
      "character": "輯",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "biānjí",
      "english": "to edit, to compile, editor, compiler"
    },
    {
      "character": "辨",
      "zhuyin": "ㄅㄧㄢˋ",
      "pinyin": "biànshì",
      "english": "identification, to identify, to recognize"
    },
    {
      "character": "籤",
      "zhuyin": "ㄑㄧㄢ",
      "pinyin": "biāoqiān",
      "english": "label, tag, (computing) tab (GUI element)"
    },
    {
      "character": "賓",
      "zhuyin": "ㄅㄧㄣ",
      "pinyin": "bīnkè",
      "english": "guests, visitors"
    },
    {
      "character": "妨",
      "zhuyin": "ㄈㄤˊ",
      "pinyin": "bùfáng",
      "english": "there is no harm in, might as well"
    },
    {
      "character": "驟",
      "zhuyin": "ㄗㄡˋ",
      "pinyin": "bùzòu",
      "english": "procedure, step"
    },
    {
      "character": "裁",
      "zhuyin": "ㄘㄞˊ",
      "pinyin": "cáipàn",
      "english": "judgment, to referee, umpire, judge, referee, CL:個|个[ge4], 位[wei4], 名[ming2]"
    },
    {
      "character": "判",
      "zhuyin": "ㄆㄢˋ",
      "pinyin": "cáipàn",
      "english": "judgment, to referee, umpire, judge, referee, CL:個|个[ge4], 位[wei4], 名[ming2]"
    },
    {
      "character": "殘",
      "zhuyin": "ㄘㄢˊ",
      "pinyin": "cánkù",
      "english": "cruel, cruelty"
    },
    {
      "character": "蒼",
      "zhuyin": "ㄘㄤ",
      "pinyin": "cāngbái",
      "english": "pale, wan"
    },
    {
      "character": "倉",
      "zhuyin": "ㄘㄤ",
      "pinyin": "cāngkù",
      "english": "depot, storehouse, warehouse"
    },
    {
      "character": "庫",
      "zhuyin": "ㄎㄨˋ",
      "pinyin": "cāngkù",
      "english": "depot, storehouse, warehouse"
    },
    {
      "character": "壽",
      "zhuyin": "ㄕㄡˋ",
      "pinyin": "chángshòu",
      "english": "longevity, long-lived"
    },
    {
      "character": "鈔",
      "zhuyin": "ㄔㄠ",
      "pinyin": "chāopiào",
      "english": "paper money, a bill (e.g. 100 yuan), CL:張|张[zhang1], 紮|扎[za1]"
    },
    {
      "character": "嘲",
      "zhuyin": "ㄔㄠˊ",
      "pinyin": "cháoxiào",
      "english": "to jeer at, to deride, to ridicule, mockery, derision"
    },
    {
      "character": "澈",
      "zhuyin": "ㄔㄜˋ",
      "pinyin": "chèdǐ",
      "english": "thorough, thoroughly, complete"
    },
    {
      "character": "廂",
      "zhuyin": "ㄒㄧㄤ",
      "pinyin": "chēxiāng",
      "english": "carriage, CL:節|节[jie2]"
    },
    {
      "character": "默",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "chénmò",
      "english": "taciturn, uncommunicative, silent"
    },
    {
      "character": "陳",
      "zhuyin": "ㄔㄣˊ",
      "pinyin": "chénshù",
      "english": "an assertion, to declare, to state"
    },
    {
      "character": "述",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "chénshù",
      "english": "an assertion, to declare, to state"
    },
    {
      "character": "懲",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéngfá",
      "english": "penalty, punishment, to punish"
    },
    {
      "character": "諾",
      "zhuyin": "ㄋㄨㄛˋ",
      "pinyin": "chéngnuò",
      "english": "to promise, to undertake to do something, commitment"
    },
    {
      "character": "誠",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéngshí",
      "english": "honest"
    },
    {
      "character": "翅",
      "zhuyin": "ㄔˋ",
      "pinyin": "chìbǎng",
      "english": "wing, CL:個|个[ge4], 對|对[dui4]"
    },
    {
      "character": "膀",
      "zhuyin": "ㄅㄤˇ",
      "pinyin": "chìbǎng",
      "english": "wing, CL:個|个[ge4], 對|对[dui4]"
    },
    {
      "character": "崇",
      "zhuyin": "ㄔㄨㄥˊ",
      "pinyin": "chóngbài",
      "english": "to worship, adoration"
    },
    {
      "character": "覆",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "chóngfù",
      "english": "to repeat, to duplicate, CL:個|个[ge4]"
    },
    {
      "character": "蟲",
      "zhuyin": "ㄔㄨㄥˊ",
      "pinyin": "chóngzi",
      "english": "insect, bug, worm, CL:條|条[tiao2], 隻|只[zhi1]"
    },
    {
      "character": "屜",
      "zhuyin": "ㄊㄧˋ",
      "pinyin": "chōutì",
      "english": "drawer"
    },
    {
      "character": "儲",
      "zhuyin": "ㄔㄨˊ",
      "pinyin": "chúcún",
      "english": "stockpile, to store, to stockpile, storage"
    },
    {
      "character": "軌",
      "zhuyin": "ㄍㄨㄟˇ",
      "pinyin": "chūguǐ",
      "english": "to be derailed, to go off the rails, (fig.) to overstep the bounds, (fig.) to have an extramarital a"
    },
    {
      "character": "播",
      "zhuyin": "ㄅㄛˋ",
      "pinyin": "chuánbò",
      "english": "to disseminate, to propagate, to spread"
    },
    {
      "character": "彙",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "cíhuì",
      "english": "vocabulary, list of words (e.g. for language teaching purposes), word"
    },
    {
      "character": "辭",
      "zhuyin": "ㄘˊ",
      "pinyin": "cízhí",
      "english": "to resign"
    },
    {
      "character": "匆",
      "zhuyin": "ㄘㄨㄥ",
      "pinyin": "cōngmáng",
      "english": "hasty, hurried"
    },
    {
      "character": "尾",
      "zhuyin": "ㄨㄟˇ",
      "pinyin": "cóngtóudàowěi",
      "english": "from start to finish, from head to tail, the whole (thing)"
    },
    {
      "character": "促",
      "zhuyin": "ㄘㄨˋ",
      "pinyin": "cùshǐ",
      "english": "to induce, to promote, to urge, to impel, to bring about, to provoke, to drive (sb to do sth), to ca"
    },
    {
      "character": "挫",
      "zhuyin": "ㄘㄨㄛˋ",
      "pinyin": "cuòzhé",
      "english": "setback, reverse, check, defeat, frustration, disappointment, to frustrate, to discourage, to set sb"
    },
    {
      "character": "擊",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "dǎjí",
      "english": "to hit, to strike, to attack, to crack down on sth, blow, (psychological) shock, percussion (music)"
    },
    {
      "character": "瞌",
      "zhuyin": "ㄎㄜ",
      "pinyin": "dǎkēshuì",
      "english": "to doze off"
    },
    {
      "character": "獵",
      "zhuyin": "ㄌㄧㄝˋ",
      "pinyin": "dǎliè",
      "english": "to go hunting"
    },
    {
      "character": "逮",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dàibǔ",
      "english": "to arrest, to apprehend, an arrest"
    },
    {
      "character": "捕",
      "zhuyin": "ㄅㄨˇ",
      "pinyin": "dàibǔ",
      "english": "to arrest, to apprehend, an arrest"
    },
    {
      "character": "貸",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dàikuǎn",
      "english": "a loan, CL:筆|笔[bi3], to provide a loan (e.g. bank), to raise a loan (from e.g. a bank)"
    },
    {
      "character": "耽",
      "zhuyin": "ㄉㄢ",
      "pinyin": "dānwù",
      "english": "to delay, to hold up, to waste time, to interfere with"
    },
    {
      "character": "憂",
      "zhuyin": "ㄧㄡ",
      "pinyin": "dānyōu",
      "english": "to worry, to be concerned"
    },
    {
      "character": "禱",
      "zhuyin": "ㄉㄠˇ",
      "pinyin": "dǎogào",
      "english": "to pray, prayer"
    },
    {
      "character": "楣",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "dǎoméi",
      "english": "to have bad luck, to be out of luck"
    },
    {
      "character": "登",
      "zhuyin": "ㄉㄥ",
      "pinyin": "dēngjì",
      "english": "to register (one's name)"
    },
    {
      "character": "抗",
      "zhuyin": "ㄎㄤˋ",
      "pinyin": "dǐkàng",
      "english": "to resist, resistance"
    },
    {
      "character": "敵",
      "zhuyin": "ㄉㄧˊ",
      "pinyin": "dírén",
      "english": "enemy, CL:個|个[ge4]"
    },
    {
      "character": "義",
      "zhuyin": "ㄧˋ",
      "pinyin": "dìngyì",
      "english": "definition, to define"
    },
    {
      "character": "墮",
      "zhuyin": "ㄉㄨㄛˋ",
      "pinyin": "duòtāi",
      "english": "to induce an abortion, induced abortion"
    },
    {
      "character": "惡",
      "zhuyin": "ㄜˋ",
      "pinyin": "èhuà",
      "english": "to worsen"
    },
    {
      "character": "劣",
      "zhuyin": "ㄌㄧㄝˋ",
      "pinyin": "èliè",
      "english": "vile, nasty, of very poor quality"
    },
    {
      "character": "額",
      "zhuyin": "ㄜˊ",
      "pinyin": "étou",
      "english": "forehead"
    },
    {
      "character": "噁",
      "zhuyin": "ㄜˇ",
      "pinyin": "ěxīn",
      "english": "bad habit, vicious habit, vice"
    },
    {
      "character": "誓",
      "zhuyin": "ㄕˋ",
      "pinyin": "fāshì",
      "english": "to vow, to pledge, to swear"
    },
    {
      "character": "駁",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "fǎnbó",
      "english": "to retort, to refute"
    },
    {
      "character": "返",
      "zhuyin": "ㄈㄢˇ",
      "pinyin": "fǎnhuí",
      "english": "to return to, to come (or go) back"
    },
    {
      "character": "繁",
      "zhuyin": "ㄈㄢˊ",
      "pinyin": "fánróng",
      "english": "prosperous, booming (economy)"
    },
    {
      "character": "榮",
      "zhuyin": "ㄖㄨㄥˊ",
      "pinyin": "fánróng",
      "english": "prosperous, booming (economy)"
    },
    {
      "character": "凡",
      "zhuyin": "ㄈㄢˊ",
      "pinyin": "fánshì",
      "english": "everything"
    },
    {
      "character": "映",
      "zhuyin": "ㄧㄥˋ",
      "pinyin": "fǎnyìng",
      "english": "to mirror, to reflect, mirror image, reflection, (fig.) to report, to make known, to render"
    },
    {
      "character": "仿",
      "zhuyin": "ㄈㄤˇ",
      "pinyin": "fǎngmào",
      "english": "to counterfeit, fake"
    },
    {
      "character": "防",
      "zhuyin": "ㄈㄤˊ",
      "pinyin": "fángshǒu",
      "english": "to defend, to protect (against)"
    },
    {
      "character": "廢",
      "zhuyin": "ㄈㄟˋ",
      "pinyin": "fèihuà",
      "english": "nonsense, rubbish, superfluous words, You don't say!, No kidding! (gently sarcastic)"
    },
    {
      "character": "紛",
      "zhuyin": "ㄈㄣ",
      "pinyin": "fēnfēn",
      "english": "one after another, in succession, one by one, continuously, diverse, in profusion, numerous and conf"
    },
    {
      "character": "吩",
      "zhuyin": "ㄈㄣ",
      "pinyin": "fēnfù",
      "english": "to tell, to instruct, to command"
    },
    {
      "character": "咐",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fēnfù",
      "english": "to tell, to instruct, to command"
    },
    {
      "character": "憤",
      "zhuyin": "ㄈㄣˋ",
      "pinyin": "fènnù",
      "english": "angry, indignant, wrath, ire"
    },
    {
      "character": "怒",
      "zhuyin": "ㄋㄨˋ",
      "pinyin": "fènnù",
      "english": "angry, indignant, wrath, ire"
    },
    {
      "character": "析",
      "zhuyin": "ㄒㄧ",
      "pinyin": "fēnxī",
      "english": "to analyze, analysis, CL:個|个[ge4]"
    },
    {
      "character": "諷",
      "zhuyin": "ㄈㄥˋ",
      "pinyin": "fèngcì",
      "english": "to satirize, to mock, irony, satire, sarcasm"
    },
    {
      "character": "蜂",
      "zhuyin": "ㄈㄥ",
      "pinyin": "fēngmì",
      "english": "honey"
    },
    {
      "character": "蜜",
      "zhuyin": "ㄇㄧˋ",
      "pinyin": "fēngmì",
      "english": "honey"
    },
    {
      "character": "俗",
      "zhuyin": "ㄙㄨˊ",
      "pinyin": "fēngsú",
      "english": "social custom, CL:個|个[ge4]"
    },
    {
      "character": "輔",
      "zhuyin": "ㄈㄨˇ",
      "pinyin": "fǔdǎo",
      "english": "to give guidance, to mentor, to counsel, to coach, to tutor"
    },
    {
      "character": "符",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "fúhào",
      "english": "symbol, mark, sign"
    },
    {
      "character": "裕",
      "zhuyin": "ㄩˋ",
      "pinyin": "fùyù",
      "english": "prosperous, well-to-do, well-off"
    },
    {
      "character": "革",
      "zhuyin": "ㄍㄜˊ",
      "pinyin": "gǎigé",
      "english": "reform, CL:次[ci4], 種|种[zhong3], 項|项[xiang4], to reform"
    },
    {
      "character": "恩",
      "zhuyin": "ㄣ",
      "pinyin": "gǎnēn",
      "english": "to be grateful"
    },
    {
      "character": "尷",
      "zhuyin": "ㄍㄢ",
      "pinyin": "gāngà",
      "english": "awkward, embarrassed"
    },
    {
      "character": "尬",
      "zhuyin": "ㄍㄚˋ",
      "pinyin": "gāngà",
      "english": "awkward, embarrassed"
    },
    {
      "character": "干",
      "zhuyin": "ㄍㄢ",
      "pinyin": "gānrǎo",
      "english": "to disturb, to interfere, perturbation, interference (physics)"
    },
    {
      "character": "擾",
      "zhuyin": "ㄖㄠˇ",
      "pinyin": "gānrǎo",
      "english": "to disturb, to interfere, perturbation, interference (physics)"
    },
    {
      "character": "攻",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "gōngdǎ",
      "english": "to attack (the enemy)"
    },
    {
      "character": "勞",
      "zhuyin": "ㄌㄠˊ",
      "pinyin": "gōngláo",
      "english": "contribution, meritorious service, credit"
    },
    {
      "character": "貢",
      "zhuyin": "ㄍㄨㄥˋ",
      "pinyin": "gòngxiàn",
      "english": "to contribute, to dedicate, to devote, contribution, CL:個|个[ge4]"
    },
    {
      "character": "構",
      "zhuyin": "ㄍㄡˋ",
      "pinyin": "gòuchéng",
      "english": "to constitute, to form, to compose, to make up, to configure (computing)"
    },
    {
      "character": "孤",
      "zhuyin": "ㄍㄨ",
      "pinyin": "gūdān",
      "english": "lone, lonely, loneliness"
    },
    {
      "character": "估",
      "zhuyin": "ㄍㄨ",
      "pinyin": "gūjì",
      "english": "to estimate, to reckon, CL:個|个[ge4], (coll.) to suppose"
    },
    {
      "character": "跡",
      "zhuyin": "ㄐㄧ",
      "pinyin": "gǔjī",
      "english": "places of historic interest, historical sites, CL:個|个[ge4]"
    },
    {
      "character": "骨",
      "zhuyin": "ㄍㄨˊ",
      "pinyin": "gútou",
      "english": "bone, CL:根[gen1], 塊|块[kuai4], moral character, bitterness, Taiwan pr. [gu2 tou5]"
    },
    {
      "character": "獸",
      "zhuyin": "ㄕㄡˋ",
      "pinyin": "guàishòu",
      "english": "rare animal, mythical animal, monster"
    },
    {
      "character": "鍵",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "guānjiàn",
      "english": "crucial point, crux, CL:個|个[ge4], key, crucial, pivotal"
    },
    {
      "character": "矩",
      "zhuyin": "ㄐㄩˇ",
      "pinyin": "guījǔ",
      "english": "lit. compass and set square, fig. established standard, rule, customs, practices, fig. upright and h"
    },
    {
      "character": "棍",
      "zhuyin": "ㄍㄨㄣˋ",
      "pinyin": "gùnzi",
      "english": "stick, rod"
    },
    {
      "character": "籍",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "guójí",
      "english": "nationality"
    },
    {
      "character": "峽",
      "zhuyin": "ㄒㄧㄚˊ",
      "pinyin": "hǎixiá",
      "english": "strait, channel"
    },
    {
      "character": "羞",
      "zhuyin": "ㄒㄧㄡ",
      "pinyin": "hàixiū",
      "english": "shy, embarrassed, bashful"
    },
    {
      "character": "罕",
      "zhuyin": "ㄏㄢˇ",
      "pinyin": "hǎnjiàn",
      "english": "rare, rarely seen"
    },
    {
      "character": "旱",
      "zhuyin": "ㄏㄢˋ",
      "pinyin": "hànzāi",
      "english": "drought"
    },
    {
      "character": "災",
      "zhuyin": "ㄗㄞ",
      "pinyin": "hànzāi",
      "english": "drought"
    },
    {
      "character": "航",
      "zhuyin": "ㄏㄤˊ",
      "pinyin": "hángkōng",
      "english": "aviation"
    },
    {
      "character": "諧",
      "zhuyin": "ㄒㄧㄝˊ",
      "pinyin": "héxié",
      "english": "harmonious, harmony, (euphemism) to censor"
    },
    {
      "character": "痕",
      "zhuyin": "ㄏㄣˊ",
      "pinyin": "hénjī",
      "english": "vestige, mark, trace"
    },
    {
      "character": "悔",
      "zhuyin": "ㄏㄨㄟˇ",
      "pinyin": "hòuhuǐ",
      "english": "to regret, to feel remorse"
    },
    {
      "character": "蝴",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "húdié",
      "english": "butterfly, CL:隻|只[zhi1]"
    },
    {
      "character": "蝶",
      "zhuyin": "ㄉㄧㄝˊ",
      "pinyin": "húdié",
      "english": "butterfly, CL:隻|只[zhi1]"
    },
    {
      "character": "狐",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "húli",
      "english": "fox, fig. sly and treacherous person"
    },
    {
      "character": "狸",
      "zhuyin": "˙ㄌㄧ",
      "pinyin": "húli",
      "english": "fox, fig. sly and treacherous person"
    },
    {
      "character": "僑",
      "zhuyin": "ㄑㄧㄠˊ",
      "pinyin": "huáqiáo",
      "english": "overseas Chinese, (in a restricted sense) Chinese emigrant who still retains Chinese nationality, CL"
    },
    {
      "character": "裔",
      "zhuyin": "ㄧˋ",
      "pinyin": "huáyì",
      "english": "ethnic Chinese, non-Chinese citizen of Chinese ancestry"
    },
    {
      "character": "孕",
      "zhuyin": "ㄩㄣˋ",
      "pinyin": "huáiyùn",
      "english": "pregnant, to have conceived, gestation, pregnancy"
    },
    {
      "character": "患",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "huànbìng",
      "english": "to fall ill"
    },
    {
      "character": "緩",
      "zhuyin": "ㄏㄨㄢˇ",
      "pinyin": "huǎnmàn",
      "english": "slow"
    },
    {
      "character": "幻",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "huànxiǎng",
      "english": "to fantasize, to imagine, an illusion, a fantasy"
    },
    {
      "character": "皇",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "huángdì",
      "english": "emperor, CL:個|个[ge4]"
    },
    {
      "character": "后",
      "zhuyin": "ㄏㄡˋ",
      "pinyin": "huánghòu",
      "english": "empress, imperial consort"
    },
    {
      "character": "謊",
      "zhuyin": "ㄏㄨㄤˇ",
      "pinyin": "huǎnghuà",
      "english": "lie"
    },
    {
      "character": "繪",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "huìhuà",
      "english": "to draw, to paint"
    },
    {
      "character": "獲",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "huòdé",
      "english": "to obtain, to receive, to get"
    },
    {
      "character": "躍",
      "zhuyin": "ㄩㄝˋ",
      "pinyin": "huóyuè",
      "english": "active, lively, excited, to enliven, to brighten up"
    },
    {
      "character": "督",
      "zhuyin": "ㄉㄨ",
      "pinyin": "jīdūjiào",
      "english": "Christianity, Christian"
    },
    {
      "character": "嫉",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jídù",
      "english": "to be jealous of, to envy"
    },
    {
      "character": "妒",
      "zhuyin": "ㄉㄨˋ",
      "pinyin": "jídù",
      "english": "to be jealous of, to envy"
    },
    {
      "character": "飢",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jīè",
      "english": "hunger, starvation, famine"
    },
    {
      "character": "寂",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jímò",
      "english": "lonely, lonesome, (of a place) quiet, silent"
    },
    {
      "character": "寞",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "jímò",
      "english": "lonely, lonesome, (of a place) quiet, silent"
    },
    {
      "character": "肌",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jīròu",
      "english": "muscle, flesh"
    },
    {
      "character": "傢",
      "zhuyin": "ㄐㄧㄚ",
      "pinyin": "jiāhuo",
      "english": "household dish, implement or furniture, domestic animal, (coll.) guy, chap, weapon"
    },
    {
      "character": "伙",
      "zhuyin": "˙ㄏㄨㄛ",
      "pinyin": "jiāhuo",
      "english": "household dish, implement or furniture, domestic animal, (coll.) guy, chap, weapon"
    },
    {
      "character": "駕",
      "zhuyin": "ㄐㄧㄚˋ",
      "pinyin": "jiàshǐ",
      "english": "to pilot (ship, airplane etc), to drive"
    },
    {
      "character": "駛",
      "zhuyin": "ㄕˇ",
      "pinyin": "jiàshǐ",
      "english": "to pilot (ship, airplane etc), to drive"
    },
    {
      "character": "肩",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiānbǎng",
      "english": "shoulder"
    },
    {
      "character": "堅",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiānchí",
      "english": "to persevere with, to persist in, to insist on"
    },
    {
      "character": "監",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiāndū",
      "english": "to control, to supervise, to inspect"
    },
    {
      "character": "艱",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiānnán",
      "english": "difficult, hard, challenging"
    },
    {
      "character": "驕",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "jiāoào",
      "english": "pride, arrogance, conceited, proud of sth"
    },
    {
      "character": "傲",
      "zhuyin": "ㄠˋ",
      "pinyin": "jiāoào",
      "english": "pride, arrogance, conceited, proud of sth"
    },
    {
      "character": "傑",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jiéchū",
      "english": "outstanding, distinguished, remarkable, prominent, illustrious"
    },
    {
      "character": "奏",
      "zhuyin": "ㄗㄡˋ",
      "pinyin": "jiézòu",
      "english": "rhythm, tempo, musical pulse, cadence, beat"
    },
    {
      "character": "禁",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "jīnbúzhù",
      "english": "can't help it, can't bear it"
    },
    {
      "character": "儘",
      "zhuyin": "ㄐㄧㄣˇ",
      "pinyin": "jǐnguǎn",
      "english": "despite, although, even though, in spite of, unhesitatingly, do not hesitate (to ask, complain etc),"
    },
    {
      "character": "僅",
      "zhuyin": "ㄐㄧㄣˇ",
      "pinyin": "jǐnjǐn",
      "english": "barely, only, merely, only (this and nothing more)"
    },
    {
      "character": "融",
      "zhuyin": "ㄖㄨㄥˊ",
      "pinyin": "jīnróng",
      "english": "banking, finance, financial"
    },
    {
      "character": "慎",
      "zhuyin": "ㄕㄣˋ",
      "pinyin": "jǐnshèn",
      "english": "cautious, prudent"
    },
    {
      "character": "敬",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "jìngjiǔ",
      "english": "to toast, to propose a toast"
    },
    {
      "character": "糾",
      "zhuyin": "ㄐㄧㄡ",
      "pinyin": "jiūfēn",
      "english": "dispute"
    },
    {
      "character": "巨",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jùdà",
      "english": "huge, immense, very large, tremendous, gigantic, enormous"
    },
    {
      "character": "懼",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "kǒngjù",
      "english": "to be frightened, fear, dread"
    },
    {
      "character": "控",
      "zhuyin": "ㄎㄨㄥˋ",
      "pinyin": "kòngzhì",
      "english": "to control"
    },
    {
      "character": "泣",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "kūqì",
      "english": "to weep"
    },
    {
      "character": "誇",
      "zhuyin": "ㄎㄨㄚ",
      "pinyin": "kuājiǎng",
      "english": "to praise, to applaud, to compliment"
    },
    {
      "character": "擴",
      "zhuyin": "ㄎㄨㄛˋ",
      "pinyin": "kuòdà",
      "english": "to expand, to enlarge, to broaden one's scope"
    },
    {
      "character": "喇",
      "zhuyin": "ㄌㄚˇ",
      "pinyin": "lǎbā",
      "english": "horn (automobile etc), loudspeaker, brass wind instrument, trumpet, suona 鎖吶|锁呐[suo3 na4]"
    },
    {
      "character": "叭",
      "zhuyin": "ㄅㄚ",
      "pinyin": "lǎbā",
      "english": "horn (automobile etc), loudspeaker, brass wind instrument, trumpet, suona 鎖吶|锁呐[suo3 na4]"
    },
    {
      "character": "燭",
      "zhuyin": "ㄓㄨˊ",
      "pinyin": "làzhú",
      "english": "candle, CL:根[gen1], 支[zhi1]"
    },
    {
      "character": "惰",
      "zhuyin": "ㄉㄨㄛˋ",
      "pinyin": "lǎnduò",
      "english": "idle, lazy"
    },
    {
      "character": "嘮",
      "zhuyin": "ㄌㄠˊ",
      "pinyin": "láodāo",
      "english": "to prattle, to chatter away, to nag, garrulous, nagging"
    },
    {
      "character": "叨",
      "zhuyin": "ㄉㄠ",
      "pinyin": "láodāo",
      "english": "to prattle, to chatter away, to nag, garrulous, nagging"
    },
    {
      "character": "鷹",
      "zhuyin": "ㄧㄥ",
      "pinyin": "lǎoyīng",
      "english": "(coll.) eagle, hawk, any similar bird of prey"
    },
    {
      "character": "似",
      "zhuyin": "ㄙˋ",
      "pinyin": "lèisì",
      "english": "similar, analogous"
    },
    {
      "character": "漠",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "lěngmò",
      "english": "cold and detached towards sb, lack of regard, indifference, neglect"
    },
    {
      "character": "潤",
      "zhuyin": "ㄖㄨㄣˋ",
      "pinyin": "lìrùn",
      "english": "profits"
    },
    {
      "character": "益",
      "zhuyin": "ㄧˋ",
      "pinyin": "lìyì",
      "english": "benefit, (in sb's) interest, CL:個|个[ge4]"
    },
    {
      "character": "儀",
      "zhuyin": "ㄧˊ",
      "pinyin": "lǐyí",
      "english": "etiquette, ceremony"
    },
    {
      "character": "智",
      "zhuyin": "ㄓˋ",
      "pinyin": "lǐzhì",
      "english": "reason, intellect, rationality, rational"
    },
    {
      "character": "頰",
      "zhuyin": "ㄐㄧㄚˊ",
      "pinyin": "liǎnjiá",
      "english": "cheek"
    },
    {
      "character": "盟",
      "zhuyin": "ㄇㄥˊ",
      "pinyin": "liánméng",
      "english": "alliance, union, coalition"
    },
    {
      "character": "糧",
      "zhuyin": "ㄌㄧㄤˊ",
      "pinyin": "liángshí",
      "english": "foodstuff, cereals, CL:種|种[zhong3]"
    },
    {
      "character": "爽",
      "zhuyin": "ㄕㄨㄤˇ",
      "pinyin": "liángshuǎng",
      "english": "cool and refreshing"
    },
    {
      "character": "袖",
      "zhuyin": "ㄒㄧㄡˋ",
      "pinyin": "lǐngxiù",
      "english": "leader"
    },
    {
      "character": "邏",
      "zhuyin": "ㄌㄨㄛˊ",
      "pinyin": "luójí",
      "english": "logic (loanword)"
    },
    {
      "character": "囉",
      "zhuyin": "ㄌㄨㄛ",
      "pinyin": "luōsuo",
      "english": "long-winded, wordy, troublesome, pesky, also pr. [luo1 suo1]"
    },
    {
      "character": "嗦",
      "zhuyin": "˙ㄙㄨㄛ",
      "pinyin": "luōsuo",
      "english": "long-winded, wordy, troublesome, pesky, also pr. [luo1 suo1]"
    },
    {
      "character": "薯",
      "zhuyin": "ㄕㄨˇ",
      "pinyin": "mǎlíngshǔ",
      "english": "potato"
    },
    {
      "character": "螞",
      "zhuyin": "ㄇㄚˇ",
      "pinyin": "mǎyǐ",
      "english": "ant"
    },
    {
      "character": "蟻",
      "zhuyin": "ㄧˇ",
      "pinyin": "mǎyǐ",
      "english": "ant"
    },
    {
      "character": "碌",
      "zhuyin": "ㄌㄨˋ",
      "pinyin": "mánglù",
      "english": "busy, bustling"
    },
    {
      "character": "矛",
      "zhuyin": "ㄇㄠˊ",
      "pinyin": "máodùn",
      "english": "contradiction, CL:個|个[ge4], conflicting views, contradictory"
    },
    {
      "character": "盾",
      "zhuyin": "ㄉㄨㄣˋ",
      "pinyin": "máodùn",
      "english": "contradiction, CL:個|个[ge4], conflicting views, contradictory"
    },
    {
      "character": "玫",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "méiguī",
      "english": "rugosa rose (shrub) (Rosa rugosa), rose flower, CL:朵[duo3], 棵[ke1]"
    },
    {
      "character": "瑰",
      "zhuyin": "ㄍㄨㄟ",
      "pinyin": "méiguī",
      "english": "rugosa rose (shrub) (Rosa rugosa), rose flower, CL:朵[duo3], 棵[ke1]"
    },
    {
      "character": "魅",
      "zhuyin": "ㄇㄟˋ",
      "pinyin": "mèilì",
      "english": "charm, fascination, glamor, charisma"
    },
    {
      "character": "眉",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "méimáo",
      "english": "eyebrow, CL:根[gen1]"
    },
    {
      "character": "祕",
      "zhuyin": "ㄇㄧˋ",
      "pinyin": "mìmì",
      "english": "secret, private, confidential, clandestine, a secret (CL:個|个[ge4])"
    },
    {
      "character": "棉",
      "zhuyin": "ㄇㄧㄢˊ",
      "pinyin": "miánhuā",
      "english": "cotton"
    },
    {
      "character": "勉",
      "zhuyin": "ㄇㄧㄢˇ",
      "pinyin": "miǎnqiǎng",
      "english": "to do with difficulty, to force sb to do sth, reluctant, barely enough"
    },
    {
      "character": "滅",
      "zhuyin": "ㄇㄧㄝˋ",
      "pinyin": "mièwáng",
      "english": "to be destroyed, to become extinct, to perish, to die out, to destroy, to exterminate"
    },
    {
      "character": "銳",
      "zhuyin": "ㄖㄨㄟˋ",
      "pinyin": "mǐnruì",
      "english": "keen, sharp, acute"
    },
    {
      "character": "顯",
      "zhuyin": "ㄒㄧㄢˇ",
      "pinyin": "míngxiǎn",
      "english": "clear, distinct, obvious"
    },
    {
      "character": "魔",
      "zhuyin": "ㄇㄛˊ",
      "pinyin": "móguǐ",
      "english": "devil"
    },
    {
      "character": "陌",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "mòshēng",
      "english": "strange, unfamiliar"
    },
    {
      "character": "柴",
      "zhuyin": "ㄔㄞˊ",
      "pinyin": "mùchái",
      "english": "firewood"
    },
    {
      "character": "納",
      "zhuyin": "ㄋㄚˋ",
      "pinyin": "nàrù",
      "english": "to bring into, to channel into, to integrate into, to incorporate"
    },
    {
      "character": "泥",
      "zhuyin": "ㄋㄧˊ",
      "pinyin": "níbā",
      "english": "mud"
    },
    {
      "character": "婿",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "nǚxù",
      "english": "daughter's husband, son-in-law"
    },
    {
      "character": "虐",
      "zhuyin": "ㄋㄩㄝˋ",
      "pinyin": "nüèdài",
      "english": "to mistreat, to maltreat, to abuse, mistreatment, maltreatment"
    },
    {
      "character": "斥",
      "zhuyin": "ㄔˋ",
      "pinyin": "páichì",
      "english": "to reject, to exclude, to eliminate, to remove, to repel"
    },
    {
      "character": "榜",
      "zhuyin": "ㄅㄤˇ",
      "pinyin": "páihángbǎng",
      "english": "the charts (of best-sellers), table of ranking"
    },
    {
      "character": "遣",
      "zhuyin": "ㄑㄧㄢˇ",
      "pinyin": "pàiqiǎn",
      "english": "to send (on a mission), to dispatch"
    },
    {
      "character": "攝",
      "zhuyin": "ㄕㄜˋ",
      "pinyin": "pāishè",
      "english": "to take (a picture), to shoot (a film)"
    },
    {
      "character": "拚",
      "zhuyin": "ㄆㄢˋ",
      "pinyin": "pànmìng",
      "english": "see 拼命[pin1 ming4]"
    },
    {
      "character": "盼",
      "zhuyin": "ㄆㄢˋ",
      "pinyin": "pànwàng",
      "english": "to hope for, to look forward to"
    },
    {
      "character": "佩",
      "zhuyin": "ㄆㄟˋ",
      "pinyin": "pèifú",
      "english": "to admire"
    },
    {
      "character": "培",
      "zhuyin": "ㄆㄟˊ",
      "pinyin": "péiyǎng",
      "english": "to cultivate, to breed, to foster, to nurture, to educate, to groom (for a position), education, fos"
    },
    {
      "character": "疲",
      "zhuyin": "ㄆㄧˊ",
      "pinyin": "píjuàn",
      "english": "to tire, tired"
    },
    {
      "character": "倦",
      "zhuyin": "ㄐㄩㄢˋ",
      "pinyin": "píjuàn",
      "english": "to tire, tired"
    },
    {
      "character": "譬",
      "zhuyin": "ㄆㄧˋ",
      "pinyin": "pìrúshuō",
      "english": "for example"
    },
    {
      "character": "薩",
      "zhuyin": "ㄙㄚˋ",
      "pinyin": "pīsà",
      "english": "pizza (loanword)"
    },
    {
      "character": "嚐",
      "zhuyin": "ㄔㄤˊ",
      "pinyin": "pǐncháng",
      "english": "to taste a small amount, to sample"
    },
    {
      "character": "頻",
      "zhuyin": "ㄆㄧㄣˊ",
      "pinyin": "pínfán",
      "english": "frequently, often"
    },
    {
      "character": "貧",
      "zhuyin": "ㄆㄧㄣˊ",
      "pinyin": "pínqióng",
      "english": "poor, impoverished"
    },
    {
      "character": "衡",
      "zhuyin": "ㄏㄥˊ",
      "pinyin": "pínghéng",
      "english": "balance, equilibrium"
    },
    {
      "character": "審",
      "zhuyin": "ㄕㄣˇ",
      "pinyin": "píngshěn",
      "english": "to appraise, to evaluate, to judge"
    },
    {
      "character": "損",
      "zhuyin": "ㄙㄨㄣˇ",
      "pinyin": "pòsǔn",
      "english": "to become damaged"
    },
    {
      "character": "瀑",
      "zhuyin": "ㄆㄨˋ",
      "pinyin": "pùbù",
      "english": "waterfall"
    },
    {
      "character": "啟",
      "zhuyin": "ㄑㄧˇ",
      "pinyin": "qǐdòng",
      "english": "to start (a machine), (fig.) to set in motion, to launch (an operation), to activate (a plan)"
    },
    {
      "character": "欺",
      "zhuyin": "ㄑㄧ",
      "pinyin": "qīfù",
      "english": "to bully"
    },
    {
      "character": "蹟",
      "zhuyin": "ㄐㄧ",
      "pinyin": "qíjī",
      "english": "miracle, wonder, marvel"
    },
    {
      "character": "歧",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qíshì",
      "english": "to discriminate against, discrimination"
    },
    {
      "character": "恰",
      "zhuyin": "ㄑㄧㄚˋ",
      "pinyin": "qiàdàng",
      "english": "appropriate, suitable"
    },
    {
      "character": "潛",
      "zhuyin": "ㄑㄧㄢˊ",
      "pinyin": "qiánlì",
      "english": "potential, capacity"
    },
    {
      "character": "謙",
      "zhuyin": "ㄑㄧㄢ",
      "pinyin": "qiānxū",
      "english": "modest, self-effacing, to make modest remarks"
    },
    {
      "character": "虛",
      "zhuyin": "ㄒㄩ",
      "pinyin": "qiānxū",
      "english": "modest, self-effacing, to make modest remarks"
    },
    {
      "character": "遷",
      "zhuyin": "ㄑㄧㄢ",
      "pinyin": "qiānyí",
      "english": "to migrate, to move"
    },
    {
      "character": "牆",
      "zhuyin": "ㄑㄧㄤˊ",
      "pinyin": "qiángbì",
      "english": "wall"
    },
    {
      "character": "奪",
      "zhuyin": "ㄉㄨㄛˊ",
      "pinyin": "qiǎngduó",
      "english": "to plunder, to pillage, to forcibly take"
    },
    {
      "character": "迫",
      "zhuyin": "ㄆㄛˋ",
      "pinyin": "qiǎngpò",
      "english": "to compel, to force"
    },
    {
      "character": "悄",
      "zhuyin": "ㄑㄧㄠˇ",
      "pinyin": "qiǎoqiǎo",
      "english": "quiet, making little or no noise, surreptitious, stealthy, anxious, worried, Taiwan pr. [qiao3 qiao3"
    },
    {
      "character": "潔",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "qīngjié",
      "english": "clean, to clean"
    },
    {
      "character": "朗",
      "zhuyin": "ㄌㄤˇ",
      "pinyin": "qínglǎng",
      "english": "sunny and cloudless"
    },
    {
      "character": "勢",
      "zhuyin": "ㄕˋ",
      "pinyin": "qíngshì",
      "english": "situation, circumstance"
    },
    {
      "character": "蛙",
      "zhuyin": "ㄨㄚ",
      "pinyin": "qīngwā",
      "english": "frog, CL:隻|只[zhi1], (old) (slang) ugly guy"
    },
    {
      "character": "緒",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "qíngxù",
      "english": "mood, state of mind, moodiness, CL:種|种[zhong3]"
    },
    {
      "character": "乏",
      "zhuyin": "ㄈㄚˊ",
      "pinyin": "quēfá",
      "english": "to lack, to be short of"
    },
    {
      "character": "陷",
      "zhuyin": "ㄒㄧㄢˋ",
      "pinyin": "quēxiàn",
      "english": "defect, flaw"
    },
    {
      "character": "燃",
      "zhuyin": "ㄖㄢˊ",
      "pinyin": "ránshāo",
      "english": "to ignite, to combust, to burn, combustion, flaming"
    },
    {
      "character": "柔",
      "zhuyin": "ㄖㄡˊ",
      "pinyin": "róuruǎn",
      "english": "soft"
    },
    {
      "character": "坡",
      "zhuyin": "ㄆㄛ",
      "pinyin": "shānpō",
      "english": "hillside"
    },
    {
      "character": "稍",
      "zhuyin": "ㄕㄠ",
      "pinyin": "shāowéi",
      "english": "a little bit"
    },
    {
      "character": "捨",
      "zhuyin": "ㄕㄜˇ",
      "pinyin": "shěbùde",
      "english": "to hate to do sth, to hate to part with, to begrudge"
    },
    {
      "character": "氏",
      "zhuyin": "ㄕˋ",
      "pinyin": "shèshì",
      "english": "Celsius, centigrade"
    },
    {
      "character": "舌",
      "zhuyin": "ㄕㄜˊ",
      "pinyin": "shétou",
      "english": "tongue, CL:個|个[ge4], enemy soldier captured for the purpose of extracting information"
    },
    {
      "character": "仙",
      "zhuyin": "ㄒㄧㄢ",
      "pinyin": "shénxiān",
      "english": "Daoist immortal, supernatural entity, (in modern fiction) fairy, elf, leprechaun etc, fig. lighthear"
    },
    {
      "character": "腎",
      "zhuyin": "ㄕㄣˋ",
      "pinyin": "shènzàng",
      "english": "kidney"
    },
    {
      "character": "臟",
      "zhuyin": "ㄗㄤˋ",
      "pinyin": "shènzàng",
      "english": "kidney"
    },
    {
      "character": "繩",
      "zhuyin": "ㄕㄥˊ",
      "pinyin": "shéngzi",
      "english": "cord, string, rope, CL:條|条[tiao2]"
    },
    {
      "character": "傅",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "shīfù",
      "english": "master, qualified worker, respectful form of address for older men, CL:個|个[ge4], 位[wei4], 名[ming2]"
    },
    {
      "character": "踐",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "shíjiàn",
      "english": "practice, to put into practice, to live up to (a promise), to carry out (a project)"
    },
    {
      "character": "獅",
      "zhuyin": "ㄕ",
      "pinyin": "shīzi",
      "english": "lion, CL:隻|只[zhi1], 頭|头[tou2]"
    },
    {
      "character": "蹤",
      "zhuyin": "ㄗㄨㄥ",
      "pinyin": "shīzōng",
      "english": "to be missing, to disappear, unaccounted for"
    },
    {
      "character": "臂",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "shǒubì",
      "english": "arm, helper"
    },
    {
      "character": "筒",
      "zhuyin": "ㄊㄨㄥˇ",
      "pinyin": "shǒudiàntǒng",
      "english": "flashlight, electric hand torch"
    },
    {
      "character": "穫",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "shōuhuò",
      "english": "to harvest, to reap, to gain, crop, harvest, profit, gain, bonus, reward"
    },
    {
      "character": "腕",
      "zhuyin": "ㄨㄢˋ",
      "pinyin": "shǒuwàn",
      "english": "wrist, trickery, finesse, ability, skill"
    },
    {
      "character": "跤",
      "zhuyin": "ㄐㄧㄠ",
      "pinyin": "shuāijiāo",
      "english": "to trip and fall, to wrestle, wrestling (sports)"
    },
    {
      "character": "胞",
      "zhuyin": "ㄅㄠ",
      "pinyin": "shuāngbāotāi",
      "english": "twin, CL:對|对[dui4]"
    },
    {
      "character": "碩",
      "zhuyin": "ㄕㄨㄛˋ",
      "pinyin": "shuòshì",
      "english": "master's degree, person who has a master's degree, learned person"
    },
    {
      "character": "私",
      "zhuyin": "ㄙ",
      "pinyin": "sīdǐxià",
      "english": "privately, secretly, confidentially"
    },
    {
      "character": "蒐",
      "zhuyin": "ㄙㄡ",
      "pinyin": "sōují",
      "english": "to gather, to collect"
    },
    {
      "character": "搜",
      "zhuyin": "ㄙㄡ",
      "pinyin": "sōuxún",
      "english": "to search, to look for"
    },
    {
      "character": "尋",
      "zhuyin": "ㄒㄩㄣˊ",
      "pinyin": "sōuxún",
      "english": "to search, to look for"
    },
    {
      "character": "痠",
      "zhuyin": "ㄙㄨㄢ",
      "pinyin": "suāntòng",
      "english": "soreness and pain"
    },
    {
      "character": "謂",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "suǒwèi",
      "english": "so-called, what is called"
    },
    {
      "character": "坦",
      "zhuyin": "ㄊㄢˇ",
      "pinyin": "tǎnbái",
      "english": "honest, forthcoming, to confess"
    },
    {
      "character": "探",
      "zhuyin": "ㄊㄢˋ",
      "pinyin": "tàntǎo",
      "english": "to investigate, to probe"
    },
    {
      "character": "毯",
      "zhuyin": "ㄊㄢˇ",
      "pinyin": "tǎnzi",
      "english": "blanket, CL:條|条[tiao2], 張|张[zhang1], 床[chuang2], 面[mian4]"
    },
    {
      "character": "桃",
      "zhuyin": "ㄊㄠˊ",
      "pinyin": "táozi",
      "english": "peach"
    },
    {
      "character": "殊",
      "zhuyin": "ㄕㄨ",
      "pinyin": "tèshū",
      "english": "special, particular, unusual, extraordinary"
    },
    {
      "character": "徵",
      "zhuyin": "ㄓㄥ",
      "pinyin": "tèzhēng",
      "english": "characteristic, diagnostic property, distinctive feature, trait"
    },
    {
      "character": "剔",
      "zhuyin": "ㄊㄧ",
      "pinyin": "tiāotī",
      "english": "picky, fussy"
    },
    {
      "character": "志",
      "zhuyin": "ㄓˋ",
      "pinyin": "tóngzhì",
      "english": "comrade, (slang) homosexual, CL:個|个[ge4]"
    },
    {
      "character": "銷",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "tuīxiāo",
      "english": "to market, to sell"
    },
    {
      "character": "延",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "tuōyán",
      "english": "to delay, to put off, to procrastinate"
    },
    {
      "character": "維",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéichí",
      "english": "to keep, to maintain, to preserve"
    },
    {
      "character": "威",
      "zhuyin": "ㄨㄟ",
      "pinyin": "wēilì",
      "english": "might, formidable power"
    },
    {
      "character": "脅",
      "zhuyin": "ㄒㄧㄝˊ",
      "pinyin": "wēixié",
      "english": "to threaten, to menace"
    },
    {
      "character": "唯",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéiyī",
      "english": "only, sole"
    },
    {
      "character": "委",
      "zhuyin": "ㄨㄟˇ",
      "pinyin": "wěiyuán",
      "english": "committee member"
    },
    {
      "character": "蹈",
      "zhuyin": "ㄉㄠˋ",
      "pinyin": "wǔdào",
      "english": "dance (performance art), dancing"
    },
    {
      "character": "武",
      "zhuyin": "ㄨˇ",
      "pinyin": "wǔgōng",
      "english": "martial art, military accomplishments, (Peking opera) martial arts feats"
    },
    {
      "character": "攜",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xīdài",
      "english": "to carry (on one's person), to support (old), Taiwan pr. [xi1 dai4]"
    },
    {
      "character": "媳",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "xífù",
      "english": "daughter-in-law, wife (of a younger man), young married woman, young woman"
    },
    {
      "character": "膝",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xīgài",
      "english": "knee, (Internet slang) to kneel down (in admiration)"
    },
    {
      "character": "菌",
      "zhuyin": "ㄐㄩㄣˋ",
      "pinyin": "xìjùn",
      "english": "bacterium, germ"
    },
    {
      "character": "悅",
      "zhuyin": "ㄩㄝˋ",
      "pinyin": "xǐyuè",
      "english": "happy, joyous"
    },
    {
      "character": "阱",
      "zhuyin": "ㄐㄧㄥˇ",
      "pinyin": "xiànjǐng",
      "english": "pitfall, snare, trap"
    },
    {
      "character": "羨",
      "zhuyin": "ㄒㄧㄢˋ",
      "pinyin": "xiànmù",
      "english": "to envy, to admire"
    },
    {
      "character": "慕",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "xiànmù",
      "english": "to envy, to admire"
    },
    {
      "character": "腸",
      "zhuyin": "ㄔㄤˊ",
      "pinyin": "xiāngcháng",
      "english": "sausage, CL:根[gen1]"
    },
    {
      "character": "孝",
      "zhuyin": "ㄒㄧㄠˋ",
      "pinyin": "xiàoshùn",
      "english": "filial, dutiful, devoted to one's parents (and grandparents etc), to show filial piety towards (an o"
    },
    {
      "character": "嘻",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xiàoxīxī",
      "english": "grinning, smiling"
    },
    {
      "character": "液",
      "zhuyin": "ㄧㄝˋ",
      "pinyin": "xiěyè",
      "english": "blood"
    },
    {
      "character": "仰",
      "zhuyin": "ㄧㄤˇ",
      "pinyin": "xìnyǎng",
      "english": "to believe in (a religion), firm belief, conviction"
    },
    {
      "character": "酗",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "xùjiǔ",
      "english": "heavy drinking, to get drunk, to drink to excess"
    },
    {
      "character": "旋",
      "zhuyin": "ㄒㄩㄢˊ",
      "pinyin": "xuánzhuǎn",
      "english": "to rotate, to revolve, to spin, to whirl"
    },
    {
      "character": "循",
      "zhuyin": "ㄒㄩㄣˊ",
      "pinyin": "xúnhuán",
      "english": "to cycle, to circulate, circle, loop"
    },
    {
      "character": "詢",
      "zhuyin": "ㄒㄩㄣˊ",
      "pinyin": "xúnwèn",
      "english": "to inquire"
    },
    {
      "character": "亞",
      "zhuyin": "ㄧㄚˋ",
      "pinyin": "yàjūn",
      "english": "second place (in a sports contest), runner-up"
    },
    {
      "character": "肅",
      "zhuyin": "ㄙㄨˋ",
      "pinyin": "yánsù",
      "english": "solemn, grave, serious, earnest, severe"
    },
    {
      "character": "丸",
      "zhuyin": "ㄨㄢˊ",
      "pinyin": "yàowán",
      "english": "pill, CL:粒[li4]"
    },
    {
      "character": "遙",
      "zhuyin": "ㄧㄠˊ",
      "pinyin": "yáoyuǎn",
      "english": "distant, remote"
    },
    {
      "character": "遺",
      "zhuyin": "ㄧˊ",
      "pinyin": "yíchǎn",
      "english": "heritage, legacy, inheritance, bequest, CL:筆|笔[bi3]"
    },
    {
      "character": "櫥",
      "zhuyin": "ㄔㄨˊ",
      "pinyin": "yīchú",
      "english": "wardrobe"
    },
    {
      "character": "憾",
      "zhuyin": "ㄏㄢˋ",
      "pinyin": "yíhàn",
      "english": "regret, to regret, to be sorry that"
    },
    {
      "character": "依",
      "zhuyin": "ㄧ",
      "pinyin": "yījiù",
      "english": "as before, still"
    },
    {
      "character": "療",
      "zhuyin": "ㄌㄧㄠˊ",
      "pinyin": "yīliáo",
      "english": "medical treatment"
    },
    {
      "character": "隱",
      "zhuyin": "ㄧㄣˇ",
      "pinyin": "yǐncáng",
      "english": "to hide, to conceal, to mask, to shelter, to harbor (i.e. keep sth hidden), to hide oneself, to lie "
    },
    {
      "character": "謀",
      "zhuyin": "ㄇㄡˊ",
      "pinyin": "yīnmóu",
      "english": "to conspire, to plot, a conspiracy, a plot"
    },
    {
      "character": "擎",
      "zhuyin": "ㄑㄧㄥˊ",
      "pinyin": "yǐnqíng",
      "english": "engine (loanword), CL:臺|台[tai2]"
    },
    {
      "character": "鎊",
      "zhuyin": "ㄅㄤˋ",
      "pinyin": "yīngbàng",
      "english": "pound sterling"
    },
    {
      "character": "俊",
      "zhuyin": "ㄐㄩㄣˋ",
      "pinyin": "yīngjùn",
      "english": "handsome"
    },
    {
      "character": "螢",
      "zhuyin": "ㄧㄥˊ",
      "pinyin": "yíngmù",
      "english": "screen (of a TV, computer etc) (Tw)"
    },
    {
      "character": "櫻",
      "zhuyin": "ㄧㄥ",
      "pinyin": "yīngtáo",
      "english": "cherry"
    },
    {
      "character": "擁",
      "zhuyin": "ㄩㄥˇ",
      "pinyin": "yǒngbào",
      "english": "to embrace, to hug"
    },
    {
      "character": "幽",
      "zhuyin": "ㄧㄡ",
      "pinyin": "yōumò",
      "english": "(loanword) humor, humorous"
    },
    {
      "character": "誼",
      "zhuyin": "ㄧˋ",
      "pinyin": "yǒuyì",
      "english": "companionship, fellowship, friendship"
    },
    {
      "character": "猶",
      "zhuyin": "ㄧㄡˊ",
      "pinyin": "yóuyù",
      "english": "to hesitate"
    },
    {
      "character": "豫",
      "zhuyin": "ㄩˋ",
      "pinyin": "yóuyù",
      "english": "to hesitate"
    },
    {
      "character": "鬱",
      "zhuyin": "ㄩˋ",
      "pinyin": "yōuyù",
      "english": "sullen, depressed, melancholy, dejected"
    },
    {
      "character": "娛",
      "zhuyin": "ㄩˊ",
      "pinyin": "yúlè",
      "english": "to entertain, to amuse, entertainment, recreation, amusement, hobby, fun, joy"
    },
    {
      "character": "漁",
      "zhuyin": "ㄩˊ",
      "pinyin": "yúmín",
      "english": "fisherman, fisher folk"
    },
    {
      "character": "慾",
      "zhuyin": "ㄩˋ",
      "pinyin": "yùwàng",
      "english": "desire, longing, appetite, craving"
    },
    {
      "character": "宇",
      "zhuyin": "ㄩˇ",
      "pinyin": "yǔzhòu",
      "english": "universe, cosmos"
    },
    {
      "character": "宙",
      "zhuyin": "ㄓㄡˋ",
      "pinyin": "yǔzhòu",
      "english": "universe, cosmos"
    },
    {
      "character": "岳",
      "zhuyin": "ㄩㄝˋ",
      "pinyin": "yuèfù",
      "english": "wife's father, father-in-law"
    },
    {
      "character": "允",
      "zhuyin": "ㄩㄣˇ",
      "pinyin": "yǔnxǔ",
      "english": "to permit, to allow"
    },
    {
      "character": "贊",
      "zhuyin": "ㄗㄢˋ",
      "pinyin": "zànchéng",
      "english": "to approve, to endorse, (literary) to assist"
    },
    {
      "character": "咱",
      "zhuyin": "ㄗㄢˊ",
      "pinyin": "zánmen",
      "english": "we or us (including both the speaker and the person(s) spoken to), (dialect) I or me, (dialect) (in "
    },
    {
      "character": "噪",
      "zhuyin": "ㄗㄠˋ",
      "pinyin": "zàoyīn",
      "english": "rumble, noise, static (in a signal)"
    },
    {
      "character": "贈",
      "zhuyin": "ㄗㄥˋ",
      "pinyin": "zèngsòng",
      "english": "to present as a gift"
    },
    {
      "character": "佔",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "zhànlǐng",
      "english": "to capture, to seize, to occupy by force"
    },
    {
      "character": "礙",
      "zhuyin": "ㄞˋ",
      "pinyin": "zhàngài",
      "english": "barrier, obstruction, hindrance, impediment, obstacle"
    },
    {
      "character": "篷",
      "zhuyin": "ㄆㄥˊ",
      "pinyin": "zhàngpéng",
      "english": "tent, CL:頂|顶[ding3], 座[zuo4]"
    },
    {
      "character": "召",
      "zhuyin": "ㄓㄠˋ",
      "pinyin": "zhàojí",
      "english": "to convene, to call together"
    },
    {
      "character": "珍",
      "zhuyin": "ㄓㄣ",
      "pinyin": "zhēnguì",
      "english": "precious"
    },
    {
      "character": "灸",
      "zhuyin": "ㄐㄧㄡˇ",
      "pinyin": "zhēnjiǔ",
      "english": "acupuncture and moxibustion, to give or have acupuncture and moxibustion"
    },
    {
      "character": "偵",
      "zhuyin": "ㄓㄣ",
      "pinyin": "zhēntàn",
      "english": "detective, to do detective work"
    },
    {
      "character": "珠",
      "zhuyin": "ㄓㄨ",
      "pinyin": "zhēnzhū",
      "english": "pearl, CL:顆|颗[ke1]"
    },
    {
      "character": "振",
      "zhuyin": "ㄓㄣˋ",
      "pinyin": "zhènzuò",
      "english": "to bestir oneself, to pull oneself together, to cheer up, to uplift, to stimulate"
    },
    {
      "character": "慧",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "zhìhuì",
      "english": "wisdom, knowledge, intelligent, intelligence"
    },
    {
      "character": "芝",
      "zhuyin": "ㄓ",
      "pinyin": "zhīmá",
      "english": "sesame (seed)"
    },
    {
      "character": "殖",
      "zhuyin": "ㄓˊ",
      "pinyin": "zhímín",
      "english": "colony, colonial"
    },
    {
      "character": "姪",
      "zhuyin": "ㄓˊ",
      "pinyin": "zhínǚ",
      "english": "brother's daughter, niece"
    },
    {
      "character": "肢",
      "zhuyin": "ㄓ",
      "pinyin": "zhītǐ",
      "english": "limb, limbs and trunk, body"
    },
    {
      "character": "秩",
      "zhuyin": "ㄓˋ",
      "pinyin": "zhìxù",
      "english": "order (orderly), order (sequence), social order, the state (of society), CL:個|个[ge4]"
    },
    {
      "character": "援",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "zhīyuán",
      "english": "to provide assistance, to support, to back"
    },
    {
      "character": "侄",
      "zhuyin": "ㄓˊ",
      "pinyin": "zhízi",
      "english": "brother's son, nephew"
    },
    {
      "character": "仲",
      "zhuyin": "ㄓㄨㄥˋ",
      "pinyin": "zhòngjiè",
      "english": "middleman, agent, broker"
    },
    {
      "character": "央",
      "zhuyin": "ㄧㄤ",
      "pinyin": "zhōngyāng",
      "english": "central, middle, center, central authorities (of a state)"
    },
    {
      "character": "逐",
      "zhuyin": "ㄓㄨˊ",
      "pinyin": "zhúbù",
      "english": "progressively, step by step"
    },
    {
      "character": "註",
      "zhuyin": "ㄓㄨˋ",
      "pinyin": "zhùcè",
      "english": "to register, to enroll"
    },
    {
      "character": "賀",
      "zhuyin": "ㄏㄜˋ",
      "pinyin": "zhùhè",
      "english": "to congratulate, congratulations, CL:個|个[ge4]"
    },
    {
      "character": "宅",
      "zhuyin": "ㄓㄞˊ",
      "pinyin": "zhùzhái",
      "english": "residence, dwelling, abode"
    },
    {
      "character": "飾",
      "zhuyin": "ㄕˋ",
      "pinyin": "zhuāngshì",
      "english": "to decorate, decoration, decorative, ornamental"
    },
    {
      "character": "姿",
      "zhuyin": "ㄗ",
      "pinyin": "zīshì",
      "english": "posture, position"
    },
    {
      "character": "滋",
      "zhuyin": "ㄗ",
      "pinyin": "zīwèi",
      "english": "taste, flavor, feeling"
    },
    {
      "character": "綜",
      "zhuyin": "ㄗㄨㄥˋ",
      "pinyin": "zònghé",
      "english": "comprehensive, composite, synthesized, mixed, to sum up, to integrate, to synthesize"
    },
    {
      "character": "阻",
      "zhuyin": "ㄗㄨˇ",
      "pinyin": "zǔài",
      "english": "to obstruct, to hinder, to block, obstruction, hindrance"
    },
    {
      "character": "織",
      "zhuyin": "ㄓ",
      "pinyin": "zǔzhī",
      "english": "to organize, organization, (biology) tissue, (textiles) weave, CL:個|个[ge4]"
    },
    {
      "character": "脣",
      "zhuyin": "ㄔㄨㄣˊ",
      "pinyin": "zuǐchún",
      "english": "lip, CL:片[pian4]"
    },
    {
      "character": "遵",
      "zhuyin": "ㄗㄨㄣ",
      "pinyin": "zūnshǒu",
      "english": "to comply with, to abide by, to respect (an agreement)"
    },
    {
      "character": "弊",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "zuòbì",
      "english": "to practice fraud, to cheat, to engage in corrupt practices"
    },
    {
      "character": "曖",
      "zhuyin": "ㄞˋ",
      "pinyin": "àimèi",
      "english": "vague, ambiguous, equivocal, dubious"
    },
    {
      "character": "昧",
      "zhuyin": "ㄇㄟˋ",
      "pinyin": "àimèi",
      "english": "vague, ambiguous, equivocal, dubious"
    },
    {
      "character": "黯",
      "zhuyin": "ㄢˋ",
      "pinyin": "àndàn",
      "english": "dark, dim (light), dull (color), drab, (fig.) gloomy, bleak"
    },
    {
      "character": "撫",
      "zhuyin": "ㄈㄨˇ",
      "pinyin": "ānfǔ",
      "english": "to placate, to pacify, to appease"
    },
    {
      "character": "鈕",
      "zhuyin": "ㄋㄧㄡˇ",
      "pinyin": "ànniǔ",
      "english": "push button"
    },
    {
      "character": "骯",
      "zhuyin": "ㄤ",
      "pinyin": "āngzāng",
      "english": "dirty, filthy"
    },
    {
      "character": "奧",
      "zhuyin": "ㄠˋ",
      "pinyin": "àomì",
      "english": "secret, mystery"
    },
    {
      "character": "懊",
      "zhuyin": "ㄠˋ",
      "pinyin": "àonǎo",
      "english": "annoyed, vexed, upset"
    },
    {
      "character": "霸",
      "zhuyin": "ㄅㄚˋ",
      "pinyin": "bàdào",
      "english": "the Way of the Hegemon, abbr. for 霸王之道, despotic rule, rule by might, evil as opposed to the Way of "
    },
    {
      "character": "卦",
      "zhuyin": "ㄍㄨㄚˋ",
      "pinyin": "bāguà",
      "english": "the eight divinatory trigrams of the Book of Changes 易經|易经[Yi4 jing1], gossip, gossipy"
    },
    {
      "character": "疤",
      "zhuyin": "ㄅㄚ",
      "pinyin": "bāhén",
      "english": "scar"
    },
    {
      "character": "頒",
      "zhuyin": "ㄅㄢ",
      "pinyin": "bānbù",
      "english": "to issue, to proclaim, to enact (laws, decrees etc)"
    },
    {
      "character": "酬",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "bàochóu",
      "english": "reward, remuneration"
    },
    {
      "character": "袱",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "bāofú",
      "english": "wrapping cloth, a bundle wrapped in cloth, load, weight, burden, funny part, punchline"
    },
    {
      "character": "佑",
      "zhuyin": "ㄧㄡˋ",
      "pinyin": "bǎoyòu",
      "english": "to bless and protect, blessing"
    },
    {
      "character": "躁",
      "zhuyin": "ㄗㄠˋ",
      "pinyin": "bàozào",
      "english": "irascible, irritable"
    },
    {
      "character": "卑",
      "zhuyin": "ㄅㄟ",
      "pinyin": "bēibǐ",
      "english": "base, mean, contemptible, despicable"
    },
    {
      "character": "鄙",
      "zhuyin": "ㄅㄧˇ",
      "pinyin": "bēibǐ",
      "english": "base, mean, contemptible, despicable"
    },
    {
      "character": "誦",
      "zhuyin": "ㄙㄨㄥˋ",
      "pinyin": "bèisòng",
      "english": "to recite, to repeat from memory"
    },
    {
      "character": "奔",
      "zhuyin": "ㄅㄣ",
      "pinyin": "bēnbō",
      "english": "to rush about, to be constantly on the move"
    },
    {
      "character": "馳",
      "zhuyin": "ㄔˊ",
      "pinyin": "bēnchí",
      "english": "to run quickly, to speed, to gallop"
    },
    {
      "character": "拙",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "bènzhuó",
      "english": "clumsy, awkward, stupid"
    },
    {
      "character": "潰",
      "zhuyin": "ㄎㄨㄟˋ",
      "pinyin": "bēngkuì",
      "english": "to collapse, to crumble, to fall apart"
    },
    {
      "character": "爐",
      "zhuyin": "ㄌㄨˊ",
      "pinyin": "bìlú",
      "english": "fireplace"
    },
    {
      "character": "辯",
      "zhuyin": "ㄅㄧㄢˋ",
      "pinyin": "biànhù",
      "english": "to speak in defense of, to argue in favor of, to defend, to plead"
    },
    {
      "character": "辮",
      "zhuyin": "ㄅㄧㄢˋ",
      "pinyin": "biànzi",
      "english": "plait, braid, pigtail, a mistake or shortcoming that may be exploited by an opponent, handle, CL:根[g"
    },
    {
      "character": "纂",
      "zhuyin": "ㄗㄨㄢˇ",
      "pinyin": "biānzuǎn",
      "english": "to compile (an encyclopedia etc)"
    },
    {
      "character": "墅",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "biéshù",
      "english": "villa, CL:幢[zhuang4], 座[zuo4]"
    },
    {
      "character": "瀕",
      "zhuyin": "ㄅㄧㄣ",
      "pinyin": "bīnlín",
      "english": "on the edge of, (fig.) on the verge of, close to"
    },
    {
      "character": "搏",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "bódòu",
      "english": "to wrestle, to fight, to struggle"
    },
    {
      "character": "鬥",
      "zhuyin": "ㄉㄡˋ",
      "pinyin": "bódòu",
      "english": "to wrestle, to fight, to struggle"
    },
    {
      "character": "濤",
      "zhuyin": "ㄊㄠˊ",
      "pinyin": "bōtáo",
      "english": "great waves, billows"
    },
    {
      "character": "償",
      "zhuyin": "ㄔㄤˊ",
      "pinyin": "bǔcháng",
      "english": "to compensate, to make up"
    },
    {
      "character": "伐",
      "zhuyin": "ㄈㄚ",
      "pinyin": "bùfā",
      "english": "pace, (measured) step, march"
    },
    {
      "character": "堪",
      "zhuyin": "ㄎㄢ",
      "pinyin": "bùkān",
      "english": "cannot bear, cannot stand, utterly, extremely"
    },
    {
      "character": "署",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "bùshù",
      "english": "to dispose, to deploy, deployment"
    },
    {
      "character": "妥",
      "zhuyin": "ㄊㄨㄛˇ",
      "pinyin": "bùtuǒ",
      "english": "not proper, inappropriate"
    },
    {
      "character": "屑",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "búxiè",
      "english": "to disdain to do sth, to think sth not worth doing, to feel it beneath one's dignity"
    },
    {
      "character": "朽",
      "zhuyin": "ㄒㄧㄡˇ",
      "pinyin": "bùxiǔ",
      "english": "to last forever, eternal, enduring"
    },
    {
      "character": "措",
      "zhuyin": "ㄘㄨㄛˋ",
      "pinyin": "bùzhīsuǒcuò",
      "english": "not knowing what to do (idiom), at one's wits' end, embarrassed and at a complete loss"
    },
    {
      "character": "拭",
      "zhuyin": "ㄕˋ",
      "pinyin": "cāshì",
      "english": "to wipe clean"
    },
    {
      "character": "慚",
      "zhuyin": "ㄘㄢˊ",
      "pinyin": "cánkuì",
      "english": "ashamed"
    },
    {
      "character": "愧",
      "zhuyin": "ㄎㄨㄟˋ",
      "pinyin": "cánkuì",
      "english": "ashamed"
    },
    {
      "character": "燦",
      "zhuyin": "ㄘㄢˋ",
      "pinyin": "cànlàn",
      "english": "to glitter, brilliant, splendid"
    },
    {
      "character": "蠅",
      "zhuyin": "ㄧㄥˊ",
      "pinyin": "cāngyíng",
      "english": "housefly, CL:隻|只[zhi1]"
    },
    {
      "character": "稿",
      "zhuyin": "ㄍㄠˇ",
      "pinyin": "cǎogǎo",
      "english": "draft, outline, sketch"
    },
    {
      "character": "詫",
      "zhuyin": "ㄔㄚˋ",
      "pinyin": "chàyì",
      "english": "flabbergasted, astonished"
    },
    {
      "character": "懺",
      "zhuyin": "ㄔㄢˋ",
      "pinyin": "chànhuǐ",
      "english": "to repent, (religion) to confess"
    },
    {
      "character": "闡",
      "zhuyin": "ㄔㄢˇ",
      "pinyin": "chǎnshù",
      "english": "to expound (a position), to elaborate (on a topic), to treat (a subject)"
    },
    {
      "character": "敞",
      "zhuyin": "ㄔㄤˇ",
      "pinyin": "chǎngkāi",
      "english": "to open wide, unrestrictedly"
    },
    {
      "character": "暢",
      "zhuyin": "ㄔㄤˋ",
      "pinyin": "chàngxiāo",
      "english": "to sell well, bestselling, chart-topping"
    },
    {
      "character": "撤",
      "zhuyin": "ㄔㄜˋ",
      "pinyin": "chèlí",
      "english": "to withdraw from, to evacuate"
    },
    {
      "character": "徹",
      "zhuyin": "ㄔㄜˋ",
      "pinyin": "chèyè",
      "english": "the whole night"
    },
    {
      "character": "浸",
      "zhuyin": "ㄐㄧㄣˋ",
      "pinyin": "chénjìn",
      "english": "to soak, to permeate, to immerse"
    },
    {
      "character": "塵",
      "zhuyin": "ㄔㄣˊ",
      "pinyin": "chéntǔ",
      "english": "dust"
    },
    {
      "character": "懇",
      "zhuyin": "ㄎㄣˇ",
      "pinyin": "chéngkěn",
      "english": "sincere, honest, cordial"
    },
    {
      "character": "澄",
      "zhuyin": "ㄔㄥˊ",
      "pinyin": "chéngqīng",
      "english": "clear (of liquid), limpid, to clarify, to make sth clear, to be clear (about the facts)"
    },
    {
      "character": "摯",
      "zhuyin": "ㄓˋ",
      "pinyin": "chéngzhì",
      "english": "sincere, cordial"
    },
    {
      "character": "塘",
      "zhuyin": "ㄊㄤˊ",
      "pinyin": "chítáng",
      "english": "pool, pond"
    },
    {
      "character": "沛",
      "zhuyin": "ㄆㄟˋ",
      "pinyin": "chōngpèi",
      "english": "abundant, plentiful"
    },
    {
      "character": "籌",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "chóubèi",
      "english": "preparations, to get ready for sth"
    },
    {
      "character": "搐",
      "zhuyin": "ㄔㄨˋ",
      "pinyin": "chōuchù",
      "english": "to twitch"
    },
    {
      "character": "陋",
      "zhuyin": "ㄌㄡˋ",
      "pinyin": "chǒulòu",
      "english": "ugly"
    },
    {
      "character": "獄",
      "zhuyin": "ㄩˋ",
      "pinyin": "chūyù",
      "english": "to be released from prison"
    },
    {
      "character": "征",
      "zhuyin": "ㄓㄥ",
      "pinyin": "chūzhēng",
      "english": "to go into battle, to campaign (military)"
    },
    {
      "character": "簾",
      "zhuyin": "ㄌㄧㄢˊ",
      "pinyin": "chuānglián",
      "english": "window curtains"
    },
    {
      "character": "粹",
      "zhuyin": "ㄘㄨㄟˋ",
      "pinyin": "chúncuì",
      "english": "pure, unadulterated, purely, completely"
    },
    {
      "character": "綽",
      "zhuyin": "ㄔㄨㄛˋ",
      "pinyin": "chuòhào",
      "english": "nickname"
    },
    {
      "character": "慈",
      "zhuyin": "ㄘˊ",
      "pinyin": "cíài",
      "english": "love, devotion (to children), affection, esp. towards children"
    },
    {
      "character": "伺",
      "zhuyin": "ㄘˋ",
      "pinyin": "cìhòu",
      "english": "to serve, to wait upon"
    },
    {
      "character": "瓷",
      "zhuyin": "ㄘˊ",
      "pinyin": "cíqì",
      "english": "chinaware, porcelain"
    },
    {
      "character": "糙",
      "zhuyin": "ㄘㄠ",
      "pinyin": "cūcāo",
      "english": "crude, gruff, rough, coarse"
    },
    {
      "character": "魯",
      "zhuyin": "ㄌㄨˇ",
      "pinyin": "cūlǔ",
      "english": "coarse, crude (in one's manner), boorish"
    },
    {
      "character": "摧",
      "zhuyin": "ㄘㄨㄟ",
      "pinyin": "cuīhuǐ",
      "english": "to destroy, to wreck"
    },
    {
      "character": "毀",
      "zhuyin": "ㄏㄨㄟˇ",
      "pinyin": "cuīhuǐ",
      "english": "to destroy, to wreck"
    },
    {
      "character": "莊",
      "zhuyin": "ㄓㄨㄤ",
      "pinyin": "cūnzhuāng",
      "english": "village, hamlet, CL:座[zuo4]"
    },
    {
      "character": "施",
      "zhuyin": "ㄕ",
      "pinyin": "cuòshī",
      "english": "measure, step, CL:個|个[ge4]"
    },
    {
      "character": "綱",
      "zhuyin": "ㄍㄤ",
      "pinyin": "dàgāng",
      "english": "synopsis, outline, program, leading principles"
    },
    {
      "character": "訕",
      "zhuyin": "ㄕㄢˋ",
      "pinyin": "dāshàn",
      "english": "to hit on someone, to strike up a conversation, to start talking to end an awkward silence or embarr"
    },
    {
      "character": "廈",
      "zhuyin": "ㄒㄧㄚˋ",
      "pinyin": "dàxià",
      "english": "(used in the names of grand buildings such as 百老匯大廈|百老汇大厦 Broadway Mansions (in Shanghai) or 帝國大廈|帝国"
    },
    {
      "character": "烊",
      "zhuyin": "ㄧㄤˊ",
      "pinyin": "dǎyáng",
      "english": "to close shop in the evening, also pr. [da3 yang2]"
    },
    {
      "character": "殆",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dàijìn",
      "english": "nearly exhausted, practically nothing left"
    },
    {
      "character": "歹",
      "zhuyin": "ㄉㄞˇ",
      "pinyin": "dǎitú",
      "english": "evildoer, malefactor, gangster, hoodlum"
    },
    {
      "character": "醇",
      "zhuyin": "ㄔㄨㄣˊ",
      "pinyin": "dǎngùchún",
      "english": "cholesterol"
    },
    {
      "character": "怯",
      "zhuyin": "ㄑㄩㄝˋ",
      "pinyin": "dǎnquè",
      "english": "timidity, timid, cowardly"
    },
    {
      "character": "黨",
      "zhuyin": "ㄉㄤˇ",
      "pinyin": "dǎngpài",
      "english": "political party, faction"
    },
    {
      "character": "刃",
      "zhuyin": "ㄖㄣˋ",
      "pinyin": "dāorèn",
      "english": "knife blade, crucial point"
    },
    {
      "character": "嶼",
      "zhuyin": "ㄩˇ",
      "pinyin": "dǎoyǔ",
      "english": "island"
    },
    {
      "character": "凳",
      "zhuyin": "ㄉㄥˋ",
      "pinyin": "dèngzi",
      "english": "stool, small seat"
    },
    {
      "character": "嘀",
      "zhuyin": "ㄉㄧˊ",
      "pinyin": "dígu",
      "english": "to mutter, to feel apprehensive"
    },
    {
      "character": "咕",
      "zhuyin": "˙ㄍㄨ",
      "pinyin": "dígu",
      "english": "to mutter, to feel apprehensive"
    },
    {
      "character": "廉",
      "zhuyin": "ㄌㄧㄢˊ",
      "pinyin": "dīlián",
      "english": "cheap, inexpensive, low"
    },
    {
      "character": "顛",
      "zhuyin": "ㄉㄧㄢ",
      "pinyin": "diāndǎo",
      "english": "to turn upside down, to reverse, back to front, confused, deranged, crazy"
    },
    {
      "character": "奠",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "diàndìng",
      "english": "to establish, to fix, to settle"
    },
    {
      "character": "巔",
      "zhuyin": "ㄉㄧㄢ",
      "pinyin": "diānfēng",
      "english": "summit, apex, pinnacle (of one's career etc), peak (of a civilization etc)"
    },
    {
      "character": "峰",
      "zhuyin": "ㄈㄥ",
      "pinyin": "diānfēng",
      "english": "summit, apex, pinnacle (of one's career etc), peak (of a civilization etc)"
    },
    {
      "character": "綴",
      "zhuyin": "ㄓㄨㄟˋ",
      "pinyin": "diǎnzhuì",
      "english": "to decorate, to adorn, sprinkled, studded, only for show"
    },
    {
      "character": "嚀",
      "zhuyin": "ㄋㄧㄥˊ",
      "pinyin": "dīngníng",
      "english": "to warn, to urge, to exhort, to give instructions carefully and insistently"
    },
    {
      "character": "盪",
      "zhuyin": "ㄉㄤˋ",
      "pinyin": "dòngdàng",
      "english": "unrest (social or political), turmoil, upheaval, commotion"
    },
    {
      "character": "董",
      "zhuyin": "ㄉㄨㄥˇ",
      "pinyin": "dǒngshì",
      "english": "board member"
    },
    {
      "character": "穴",
      "zhuyin": "ㄒㄩㄝˋ",
      "pinyin": "dòngxuè",
      "english": "cave, cavern"
    },
    {
      "character": "鍛",
      "zhuyin": "ㄉㄨㄢˋ",
      "pinyin": "duànliàn",
      "english": "to toughen, to temper, to engage in physical exercise, to work out, (fig.) to develop one's skills, "
    },
    {
      "character": "峙",
      "zhuyin": "ㄓˋ",
      "pinyin": "duìzhì",
      "english": "to stand opposite, to confront, confrontation"
    },
    {
      "character": "采",
      "zhuyin": "ㄘㄞˇ",
      "pinyin": "duōcǎiduōzī",
      "english": "describes the variety of postures and bright and charming colors. Later it was extended to mean that"
    },
    {
      "character": "魁",
      "zhuyin": "ㄎㄨㄟˊ",
      "pinyin": "duókuí",
      "english": "to seize, to win"
    },
    {
      "character": "氧",
      "zhuyin": "ㄧㄤˇ",
      "pinyin": "èryǎnghuàtàn",
      "english": "carbon dioxide CO2"
    },
    {
      "character": "掘",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "fājué",
      "english": "to excavate, to explore, (fig.) to unearth, to tap into"
    },
    {
      "character": "霉",
      "zhuyin": "ㄇㄟˊ",
      "pinyin": "fāméi",
      "english": "to become moldy"
    },
    {
      "character": "酵",
      "zhuyin": "ㄒㄧㄠˋ",
      "pinyin": "fāxiào",
      "english": "to ferment, (fig.) (of trends, emotions or repercussions etc) to bubble away, to simmer, to develop"
    },
    {
      "character": "洩",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "fāxiè",
      "english": "to give vent to (one's feelings)"
    },
    {
      "character": "疇",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "fànchóu",
      "english": "category"
    },
    {
      "character": "帆",
      "zhuyin": "ㄈㄢˊ",
      "pinyin": "fánchuán",
      "english": "sailboat"
    },
    {
      "character": "氾",
      "zhuyin": "ㄈㄢˋ",
      "pinyin": "fànlàn",
      "english": "to flow across the river and overflows everywhere; a metaphor for the abnormal growth or excessive p"
    },
    {
      "character": "彷",
      "zhuyin": "ㄈㄤˇ",
      "pinyin": "fǎngfú",
      "english": "to seem, as if, alike, similar"
    },
    {
      "character": "彿",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "fǎngfú",
      "english": "to seem, as if, alike, similar"
    },
    {
      "character": "坊",
      "zhuyin": "ㄈㄤ",
      "pinyin": "fāngjiān",
      "english": "street stalls, bookshops, in the streets"
    },
    {
      "character": "芳",
      "zhuyin": "ㄈㄤ",
      "pinyin": "fāngxiāng",
      "english": "fragrant, aromatic, fragrance, aroma"
    },
    {
      "character": "禦",
      "zhuyin": "ㄩˋ",
      "pinyin": "fángyù",
      "english": "defense, to defend"
    },
    {
      "character": "紡",
      "zhuyin": "ㄈㄤˇ",
      "pinyin": "fǎngzhī",
      "english": "spinning and weaving"
    },
    {
      "character": "沸",
      "zhuyin": "ㄈㄟˋ",
      "pinyin": "fèiténg",
      "english": "(of a liquid) to boil, (of sentiments etc) to boil over, to flare up, to be impassioned"
    },
    {
      "character": "騰",
      "zhuyin": "ㄊㄥˊ",
      "pinyin": "fèiténg",
      "english": "(of a liquid) to boil, (of sentiments etc) to boil over, to flare up, to be impassioned"
    },
    {
      "character": "翔",
      "zhuyin": "ㄒㄧㄤˊ",
      "pinyin": "fēixiáng",
      "english": "to circle in the air, to soar"
    },
    {
      "character": "墟",
      "zhuyin": "ㄒㄩ",
      "pinyin": "fèixū",
      "english": "ruins"
    },
    {
      "character": "揚",
      "zhuyin": "ㄧㄤˊ",
      "pinyin": "fēiyáng",
      "english": "to rise, to fly upward"
    },
    {
      "character": "泌",
      "zhuyin": "ㄇㄧˋ",
      "pinyin": "fēnmì",
      "english": "to secrete, secretion"
    },
    {
      "character": "墳",
      "zhuyin": "ㄈㄣˊ",
      "pinyin": "fénmù",
      "english": "grave, tomb"
    },
    {
      "character": "墓",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "fénmù",
      "english": "grave, tomb"
    },
    {
      "character": "焚",
      "zhuyin": "ㄈㄣˊ",
      "pinyin": "fénshāo",
      "english": "to burn, to set on fire"
    },
    {
      "character": "凰",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "fènghuáng",
      "english": "phoenix"
    },
    {
      "character": "鋒",
      "zhuyin": "ㄈㄥ",
      "pinyin": "fēnglì",
      "english": "sharp (e.g. knife blade), incisive, to the point"
    },
    {
      "character": "隙",
      "zhuyin": "ㄒㄧˋ",
      "pinyin": "fèngxì",
      "english": "small crack, chink"
    },
    {
      "character": "豪",
      "zhuyin": "ㄏㄠˊ",
      "pinyin": "fùháo",
      "english": "rich and powerful person"
    },
    {
      "character": "俘",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "fúlǔ",
      "english": "captive"
    },
    {
      "character": "虜",
      "zhuyin": "ㄌㄨˇ",
      "pinyin": "fúlǔ",
      "english": "captive"
    },
    {
      "character": "侍",
      "zhuyin": "ㄕˋ",
      "pinyin": "fúshì",
      "english": "to attend to, to care for (patients etc), to look after, to wait upon, to serve, also written 伏侍, se"
    },
    {
      "character": "甦",
      "zhuyin": "ㄙㄨ",
      "pinyin": "fùsū",
      "english": "to recover (health, economic), to resuscitate, anabiosis"
    },
    {
      "character": "斧",
      "zhuyin": "ㄈㄨˇ",
      "pinyin": "fǔtou",
      "english": "ax, hatchet, CL:柄[bing3]"
    },
    {
      "character": "翁",
      "zhuyin": "ㄨㄥ",
      "pinyin": "fùwēng",
      "english": "rich person, millionaire, billionaire"
    },
    {
      "character": "衍",
      "zhuyin": "ㄧㄢˇ",
      "pinyin": "fūyǎn",
      "english": "to elaborate (on a theme), to expound (the classics), perfunctory, to skimp, to botch, to do sth hal"
    },
    {
      "character": "予",
      "zhuyin": "ㄩˇ",
      "pinyin": "fùyǔ",
      "english": "to assign, to entrust (a task), to give, to bestow"
    },
    {
      "character": "佐",
      "zhuyin": "ㄗㄨㄛˇ",
      "pinyin": "fǔzuǒ",
      "english": "to assist (usually a ruler)"
    },
    {
      "character": "慨",
      "zhuyin": "ㄎㄞˇ",
      "pinyin": "gǎnkǎi",
      "english": "to sigh with sorrow, regret etc, rueful, deeply moved"
    },
    {
      "character": "涉",
      "zhuyin": "ㄕㄜˋ",
      "pinyin": "gānshè",
      "english": "to interfere, to meddle, interference"
    },
    {
      "character": "燥",
      "zhuyin": "ㄗㄠˋ",
      "pinyin": "gānzào",
      "english": "(of weather, climate, soil etc) dry, arid, (of skin, mouth etc) dry, (fig.) dull, dry, boring, (of t"
    },
    {
      "character": "崗",
      "zhuyin": "ㄍㄤˇ",
      "pinyin": "gǎngwèi",
      "english": "a post, a job"
    },
    {
      "character": "誡",
      "zhuyin": "ㄐㄧㄝˋ",
      "pinyin": "gàojiè",
      "english": "to warn, to admonish"
    },
    {
      "character": "聳",
      "zhuyin": "ㄙㄨㄥˇ",
      "pinyin": "gāosǒng",
      "english": "erect, towering, to stand tall"
    },
    {
      "character": "雅",
      "zhuyin": "ㄧㄚˇ",
      "pinyin": "gāoyǎ",
      "english": "dainty, elegance, elegant"
    },
    {
      "character": "閡",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "géhé",
      "english": "misunderstanding, estrangement, (language etc) barrier"
    },
    {
      "character": "閣",
      "zhuyin": "ㄍㄜˊ",
      "pinyin": "gélóu",
      "english": "garret, loft, attic"
    },
    {
      "character": "箇",
      "zhuyin": "ㄍㄜˋ",
      "pinyin": "gèzhōng",
      "english": "therein, in this"
    },
    {
      "character": "鴿",
      "zhuyin": "ㄍㄜ",
      "pinyin": "gēzi",
      "english": "pigeon, dove, various birds of the family Columbidae"
    },
    {
      "character": "耕",
      "zhuyin": "ㄍㄥ",
      "pinyin": "gēngyún",
      "english": "plowing and weeding, farm work, fig. to work or study diligently"
    },
    {
      "character": "耘",
      "zhuyin": "ㄩㄣˊ",
      "pinyin": "gēngyún",
      "english": "plowing and weeding, farm work, fig. to work or study diligently"
    },
    {
      "character": "臣",
      "zhuyin": "ㄔㄣˊ",
      "pinyin": "gōngchén",
      "english": "meritorious official, person who renders exceptional service, hero, (fig.) sth that plays a vital ro"
    },
    {
      "character": "鞏",
      "zhuyin": "ㄍㄨㄥˇ",
      "pinyin": "gǒnggù",
      "english": "to consolidate, consolidation, to strengthen"
    },
    {
      "character": "匠",
      "zhuyin": "ㄐㄧㄤˋ",
      "pinyin": "gōngjiàng",
      "english": "artisan, smith"
    },
    {
      "character": "辜",
      "zhuyin": "ㄍㄨ",
      "pinyin": "gūfù",
      "english": "to fail to live up (to expectations), unworthy (of trust), to let down, to betray (hopes), to disapp"
    },
    {
      "character": "骼",
      "zhuyin": "ㄍㄜˊ",
      "pinyin": "gǔgé",
      "english": "bones, skeleton"
    },
    {
      "character": "稽",
      "zhuyin": "ㄐㄧ",
      "pinyin": "gǔjī",
      "english": "comical, funny, amusing (old pr. [gu3 ji1]), huaji, a form of comedy performance popular in Shanghai"
    },
    {
      "character": "僱",
      "zhuyin": "ㄍㄨˋ",
      "pinyin": "gùyòng",
      "english": "to employ, to hire"
    },
    {
      "character": "雇",
      "zhuyin": "ㄍㄨˋ",
      "pinyin": "gùyòng",
      "english": "to employ, to hire"
    },
    {
      "character": "杖",
      "zhuyin": "ㄓㄤˋ",
      "pinyin": "guǎizhàng",
      "english": "crutches, crutch, walking stick"
    },
    {
      "character": "棺",
      "zhuyin": "ㄍㄨㄢ",
      "pinyin": "guāncái",
      "english": "coffin, CL:具[ju4], 口[kou3]"
    },
    {
      "character": "貫",
      "zhuyin": "ㄍㄨㄢˋ",
      "pinyin": "guànchè",
      "english": "to implement, to put into practice, to carry out"
    },
    {
      "character": "僚",
      "zhuyin": "ㄌㄧㄠˊ",
      "pinyin": "guānliáo",
      "english": "bureaucrat, bureaucracy, bureaucratic"
    },
    {
      "character": "轄",
      "zhuyin": "ㄒㄧㄚˊ",
      "pinyin": "guǎnxiá",
      "english": "to administer, to have jurisdiction (over)"
    },
    {
      "character": "輝",
      "zhuyin": "ㄏㄨㄟ",
      "pinyin": "guānghuī",
      "english": "radiance, glory, brilliant, magnificent"
    },
    {
      "character": "闊",
      "zhuyin": "ㄎㄨㄛˋ",
      "pinyin": "guǎngkuò",
      "english": "wide, vast"
    },
    {
      "character": "詭",
      "zhuyin": "ㄍㄨㄟˇ",
      "pinyin": "guǐjì",
      "english": "trick, ruse, crafty scheme"
    },
    {
      "character": "濾",
      "zhuyin": "ㄌㄩˋ",
      "pinyin": "guòlǜ",
      "english": "to filter, filter"
    },
    {
      "character": "涵",
      "zhuyin": "ㄏㄢˊ",
      "pinyin": "hángài",
      "english": "to cover, to comprise, to include"
    },
    {
      "character": "捍",
      "zhuyin": "ㄏㄢˋ",
      "pinyin": "hànwèi",
      "english": "to defend, to uphold, to safeguard"
    },
    {
      "character": "耗",
      "zhuyin": "ㄏㄠˋ",
      "pinyin": "hàofèi",
      "english": "to waste, to spend, to consume, to squander"
    },
    {
      "character": "併",
      "zhuyin": "ㄅㄧㄥˋ",
      "pinyin": "hébìng",
      "english": "to merge, to annex"
    },
    {
      "character": "川",
      "zhuyin": "ㄔㄨㄢ",
      "pinyin": "héchuān",
      "english": "rivers"
    },
    {
      "character": "呵",
      "zhuyin": "ㄏㄜ",
      "pinyin": "hēhù",
      "english": "to bless, to cherish, to take good care of, to conserve"
    },
    {
      "character": "睦",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "hémù",
      "english": "peaceful relations, harmonious"
    },
    {
      "character": "狠",
      "zhuyin": "ㄏㄣˇ",
      "pinyin": "hěnhěn",
      "english": "resolutely, firmly, ferociously, ruthlessly"
    },
    {
      "character": "轟",
      "zhuyin": "ㄏㄨㄥ",
      "pinyin": "hōngdòng",
      "english": "to cause a sensation, to create a stir in (a place), commotion, controversy"
    },
    {
      "character": "洪",
      "zhuyin": "ㄏㄨㄥˊ",
      "pinyin": "hóngshuǐ",
      "english": "deluge, flood"
    },
    {
      "character": "喚",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "hūhuàn",
      "english": "to call out (a name etc), to shout"
    },
    {
      "character": "嘯",
      "zhuyin": "ㄒㄧㄠˋ",
      "pinyin": "hūxiào",
      "english": "to whistle, to scream, to whiz"
    },
    {
      "character": "籲",
      "zhuyin": "ㄩˋ",
      "pinyin": "hūyù",
      "english": "to call on (sb to do sth), to appeal (to), an appeal"
    },
    {
      "character": "紋",
      "zhuyin": "ㄨㄣˊ",
      "pinyin": "huāwén",
      "english": "decorative design"
    },
    {
      "character": "荒",
      "zhuyin": "ㄏㄨㄤ",
      "pinyin": "huāngfèi",
      "english": "to abandon (cultivated fields), no longer cultivated, to lie waste, wasted, to neglect (one's work o"
    },
    {
      "character": "恍",
      "zhuyin": "ㄏㄨㄤˇ",
      "pinyin": "huǎnghū",
      "english": "absent-minded, distracted, dazzled, vaguely, dimly"
    },
    {
      "character": "惚",
      "zhuyin": "ㄏㄨ",
      "pinyin": "huǎnghū",
      "english": "absent-minded, distracted, dazzled, vaguely, dimly"
    },
    {
      "character": "謬",
      "zhuyin": "ㄇㄧㄡˋ",
      "pinyin": "huāngmiù",
      "english": "absurd, ridiculous"
    },
    {
      "character": "悟",
      "zhuyin": "ㄨˋ",
      "pinyin": "huǎngrándàwù",
      "english": "to suddenly realize, to suddenly see the light"
    },
    {
      "character": "唐",
      "zhuyin": "ㄊㄤˊ",
      "pinyin": "huāngtáng",
      "english": "beyond belief, preposterous, absurd, intemperate, dissipated"
    },
    {
      "character": "迴",
      "zhuyin": "ㄏㄨㄟˊ",
      "pinyin": "huíbì",
      "english": "to shun, to avoid (sb), to skirt, to evade (an issue), to step back, to withdraw, to recuse (a judge"
    },
    {
      "character": "煌",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "huīhuáng",
      "english": "splendid, glorious"
    },
    {
      "character": "饋",
      "zhuyin": "ㄎㄨㄟˋ",
      "pinyin": "huíkuì",
      "english": "to repay a favor, to give back, feedback"
    },
    {
      "character": "賄",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "huìlù",
      "english": "to bribe, a bribe"
    },
    {
      "character": "賂",
      "zhuyin": "ㄌㄨˋ",
      "pinyin": "huìlù",
      "english": "to bribe, a bribe"
    },
    {
      "character": "渾",
      "zhuyin": "ㄏㄨㄣˊ",
      "pinyin": "húnshēn",
      "english": "all over, from head to foot"
    },
    {
      "character": "淆",
      "zhuyin": "ㄧㄠˊ",
      "pinyin": "hùnyáo",
      "english": "to obscure, to confuse, to mix up, to blur, to mislead"
    },
    {
      "character": "焰",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "huǒyàn",
      "english": "blaze, flame"
    },
    {
      "character": "諱",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "jìhuì",
      "english": "taboo, to avoid as taboo, to abstain from"
    },
    {
      "character": "妓",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jìnǚ",
      "english": "prostitute, hooker"
    },
    {
      "character": "汲",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jíqǔ",
      "english": "to draw, to derive, to absorb"
    },
    {
      "character": "棘",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jíshǒu",
      "english": "thorny (problem), intractable"
    },
    {
      "character": "祀",
      "zhuyin": "ㄙˋ",
      "pinyin": "jìsì",
      "english": "to offer sacrifices to the gods or ancestors"
    },
    {
      "character": "譏",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jīxiào",
      "english": "to sneer"
    },
    {
      "character": "械",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "jīxiè",
      "english": "machine, machinery, mechanical, (old) cunning, scheming"
    },
    {
      "character": "畸",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jīxíng",
      "english": "deformed, malformed, lopsided, unbalanced"
    },
    {
      "character": "敘",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "jìxù",
      "english": "to narrate, narrative"
    },
    {
      "character": "脊",
      "zhuyin": "ㄐㄧˇ",
      "pinyin": "jǐzhuī",
      "english": "vertebra, backbone"
    },
    {
      "character": "椎",
      "zhuyin": "ㄓㄨㄟ",
      "pinyin": "jǐzhuī",
      "english": "vertebra, backbone"
    },
    {
      "character": "馭",
      "zhuyin": "ㄩˋ",
      "pinyin": "jiàyù",
      "english": "to urge on (of horse), to drive, to steer, to handle, to manage, to master, to dominate"
    },
    {
      "character": "諜",
      "zhuyin": "ㄉㄧㄝˊ",
      "pinyin": "jiàndié",
      "english": "spy"
    },
    {
      "character": "毅",
      "zhuyin": "ㄧˋ",
      "pinyin": "jiānyì",
      "english": "firm and persistent, unswerving determination"
    },
    {
      "character": "轎",
      "zhuyin": "ㄐㄧㄠˋ",
      "pinyin": "jiàochē",
      "english": "enclosed carriage for carrying passengers, motor carriage, car or bus, limousine, CL:部[bu4], 輛|辆[lia"
    },
    {
      "character": "狡",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎohuá",
      "english": "crafty, cunning, sly"
    },
    {
      "character": "猾",
      "zhuyin": "ㄏㄨㄚˊ",
      "pinyin": "jiǎohuá",
      "english": "crafty, cunning, sly"
    },
    {
      "character": "誨",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "jiàohuì",
      "english": "(literary) to instruct, to admonish, to counsel, teachings, instruction, guidance"
    },
    {
      "character": "僥",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎoxìng",
      "english": "luckily, by a fluke"
    },
    {
      "character": "倖",
      "zhuyin": "ㄒㄧㄥˋ",
      "pinyin": "jiǎoxìng",
      "english": "luckily, by a fluke"
    },
    {
      "character": "揭",
      "zhuyin": "ㄐㄧㄝ",
      "pinyin": "jiēfā",
      "english": "to expose, to bring to light, to disclose, revelation"
    },
    {
      "character": "儉",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "jiéjiǎn",
      "english": "frugal, economical"
    },
    {
      "character": "徑",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "jiéjìng",
      "english": "shortcut"
    },
    {
      "character": "晶",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jiéjīng",
      "english": "to crystallize, crystallization, crystal, crystalline, (fig.) the fruit (of labor etc)"
    },
    {
      "character": "繃",
      "zhuyin": "ㄅㄥ",
      "pinyin": "jǐnbēng",
      "english": "to stretch taut, (of muscles etc) taut, strained, tense"
    },
    {
      "character": "晉",
      "zhuyin": "ㄐㄧㄣˋ",
      "pinyin": "jìnjí",
      "english": "to advance in rank, promotion, advancement"
    },
    {
      "character": "津",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "jīnjīnyǒuwèi",
      "english": "with keen interest (idiom), with great pleasure, with gusto, eagerly"
    },
    {
      "character": "髓",
      "zhuyin": "ㄙㄨㄟˇ",
      "pinyin": "jīngsuǐ",
      "english": "marrow, pith, quintessence, essence"
    },
    {
      "character": "惕",
      "zhuyin": "ㄊㄧˋ",
      "pinyin": "jǐngtì",
      "english": "to be on the alert, vigilant, alert, on guard, to warn"
    },
    {
      "character": "畏",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "jìngwèi",
      "english": "to revere"
    },
    {
      "character": "菁",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jīngyīng",
      "english": "elite"
    },
    {
      "character": "緻",
      "zhuyin": "ㄓˋ",
      "pinyin": "jīngzhì",
      "english": "delicate, fine, exquisite, refined"
    },
    {
      "character": "鞠",
      "zhuyin": "ㄐㄩˊ",
      "pinyin": "júgōng",
      "english": "to bow, (literary) to bend down"
    },
    {
      "character": "躬",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "júgōng",
      "english": "to bow, (literary) to bend down"
    },
    {
      "character": "咀",
      "zhuyin": "ㄐㄩˇ",
      "pinyin": "jǔjué",
      "english": "to chew, to think over"
    },
    {
      "character": "沮",
      "zhuyin": "ㄐㄩˇ",
      "pinyin": "jǔsàng",
      "english": "dispirited, dejected, dismayed"
    },
    {
      "character": "喪",
      "zhuyin": "ㄙㄤˋ",
      "pinyin": "jǔsàng",
      "english": "dispirited, dejected, dismayed"
    },
    {
      "character": "拘",
      "zhuyin": "ㄐㄩ",
      "pinyin": "jūshù",
      "english": "to restrict, to restrain, constrained, awkward, ill at ease, uncomfortable, reticent"
    },
    {
      "character": "侷",
      "zhuyin": "ㄐㄩˊ",
      "pinyin": "júxiàn",
      "english": "to limit, to confine, to restrict sth within set boundaries"
    },
    {
      "character": "倔",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "juéjiàng",
      "english": "stubborn, obstinate, unbending"
    },
    {
      "character": "崛",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "juéqǐ",
      "english": "to rise abruptly (to a towering position), to tower over, to spring up, to emerge suddenly, the emer"
    },
    {
      "character": "訣",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "juéqiào",
      "english": "secret, trick, knack, key"
    },
    {
      "character": "竅",
      "zhuyin": "ㄑㄧㄠˋ",
      "pinyin": "juéqiào",
      "english": "secret, trick, knack, key"
    },
    {
      "character": "爵",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "juéshì",
      "english": "knight, Sir, (loanword) jazz"
    },
    {
      "character": "抉",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "juézé",
      "english": "to choose (literary)"
    },
    {
      "character": "勻",
      "zhuyin": "ㄩㄣˊ",
      "pinyin": "jūnyún",
      "english": "even, well-distributed, homogeneous, well-proportioned (figure, body etc)"
    },
    {
      "character": "君",
      "zhuyin": "ㄐㄩㄣ",
      "pinyin": "jūnzhǔ",
      "english": "monarch, sovereign"
    },
    {
      "character": "闢",
      "zhuyin": "ㄆㄧˋ",
      "pinyin": "kāipì",
      "english": "to open up, to set up, to establish"
    },
    {
      "character": "拓",
      "zhuyin": "ㄊㄨㄛˋ",
      "pinyin": "kāituò",
      "english": "to break new ground (for agriculture), to open up (a new seam), to develop (border regions), fig. to"
    },
    {
      "character": "慷",
      "zhuyin": "ㄎㄤ",
      "pinyin": "kāngkǎi",
      "english": "vehement, fervent, generous, magnanimous"
    },
    {
      "character": "恥",
      "zhuyin": "ㄔˇ",
      "pinyin": "kěchǐ",
      "english": "shameful, disgraceful, ignominious"
    },
    {
      "character": "蕩",
      "zhuyin": "ㄉㄤˋ",
      "pinyin": "kōngdàngdàng",
      "english": "empty, deserted"
    },
    {
      "character": "雀",
      "zhuyin": "ㄑㄩㄝˋ",
      "pinyin": "kǒngquè",
      "english": "peacock"
    },
    {
      "character": "碑",
      "zhuyin": "ㄅㄟ",
      "pinyin": "kǒubēi",
      "english": "public praise, public reputation, commonly held opinions, current idiom"
    },
    {
      "character": "哨",
      "zhuyin": "ㄕㄠˋ",
      "pinyin": "kǒushào",
      "english": "whistle"
    },
    {
      "character": "枯",
      "zhuyin": "ㄎㄨ",
      "pinyin": "kūzào",
      "english": "dry and dull, uninteresting, dry-as-dust"
    },
    {
      "character": "恕",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "kuānshù",
      "english": "to forgive, forgiveness"
    },
    {
      "character": "匱",
      "zhuyin": "ㄎㄨㄟˋ",
      "pinyin": "kuìfá",
      "english": "to be deficient in sth, to be short of sth (supplies, money etc)"
    },
    {
      "character": "昆",
      "zhuyin": "ㄎㄨㄣ",
      "pinyin": "kūnchóng",
      "english": "insect, CL:隻|只[zhi1], 群[qun2], 堆[dui1]"
    },
    {
      "character": "惑",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "kùnhuò",
      "english": "bewildered, perplexed, confused, difficult problem, perplexity"
    },
    {
      "character": "杆",
      "zhuyin": "ㄍㄢ",
      "pinyin": "lángān",
      "english": "railing, banister"
    },
    {
      "character": "狽",
      "zhuyin": "ㄅㄟˋ",
      "pinyin": "lángbèi",
      "english": "in a difficult situation, to cut a sorry figure, scoundrel! (derog.)"
    },
    {
      "character": "騷",
      "zhuyin": "ㄙㄠ",
      "pinyin": "láosāo",
      "english": "discontent, complaint, to complain"
    },
    {
      "character": "勒",
      "zhuyin": "ㄌㄜˋ",
      "pinyin": "lèsuǒ",
      "english": "to blackmail, to extort"
    },
    {
      "character": "索",
      "zhuyin": "ㄙㄨㄛˇ",
      "pinyin": "lèsuǒ",
      "english": "to blackmail, to extort"
    },
    {
      "character": "籬",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "líbā",
      "english": "fence (esp. of bamboo or wood railings)"
    },
    {
      "character": "笆",
      "zhuyin": "ㄅㄚ",
      "pinyin": "líbā",
      "english": "fence (esp. of bamboo or wood railings)"
    },
    {
      "character": "罹",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "líhuàn",
      "english": "to suffer (from an illness), to fall ill"
    },
    {
      "character": "俐",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lìluò",
      "english": "agile, nimble, all settled, in order"
    },
    {
      "character": "黎",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "límíng",
      "english": "dawn, daybreak"
    },
    {
      "character": "隸",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lìshǔ",
      "english": "to be subordinate to, to be under the jurisdiction of"
    },
    {
      "character": "邦",
      "zhuyin": "ㄅㄤ",
      "pinyin": "liánbāng",
      "english": "federal, federation, commonwealth, federal union, federal state, union"
    },
    {
      "character": "蓮",
      "zhuyin": "ㄌㄧㄢˊ",
      "pinyin": "liánhuā",
      "english": "lotus flower (Nelumbo nucifera Gaertn, among others), water-lily"
    },
    {
      "character": "憫",
      "zhuyin": "ㄇㄧㄣˇ",
      "pinyin": "liánmǐn",
      "english": "to take pity on, pity, mercy"
    },
    {
      "character": "龐",
      "zhuyin": "ㄆㄤˊ",
      "pinyin": "liǎnpáng",
      "english": "face"
    },
    {
      "character": "遼",
      "zhuyin": "ㄌㄧㄠˊ",
      "pinyin": "liáokuò",
      "english": "vast, extensive"
    },
    {
      "character": "吝",
      "zhuyin": "ㄌㄧㄣˋ",
      "pinyin": "lìnsè",
      "english": "stingy, mean, miserly"
    },
    {
      "character": "嗇",
      "zhuyin": "ㄙㄜˋ",
      "pinyin": "lìnsè",
      "english": "stingy, mean, miserly"
    },
    {
      "character": "凌",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "língchén",
      "english": "very early in the morning, in the wee hours"
    },
    {
      "character": "聆",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "língtīng",
      "english": "to listen (respectfully)"
    },
    {
      "character": "瀏",
      "zhuyin": "ㄌㄧㄡˊ",
      "pinyin": "liúlǎn",
      "english": "to skim over, to browse"
    },
    {
      "character": "氓",
      "zhuyin": "ㄇㄤˊ",
      "pinyin": "liúmáng",
      "english": "rogue, hoodlum, gangster, immoral behavior"
    },
    {
      "character": "逝",
      "zhuyin": "ㄕˋ",
      "pinyin": "liúshì",
      "english": "(of time) to pass, to elapse"
    },
    {
      "character": "壟",
      "zhuyin": "ㄌㄨㄥˇ",
      "pinyin": "lǒngduàn",
      "english": "to monopolize"
    },
    {
      "character": "隆",
      "zhuyin": "ㄌㄨㄥˊ",
      "pinyin": "lóngzhòng",
      "english": "grand, prosperous, ceremonious, solemn"
    },
    {
      "character": "屢",
      "zhuyin": "ㄌㄩˇ",
      "pinyin": "lǚcì",
      "english": "repeatedly, time and again"
    },
    {
      "character": "履",
      "zhuyin": "ㄌㄩˇ",
      "pinyin": "lǚxíng",
      "english": "to fulfill (one's obligations), to carry out (a task), to implement (an agreement), to perform"
    },
    {
      "character": "掠",
      "zhuyin": "ㄌㄩㄝˋ",
      "pinyin": "lüèguò",
      "english": "to flit across, to sweep past, to glance (strike at an angle)"
    },
    {
      "character": "廓",
      "zhuyin": "ㄎㄨㄛˋ",
      "pinyin": "lúnkuò",
      "english": "outline, silhouette"
    },
    {
      "character": "倫",
      "zhuyin": "ㄌㄨㄣˊ",
      "pinyin": "lúnlǐ",
      "english": "ethics"
    },
    {
      "character": "淪",
      "zhuyin": "ㄌㄨㄣˊㄨㄟˊ",
      "pinyin": "lúnwéi",
      "english": "to sink down to, to be reduced to (sth inferior)"
    },
    {
      "character": "蘿",
      "zhuyin": "ㄌㄨㄛˊ",
      "pinyin": "luóbo",
      "english": "radish (Raphanus sativus), esp. white radish 白蘿蔔|白萝卜[bai2 luo2 bo5], CL:個|个[ge4], 根[gen1]"
    },
    {
      "character": "蔔",
      "zhuyin": "˙ㄅㄛ",
      "pinyin": "luóbo",
      "english": "radish (Raphanus sativus), esp. white radish 白蘿蔔|白萝卜[bai2 luo2 bo5], CL:個|个[ge4], 根[gen1]"
    },
    {
      "character": "裸",
      "zhuyin": "ㄌㄨㄛˇ",
      "pinyin": "luǒtǐ",
      "english": "naked"
    },
    {
      "character": "痺",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "mábì",
      "english": "paralysis, palsy, numbness, to benumb, (fig.) to lull, negligent, apathetic"
    },
    {
      "character": "脈",
      "zhuyin": "ㄇㄞˋ",
      "pinyin": "màibó",
      "english": "pulse (both medical and figurative)"
    },
    {
      "character": "伏",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "máifú",
      "english": "to ambush, to lie in wait for, to lie low, ambush"
    },
    {
      "character": "葬",
      "zhuyin": "ㄗㄤˋ",
      "pinyin": "máizàng",
      "english": "to bury"
    },
    {
      "character": "蔓",
      "zhuyin": "ㄇㄢˋ",
      "pinyin": "mànyán",
      "english": "to extend, to spread"
    },
    {
      "character": "茫",
      "zhuyin": "ㄇㄤˊ",
      "pinyin": "mángmáng",
      "english": "boundless, vast and obscure"
    },
    {
      "character": "檻",
      "zhuyin": "ㄎㄢˇ",
      "pinyin": "ménkǎn",
      "english": "doorstep, sill, threshold, fig. knack or trick (esp. scheme to get sth cheaper)"
    },
    {
      "character": "朦",
      "zhuyin": "ㄇㄥˊ",
      "pinyin": "ménglóng",
      "english": "(literary) (of moonlight) dim, (literary) murky, indistinct"
    },
    {
      "character": "朧",
      "zhuyin": "ㄌㄨㄥˊ",
      "pinyin": "ménglóng",
      "english": "(literary) (of moonlight) dim, (literary) murky, indistinct"
    },
    {
      "character": "彌",
      "zhuyin": "ㄇㄧˊ",
      "pinyin": "míbǔ",
      "english": "to complement, to make up for a deficiency"
    },
    {
      "character": "宮",
      "zhuyin": "ㄍㄨㄥ",
      "pinyin": "mígōng",
      "english": "maze, labyrinth"
    },
    {
      "character": "瀰",
      "zhuyin": "ㄇㄧˊ",
      "pinyin": "mímàn",
      "english": "to pervade, to fill the air, diffuse, everywhere present, about to inundate (water), permeated by (s"
    },
    {
      "character": "疫",
      "zhuyin": "ㄧˋ",
      "pinyin": "miǎnyì",
      "english": "immunity (to disease)"
    },
    {
      "character": "渺",
      "zhuyin": "ㄇㄧㄠˇ",
      "pinyin": "miǎoxiǎo",
      "english": "minute, tiny, negligible, insignificant"
    },
    {
      "character": "瞭",
      "zhuyin": "ㄌㄧㄠˇ",
      "pinyin": "míngliǎo",
      "english": "to understand clearly, to be clear about, plain, clear"
    },
    {
      "character": "冥",
      "zhuyin": "ㄇㄧㄥˊ",
      "pinyin": "míngxiǎng",
      "english": "to meditate, meditation"
    },
    {
      "character": "譽",
      "zhuyin": "ㄩˋ",
      "pinyin": "míngyù",
      "english": "fame, reputation, honor, honorary, emeritus (of retired professor)"
    },
    {
      "character": "契",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "mòqì",
      "english": "tacit understanding, mutual understanding, rapport, connected at a deep level with each other, (of t"
    },
    {
      "character": "睹",
      "zhuyin": "ㄉㄨˇ",
      "pinyin": "mùdǔ",
      "english": "to witness, to see at first hand, to see with one's own eyes"
    },
    {
      "character": "募",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "mùkuǎn",
      "english": "to raise money, donated money"
    },
    {
      "character": "牧",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "mùshī",
      "english": "chaplain, churchman, clergyman, parson, pastor, priest, rector"
    },
    {
      "character": "拇",
      "zhuyin": "ㄇㄨˇ",
      "pinyin": "mǔzhǐ",
      "english": "thumb, big toe"
    },
    {
      "character": "吶",
      "zhuyin": "ㄋㄚˋ",
      "pinyin": "nàhǎn",
      "english": "shout, rallying cry, cheering, to shout"
    },
    {
      "character": "乃",
      "zhuyin": "ㄋㄞˇ",
      "pinyin": "nǎishì",
      "english": "equivalent to either 是[shi4] or 就是[jiu4 shi4]"
    },
    {
      "character": "喃",
      "zhuyin": "ㄋㄢˊ",
      "pinyin": "nánnán",
      "english": "(onom.) to mutter, to mumble, to murmur"
    },
    {
      "character": "溺",
      "zhuyin": "ㄋㄧˋ",
      "pinyin": "nìài",
      "english": "to spoil, to pamper, to dote on"
    },
    {
      "character": "匿",
      "zhuyin": "ㄋㄧˋ",
      "pinyin": "nìmíng",
      "english": "anonymous"
    },
    {
      "character": "邁",
      "zhuyin": "ㄇㄞˋ",
      "pinyin": "niánmài",
      "english": "old, aged"
    },
    {
      "character": "凝",
      "zhuyin": "ㄋㄧㄥˊ",
      "pinyin": "níngjù",
      "english": "to condense, to coagulate, coacervation (i.e. form tiny droplets), aggregation, coherent"
    },
    {
      "character": "郁",
      "zhuyin": "ㄩˋ",
      "pinyin": "nóngyù",
      "english": "rich, strong, heavy (fragrance), dense, full-bodied, intense"
    },
    {
      "character": "奴",
      "zhuyin": "ㄋㄨˊ",
      "pinyin": "núlì",
      "english": "slave"
    },
    {
      "character": "懦",
      "zhuyin": "ㄋㄨㄛˋ",
      "pinyin": "nuòruò",
      "english": "cowardly, weak"
    },
    {
      "character": "毆",
      "zhuyin": "ㄡ",
      "pinyin": "ōudǎ",
      "english": "to beat up, to come to blows, battery (law)"
    },
    {
      "character": "嘔",
      "zhuyin": "ㄡˇ",
      "pinyin": "ǒutù",
      "english": "to vomit"
    },
    {
      "character": "徘",
      "zhuyin": "ㄆㄞˊ",
      "pinyin": "páihuái",
      "english": "to pace back and forth, to dither, to hesitate, (of sales figures etc) to fluctuate"
    },
    {
      "character": "徊",
      "zhuyin": "ㄏㄨㄞˊ",
      "pinyin": "páihuái",
      "english": "to pace back and forth, to dither, to hesitate, (of sales figures etc) to fluctuate"
    },
    {
      "character": "徬",
      "zhuyin": "ㄆㄤˊ",
      "pinyin": "pánghuáng",
      "english": "to linger, to hesitate"
    },
    {
      "character": "徨",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "pánghuáng",
      "english": "to linger, to hesitate"
    },
    {
      "character": "沫",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "pàomò",
      "english": "foam, (soap) bubble, (economic) bubble"
    },
    {
      "character": "咆",
      "zhuyin": "ㄆㄠˊ",
      "pinyin": "páoxiāo",
      "english": "(of beasts of prey, torrents of water, a person in a rage etc) to roar"
    },
    {
      "character": "哮",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "páoxiāo",
      "english": "(of beasts of prey, torrents of water, a person in a rage etc) to roar"
    },
    {
      "character": "蓬",
      "zhuyin": "ㄆㄥˊ",
      "pinyin": "péngbó",
      "english": "vigorous, flourishing, full of vitality"
    },
    {
      "character": "勃",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "péngbó",
      "english": "vigorous, flourishing, full of vitality"
    },
    {
      "character": "抨",
      "zhuyin": "ㄆㄥ",
      "pinyin": "pēngjí",
      "english": "to attack (verbally or in writing)"
    },
    {
      "character": "烹",
      "zhuyin": "ㄆㄥ",
      "pinyin": "pēngrèn",
      "english": "cooking, culinary arts"
    },
    {
      "character": "飪",
      "zhuyin": "ㄖㄣˋ",
      "pinyin": "pēngrèn",
      "english": "cooking, culinary arts"
    },
    {
      "character": "膨",
      "zhuyin": "ㄆㄥˊ",
      "pinyin": "péngzhàng",
      "english": "to expand, to inflate, to swell"
    },
    {
      "character": "憊",
      "zhuyin": "ㄅㄟˋ",
      "pinyin": "píbèi",
      "english": "beaten, exhausted, tired"
    },
    {
      "character": "僻",
      "zhuyin": "ㄆㄧˋ",
      "pinyin": "piānpì",
      "english": "remote, desolate, far from the city"
    },
    {
      "character": "瞥",
      "zhuyin": "ㄆㄧㄝ",
      "pinyin": "piējiàn",
      "english": "to glimpse"
    },
    {
      "character": "聘",
      "zhuyin": "ㄆㄧㄣˋ",
      "pinyin": "pìnqǐng",
      "english": "to engage, to hire (a lawyer etc)"
    },
    {
      "character": "魄",
      "zhuyin": "ㄆㄛˋ",
      "pinyin": "pòlì",
      "english": "courage, daring, boldness, resolution, drive"
    },
    {
      "character": "曝",
      "zhuyin": "ㄆㄨˋ",
      "pinyin": "pùguāng",
      "english": "to expose (photography), (fig.) to expose (a scandal), (advertising) exposure, Taiwan pr. [pu4 guang"
    },
    {
      "character": "僕",
      "zhuyin": "ㄆㄨˊ",
      "pinyin": "púrén",
      "english": "servant"
    },
    {
      "character": "菩",
      "zhuyin": "ㄆㄨˊ",
      "pinyin": "púsà",
      "english": "Bodhisattva (Buddhism)"
    },
    {
      "character": "樸",
      "zhuyin": "ㄆㄨˊ",
      "pinyin": "púshí",
      "english": "plain, simple, guileless, down-to-earth, sincere and honest"
    },
    {
      "character": "祈",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qídǎo",
      "english": "to pray, to say one's prayers, prayer"
    },
    {
      "character": "乞",
      "zhuyin": "ㄑㄧˇ",
      "pinyin": "qǐgài",
      "english": "beggar"
    },
    {
      "character": "丐",
      "zhuyin": "ㄍㄞˋ",
      "pinyin": "qǐgài",
      "english": "beggar"
    },
    {
      "character": "淒",
      "zhuyin": "ㄑㄧ",
      "pinyin": "qīliáng",
      "english": "desolate (place)"
    },
    {
      "character": "餒",
      "zhuyin": "ㄋㄟˇ",
      "pinyin": "qìněi",
      "english": "to be discouraged"
    },
    {
      "character": "侮",
      "zhuyin": "ㄨˇ",
      "pinyin": "qīwǔ",
      "english": "to bully"
    },
    {
      "character": "幟",
      "zhuyin": "ㄓˋ",
      "pinyin": "qízhì",
      "english": "ensign, flag"
    },
    {
      "character": "洽",
      "zhuyin": "ㄑㄧㄚˋ",
      "pinyin": "qiàshāng",
      "english": "to negotiate, to talk over"
    },
    {
      "character": "虔",
      "zhuyin": "ㄑㄧㄢˊ",
      "pinyin": "qiánchéng",
      "english": "pious, devout, sincere"
    },
    {
      "character": "傾",
      "zhuyin": "ㄑㄧㄥ",
      "pinyin": "qiánqīng",
      "english": "to lean forward"
    },
    {
      "character": "譴",
      "zhuyin": "ㄑㄧㄢˇ",
      "pinyin": "qiǎnzé",
      "english": "to denounce, to condemn, to criticize, condemnation, criticism"
    },
    {
      "character": "悍",
      "zhuyin": "ㄏㄢˋ",
      "pinyin": "qiánghàn",
      "english": "tough, strong, formidable, fearsome"
    },
    {
      "character": "憔",
      "zhuyin": "ㄑㄧㄠˊ",
      "pinyin": "qiáocuì",
      "english": "wan and sallow, thin and pallid, haggard, (of plants) withered"
    },
    {
      "character": "悴",
      "zhuyin": "ㄘㄨㄟˋ",
      "pinyin": "qiáocuì",
      "english": "wan and sallow, thin and pallid, haggard, (of plants) withered"
    },
    {
      "character": "俏",
      "zhuyin": "ㄑㄧㄠˋ",
      "pinyin": "qiàolì",
      "english": "handsome, pretty"
    },
    {
      "character": "侵",
      "zhuyin": "ㄑㄧㄣ",
      "pinyin": "qīnfàn",
      "english": "to infringe on, to encroach on, to violate, to assault"
    },
    {
      "character": "勤",
      "zhuyin": "ㄑㄧㄣˊ",
      "pinyin": "qínfèn",
      "english": "hardworking, diligent"
    },
    {
      "character": "欽",
      "zhuyin": "ㄑㄧㄣ",
      "pinyin": "qīnpèi",
      "english": "to admire, to look up to, to respect sb greatly"
    },
    {
      "character": "睞",
      "zhuyin": "ㄌㄞˋ",
      "pinyin": "qīnglài",
      "english": "(lit.) to fix one's gaze on, (fig.) to show interest in, (favorable) attention, favor"
    },
    {
      "character": "晰",
      "zhuyin": "ㄒㄧ",
      "pinyin": "qīngxī",
      "english": "clear, distinct"
    },
    {
      "character": "囚",
      "zhuyin": "ㄑㄧㄡˊ",
      "pinyin": "qiúfàn",
      "english": "prisoner, convict"
    },
    {
      "character": "締",
      "zhuyin": "ㄉㄧˋ",
      "pinyin": "qǔdì",
      "english": "to suppress, to crack down on, to prohibit"
    },
    {
      "character": "驅",
      "zhuyin": "ㄑㄩ",
      "pinyin": "qūdòng",
      "english": "to drive, to propel, drive (vehicle wheel), drive mechanism (tape or disk), device driver (computing"
    },
    {
      "character": "屈",
      "zhuyin": "ㄑㄩ",
      "pinyin": "qūfú",
      "english": "to surrender, to succumb, to yield, (as a transitive verb) to defeat, to prevail over"
    },
    {
      "character": "軀",
      "zhuyin": "ㄑㄩ",
      "pinyin": "qūtǐ",
      "english": "(human) body"
    },
    {
      "character": "詮",
      "zhuyin": "ㄑㄩㄢˊ",
      "pinyin": "quánshì",
      "english": "to interpret, to comment and explain, to annotate, to perform (i.e. interpret a theatrical role), to"
    },
    {
      "character": "痊",
      "zhuyin": "ㄑㄩㄢˊ",
      "pinyin": "quányù",
      "english": "to recover completely (from illness or injury)"
    },
    {
      "character": "癒",
      "zhuyin": "ㄩˋ",
      "pinyin": "quányù",
      "english": "to recover completely (from illness or injury)"
    },
    {
      "character": "忱",
      "zhuyin": "ㄔㄣˊ",
      "pinyin": "rèchén",
      "english": "zeal, enthusiasm, ardor, enthusiastic, warmhearted"
    },
    {
      "character": "韌",
      "zhuyin": "ㄖㄣˋ",
      "pinyin": "rènxìng",
      "english": "toughness"
    },
    {
      "character": "冗",
      "zhuyin": "ㄖㄨㄥˇ",
      "pinyin": "rǒngcháng",
      "english": "long and tedious, redundant, superfluous, supernumerary, verbose (of writing)"
    },
    {
      "character": "耀",
      "zhuyin": "ㄧㄠˋ",
      "pinyin": "róngyào",
      "english": "honor, glory"
    },
    {
      "character": "儒",
      "zhuyin": "ㄖㄨˊ",
      "pinyin": "rújiā",
      "english": "Confucian school, founded by Confucius 孔子[Kong3 zi3] (551-479 BC) and Mencius 孟子[Meng4 zi3] (c. 372-"
    },
    {
      "character": "瑞",
      "zhuyin": "ㄖㄨㄟˋ",
      "pinyin": "ruìdiǎn",
      "english": "Sweden"
    },
    {
      "character": "嗓",
      "zhuyin": "ㄙㄤˇ",
      "pinyin": "sǎngmén",
      "english": "voice, windpipe"
    },
    {
      "character": "篩",
      "zhuyin": "ㄕㄞ",
      "pinyin": "shāixuǎn",
      "english": "to filter"
    },
    {
      "character": "擅",
      "zhuyin": "ㄕㄢˋ",
      "pinyin": "shàncháng",
      "english": "to be good at, to be expert in"
    },
    {
      "character": "刪",
      "zhuyin": "ㄕㄢ",
      "pinyin": "shānchú",
      "english": "to delete, to cancel"
    },
    {
      "character": "丘",
      "zhuyin": "ㄑㄧㄡ",
      "pinyin": "shānqiū",
      "english": "hill"
    },
    {
      "character": "爍",
      "zhuyin": "ㄕㄨㄛˋ",
      "pinyin": "shǎnshuò",
      "english": "flickering, twinkling, evasive, vague (of speech)"
    },
    {
      "character": "奢",
      "zhuyin": "ㄕㄜ",
      "pinyin": "shēchǐ",
      "english": "luxurious, extravagant"
    },
    {
      "character": "侈",
      "zhuyin": "ㄔˇ",
      "pinyin": "shēchǐ",
      "english": "luxurious, extravagant"
    },
    {
      "character": "紳",
      "zhuyin": "ㄕㄣ",
      "pinyin": "shēnshì",
      "english": "gentleman"
    },
    {
      "character": "呻",
      "zhuyin": "ㄕㄣ",
      "pinyin": "shēnyín",
      "english": "to moan, to groan"
    },
    {
      "character": "吟",
      "zhuyin": "ㄧㄣˊ",
      "pinyin": "shēnyín",
      "english": "to moan, to groan"
    },
    {
      "character": "淵",
      "zhuyin": "ㄩㄢ",
      "pinyin": "shēnyuān",
      "english": "abyss"
    },
    {
      "character": "牲",
      "zhuyin": "ㄕㄥ",
      "pinyin": "shēngchù",
      "english": "domesticated animals, livestock"
    },
    {
      "character": "畜",
      "zhuyin": "ㄔㄨˋ",
      "pinyin": "shēngchù",
      "english": "domesticated animals, livestock"
    },
    {
      "character": "涯",
      "zhuyin": "ㄧㄚˊ",
      "pinyin": "shēngyá",
      "english": "career, life (way in which sb lives), period of one's life"
    },
    {
      "character": "辰",
      "zhuyin": "ㄔㄣˊ",
      "pinyin": "shíchén",
      "english": "time, one of the 12 two-hour periods of the day"
    },
    {
      "character": "髦",
      "zhuyin": "ㄇㄠˊ",
      "pinyin": "shímáo",
      "english": "in vogue, fashionable"
    },
    {
      "character": "屍",
      "zhuyin": "ㄕ",
      "pinyin": "shītǐ",
      "english": "dead body, corpse, carcass, CL:具[ju4]"
    },
    {
      "character": "帕",
      "zhuyin": "ㄆㄚˋ",
      "pinyin": "shǒupà",
      "english": "handkerchief, CL:方[fang1]"
    },
    {
      "character": "肘",
      "zhuyin": "ㄓㄡˇ",
      "pinyin": "shǒuzhǒu",
      "english": "elbow"
    },
    {
      "character": "縛",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "shùfú",
      "english": "to bind, to tie up, to fetter, to shackle"
    },
    {
      "character": "疏",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shūhū",
      "english": "to neglect, to overlook, negligence, carelessness"
    },
    {
      "character": "紓",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shūjiě",
      "english": "to relieve, to ease (pressure), to alleviate, to remove, to get rid of"
    },
    {
      "character": "淑",
      "zhuyin": "ㄕㄨˊ",
      "pinyin": "shúnǚ",
      "english": "wise and virtuous woman, lady"
    },
    {
      "character": "蔭",
      "zhuyin": "ㄧㄣˋ",
      "pinyin": "shùyìn",
      "english": "shade of a tree, Taiwan pr. [shu4 yin4]"
    },
    {
      "character": "衰",
      "zhuyin": "ㄕㄨㄞ",
      "pinyin": "shuāilǎo",
      "english": "to age, to deteriorate with age, old and weak"
    },
    {
      "character": "瞬",
      "zhuyin": "ㄕㄨㄣˋ",
      "pinyin": "shùnjiān",
      "english": "in an instant, in a flash"
    },
    {
      "character": "嘶",
      "zhuyin": "ㄙ",
      "pinyin": "sīhǎn",
      "english": "to shout"
    },
    {
      "character": "飼",
      "zhuyin": "ㄙˋ",
      "pinyin": "sìyǎng",
      "english": "to raise, to rear"
    },
    {
      "character": "賜",
      "zhuyin": "ㄙˋ",
      "pinyin": "sìyǔ",
      "english": "to grant, to bestow"
    },
    {
      "character": "弛",
      "zhuyin": "ㄔˊ",
      "pinyin": "sōngchí",
      "english": "to relax, relaxed, limp, lax"
    },
    {
      "character": "松",
      "zhuyin": "ㄙㄨㄥ",
      "pinyin": "sōngshù",
      "english": "pine, pine tree, CL:棵[ke1]"
    },
    {
      "character": "懈",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "sōngxiè",
      "english": "to relax, to relax efforts, to slack off, to take it easy, complacent, undisciplined"
    },
    {
      "character": "慫",
      "zhuyin": "ㄙㄨㄥˇ",
      "pinyin": "sǒngyǒng",
      "english": "to instigate, to incite, to urge, to encourage"
    },
    {
      "character": "恿",
      "zhuyin": "ㄩㄥˇ",
      "pinyin": "sǒngyǒng",
      "english": "to instigate, to incite, to urge, to encourage"
    },
    {
      "character": "訟",
      "zhuyin": "ㄙㄨㄥˋ",
      "pinyin": "sùsòng",
      "english": "lawsuit"
    },
    {
      "character": "隧",
      "zhuyin": "ㄙㄨㄟˋ",
      "pinyin": "suìdào",
      "english": "tunnel"
    },
    {
      "character": "瑣",
      "zhuyin": "ㄙㄨㄛˇ",
      "pinyin": "suǒshì",
      "english": "trifle"
    },
    {
      "character": "劾",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "tánhé",
      "english": "to impeach (an official)"
    },
    {
      "character": "瘓",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "tānhuàn",
      "english": "paralysis, be paralyzed (body, transportation, etc)"
    },
    {
      "character": "婪",
      "zhuyin": "ㄌㄢˊ",
      "pinyin": "tānlán",
      "english": "avaricious, greedy, rapacious, insatiable, avid"
    },
    {
      "character": "倘",
      "zhuyin": "ㄊㄤˇ",
      "pinyin": "tǎngruò",
      "english": "if, supposing, in case"
    },
    {
      "character": "陶",
      "zhuyin": "ㄊㄠˊ",
      "pinyin": "táocí",
      "english": "pottery and porcelain, ceramics"
    },
    {
      "character": "淘",
      "zhuyin": "ㄊㄠˊ",
      "pinyin": "táotài",
      "english": "to wash out, (fig.) to cull, to weed out, to eliminate, to die out, to phase out"
    },
    {
      "character": "汰",
      "zhuyin": "ㄊㄞˋ",
      "pinyin": "táotài",
      "english": "to wash out, (fig.) to cull, to weed out, to eliminate, to die out, to phase out"
    },
    {
      "character": "滔",
      "zhuyin": "ㄊㄠ",
      "pinyin": "tāotāobùjué",
      "english": "unceasing torrent (idiom), talking non-stop, gabbling forty to the dozen"
    },
    {
      "character": "倡",
      "zhuyin": "ㄔㄤˋ",
      "pinyin": "tíchàng",
      "english": "to promote, to advocate"
    },
    {
      "character": "堤",
      "zhuyin": "ㄊㄧˊ",
      "pinyin": "tífáng",
      "english": "dike, embankment, levee"
    },
    {
      "character": "眺",
      "zhuyin": "ㄊㄧㄠˋ",
      "pinyin": "tiàowàng",
      "english": "to survey the scene from an elevated position"
    },
    {
      "character": "釁",
      "zhuyin": "ㄒㄧㄣˋ",
      "pinyin": "tiǎoxìn",
      "english": "to provoke, provocation"
    },
    {
      "character": "滯",
      "zhuyin": "ㄓˋ",
      "pinyin": "tíngzhì",
      "english": "stagnation, at a standstill, bogged down"
    },
    {
      "character": "儕",
      "zhuyin": "ㄔㄞˊ",
      "pinyin": "tóngchái",
      "english": "peer, member of the same class, generation or social group"
    },
    {
      "character": "竊",
      "zhuyin": "ㄑㄧㄝˋ",
      "pinyin": "tōuqiè",
      "english": "to steal, to pilfer"
    },
    {
      "character": "壤",
      "zhuyin": "ㄖㄤˇ",
      "pinyin": "tǔrǎng",
      "english": "soil"
    },
    {
      "character": "屠",
      "zhuyin": "ㄊㄨˊ",
      "pinyin": "túshā",
      "english": "to massacre, to slaughter"
    },
    {
      "character": "凸",
      "zhuyin": "ㄊㄨˊ",
      "pinyin": "túxiǎn",
      "english": "to present clearly, to give prominence to, to magnify, clear and obvious"
    },
    {
      "character": "褪",
      "zhuyin": "ㄊㄨㄣˋ",
      "pinyin": "tùnsè",
      "english": "(of colors) to fade, also pr. [tui4 shai3]"
    },
    {
      "character": "駝",
      "zhuyin": "ㄊㄨㄛˊ",
      "pinyin": "tuóbèi",
      "english": "hunchbacked, stooping, hunchback"
    },
    {
      "character": "甥",
      "zhuyin": "ㄕㄥ",
      "pinyin": "wàishēng",
      "english": "sister's son, wife's sibling's son"
    },
    {
      "character": "頑",
      "zhuyin": "ㄨㄢˊ",
      "pinyin": "wángù",
      "english": "stubborn, obstinate"
    },
    {
      "character": "宛",
      "zhuyin": "ㄨㄢˇ",
      "pinyin": "wǎnrú",
      "english": "to be just like"
    },
    {
      "character": "惋",
      "zhuyin": "ㄨㄢˋ",
      "pinyin": "wànxí",
      "english": "to regret, to feel that it is a great pity, to feel sorry for sb"
    },
    {
      "character": "蜿",
      "zhuyin": "ㄨㄢˇ",
      "pinyin": "wǎnyán",
      "english": "(of a snake) to wriggle along, (of a river etc) to zigzag, to meander, to wind"
    },
    {
      "character": "蜒",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "wǎnyán",
      "english": "(of a snake) to wriggle along, (of a river etc) to zigzag, to meander, to wind"
    },
    {
      "character": "宴",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "wǎnyàn",
      "english": "banquet, dinner party, soiree"
    },
    {
      "character": "昔",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "wǎngxí",
      "english": "the past"
    },
    {
      "character": "妄",
      "zhuyin": "ㄨㄤˋ",
      "pinyin": "wàngxiǎng",
      "english": "to attempt vainly, a vain attempt, delusion"
    },
    {
      "character": "違",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéibèi",
      "english": "to go against, to be contrary to, to violate"
    },
    {
      "character": "萎",
      "zhuyin": "ㄨㄟ",
      "pinyin": "wēisuō",
      "english": "to wither, to dry up (of a plant), to atrophy (of muscle, social custom etc)"
    },
    {
      "character": "紊",
      "zhuyin": "ㄨㄣˋ",
      "pinyin": "wènluàn",
      "english": "disorder, chaos"
    },
    {
      "character": "馨",
      "zhuyin": "ㄒㄧㄣ",
      "pinyin": "wēnxīn",
      "english": "comfort, soft and fragrant, warm"
    },
    {
      "character": "瘟",
      "zhuyin": "ㄨㄣ",
      "pinyin": "wēnyì",
      "english": "plague, pestilence"
    },
    {
      "character": "龜",
      "zhuyin": "ㄍㄨㄟ",
      "pinyin": "wūguī",
      "english": "tortoise, cuckold"
    },
    {
      "character": "奈",
      "zhuyin": "ㄋㄞˋ",
      "pinyin": "wúkěnàihé",
      "english": "have no way out, have no alternative, abbr. to 無奈|无奈[wu2 nai4]"
    },
    {
      "character": "辱",
      "zhuyin": "ㄖㄨˋ",
      "pinyin": "wǔrù",
      "english": "to insult, to humiliate, dishonor"
    },
    {
      "character": "晤",
      "zhuyin": "ㄨˋ",
      "pinyin": "wùtán",
      "english": "to speak face to face, meeting, interview"
    },
    {
      "character": "俠",
      "zhuyin": "ㄒㄧㄚˊ",
      "pinyin": "wǔxiá",
      "english": "martial arts chivalry (Chinese literary, theatrical and cinema genre), knight-errant"
    },
    {
      "character": "鴉",
      "zhuyin": "ㄧㄚ",
      "pinyin": "wūyā",
      "english": "crow, raven"
    },
    {
      "character": "熄",
      "zhuyin": "ㄒㄧˊ",
      "pinyin": "xímiè",
      "english": "to stop burning, to go out (of fire), to die out, extinguished"
    },
    {
      "character": "犧",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xīshēng",
      "english": "to sacrifice one's life, to sacrifice (sth valued), beast slaughtered as a sacrifice"
    },
    {
      "character": "狹",
      "zhuyin": "ㄒㄧㄚˊ",
      "pinyin": "xiáài",
      "english": "narrow, tight, narrow minded, lacking in experience"
    },
    {
      "character": "隘",
      "zhuyin": "ㄞˋ",
      "pinyin": "xiáài",
      "english": "narrow, tight, narrow minded, lacking in experience"
    },
    {
      "character": "瑕",
      "zhuyin": "ㄒㄧㄚˊ",
      "pinyin": "xiácī",
      "english": "blemish, flaw, defect"
    },
    {
      "character": "疵",
      "zhuyin": "ㄘ",
      "pinyin": "xiácī",
      "english": "blemish, flaw, defect"
    },
    {
      "character": "憲",
      "zhuyin": "ㄒㄧㄢˋ",
      "pinyin": "xiànfǎ",
      "english": "constitution (of a country), CL:部[bu4]"
    },
    {
      "character": "赫",
      "zhuyin": "ㄏㄜˋ",
      "pinyin": "xiǎnhè",
      "english": "illustrious, celebrated"
    },
    {
      "character": "纖",
      "zhuyin": "ㄒㄧㄢ",
      "pinyin": "xiānwéi",
      "english": "fiber, CL:種|种[zhong3]"
    },
    {
      "character": "暇",
      "zhuyin": "ㄒㄧㄚˊ",
      "pinyin": "xiánxiá",
      "english": "leisure"
    },
    {
      "character": "嚮",
      "zhuyin": "ㄒㄧㄤˋ",
      "pinyin": "xiàngdǎo",
      "english": "guide"
    },
    {
      "character": "祥",
      "zhuyin": "ㄒㄧㄤˊ",
      "pinyin": "xiánghé",
      "english": "auspicious and peaceful"
    },
    {
      "character": "丑",
      "zhuyin": "ㄔㄡˇ",
      "pinyin": "xiǎochǒu",
      "english": "clown"
    },
    {
      "character": "咪",
      "zhuyin": "ㄇㄧ",
      "pinyin": "xiàomīmī",
      "english": "smiling look"
    },
    {
      "character": "瀟",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "xiāosǎ",
      "english": "confident and at ease, free and easy"
    },
    {
      "character": "蕭",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "xiāotiáo",
      "english": "bleak, desolate, (economics) in a slump, sluggish, depressed"
    },
    {
      "character": "逍",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "xiāoyáo",
      "english": "free and unfettered"
    },
    {
      "character": "忠",
      "zhuyin": "ㄓㄨㄥ",
      "pinyin": "xiàozhōng",
      "english": "to vow loyalty and devotion to"
    },
    {
      "character": "腥",
      "zhuyin": "ㄒㄧㄥ",
      "pinyin": "xiěxīng",
      "english": "reeking of blood, bloody (events)"
    },
    {
      "character": "函",
      "zhuyin": "ㄏㄢˊ",
      "pinyin": "xìnhán",
      "english": "letter, piece of correspondence (incl. email)"
    },
    {
      "character": "穎",
      "zhuyin": "ㄧㄥˇ",
      "pinyin": "xīnyǐng",
      "english": "lit. new bud, fig. new and original"
    },
    {
      "character": "襟",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "xiōngjīn",
      "english": "lapel of jacket, heart, aspiration, vision"
    },
    {
      "character": "膛",
      "zhuyin": "ㄊㄤˊ",
      "pinyin": "xiōngtáng",
      "english": "chest"
    },
    {
      "character": "洶",
      "zhuyin": "ㄒㄩㄥ",
      "pinyin": "xiōngyǒng",
      "english": "to surge up violently (of ocean, river, lake etc), turbulent"
    },
    {
      "character": "湧",
      "zhuyin": "ㄩㄥˇ",
      "pinyin": "xiōngyǒng",
      "english": "to surge up violently (of ocean, river, lake etc), turbulent"
    },
    {
      "character": "漩",
      "zhuyin": "ㄒㄩㄢˊ",
      "pinyin": "xuánwō",
      "english": "whirlpool, eddy, vortex, (fig.) maelstrom"
    },
    {
      "character": "渦",
      "zhuyin": "ㄨㄛ",
      "pinyin": "xuánwō",
      "english": "whirlpool, eddy, vortex, (fig.) maelstrom"
    },
    {
      "character": "崖",
      "zhuyin": "ㄧㄞˊ",
      "pinyin": "xuányái",
      "english": "precipice, overhanging cliff"
    },
    {
      "character": "炫",
      "zhuyin": "ㄒㄩㄢˋ",
      "pinyin": "xuànyào",
      "english": "dazzling, to show off, to flaunt"
    },
    {
      "character": "巡",
      "zhuyin": "ㄒㄩㄣˊ",
      "pinyin": "xúnhuí",
      "english": "to go around, to roam, to tour"
    },
    {
      "character": "覓",
      "zhuyin": "ㄇㄧˋ",
      "pinyin": "xúnmì",
      "english": "to look for"
    },
    {
      "character": "丫",
      "zhuyin": "ㄧㄚ",
      "pinyin": "yātou",
      "english": "girl, servant girl, (used deprecatingly, but sometimes also as a term of endearment)"
    },
    {
      "character": "抑",
      "zhuyin": "ㄧˋ",
      "pinyin": "yāyì",
      "english": "to constrain or repress emotions, oppressive, stifling, depressing, repression"
    },
    {
      "character": "苛",
      "zhuyin": "ㄎㄜ",
      "pinyin": "yánkē",
      "english": "severe, harsh"
    },
    {
      "character": "眶",
      "zhuyin": "ㄎㄨㄤ",
      "pinyin": "yǎnkuāng",
      "english": "eye socket, rim of the eye"
    },
    {
      "character": "岩",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "yánshí",
      "english": "rock"
    },
    {
      "character": "諺",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "yànyǔ",
      "english": "proverb"
    },
    {
      "character": "睜",
      "zhuyin": "ㄓㄥ",
      "pinyin": "yǎnzhēngzhēng",
      "english": "to stare blankly, to look on helplessly, to look on unfeelingly"
    },
    {
      "character": "燕",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "yànzi",
      "english": "swallow"
    },
    {
      "character": "妖",
      "zhuyin": "ㄧㄠ",
      "pinyin": "yāoguài",
      "english": "monster, devil"
    },
    {
      "character": "謠",
      "zhuyin": "ㄧㄠˊ",
      "pinyin": "yáoyán",
      "english": "rumor"
    },
    {
      "character": "翌",
      "zhuyin": "ㄧˋ",
      "pinyin": "yìnián",
      "english": "the following year, the next year"
    },
    {
      "character": "裳",
      "zhuyin": "˙ㄕㄤ",
      "pinyin": "yīshang",
      "english": "(coll.) clothes"
    },
    {
      "character": "植",
      "zhuyin": "ㄓˊ",
      "pinyin": "yízhí",
      "english": "to transplant"
    },
    {
      "character": "誘",
      "zhuyin": "ㄧㄡˋ",
      "pinyin": "yǐnyòu",
      "english": "to coerce (sb into doing sth bad), to lure (into a trap), to seduce"
    },
    {
      "character": "恆",
      "zhuyin": "ㄏㄥˊ",
      "pinyin": "yǒnghéng",
      "english": "eternal, everlasting, fig. to pass into eternity (i.e. to die)"
    },
    {
      "character": "佣",
      "zhuyin": "ㄩㄥˋ",
      "pinyin": "yòngrén",
      "english": "servant"
    },
    {
      "character": "黝",
      "zhuyin": "ㄧㄡˇ",
      "pinyin": "yǒuhēi",
      "english": "dark, black, suntanned"
    },
    {
      "character": "惠",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "yōuhuì",
      "english": "privilege, favorable (terms), preferential (treatment), discount (price)"
    },
    {
      "character": "悠",
      "zhuyin": "ㄧㄡ",
      "pinyin": "yōujiǔ",
      "english": "long (tradition, history etc)"
    },
    {
      "character": "愚",
      "zhuyin": "ㄩˊ",
      "pinyin": "yúchǔn",
      "english": "silly, stupid"
    },
    {
      "character": "輿",
      "zhuyin": "ㄩˊ",
      "pinyin": "yúlùn",
      "english": "public opinion"
    },
    {
      "character": "羽",
      "zhuyin": "ㄩˇ",
      "pinyin": "yǔmáo",
      "english": "feather, plumage, plume"
    },
    {
      "character": "冤",
      "zhuyin": "ㄩㄢ",
      "pinyin": "yuāndàtóu",
      "english": "spendthrift and foolish, sb with more money than sense"
    },
    {
      "character": "枉",
      "zhuyin": "ㄨㄤˇ",
      "pinyin": "yuānwǎng",
      "english": "to accuse wrongly, to treat unjustly, injustice, wronged, not worthwhile"
    },
    {
      "character": "韻",
      "zhuyin": "ㄩㄣˋ",
      "pinyin": "yùnlǜ",
      "english": "cadence, rhythm, rhyme scheme, meter (in verse), (linguistics) prosody"
    },
    {
      "character": "醞",
      "zhuyin": "ㄩㄣˋ",
      "pinyin": "yùnniàng",
      "english": "(of alcohol) to ferment, (of a crisis) to be brewing, to mull over (an issue), to hold exploratory d"
    },
    {
      "character": "釀",
      "zhuyin": "ㄋㄧㄤˋ",
      "pinyin": "yùnniàng",
      "english": "(of alcohol) to ferment, (of a crisis) to be brewing, to mull over (an issue), to hold exploratory d"
    },
    {
      "character": "歎",
      "zhuyin": "ㄊㄢˋ",
      "pinyin": "zàntàn",
      "english": "to praise"
    },
    {
      "character": "兮",
      "zhuyin": "ㄒㄧ",
      "pinyin": "zāngxīxī",
      "english": "dirty, filthy"
    },
    {
      "character": "蹋",
      "zhuyin": "ㄊㄚˋ",
      "pinyin": "zāotà",
      "english": "to waste, to defile, to abuse, to insult, to defile, to trample on, to wreck, also pr. [zao1 ta5]"
    },
    {
      "character": "憎",
      "zhuyin": "ㄗㄥ",
      "pinyin": "zēnghèn",
      "english": "to detest, hatred"
    },
    {
      "character": "柵",
      "zhuyin": "ㄓㄚˋ",
      "pinyin": "zhàlán",
      "english": "fence"
    },
    {
      "character": "眨",
      "zhuyin": "ㄓㄚˇ",
      "pinyin": "zhǎyǎn",
      "english": "to blink, to wink, in the twinkling of an eye"
    },
    {
      "character": "顫",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "zhàndòng",
      "english": "to vibrate, to quiver"
    },
    {
      "character": "綻",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "zhànfàng",
      "english": "to blossom"
    },
    {
      "character": "嶄",
      "zhuyin": "ㄓㄢˇ",
      "pinyin": "zhǎnxīn",
      "english": "brand new"
    },
    {
      "character": "輾",
      "zhuyin": "ㄓㄢˇ",
      "pinyin": "zhǎnzhuǎn",
      "english": "to toss about in bed, from person to person, indirectly, to wander"
    },
    {
      "character": "彰",
      "zhuyin": "ㄓㄤ",
      "pinyin": "zhāngxiǎn",
      "english": "to put on display (sth abstract), to draw attention to, conspicuous"
    },
    {
      "character": "撼",
      "zhuyin": "ㄏㄢˋ",
      "pinyin": "zhènhàn",
      "english": "to shake, to shock, to stun, shocking, stunning, shock"
    },
    {
      "character": "癥",
      "zhuyin": "ㄓㄥ",
      "pinyin": "zhēngjié",
      "english": "hard lump in the abdomen (in Chinese medicine), crux of an issue, main point in an argument, stickin"
    },
    {
      "character": "拯",
      "zhuyin": "ㄓㄥˇ",
      "pinyin": "zhěngjiù",
      "english": "to save, to rescue"
    },
    {
      "character": "券",
      "zhuyin": "ㄑㄩㄢˋ",
      "pinyin": "zhèngquàn",
      "english": "negotiable security (financial), certificate, stocks and bonds"
    },
    {
      "character": "壇",
      "zhuyin": "ㄊㄢˊ",
      "pinyin": "zhèngtán",
      "english": "political circles"
    },
    {
      "character": "兆",
      "zhuyin": "ㄓㄠˋ",
      "pinyin": "zhēngzhào",
      "english": "omen, sign (that sth is about to happen), warning sign"
    },
    {
      "character": "脂",
      "zhuyin": "ㄓ",
      "pinyin": "zhīfáng",
      "english": "fat (in the body, in a plant, or in food)"
    },
    {
      "character": "肪",
      "zhuyin": "ㄈㄤˊ",
      "pinyin": "zhīfáng",
      "english": "fat (in the body, in a plant, or in food)"
    },
    {
      "character": "窒",
      "zhuyin": "ㄓˋ",
      "pinyin": "zhìxí",
      "english": "to choke, to stifle, to suffocate"
    },
    {
      "character": "咒",
      "zhuyin": "ㄓㄡˋ",
      "pinyin": "zhòumà",
      "english": "to damn, to curse, to revile"
    },
    {
      "character": "晝",
      "zhuyin": "ㄓㄡˋ",
      "pinyin": "zhòuyè",
      "english": "day and night, period of 24 hours, continuously, without stop"
    },
    {
      "character": "諸",
      "zhuyin": "ㄓㄨ",
      "pinyin": "zhūduō",
      "english": "(used for abstract things) a good deal, a lot of"
    },
    {
      "character": "囑",
      "zhuyin": "ㄓㄨˇ",
      "pinyin": "zhǔfù",
      "english": "to tell, to exhort, injunction"
    },
    {
      "character": "矚",
      "zhuyin": "ㄓㄨˇ",
      "pinyin": "zhǔmù",
      "english": "to focus attention upon"
    },
    {
      "character": "旨",
      "zhuyin": "ㄓˇ",
      "pinyin": "zhǔzhǐ",
      "english": "gist, main idea, general tenor, one's judgment"
    },
    {
      "character": "軸",
      "zhuyin": "ㄓㄡˊ",
      "pinyin": "zhǔzhóu",
      "english": "axis, principal axis (in mechanics, optics, botany etc), main axle (of engine)"
    },
    {
      "character": "撰",
      "zhuyin": "ㄓㄨㄢˋ",
      "pinyin": "zhuànxiě",
      "english": "to write, to compose"
    },
    {
      "character": "潢",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "zhuānghuáng",
      "english": "to mount (a picture), to dress, to adorn, decoration, packaging"
    },
    {
      "character": "溯",
      "zhuyin": "ㄙㄨˋ",
      "pinyin": "zhuīsù",
      "english": "lit. to go upstream, to trace sth back to, to date from"
    },
    {
      "character": "琢",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "zhuómó",
      "english": "to carve and polish (jade), to polish and refine a literary work"
    },
    {
      "character": "卓",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "zhuóyuè",
      "english": "outstanding, surpassing, distinguished, splendid"
    },
    {
      "character": "茁",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "zhuózhuàng",
      "english": "healthy and strong, sturdy, thriving, vigorous, robust, flourishing"
    },
    {
      "character": "諮",
      "zhuyin": "ㄗ",
      "pinyin": "zīshāng",
      "english": "(Tw) consultation, counseling"
    },
    {
      "character": "賃",
      "zhuyin": "ㄌㄧㄣˋ",
      "pinyin": "zūlìn",
      "english": "to rent, to lease, to hire"
    },
    {
      "character": "撓",
      "zhuyin": "ㄋㄠˊ",
      "pinyin": "zǔnáo",
      "english": "to thwart, to obstruct (sth)"
    },
    {
      "character": "詛",
      "zhuyin": "ㄗㄨˇ",
      "pinyin": "zǔzhòu",
      "english": "to curse"
    },
    {
      "character": "悼",
      "zhuyin": "ㄉㄠˋ",
      "pinyin": "āidào",
      "english": "to grieve over sb's death, to lament sb's death, mourning"
    },
    {
      "character": "嚎",
      "zhuyin": "ㄏㄠˊ",
      "pinyin": "āiháo",
      "english": "to howl in grief, anguished wailing, same as 哀號|哀号[ai1 hao2]"
    },
    {
      "character": "捺",
      "zhuyin": "ㄋㄚˋ",
      "pinyin": "ànnà",
      "english": "to restrain, to control"
    },
    {
      "character": "恙",
      "zhuyin": "ㄧㄤˋ",
      "pinyin": "ānránwúyàng",
      "english": "safe and sound (idiom), to come out unscathed (e.g. from an accident or illness)"
    },
    {
      "character": "逸",
      "zhuyin": "ㄧˋ",
      "pinyin": "ānyì",
      "english": "easy and comfortable, easy"
    },
    {
      "character": "盎",
      "zhuyin": "ㄤˋ",
      "pinyin": "àngrán",
      "english": "abundant, plentiful, overflowing, exuberant"
    },
    {
      "character": "翱",
      "zhuyin": "ㄠˊ",
      "pinyin": "áoxiáng",
      "english": "to soar, to wheel about in the sky"
    },
    {
      "character": "遨",
      "zhuyin": "ㄠˊ",
      "pinyin": "áoyóu",
      "english": "to travel, to go on a tour, to roam"
    },
    {
      "character": "黜",
      "zhuyin": "ㄔㄨˋ",
      "pinyin": "bàchù",
      "english": "to dismiss from office, to ban, to reject"
    },
    {
      "character": "跋",
      "zhuyin": "ㄅㄚˊ",
      "pinyin": "báhù",
      "english": "domineering, bossy"
    },
    {
      "character": "扈",
      "zhuyin": "ㄏㄨˋ",
      "pinyin": "báhù",
      "english": "domineering, bossy"
    },
    {
      "character": "擢",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "bázhuó",
      "english": "select the best people for promotion"
    },
    {
      "character": "佈",
      "zhuyin": "ㄅㄨˋ",
      "pinyin": "bǎibù",
      "english": "to arrange, to order about, to manipulate"
    },
    {
      "character": "皙",
      "zhuyin": "ㄒㄧ",
      "pinyin": "báixī",
      "english": "(of complexion or skin) fair and clear"
    },
    {
      "character": "晌",
      "zhuyin": "ㄕㄤˇ",
      "pinyin": "bànshǎng",
      "english": "half of the day, a long time, quite a while"
    },
    {
      "character": "壘",
      "zhuyin": "ㄌㄟˇ",
      "pinyin": "bǎolěi",
      "english": "fort"
    },
    {
      "character": "戾",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "bàolì",
      "english": "ruthless"
    },
    {
      "character": "姆",
      "zhuyin": "ㄇㄨˇ",
      "pinyin": "bǎomǔ",
      "english": "nanny, housekeeper"
    },
    {
      "character": "庇",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bìhù",
      "english": "asylum, shelter, to shield, to put under protection, to take under one's wing"
    },
    {
      "character": "碧",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bìlǜ",
      "english": "dark green"
    },
    {
      "character": "篳",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bìlùlánlǚ",
      "english": "the hardships of beginning an undertaking (idiom)"
    },
    {
      "character": "陛",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "bìxià",
      "english": "Your Majesty, His or Her Majesty"
    },
    {
      "character": "夷",
      "zhuyin": "ㄧˊ",
      "pinyin": "bǐyí",
      "english": "to despise, to look down upon, despicable"
    },
    {
      "character": "陲",
      "zhuyin": "ㄔㄨㄟˊ",
      "pinyin": "biānchuí",
      "english": "border area, frontier"
    },
    {
      "character": "疆",
      "zhuyin": "ㄐㄧㄤ",
      "pinyin": "biānjiāng",
      "english": "border area, borderland, frontier, frontier region"
    },
    {
      "character": "竿",
      "zhuyin": "ㄍㄢ",
      "pinyin": "biāogān",
      "english": "benchmark, pole serving as mark or symbol, pole with a trophy hung on it"
    },
    {
      "character": "彆",
      "zhuyin": "ㄅㄧㄝˋ",
      "pinyin": "bièniǔ",
      "english": "awkward, difficult, uncomfortable, not agreeing, at loggerheads, gauche"
    },
    {
      "character": "彬",
      "zhuyin": "ㄅㄧㄣ",
      "pinyin": "bīnbīnyǒulǐ",
      "english": "refined and courteous, urbane"
    },
    {
      "character": "繽",
      "zhuyin": "ㄅㄧㄣ",
      "pinyin": "bīnfēn",
      "english": "vast and various, rich and diverse"
    },
    {
      "character": "檳",
      "zhuyin": "ㄅㄧㄣ",
      "pinyin": "bīnláng",
      "english": "betel palm (Areca catechu), betel nut"
    },
    {
      "character": "榔",
      "zhuyin": "ㄌㄤˊ",
      "pinyin": "bīnláng",
      "english": "betel palm (Areca catechu), betel nut"
    },
    {
      "character": "稟",
      "zhuyin": "ㄅㄧㄥˇ",
      "pinyin": "bǐngbào",
      "english": "to report (to one's superior)"
    },
    {
      "character": "秉",
      "zhuyin": "ㄅㄧㄥˇ",
      "pinyin": "bǐngchí",
      "english": "to uphold, to hold fast to"
    },
    {
      "character": "摒",
      "zhuyin": "ㄅㄧㄥˋ",
      "pinyin": "bìngchú",
      "english": "to get rid of, to dismiss"
    },
    {
      "character": "肓",
      "zhuyin": "ㄏㄨㄤ",
      "pinyin": "bìngrùgāohuāng",
      "english": "lit. the disease has attacked the vitals (idiom), fig. beyond cure, the situation is hopeless"
    },
    {
      "character": "榻",
      "zhuyin": "ㄊㄚˋ",
      "pinyin": "bìngtà",
      "english": "sickbed"
    },
    {
      "character": "屏",
      "zhuyin": "ㄅㄧㄥˇ",
      "pinyin": "bǐngxí",
      "english": "hold one's breath"
    },
    {
      "character": "悖",
      "zhuyin": "ㄅㄟˋ",
      "pinyin": "bìngxíngbúbèi",
      "english": "to run in parallel without hindrance, not mutually exclusive, two processes can be implemented witho"
    },
    {
      "character": "瀾",
      "zhuyin": "ㄌㄢˊ",
      "pinyin": "bōlán",
      "english": "billows, great waves (fig. of a story with great momentum)"
    },
    {
      "character": "啻",
      "zhuyin": "ㄔˋ",
      "pinyin": "búchì",
      "english": "just as, no less than, like (sth momentous), as good as, tantamount to"
    },
    {
      "character": "慄",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "bùhánérlì",
      "english": "lit. not cold, yet shivering (idiom), fig. to tremble with fear, to be terrified"
    },
    {
      "character": "羈",
      "zhuyin": "ㄐㄧ",
      "pinyin": "bùjī",
      "english": "unruly, uninhibited"
    },
    {
      "character": "倚",
      "zhuyin": "ㄧˇ",
      "pinyin": "bùpiānbùyǐ",
      "english": "even-handed, impartial, unbiased, exact, just"
    },
    {
      "character": "哺",
      "zhuyin": "ㄅㄨˇ",
      "pinyin": "bǔrǔdòngwù",
      "english": "mammal"
    },
    {
      "character": "渝",
      "zhuyin": "ㄩˊ",
      "pinyin": "bùyú",
      "english": "constant, unchanging, abiding, faithful"
    },
    {
      "character": "虞",
      "zhuyin": "ㄩˊ",
      "pinyin": "bùyú",
      "english": "unexpected, eventuality, contingency, not worry about"
    },
    {
      "character": "云",
      "zhuyin": "ㄩㄣˊ",
      "pinyin": "bùzhīsuǒyún",
      "english": "to not know what sb is driving at, to be unintelligible"
    },
    {
      "character": "餚",
      "zhuyin": "ㄧㄠˊ",
      "pinyin": "càiyáo",
      "english": "vegetable and meat dishes, dish"
    },
    {
      "character": "骸",
      "zhuyin": "ㄏㄞˊ",
      "pinyin": "cánhái",
      "english": "remains, wreckage"
    },
    {
      "character": "滄",
      "zhuyin": "ㄘㄤ",
      "pinyin": "cāngsāng",
      "english": "great changes, ups and downs, vicissitudes, abbr. of 滄海桑田|沧海桑田[cang1 hai3 sang1 tian2]"
    },
    {
      "character": "桑",
      "zhuyin": "ㄙㄤ",
      "pinyin": "cāngsāng",
      "english": "great changes, ups and downs, vicissitudes, abbr. of 滄海桑田|沧海桑田[cang1 hai3 sang1 tian2]"
    },
    {
      "character": "嘈",
      "zhuyin": "ㄘㄠˊ",
      "pinyin": "cáozá",
      "english": "noisy, clamorous"
    },
    {
      "character": "几",
      "zhuyin": "ㄐㄧ",
      "pinyin": "chájī",
      "english": "small side table, coffee table, teapoy (ornamental tripod with caddies for tea)"
    },
    {
      "character": "剎",
      "zhuyin": "ㄔㄚˋ",
      "pinyin": "chànà",
      "english": "an instant (Sanskrit: ksana), split second, the twinkling of an eye"
    },
    {
      "character": "潺",
      "zhuyin": "ㄔㄢˊ",
      "pinyin": "chánchán",
      "english": "murmur, babble (sound of water)"
    },
    {
      "character": "剷",
      "zhuyin": "ㄔㄢˇ",
      "pinyin": "chǎnchú",
      "english": "to root out, to eradicate, to sweep away, to abolish"
    },
    {
      "character": "攙",
      "zhuyin": "ㄔㄢ",
      "pinyin": "chānfú",
      "english": "to lend an arm to support sb"
    },
    {
      "character": "諂",
      "zhuyin": "ㄔㄢˇ",
      "pinyin": "chǎnmèi",
      "english": "to flatter"
    },
    {
      "character": "媚",
      "zhuyin": "ㄇㄟˋ",
      "pinyin": "chǎnmèi",
      "english": "to flatter"
    },
    {
      "character": "綿",
      "zhuyin": "ㄇㄧㄢˊ",
      "pinyin": "chánmián",
      "english": "touching (emotions), lingering (illness)"
    },
    {
      "character": "鏟",
      "zhuyin": "ㄔㄢˇ",
      "pinyin": "chǎnzi",
      "english": "shovel, spade, trowel, spatula (kitchen utensil), CL:把[ba3]"
    },
    {
      "character": "猖",
      "zhuyin": "ㄔㄤ",
      "pinyin": "chāngjué",
      "english": "to be rampant, to run wild"
    },
    {
      "character": "獗",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "chāngjué",
      "english": "to be rampant, to run wild"
    },
    {
      "character": "悵",
      "zhuyin": "ㄔㄤˋ",
      "pinyin": "chàngrán",
      "english": "disappointed and frustrated"
    },
    {
      "character": "廷",
      "zhuyin": "ㄊㄧㄥˊ",
      "pinyin": "cháotíng",
      "english": "court, imperial household, dynasty"
    },
    {
      "character": "埃",
      "zhuyin": "ㄞ",
      "pinyin": "chénāi",
      "english": "dust"
    },
    {
      "character": "澱",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "chéndiàn",
      "english": "to settle, to precipitate, sedimentation"
    },
    {
      "character": "甸",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "chéndiàndiàn",
      "english": "heavy"
    },
    {
      "character": "曦",
      "zhuyin": "ㄒㄧ",
      "pinyin": "chénxī",
      "english": "first rays of morning sun, first glimmer of dawn"
    },
    {
      "character": "瞠",
      "zhuyin": "ㄔㄥ",
      "pinyin": "chēngmùjiéshé",
      "english": "stupefied, flabbergasted"
    },
    {
      "character": "頌",
      "zhuyin": "ㄙㄨㄥˋ",
      "pinyin": "chēngsòng",
      "english": "to praise"
    },
    {
      "character": "騁",
      "zhuyin": "ㄔㄥˇ",
      "pinyin": "chíchěng",
      "english": "to gallop, to rush headlong"
    },
    {
      "character": "赤",
      "zhuyin": "ㄔˋ",
      "pinyin": "chìluǒ",
      "english": "naked, bare"
    },
    {
      "character": "熾",
      "zhuyin": "ㄔˋ",
      "pinyin": "chìrè",
      "english": "red-hot, glowing, blazing, (fig.) passionate"
    },
    {
      "character": "嗤",
      "zhuyin": "ㄔ",
      "pinyin": "chīzhīyǐbí",
      "english": "to snort disdainfully, to scoff at, to turn up one's nose"
    },
    {
      "character": "憧",
      "zhuyin": "ㄔㄨㄥ",
      "pinyin": "chōngjǐng",
      "english": "to long for, to look forward to, longing, vision for the future"
    },
    {
      "character": "憬",
      "zhuyin": "ㄐㄧㄥˇ",
      "pinyin": "chōngjǐng",
      "english": "to long for, to look forward to, longing, vision for the future"
    },
    {
      "character": "惆",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "chóuchàng",
      "english": "melancholy, depression"
    },
    {
      "character": "躊",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "chóuchú",
      "english": "to hesitate"
    },
    {
      "character": "躇",
      "zhuyin": "ㄔㄨˊ",
      "pinyin": "chóuchú",
      "english": "to hesitate"
    },
    {
      "character": "綢",
      "zhuyin": "ㄔㄡˊ",
      "pinyin": "chóuduàn",
      "english": "satin, silk fabric"
    },
    {
      "character": "緞",
      "zhuyin": "ㄉㄨㄢˋ",
      "pinyin": "chóuduàn",
      "english": "satin, silk fabric"
    },
    {
      "character": "繭",
      "zhuyin": "ㄐㄧㄢˇ",
      "pinyin": "chōusībōjiǎn",
      "english": "lit. to unwind the silk thread from the cocoon (idiom), fig. to unravel a mystery, to painstakingly "
    },
    {
      "character": "萃",
      "zhuyin": "ㄘㄨㄟˋ",
      "pinyin": "chūlèibácuì",
      "english": "to excel the common (idiom), surpassing, preeminent, outstanding"
    },
    {
      "character": "矗",
      "zhuyin": "ㄔㄨˋ",
      "pinyin": "chùlì",
      "english": "to tower, standing tall and upright (of large building)"
    },
    {
      "character": "鋤",
      "zhuyin": "ㄔㄨˊ",
      "pinyin": "chútou",
      "english": "hoe, CL:把[ba3]"
    },
    {
      "character": "衷",
      "zhuyin": "ㄓㄨㄥ",
      "pinyin": "chūzhōng",
      "english": "original intention"
    },
    {
      "character": "揣",
      "zhuyin": "ㄔㄨㄞˇ",
      "pinyin": "chuǎicè",
      "english": "to guess, to conjecture"
    },
    {
      "character": "艙",
      "zhuyin": "ㄘㄤ",
      "pinyin": "chuáncāng",
      "english": "hold of ship"
    },
    {
      "character": "梭",
      "zhuyin": "ㄙㄨㄛ",
      "pinyin": "chuānsuō",
      "english": "to travel back and forth, to shuttle"
    },
    {
      "character": "涎",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "chuíxián",
      "english": "to water at the mouth, to drool"
    },
    {
      "character": "唇",
      "zhuyin": "ㄔㄨㄣˊ",
      "pinyin": "chúnshé",
      "english": "argument, words, lips and tongue"
    },
    {
      "character": "輟",
      "zhuyin": "ㄔㄨㄛˋ",
      "pinyin": "chuòxué",
      "english": "to drop out of school, to leave off studying, to interrupt one's studies"
    },
    {
      "character": "獷",
      "zhuyin": "ㄍㄨㄤˇ",
      "pinyin": "cūguǎng",
      "english": "rough, rude, boorish, straightforward, uninhibited"
    },
    {
      "character": "簇",
      "zhuyin": "ㄘㄨˋ",
      "pinyin": "cùyǒng",
      "english": "to crowd around, to escort"
    },
    {
      "character": "璀",
      "zhuyin": "ㄘㄨㄟˇ",
      "pinyin": "cuǐcàn",
      "english": "bright, resplendent"
    },
    {
      "character": "璨",
      "zhuyin": "ㄘㄢˋ",
      "pinyin": "cuǐcàn",
      "english": "bright, resplendent"
    },
    {
      "character": "翠",
      "zhuyin": "ㄘㄨㄟˋ",
      "pinyin": "cuìlǜ",
      "english": "greenish-blue, emerald green"
    },
    {
      "character": "愕",
      "zhuyin": "ㄜˋ",
      "pinyin": "cuòè",
      "english": "astonished, startled"
    },
    {
      "character": "磋",
      "zhuyin": "ㄘㄨㄛ",
      "pinyin": "cuōshāng",
      "english": "to consult, to discuss seriously, to negotiate, to confer, negotiations, consultations"
    },
    {
      "character": "霆",
      "zhuyin": "ㄊㄧㄥˊ",
      "pinyin": "dàfāléitíng",
      "english": "to be furious, to fly into a terrible rage"
    },
    {
      "character": "亨",
      "zhuyin": "ㄏㄥ",
      "pinyin": "dàhēng",
      "english": "big shot, top gun, superstar, VIP"
    },
    {
      "character": "剌",
      "zhuyin": "ㄌㄚˋ",
      "pinyin": "dàlàlà",
      "english": "pompous, with a swagger, casual"
    },
    {
      "character": "鼎",
      "zhuyin": "ㄉㄧㄥˇ",
      "pinyin": "dàmíngdǐngdǐng",
      "english": "grand reputation, renowned, famous"
    },
    {
      "character": "逕",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "dàxiāngjìngtíng",
      "english": "completely different"
    },
    {
      "character": "怠",
      "zhuyin": "ㄉㄞˋ",
      "pinyin": "dàiduò",
      "english": "idleness"
    },
    {
      "character": "稻",
      "zhuyin": "ㄉㄠˋ",
      "pinyin": "dàocǎo",
      "english": "rice straw"
    },
    {
      "character": "牴",
      "zhuyin": "ㄉㄧˇ",
      "pinyin": "dǐchù",
      "english": "to conflict, to contradict"
    },
    {
      "character": "詆",
      "zhuyin": "ㄉㄧˇ",
      "pinyin": "dǐhuǐ",
      "english": "to vilify, to slander, vilification"
    },
    {
      "character": "窖",
      "zhuyin": "ㄐㄧㄠˋ",
      "pinyin": "dìjiào",
      "english": "cellar, basement"
    },
    {
      "character": "簸",
      "zhuyin": "ㄅㄛˇ",
      "pinyin": "diānbǒ",
      "english": "to be jolted around (car on a bumpy road, boat on a rough sea, aircraft experiencing turbulence), (f"
    },
    {
      "character": "惦",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "diànjì",
      "english": "to think of, to keep thinking about, to be concerned about"
    },
    {
      "character": "癲",
      "zhuyin": "ㄉㄧㄢ",
      "pinyin": "diānxián",
      "english": "epilepsy"
    },
    {
      "character": "癇",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "diānxián",
      "english": "epilepsy"
    },
    {
      "character": "墊",
      "zhuyin": "ㄉㄧㄢˋ",
      "pinyin": "diànzi",
      "english": "cushion, mat, pad"
    },
    {
      "character": "凋",
      "zhuyin": "ㄉㄧㄠ",
      "pinyin": "diāolíng",
      "english": "withered, wilted, to wither, to fade, to decay"
    },
    {
      "character": "刁",
      "zhuyin": "ㄉㄧㄠ",
      "pinyin": "diāonán",
      "english": "to be hard on sb, to deliberately make things difficult, Taiwan pr. [diao1 nan2]"
    },
    {
      "character": "喋",
      "zhuyin": "ㄉㄧㄝˊ",
      "pinyin": "diédiébùxiū",
      "english": "to chatter or jabber on and on"
    },
    {
      "character": "恫",
      "zhuyin": "ㄉㄨㄥˋ",
      "pinyin": "dònghè",
      "english": "to intimidate, to threaten"
    },
    {
      "character": "輒",
      "zhuyin": "ㄓㄜˊ",
      "pinyin": "dòngzhé",
      "english": "easily, readily, frequently, at every turn, at the slightest pretext"
    },
    {
      "character": "峭",
      "zhuyin": "ㄑㄧㄠˋ",
      "pinyin": "dǒuqiào",
      "english": "precipitous"
    },
    {
      "character": "篤",
      "zhuyin": "ㄉㄨˇ",
      "pinyin": "dǔdìng",
      "english": "certain, confident (of some outcome), calm and unhurried"
    },
    {
      "character": "鍍",
      "zhuyin": "ㄉㄨˋ",
      "pinyin": "dùjīn",
      "english": "to gold-plate, to gild, (fig.) to make sth quite ordinary seem special"
    },
    {
      "character": "杜",
      "zhuyin": "ㄉㄨˋ",
      "pinyin": "dùjué",
      "english": "to put an end to"
    },
    {
      "character": "嘟",
      "zhuyin": "ㄉㄨ",
      "pinyin": "dūnang",
      "english": "to mumble to oneself"
    },
    {
      "character": "囔",
      "zhuyin": "˙ㄋㄤ",
      "pinyin": "dūnang",
      "english": "to mumble to oneself"
    },
    {
      "character": "噥",
      "zhuyin": "˙ㄋㄨㄥ",
      "pinyin": "dūnong",
      "english": "to mutter, to mumble complaints, to grumble"
    },
    {
      "character": "倪",
      "zhuyin": "ㄋㄧˊ",
      "pinyin": "duānní",
      "english": "boundary, clue, indication, to obtain clues, to infer"
    },
    {
      "character": "砌",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "duīqì",
      "english": "lit. to pile up (bricks), to pack, fig. to pad out (writing with fancy phrases), ornate rhetoric"
    },
    {
      "character": "兌",
      "zhuyin": "ㄉㄨㄟˋ",
      "pinyin": "duìxiàn",
      "english": "(of a check etc) to cash, to honor a commitment"
    },
    {
      "character": "敦",
      "zhuyin": "ㄉㄨㄣ",
      "pinyin": "dūncù",
      "english": "to press, to urge, to hasten"
    },
    {
      "character": "踱",
      "zhuyin": "ㄉㄨㄛˋ",
      "pinyin": "duòbù",
      "english": "to pace, to stroll"
    },
    {
      "character": "咄",
      "zhuyin": "ㄉㄨㄛˋ",
      "pinyin": "duòduòbīrén",
      "english": "overbearing, forceful, aggressive, menacing, imperious"
    },
    {
      "character": "跺",
      "zhuyin": "ㄉㄨㄛˋ",
      "pinyin": "duòjiǎo",
      "english": "to stamp one's feet"
    },
    {
      "character": "哆",
      "zhuyin": "ㄉㄨㄛ",
      "pinyin": "duōsuo",
      "english": "to tremble, to shiver, uncontrolled shaking of the body"
    },
    {
      "character": "噩",
      "zhuyin": "ㄜˋ",
      "pinyin": "èhào",
      "english": "news of sb's death, sad news"
    },
    {
      "character": "扼",
      "zhuyin": "ㄜˋ",
      "pinyin": "èshā",
      "english": "to strangle, to throttle"
    },
    {
      "character": "鱷",
      "zhuyin": "ㄜˋ",
      "pinyin": "èyú",
      "english": "alligator, crocodile"
    },
    {
      "character": "諛",
      "zhuyin": "ㄩˊ",
      "pinyin": "ēyú",
      "english": "to flatter, to toady"
    },
    {
      "character": "厄",
      "zhuyin": "ㄜˋ",
      "pinyin": "èyùn",
      "english": "bad luck, misfortune, adversity"
    },
    {
      "character": "遏",
      "zhuyin": "ㄜˋ",
      "pinyin": "èzhǐ",
      "english": "to hold back, to check (i.e. to stop sb's advance), to resist, esp. with negative, irresistible, uns"
    },
    {
      "character": "飆",
      "zhuyin": "ㄅㄧㄠ",
      "pinyin": "fābiāo",
      "english": "to flip out, to act out violently"
    },
    {
      "character": "藩",
      "zhuyin": "ㄈㄢˊ",
      "pinyin": "fánlí",
      "english": "hedge, fence, (fig.) barrier"
    },
    {
      "character": "茂",
      "zhuyin": "ㄇㄠˋ",
      "pinyin": "fánmào",
      "english": "(of vegetation) lush, luxuriant"
    },
    {
      "character": "誹",
      "zhuyin": "ㄈㄟˇ",
      "pinyin": "fěibàng",
      "english": "to slander, to libel"
    },
    {
      "character": "謗",
      "zhuyin": "ㄅㄤˋ",
      "pinyin": "fěibàng",
      "english": "to slander, to libel"
    },
    {
      "character": "腑",
      "zhuyin": "ㄈㄨˇ",
      "pinyin": "fèifǔ",
      "english": "bottom of the heart (fig.)"
    },
    {
      "character": "寢",
      "zhuyin": "ㄑㄧㄣˇ",
      "pinyin": "fèiqǐnwàngshí",
      "english": "(idiom) to skip one's sleep and meals, to be completely wrapped up in one's work"
    },
    {
      "character": "斐",
      "zhuyin": "ㄈㄟˇ",
      "pinyin": "fěirán",
      "english": "(literary) remarkable, brilliant"
    },
    {
      "character": "沃",
      "zhuyin": "ㄨㄛˋ",
      "pinyin": "féiwò",
      "english": "fertile"
    },
    {
      "character": "匪",
      "zhuyin": "ㄈㄟˇ",
      "pinyin": "fěiyísuǒsī",
      "english": "unimaginable, outrageous, freakish"
    },
    {
      "character": "鑣",
      "zhuyin": "ㄅㄧㄠ",
      "pinyin": "fēndàoyángbiāo",
      "english": "lit. to take different roads and urge the horses on (idiom), fig. to part ways"
    },
    {
      "character": "芬",
      "zhuyin": "ㄈㄣ",
      "pinyin": "fēnfāng",
      "english": "perfume, fragrant"
    },
    {
      "character": "忿",
      "zhuyin": "ㄈㄣˋ",
      "pinyin": "fènfènbùpíng",
      "english": "to feel indignant, to feel aggrieved"
    },
    {
      "character": "懣",
      "zhuyin": "ㄇㄣˋ",
      "pinyin": "fènmèn",
      "english": "depressed, resentful, discontented, indignant, perturbed"
    },
    {
      "character": "嶺",
      "zhuyin": "ㄌㄧㄥˇ",
      "pinyin": "fēnshuǐlǐng",
      "english": "dividing range, drainage divide, (fig.) dividing line, watershed"
    },
    {
      "character": "烽",
      "zhuyin": "ㄈㄥ",
      "pinyin": "fēnghuǒ",
      "english": "fire beacon (to give alarm)"
    },
    {
      "character": "俸",
      "zhuyin": "ㄈㄥˋ",
      "pinyin": "fènglù",
      "english": "official's salary (in feudal times)"
    },
    {
      "character": "祿",
      "zhuyin": "ㄌㄨˋ",
      "pinyin": "fènglù",
      "english": "official's salary (in feudal times)"
    },
    {
      "character": "靡",
      "zhuyin": "ㄇㄧˇ",
      "pinyin": "fēngmǐ",
      "english": "fashionable, popular"
    },
    {
      "character": "紉",
      "zhuyin": "ㄖㄣˋ",
      "pinyin": "féngrèn",
      "english": "to sew, tailoring"
    },
    {
      "character": "俯",
      "zhuyin": "ㄈㄨˇ",
      "pinyin": "fǔkàn",
      "english": "to overlook, to look down from a height"
    },
    {
      "character": "瞰",
      "zhuyin": "ㄎㄢˋ",
      "pinyin": "fǔkàn",
      "english": "to overlook, to look down from a height"
    },
    {
      "character": "駙",
      "zhuyin": "ㄈㄨˋ",
      "pinyin": "fùmǎ",
      "english": "emperor's son-in-law"
    },
    {
      "character": "輻",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "fúshè",
      "english": "radiation"
    },
    {
      "character": "蝕",
      "zhuyin": "ㄕˊ",
      "pinyin": "fǔshí",
      "english": "corrosion, to corrode (degrade chemically), to rot, corruption"
    },
    {
      "character": "庶",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "fùshù",
      "english": "populous and affluent"
    },
    {
      "character": "膺",
      "zhuyin": "ㄧㄥ",
      "pinyin": "fúyīng",
      "english": "to bear in mind"
    },
    {
      "character": "祉",
      "zhuyin": "ㄓˇ",
      "pinyin": "fúzhǐ",
      "english": "well-being, welfare"
    },
    {
      "character": "涸",
      "zhuyin": "ㄏㄜˊ",
      "pinyin": "gānhé",
      "english": "to dry up"
    },
    {
      "character": "蔗",
      "zhuyin": "ㄓㄜˋ",
      "pinyin": "gānzhè",
      "english": "sugar cane, CL:節|节[jie2]"
    },
    {
      "character": "槓",
      "zhuyin": "ㄍㄤˋ",
      "pinyin": "gànggǎn",
      "english": "lever, pry bar, crowbar, financial leverage"
    },
    {
      "character": "亢",
      "zhuyin": "ㄎㄤˋ",
      "pinyin": "gāokàng",
      "english": "high-pitched and penetrating (musical instrument, voice etc), high-spirited, fever-pitched (atmosphe"
    },
    {
      "character": "羔",
      "zhuyin": "ㄍㄠ",
      "pinyin": "gāoyáng",
      "english": "sheep, lamb"
    },
    {
      "character": "胳",
      "zhuyin": "ㄍㄜ",
      "pinyin": "gēbó",
      "english": "arm, CL:隻|只[zhi1], 條|条[tiao2], 雙|双[shuang1]"
    },
    {
      "character": "膊",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "gēbó",
      "english": "arm, CL:隻|只[zhi1], 條|条[tiao2], 雙|双[shuang1]"
    },
    {
      "character": "疙",
      "zhuyin": "ㄍㄜ",
      "pinyin": "gēda",
      "english": "swelling or lump on skin, pimple, knot, lump, preoccupation, problem"
    },
    {
      "character": "瘩",
      "zhuyin": "˙ㄉㄚ",
      "pinyin": "gēda",
      "english": "swelling or lump on skin, pimple, knot, lump, preoccupation, problem"
    },
    {
      "character": "蒂",
      "zhuyin": "ㄉㄧˋ",
      "pinyin": "gēnshēndìgù",
      "english": "deep-rooted (problem etc)"
    },
    {
      "character": "柢",
      "zhuyin": "ㄉㄧˇ",
      "pinyin": "gēnshēndǐgù",
      "english": "(root) to grow deep and strong; the foundation is solid and unbreakable. "
    },
    {
      "character": "迭",
      "zhuyin": "ㄉㄧㄝˊ",
      "pinyin": "gēngdié",
      "english": "to alternate, to change"
    },
    {
      "character": "耿",
      "zhuyin": "ㄍㄥˇ",
      "pinyin": "gěnggěngyúhuái",
      "english": "to take troubles to heart (idiom), brooding"
    },
    {
      "character": "哽",
      "zhuyin": "ㄍㄥˇ",
      "pinyin": "gěngyè",
      "english": "to choke with emotion, to choke with sobs"
    },
    {
      "character": "咽",
      "zhuyin": "ㄧㄝˋ",
      "pinyin": "gěngyè",
      "english": "to choke with emotion, to choke with sobs"
    },
    {
      "character": "訐",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "gōngjié",
      "english": "to attack sb by exposing faults, to denounce"
    },
    {
      "character": "簣",
      "zhuyin": "ㄎㄨㄟˋ",
      "pinyin": "gōngkuīyīkuì",
      "english": "lit. to ruin the enterprise for the sake of one basketful, to fail through lack of a final effort, t"
    },
    {
      "character": "頃",
      "zhuyin": "ㄑㄧㄥˇ",
      "pinyin": "gōngqǐng",
      "english": "hectare"
    },
    {
      "character": "勳",
      "zhuyin": "ㄒㄩㄣ",
      "pinyin": "gōngxūn",
      "english": "meritorious contributions to the country and society"
    },
    {
      "character": "苟",
      "zhuyin": "ㄍㄡˇ",
      "pinyin": "gǒuqiě",
      "english": "perfunctory, careless, drifting along, resigned to one's fate, improper (relations), illicit (sex)"
    },
    {
      "character": "蠱",
      "zhuyin": "ㄍㄨˇ",
      "pinyin": "gǔhuò",
      "english": "to entice, to lead astray"
    },
    {
      "character": "葛",
      "zhuyin": "ㄍㄜˊ",
      "pinyin": "guāgé",
      "english": "connection, association, involvement"
    },
    {
      "character": "邸",
      "zhuyin": "ㄉㄧˇ",
      "pinyin": "guāndǐ",
      "english": "official residence"
    },
    {
      "character": "溉",
      "zhuyin": "ㄍㄞˋ",
      "pinyin": "guàngài",
      "english": "to irrigate"
    },
    {
      "character": "吏",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "guānlì",
      "english": "bureaucrat, official"
    },
    {
      "character": "冕",
      "zhuyin": "ㄇㄧㄢˇ",
      "pinyin": "guānmiǎntánghuáng",
      "english": "high-sounding, dignified, pompous (idiom)"
    },
    {
      "character": "禿",
      "zhuyin": "ㄊㄨ",
      "pinyin": "guāngtūtū",
      "english": "bald, bare (no hair, no leaves, no vegetation etc)"
    },
    {
      "character": "澤",
      "zhuyin": "ㄗㄜˊ",
      "pinyin": "guāngzé",
      "english": "luster, gloss"
    },
    {
      "character": "妃",
      "zhuyin": "ㄈㄟ",
      "pinyin": "guìfēi",
      "english": "senior concubine, imperial consort"
    },
    {
      "character": "桂",
      "zhuyin": "ㄍㄨㄟˋ",
      "pinyin": "guìguān",
      "english": "laurel (as a symbol of victory or merit)"
    },
    {
      "character": "祟",
      "zhuyin": "ㄙㄨㄟˋ",
      "pinyin": "guǐguǐsuìsuì",
      "english": "sneaky, secretive, furtive"
    },
    {
      "character": "咎",
      "zhuyin": "ㄐㄧㄡˋ",
      "pinyin": "guījiù",
      "english": "to put the blame on, to accuse"
    },
    {
      "character": "譎",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "guǐjué",
      "english": "weird, sly, treacherous"
    },
    {
      "character": "圭",
      "zhuyin": "ㄍㄨㄟ",
      "pinyin": "guīniè",
      "english": "sundial, a metaphor for laws and regulations."
    },
    {
      "character": "臬",
      "zhuyin": "ㄋㄧㄝˋ",
      "pinyin": "guīniè",
      "english": "sundial, a metaphor for laws and regulations."
    },
    {
      "character": "鮭",
      "zhuyin": "ㄍㄨㄟ",
      "pinyin": "guīyú",
      "english": "salmon, trout"
    },
    {
      "character": "濱",
      "zhuyin": "ㄅㄧㄣ",
      "pinyin": "hǎibīn",
      "english": "shore, seaside"
    },
    {
      "character": "駭",
      "zhuyin": "ㄏㄞˋ",
      "pinyin": "hàirén",
      "english": "terrifying, shocking, dreadful"
    },
    {
      "character": "浹",
      "zhuyin": "ㄐㄧㄚˊ",
      "pinyin": "hànliújiábèi",
      "english": "to sweat profusely (idiom), drenched in sweat"
    },
    {
      "character": "鼾",
      "zhuyin": "ㄏㄢ",
      "pinyin": "hānshēng",
      "english": "sound of snoring"
    },
    {
      "character": "暄",
      "zhuyin": "ㄒㄩㄢ",
      "pinyin": "hánxuān",
      "english": "to exchange conventional greetings, to exchange pleasantries"
    },
    {
      "character": "浩",
      "zhuyin": "ㄏㄠˋ",
      "pinyin": "hàodà",
      "english": "vast, huge"
    },
    {
      "character": "瀚",
      "zhuyin": "ㄏㄢˋ",
      "pinyin": "hàohàn",
      "english": "vast (of ocean), boundless"
    },
    {
      "character": "啕",
      "zhuyin": "ㄊㄠˊ",
      "pinyin": "háotáodàkū",
      "english": "to wail, to bawl (idiom)"
    },
    {
      "character": "藹",
      "zhuyin": "ㄞˇ",
      "pinyin": "héǎi",
      "english": "kindly, nice, amiable"
    },
    {
      "character": "宏",
      "zhuyin": "ㄏㄨㄥˊ",
      "pinyin": "hóngdà",
      "english": "great, grand"
    },
    {
      "character": "鴻",
      "zhuyin": "ㄏㄨㄥˊ",
      "pinyin": "hónggōu",
      "english": "(fig.) gulf, chasm, wide gap, (originally) the Hong Canal in Henan, which in ancient times formed th"
    },
    {
      "character": "泊",
      "zhuyin": "ㄅㄛˊ",
      "pinyin": "húbó",
      "english": "lake"
    },
    {
      "character": "餬",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "húkǒu",
      "english": "to scrape a meager living, to get by with difficulty"
    },
    {
      "character": "葫",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "húlu",
      "english": "calabash or bottle gourd (Lagenaria siceraria), hoist, generic term for block and tackle (or parts t"
    },
    {
      "character": "蘆",
      "zhuyin": "˙ㄌㄨ",
      "pinyin": "húlu",
      "english": "calabash or bottle gourd (Lagenaria siceraria), hoist, generic term for block and tackle (or parts t"
    },
    {
      "character": "眈",
      "zhuyin": "ㄉㄢ",
      "pinyin": "hǔshìdāndān",
      "english": "to glare like a tiger watching his prey (idiom), to eye covetously"
    },
    {
      "character": "卉",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "huāhuì",
      "english": "flowers and plants"
    },
    {
      "character": "譁",
      "zhuyin": "ㄏㄨㄚˊ",
      "pinyin": "huárán",
      "english": "in uproar, commotion, causing a storm of protest, tumultuous"
    },
    {
      "character": "煥",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "huànfā",
      "english": "to shine, to glow, to irradiate, to flash"
    },
    {
      "character": "宦",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "huànguān",
      "english": "court eunuch"
    },
    {
      "character": "渙",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "huànsàn",
      "english": "to slacken, lax, slack, disorganized"
    },
    {
      "character": "豢",
      "zhuyin": "ㄏㄨㄢˋ",
      "pinyin": "huànyǎng",
      "english": "to keep (an animal), to look after the needs of (a person or an animal), (fig.) to keep (a spy, lack"
    },
    {
      "character": "惶",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "huángkǒng",
      "english": "terrified"
    },
    {
      "character": "遑",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "huánglùn",
      "english": "let alone, not to mention"
    },
    {
      "character": "蕪",
      "zhuyin": "ㄨˊ",
      "pinyin": "huāngwú",
      "english": "left to return to unchecked growth, overgrown, grown wild"
    },
    {
      "character": "晦",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "huìàn",
      "english": "dark and gloomy"
    },
    {
      "character": "霍",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "huīhuò",
      "english": "to squander money, extravagant, prodigal, free and easy, agile"
    },
    {
      "character": "燼",
      "zhuyin": "ㄐㄧㄣˋ",
      "pinyin": "huījìn",
      "english": "ashes"
    },
    {
      "character": "麾",
      "zhuyin": "ㄏㄨㄟ",
      "pinyin": "huīxià",
      "english": "troops, subordinates, (honorific appellation for a general)"
    },
    {
      "character": "詼",
      "zhuyin": "ㄏㄨㄟ",
      "pinyin": "huīxié",
      "english": "humorous, jocular, zany"
    },
    {
      "character": "沌",
      "zhuyin": "ㄉㄨㄣˋ",
      "pinyin": "hùndùn",
      "english": "primal chaos, formless mass before creation in Chinese mythology, muddled, innocent as a baby"
    },
    {
      "character": "豁",
      "zhuyin": "ㄏㄨㄛˋ",
      "pinyin": "huòdá",
      "english": "optimistic, sanguine, generous, magnanimous, open-minded"
    },
    {
      "character": "悸",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jìdòng",
      "english": "to pound, to throb"
    },
    {
      "character": "饑",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jīhuāng",
      "english": "crop failure, famine, debt, difficulty"
    },
    {
      "character": "岌",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "jíjíkěwéi",
      "english": "imminent danger (idiom), approaching a crisis"
    },
    {
      "character": "遽",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jíjù",
      "english": "rapid, sudden"
    },
    {
      "character": "伎",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jìliǎng",
      "english": "trick, scheme, ploy, skill"
    },
    {
      "character": "倆",
      "zhuyin": "ㄌㄧㄤˇ",
      "pinyin": "jìliǎng",
      "english": "trick, scheme, ploy, skill"
    },
    {
      "character": "躋",
      "zhuyin": "ㄐㄧ",
      "pinyin": "jīshēn",
      "english": "to rise (in society)"
    },
    {
      "character": "覬",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "jìyú",
      "english": "(literary) to covet, to cast greedy eyes on"
    },
    {
      "character": "覦",
      "zhuyin": "ㄩˊ",
      "pinyin": "jìyú",
      "english": "(literary) to covet, to cast greedy eyes on"
    },
    {
      "character": "枷",
      "zhuyin": "ㄐㄧㄚ",
      "pinyin": "jiāsuǒ",
      "english": "stocks and chain, in fetters"
    },
    {
      "character": "嘉",
      "zhuyin": "ㄐㄧㄚ",
      "pinyin": "jiāxǔ",
      "english": "favorable, praise"
    },
    {
      "character": "艦",
      "zhuyin": "ㄐㄧㄢˋ",
      "pinyin": "jiànduì",
      "english": "fleet, CL:支[zhi1]"
    },
    {
      "character": "殲",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiānmiè",
      "english": "to wipe out, to crush, to annihilate"
    },
    {
      "character": "緘",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "jiānmò",
      "english": "to keep silent"
    },
    {
      "character": "澀",
      "zhuyin": "ㄙㄜˋ",
      "pinyin": "jiānsè",
      "english": "difficult"
    },
    {
      "character": "矯",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "jiǎojiàn",
      "english": "strong and healthy, vigorous"
    },
    {
      "character": "囂",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "jiàoxiāo",
      "english": "to hoot"
    },
    {
      "character": "芥",
      "zhuyin": "ㄐㄧㄝˋ",
      "pinyin": "jièdì",
      "english": "an obstruction, barrier, ill-feeling, grudge"
    },
    {
      "character": "竭",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jiéjìn",
      "english": "to use up, to exhaust"
    },
    {
      "character": "拮",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jiéjū",
      "english": "hard pressed for money, in financial straits"
    },
    {
      "character": "据",
      "zhuyin": "ㄐㄩ",
      "pinyin": "jiéjū",
      "english": "hard pressed for money, in financial straits"
    },
    {
      "character": "睫",
      "zhuyin": "ㄐㄧㄝˊ",
      "pinyin": "jiémáo",
      "english": "eyelashes"
    },
    {
      "character": "踵",
      "zhuyin": "ㄓㄨㄥˇ",
      "pinyin": "jiēzhǒngérlái",
      "english": "to come one after the other"
    },
    {
      "character": "櫫",
      "zhuyin": "ㄓㄨ",
      "pinyin": "jiēzhū",
      "english": "to disclose, to announce"
    },
    {
      "character": "矜",
      "zhuyin": "ㄐㄧㄣ",
      "pinyin": "jīnchí",
      "english": "reserved, aloof"
    },
    {
      "character": "錮",
      "zhuyin": "ㄍㄨˋ",
      "pinyin": "jìngù",
      "english": "to confine, to imprison, prohibition, shackles, fetters"
    },
    {
      "character": "錦",
      "zhuyin": "ㄐㄧㄣˇ",
      "pinyin": "jǐnshàngtiānhuā",
      "english": "lit. add flowers to brocade (idiom), fig. to give sth additional splendor, to provide the crowning t"
    },
    {
      "character": "咫",
      "zhuyin": "ㄓˇ",
      "pinyin": "jìnzàizhǐchǐ",
      "english": "to be almost within reach, to be close at hand"
    },
    {
      "character": "京",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jīngchéng",
      "english": "capital of a country"
    },
    {
      "character": "荊",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jīngjí",
      "english": "thistles and thorns, brambles, thorny undergrowth"
    },
    {
      "character": "兢",
      "zhuyin": "ㄐㄧㄥ",
      "pinyin": "jīngjīngyèyè",
      "english": "(idiom) conscientious, assiduous"
    },
    {
      "character": "痙",
      "zhuyin": "ㄐㄧㄥˋ",
      "pinyin": "jìngluán",
      "english": "to jerk, to contort, spasm, convulsion"
    },
    {
      "character": "攣",
      "zhuyin": "ㄌㄨㄢˊ",
      "pinyin": "jìngluán",
      "english": "to jerk, to contort, spasm, convulsion"
    },
    {
      "character": "謐",
      "zhuyin": "ㄇㄧˋ",
      "pinyin": "jìngmì",
      "english": "quiet, still, tranquil"
    },
    {
      "character": "擻",
      "zhuyin": "ㄙㄡˇ",
      "pinyin": "jīngshéndǒusǒu",
      "english": "spirit trembling with excitement (idiom), in high spirits, lively and full of enthusiasm, full of en"
    },
    {
      "character": "豔",
      "zhuyin": "ㄧㄢˋ",
      "pinyin": "jīngyàn",
      "english": "be marvel at the beauty (of women’s appearance, of things)"
    },
    {
      "character": "瑩",
      "zhuyin": "ㄧㄥˊ",
      "pinyin": "jīngyíng",
      "english": "sparkling and translucent"
    },
    {
      "character": "湛",
      "zhuyin": "ㄓㄢˋ",
      "pinyin": "jīngzhàn",
      "english": "consummate, exquisite"
    },
    {
      "character": "迥",
      "zhuyin": "ㄐㄩㄥˇ",
      "pinyin": "jiǒngránbùtóng",
      "english": "widely different, utterly different"
    },
    {
      "character": "霄",
      "zhuyin": "ㄒㄧㄠ",
      "pinyin": "jiǔxiāoyúnwài",
      "english": "beyond the topmost clouds (idiom), unimaginably far away"
    },
    {
      "character": "颶",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "jùfēng",
      "english": "hurricane"
    },
    {
      "character": "眷",
      "zhuyin": "ㄐㄩㄢˋ",
      "pinyin": "juànliàn",
      "english": "to miss, to long for, to remember with longing, yearning"
    },
    {
      "character": "攫",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "juéqǔ",
      "english": "to seize, to capture, to grab"
    },
    {
      "character": "閥",
      "zhuyin": "ㄈㄚˊ",
      "pinyin": "jūnfá",
      "english": "military clique, junta, warlord"
    },
    {
      "character": "駿",
      "zhuyin": "ㄐㄩㄣˋ",
      "pinyin": "jùnmǎ",
      "english": "fine horse, steed"
    },
    {
      "character": "墾",
      "zhuyin": "ㄎㄣˇ",
      "pinyin": "kāikěn",
      "english": "to clear a wild area for cultivation, to put under the plow"
    },
    {
      "character": "楷",
      "zhuyin": "ㄎㄞˇ",
      "pinyin": "kǎimó",
      "english": "model, example"
    },
    {
      "character": "侃",
      "zhuyin": "ㄎㄢˇ",
      "pinyin": "kǎnkǎnértán",
      "english": "to speak frankly with assurance"
    },
    {
      "character": "坎",
      "zhuyin": "ㄎㄢˇ",
      "pinyin": "kǎnkě",
      "english": "(of a road) bumpy, (of life) rough, to be down on one's luck, to be full of frustrations and dashed "
    },
    {
      "character": "坷",
      "zhuyin": "ㄎㄜˇ",
      "pinyin": "kǎnkě",
      "english": "(of a road) bumpy, (of life) rough, to be down on one's luck, to be full of frustrations and dashed "
    },
    {
      "character": "拷",
      "zhuyin": "ㄎㄠˇ",
      "pinyin": "kǎodǎ",
      "english": "to beat a prisoner (to obtain confessions), to give sb the third degree, to torture"
    },
    {
      "character": "攏",
      "zhuyin": "ㄌㄨㄥˇ",
      "pinyin": "kàolǒng",
      "english": "to draw close to"
    },
    {
      "character": "犒",
      "zhuyin": "ㄎㄠˋ",
      "pinyin": "kàoshǎng",
      "english": "reward, to reward"
    },
    {
      "character": "銘",
      "zhuyin": "ㄇㄧㄥˊ",
      "pinyin": "kègǔmíngxīn",
      "english": "lit. carved in bones and engraved in the heart (idiom), fig. etched in one's memory, unforgettable"
    },
    {
      "character": "窠",
      "zhuyin": "ㄎㄜ",
      "pinyin": "kējiù",
      "english": "stereotypical pattern, rut"
    },
    {
      "character": "臼",
      "zhuyin": "ㄐㄧㄡˋ",
      "pinyin": "kējiù",
      "english": "stereotypical pattern, rut"
    },
    {
      "character": "蘭",
      "zhuyin": "ㄌㄢˊ",
      "pinyin": "kělánjīng",
      "english": "Quran (Islamic scripture)"
    },
    {
      "character": "磕",
      "zhuyin": "ㄎㄜ",
      "pinyin": "kētóu",
      "english": "to kowtow (traditional greeting, esp. to a superior, involving kneeling and pressing one's forehead "
    },
    {
      "character": "嗑",
      "zhuyin": "ㄎㄜˋ",
      "pinyin": "kèyào",
      "english": "to take (illegal) drugs"
    },
    {
      "character": "鏗",
      "zhuyin": "ㄎㄥ",
      "pinyin": "kēngqiāng",
      "english": "sonorous, resounding, fig. resounding words"
    },
    {
      "character": "鏘",
      "zhuyin": "ㄑㄧㄤ",
      "pinyin": "kēngqiāng",
      "english": "sonorous, resounding, fig. resounding words"
    },
    {
      "character": "吭",
      "zhuyin": "ㄎㄥ",
      "pinyin": "kēngshēng",
      "english": "to utter a word"
    },
    {
      "character": "曠",
      "zhuyin": "ㄎㄨㄤˋ",
      "pinyin": "kōngkuàng",
      "english": "spacious and empty, void"
    },
    {
      "character": "窟",
      "zhuyin": "ㄎㄨ",
      "pinyin": "kūlong",
      "english": "hole, pocket, cavity, loophole, debt"
    },
    {
      "character": "窿",
      "zhuyin": "˙ㄌㄨㄥ",
      "pinyin": "kūlong",
      "english": "hole, pocket, cavity, loophole, debt"
    },
    {
      "character": "膾",
      "zhuyin": "ㄎㄨㄞˋ",
      "pinyin": "kuàizhìrénkǒu",
      "english": "appealing to the masses, universally appreciated (idiom)"
    },
    {
      "character": "炙",
      "zhuyin": "ㄓˋ",
      "pinyin": "kuàizhìrénkǒu",
      "english": "appealing to the masses, universally appreciated (idiom)"
    },
    {
      "character": "劊",
      "zhuyin": "ㄎㄨㄞˋ",
      "pinyin": "kuàizishǒu",
      "english": "executioner, headsman, slaughterer, fig. indiscriminate murderer"
    },
    {
      "character": "疚",
      "zhuyin": "ㄐㄧㄡˋ",
      "pinyin": "kuìjiù",
      "english": "to feel guilty, to feel ashamed of oneself, to be remorseful"
    },
    {
      "character": "傀",
      "zhuyin": "ㄎㄨㄟˇ",
      "pinyin": "kuǐlěi",
      "english": "(lit. and fig.) puppet"
    },
    {
      "character": "儡",
      "zhuyin": "ㄌㄟˇ",
      "pinyin": "kuǐlěi",
      "english": "(lit. and fig.) puppet"
    },
    {
      "character": "窺",
      "zhuyin": "ㄎㄨㄟ",
      "pinyin": "kuīshì",
      "english": "to peep at, to spy on, to peek"
    },
    {
      "character": "梧",
      "zhuyin": "ㄨˊ",
      "pinyin": "kuíwú",
      "english": "tall and sturdy"
    },
    {
      "character": "綑",
      "zhuyin": "ㄎㄨㄣˇ",
      "pinyin": "kǔnbǎng",
      "english": "to tie with rope; to constrain; to bind"
    },
    {
      "character": "邋",
      "zhuyin": "ㄌㄚ",
      "pinyin": "lāta",
      "english": "unkempt"
    },
    {
      "character": "遢",
      "zhuyin": "˙ㄊㄚ",
      "pinyin": "lāta",
      "english": "unkempt"
    },
    {
      "character": "襤",
      "zhuyin": "ㄌㄢˊ",
      "pinyin": "lánlǚ",
      "english": "ragged, shabby"
    },
    {
      "character": "褸",
      "zhuyin": "ㄌㄩˇ",
      "pinyin": "lánlǚ",
      "english": "ragged, shabby"
    },
    {
      "character": "烙",
      "zhuyin": "ㄌㄠˋ",
      "pinyin": "làoyìn",
      "english": "to brand (cattle etc), brand, (fig.) to leave a lasting mark, to stigmatize, mark, stamp, stigma"
    },
    {
      "character": "贅",
      "zhuyin": "ㄓㄨㄟˋ",
      "pinyin": "lěizhuì",
      "english": "superfluous, cumbersome, a burden on sb, a nuisance to sb, to inconvenience, to tie sb down, long-wi"
    },
    {
      "character": "睬",
      "zhuyin": "ㄘㄞˇ",
      "pinyin": "lǐcǎi",
      "english": "to heed, to pay attention to"
    },
    {
      "character": "蒞",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "lìlín",
      "english": "to arrive (esp. of notable person), to visit (more formal than 光臨|光临[guang1 lin2])"
    },
    {
      "character": "釐",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "líqīng",
      "english": "to clarify (the facts), clarification"
    },
    {
      "character": "鯉",
      "zhuyin": "ㄌㄧˇ",
      "pinyin": "lǐyú",
      "english": "carp"
    },
    {
      "character": "漣",
      "zhuyin": "ㄌㄧㄢˊ",
      "pinyin": "liányī",
      "english": "ripple"
    },
    {
      "character": "漪",
      "zhuyin": "ㄧ",
      "pinyin": "liányī",
      "english": "ripple"
    },
    {
      "character": "煉",
      "zhuyin": "ㄌㄧㄢˋ",
      "pinyin": "liànyù",
      "english": "purgatory"
    },
    {
      "character": "踉",
      "zhuyin": "ㄌㄧㄤˋ",
      "pinyin": "liàngqiàng",
      "english": "to stagger, to stumble"
    },
    {
      "character": "蹌",
      "zhuyin": "ㄑㄧㄤˋ",
      "pinyin": "liàngqiàng",
      "english": "to stagger, to stumble"
    },
    {
      "character": "潦",
      "zhuyin": "ㄌㄧㄠˊ",
      "pinyin": "liáocǎo",
      "english": "slipshod, careless, slovenly, (of handwriting) scrawly, illegible"
    },
    {
      "character": "寥",
      "zhuyin": "ㄌㄧㄠˊ",
      "pinyin": "liáoliáo",
      "english": "very few"
    },
    {
      "character": "繚",
      "zhuyin": "ㄌㄧㄠˊ",
      "pinyin": "liáorào",
      "english": "(of smoke from a chimney) to curl upward, (of a sound) to linger on"
    },
    {
      "character": "咧",
      "zhuyin": "ㄌㄧㄝˇ",
      "pinyin": "liězuǐ",
      "english": "to grin"
    },
    {
      "character": "琳",
      "zhuyin": "ㄌㄧㄣˊ",
      "pinyin": "línlángmǎnmù",
      "english": "glittering jewels to delight the eye (idiom), fig. a dazzling lineup"
    },
    {
      "character": "瑯",
      "zhuyin": "ㄌㄤˊ",
      "pinyin": "línlángmǎnmù",
      "english": "glittering jewels to delight the eye (idiom), fig. a dazzling lineup"
    },
    {
      "character": "漓",
      "zhuyin": "ㄌㄧˊ",
      "pinyin": "línlí",
      "english": "dripping wet, pouring, saturated, (fig.) uninhibited, fluid, emotionally unrestrained, extreme"
    },
    {
      "character": "凜",
      "zhuyin": "ㄌㄧㄣˇ",
      "pinyin": "lǐnrán",
      "english": "an upright attitude, a strict personality"
    },
    {
      "character": "遴",
      "zhuyin": "ㄌㄧㄣˊ",
      "pinyin": "línxuǎn",
      "english": "to pick, to choose, to select"
    },
    {
      "character": "伶",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "línglì",
      "english": "clever, witty, intelligent"
    },
    {
      "character": "玲",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "línglóng",
      "english": "(onom.) clink of jewels, exquisite, detailed and fine, clever, nimble"
    },
    {
      "character": "瓏",
      "zhuyin": "ㄌㄨㄥˊ",
      "pinyin": "línglóng",
      "english": "(onom.) clink of jewels, exquisite, detailed and fine, clever, nimble"
    },
    {
      "character": "莽",
      "zhuyin": "ㄇㄤˇ",
      "pinyin": "lǔmǎng",
      "english": "hot-headed, impulsive, reckless"
    },
    {
      "character": "羅",
      "zhuyin": "ㄌㄨㄛˊ",
      "pinyin": "luópán",
      "english": "compass"
    },
    {
      "character": "唆",
      "zhuyin": "ㄙㄨㄛ",
      "pinyin": "luōsuō",
      "english": "long-winded, wordy, troublesome, pesky, also pr. [luo1 suo1]"
    },
    {
      "character": "繹",
      "zhuyin": "ㄧˋ",
      "pinyin": "luòyìbùjué",
      "english": "(idiom) continuously, in an endless stream"
    },
    {
      "character": "謾",
      "zhuyin": "ㄇㄢˋ",
      "pinyin": "mànmà",
      "english": "to hurl abuse, to deride, to call sb names"
    },
    {
      "character": "蹣",
      "zhuyin": "ㄇㄢˊ",
      "pinyin": "mánshān",
      "english": "to walk unsteadily, to stagger, to lurch, to hobble, to totter"
    },
    {
      "character": "跚",
      "zhuyin": "ㄕㄢ",
      "pinyin": "mánshān",
      "english": "to walk unsteadily, to stagger, to lurch, to hobble, to totter"
    },
    {
      "character": "悚",
      "zhuyin": "ㄙㄨㄥˇ",
      "pinyin": "máogǔsǒngrán",
      "english": "to have one's hair stand on end (idiom), to feel one's blood run cold"
    },
    {
      "character": "卯",
      "zhuyin": "ㄇㄠˇ",
      "pinyin": "mǎozú",
      "english": ""
    },
    {
      "character": "捫",
      "zhuyin": "ㄇㄣˊ",
      "pinyin": "ménxīnzìwèn",
      "english": "to ask oneself honestly, to search in one's heart"
    },
    {
      "character": "蔽",
      "zhuyin": "ㄅㄧˋ",
      "pinyin": "méngbì",
      "english": "to deceive, to hoodwink"
    },
    {
      "character": "寐",
      "zhuyin": "ㄇㄟˋ",
      "pinyin": "mèngmèiyǐqiú",
      "english": "to yearn for sth even in one's dreams (idiom), to long for sth day and night"
    },
    {
      "character": "萌",
      "zhuyin": "ㄇㄥˊ",
      "pinyin": "méngshēng",
      "english": "to burgeon, to produce, to conceive, to be in the initial stage"
    },
    {
      "character": "魘",
      "zhuyin": "ㄧㄢˇ",
      "pinyin": "mèngyǎn",
      "english": "nightmare"
    },
    {
      "character": "濛",
      "zhuyin": "ㄇㄥˊ",
      "pinyin": "míméng",
      "english": "misty"
    },
    {
      "character": "惘",
      "zhuyin": "ㄨㄤˇ",
      "pinyin": "míwǎng",
      "english": "perplexed, at a loss"
    },
    {
      "character": "緬",
      "zhuyin": "ㄇㄧㄢˇ",
      "pinyin": "miǎnhuái",
      "english": "to commemorate, to recall fondly, to think of the past"
    },
    {
      "character": "覷",
      "zhuyin": "ㄑㄩˋ",
      "pinyin": "miànmiànxiāngqù",
      "english": "to look at each other in dismay (idiom)"
    },
    {
      "character": "靦",
      "zhuyin": "ㄇㄧㄢˇ",
      "pinyin": "miǎntiǎn",
      "english": "shy, bashful"
    },
    {
      "character": "腆",
      "zhuyin": "ㄊㄧㄢˇ",
      "pinyin": "miǎntiǎn",
      "english": "shy, bashful"
    },
    {
      "character": "蔑",
      "zhuyin": "ㄇㄧㄝˋ",
      "pinyin": "mièshì",
      "english": "to loathe, to despise, contempt"
    },
    {
      "character": "茅",
      "zhuyin": "ㄇㄠˊ",
      "pinyin": "mínglièqiánmáo",
      "english": "to rank among the best"
    },
    {
      "character": "膜",
      "zhuyin": "ㄇㄛˊ",
      "pinyin": "móbài",
      "english": "to kneel and bow with joined hands at forehead level, to worship"
    },
    {
      "character": "稜",
      "zhuyin": "ㄌㄥˊ",
      "pinyin": "móléngliǎngkě",
      "english": "equivocal, ambiguous"
    },
    {
      "character": "驀",
      "zhuyin": "ㄇㄛˋ",
      "pinyin": "mòrán",
      "english": "suddenly, sudden"
    },
    {
      "character": "牡",
      "zhuyin": "ㄇㄨˇ",
      "pinyin": "mǔdān",
      "english": "tree peony (Paeonia suffruticosa)"
    },
    {
      "character": "丹",
      "zhuyin": "ㄉㄢ",
      "pinyin": "mǔdān",
      "english": "tree peony (Paeonia suffruticosa)"
    },
    {
      "character": "暮",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "mùsè",
      "english": "twilight"
    },
    {
      "character": "眩",
      "zhuyin": "ㄒㄩㄢˋ",
      "pinyin": "mùxuàn",
      "english": "dizzy, dazzled"
    },
    {
      "character": "轅",
      "zhuyin": "ㄩㄢˊ",
      "pinyin": "nányuánběichè",
      "english": "to act in a way that defeats one's purpose (idiom)"
    },
    {
      "character": "轍",
      "zhuyin": "ㄔㄜˋ",
      "pinyin": "nányuánběichè",
      "english": "to act in a way that defeats one's purpose (idiom)"
    },
    {
      "character": "囊",
      "zhuyin": "ㄋㄤˊ",
      "pinyin": "nángguā",
      "english": "to include, to embrace, to bring together"
    },
    {
      "character": "斂",
      "zhuyin": "ㄌㄧㄢˋ",
      "pinyin": "nèiliàn",
      "english": "introverted, reserved, (artistic style) understated"
    },
    {
      "character": "暱",
      "zhuyin": "ㄋㄧˋ",
      "pinyin": "nìchēng",
      "english": "nickname, diminutive, term of endearment, to nickname"
    },
    {
      "character": "淖",
      "zhuyin": "ㄋㄠˋ",
      "pinyin": "nínào",
      "english": "mud, muddy swamp, sump, fig. a sticky predicament"
    },
    {
      "character": "濘",
      "zhuyin": "ㄋㄧㄥˋ",
      "pinyin": "nínìng",
      "english": "muddy, mud"
    },
    {
      "character": "沼",
      "zhuyin": "ㄓㄠˇ",
      "pinyin": "nízhǎo",
      "english": "swamp"
    },
    {
      "character": "裊",
      "zhuyin": "ㄋㄧㄠˇ",
      "pinyin": "niǎoniǎo",
      "english": "rising in spirals"
    },
    {
      "character": "躡",
      "zhuyin": "ㄋㄧㄝˋ",
      "pinyin": "nièshǒunièjiǎo",
      "english": "to walk quietly on tiptoe (idiom)"
    },
    {
      "character": "瘧",
      "zhuyin": "ㄋㄩㄝˋ",
      "pinyin": "nüèjí",
      "english": "malaria"
    },
    {
      "character": "踞",
      "zhuyin": "ㄐㄩˋ",
      "pinyin": "pánjù",
      "english": "to occupy illegally, to seize (territory), to entrench (oneself)"
    },
    {
      "character": "磐",
      "zhuyin": "ㄆㄢˊ",
      "pinyin": "pánshí",
      "english": "boulder"
    },
    {
      "character": "螃",
      "zhuyin": "ㄆㄤˊ",
      "pinyin": "pángxiè",
      "english": "crab, CL:隻|只[zhi1]"
    },
    {
      "character": "蟹",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "pángxiè",
      "english": "crab, CL:隻|只[zhi1]"
    },
    {
      "character": "澎",
      "zhuyin": "ㄆㄥ",
      "pinyin": "pēngpài",
      "english": "to surge"
    },
    {
      "character": "湃",
      "zhuyin": "ㄆㄞˋ",
      "pinyin": "pēngpài",
      "english": "to surge"
    },
    {
      "character": "癖",
      "zhuyin": "ㄆㄧˇ",
      "pinyin": "pǐhào",
      "english": "one's passion, one's obsession"
    },
    {
      "character": "霹",
      "zhuyin": "ㄆㄧ",
      "pinyin": "pīlì",
      "english": "thunderclap, (slang) awesome, shocking, terrifying"
    },
    {
      "character": "靂",
      "zhuyin": "ㄌㄧˋ",
      "pinyin": "pīlì",
      "english": "thunderclap, (slang) awesome, shocking, terrifying"
    },
    {
      "character": "媲",
      "zhuyin": "ㄆㄧˋ",
      "pinyin": "pìměi",
      "english": "to match, is comparable with"
    },
    {
      "character": "翩",
      "zhuyin": "ㄆㄧㄢ",
      "pinyin": "piānpiān",
      "english": "elegant, graceful, smart, to dance lightly"
    },
    {
      "character": "袒",
      "zhuyin": "ㄊㄢˇ",
      "pinyin": "piāntǎn",
      "english": "to bare one shoulder, (fig.) to side with, to discriminate in favor of"
    },
    {
      "character": "瘠",
      "zhuyin": "ㄐㄧˊ",
      "pinyin": "pínjí",
      "english": "barren, infertile, poor"
    },
    {
      "character": "庸",
      "zhuyin": "ㄩㄥ",
      "pinyin": "píngyōng",
      "english": "mediocre, indifferent, commonplace"
    },
    {
      "character": "悽",
      "zhuyin": "ㄑㄧ",
      "pinyin": "qīcǎn",
      "english": "plaintive, mournful, miserable"
    },
    {
      "character": "迪",
      "zhuyin": "ㄉㄧˊ",
      "pinyin": "qǐdí",
      "english": "to edify, enlightenment"
    },
    {
      "character": "皿",
      "zhuyin": "ㄇㄧㄣˇ",
      "pinyin": "qìmǐn",
      "english": "household utensils"
    },
    {
      "character": "崎",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "qíqū",
      "english": "rugged, craggy"
    },
    {
      "character": "嶇",
      "zhuyin": "ㄑㄩ",
      "pinyin": "qíqū",
      "english": "rugged, craggy"
    },
    {
      "character": "棲",
      "zhuyin": "ㄑㄧ",
      "pinyin": "qīshēn",
      "english": "to stay at, to live in (temporarily)"
    },
    {
      "character": "鈞",
      "zhuyin": "ㄐㄩㄣ",
      "pinyin": "qiānjūnyìfǎ",
      "english": "a thousand pounds hangs by a thread (idiom), imminent peril, a matter of life or death"
    },
    {
      "character": "坤",
      "zhuyin": "ㄎㄨㄣ",
      "pinyin": "qiánkūn",
      "english": "yin and yang, heaven and earth, the universe"
    },
    {
      "character": "迢",
      "zhuyin": "ㄊㄧㄠˊ",
      "pinyin": "qiānlǐtiáotiáo",
      "english": "from distant parts"
    },
    {
      "character": "仆",
      "zhuyin": "ㄆㄨ",
      "pinyin": "qiánpūhòujì",
      "english": "one falls, the next follows (idiom), stepping into the breach to replace fallen comrades, advancing "
    },
    {
      "character": "徙",
      "zhuyin": "ㄒㄧˇ",
      "pinyin": "qiānxǐ",
      "english": "to migrate, to move"
    },
    {
      "character": "遜",
      "zhuyin": "ㄒㄩㄣˋ",
      "pinyin": "qiānxùn",
      "english": "humble, modest, unpretentious, modesty"
    },
    {
      "character": "瞻",
      "zhuyin": "ㄓㄢ",
      "pinyin": "qiánzhān",
      "english": "forward-looking, prescient, foresight, forethought, outlook"
    },
    {
      "character": "姦",
      "zhuyin": "ㄐㄧㄢ",
      "pinyin": "qiángjiān",
      "english": "to rape"
    },
    {
      "character": "鍥",
      "zhuyin": "ㄑㄧㄝˋ",
      "pinyin": "qièérbùshě",
      "english": "to chip away at a task and not abandon it (idiom), to chisel away at sth, to persevere, unflagging e"
    },
    {
      "character": "愜",
      "zhuyin": "ㄑㄧㄝˋ",
      "pinyin": "qièyì",
      "english": "satisfied, pleased, contented"
    },
    {
      "character": "秦",
      "zhuyin": "ㄑㄧㄣˊ",
      "pinyin": "qíncháo",
      "english": "Qin Dynasty (221-207 BC)"
    },
    {
      "character": "禽",
      "zhuyin": "ㄑㄧㄣˊ",
      "pinyin": "qínshòu",
      "english": "birds and animals, creature, beast (brutal person)"
    },
    {
      "character": "苔",
      "zhuyin": "ㄊㄞˊ",
      "pinyin": "qīngtái",
      "english": "moss, lichen"
    },
    {
      "character": "軋",
      "zhuyin": "ㄧㄚˋ",
      "pinyin": "qīngyà",
      "english": "conflict, internal strife, dissension"
    },
    {
      "character": "盈",
      "zhuyin": "ㄧㄥˊ",
      "pinyin": "qīngyíng",
      "english": "graceful, lithe, light and graceful, lighthearted, relaxed"
    },
    {
      "character": "陵",
      "zhuyin": "ㄌㄧㄥˊ",
      "pinyin": "qiūlíng",
      "english": "hills"
    },
    {
      "character": "蚯",
      "zhuyin": "ㄑㄧㄡ",
      "pinyin": "qiūyǐn",
      "english": "earthworm"
    },
    {
      "character": "蚓",
      "zhuyin": "ㄧㄣˇ",
      "pinyin": "qiūyǐn",
      "english": "earthworm"
    },
    {
      "character": "蜷",
      "zhuyin": "ㄑㄩㄢˊ",
      "pinyin": "quánqū",
      "english": "twisted, coiled, curled"
    },
    {
      "character": "曬",
      "zhuyin": "ㄕㄞˋ",
      "pinyin": "rìshài",
      "english": "sundried"
    },
    {
      "character": "溶",
      "zhuyin": "ㄖㄨㄥˊ",
      "pinyin": "rónghuà",
      "english": "to melt, to dissolve (of sugar etc)"
    },
    {
      "character": "絨",
      "zhuyin": "ㄖㄨㄥˊ",
      "pinyin": "róngmáo",
      "english": "fur, down (soft fur), villi capillary (in the small intestine)"
    },
    {
      "character": "蹂",
      "zhuyin": "ㄖㄡˊ",
      "pinyin": "róulìn",
      "english": "to ravage, to devastate, to trample on, to violate"
    },
    {
      "character": "躪",
      "zhuyin": "ㄌㄧㄣˋ",
      "pinyin": "róulìn",
      "english": "to ravage, to devastate, to trample on, to violate"
    },
    {
      "character": "蠕",
      "zhuyin": "ㄖㄨˊ",
      "pinyin": "rúdòng",
      "english": "to wiggle, to squirm, peristalsis (wave movement of gut wall)"
    },
    {
      "character": "荼",
      "zhuyin": "ㄊㄨˊ",
      "pinyin": "rúhuǒrútú",
      "english": "like wildfire (idiom), unstoppable"
    },
    {
      "character": "睿",
      "zhuyin": "ㄖㄨㄟˋ",
      "pinyin": "ruìzhì",
      "english": "wise and farsighted"
    },
    {
      "character": "偌",
      "zhuyin": "ㄖㄨㄛˋ",
      "pinyin": "ruòdà",
      "english": "so big, such a big"
    },
    {
      "character": "僧",
      "zhuyin": "ㄙㄥ",
      "pinyin": "sēnglǚ",
      "english": "monk"
    },
    {
      "character": "戮",
      "zhuyin": "ㄌㄨˋ",
      "pinyin": "shālù",
      "english": "to massacre, to slaughter"
    },
    {
      "character": "霎",
      "zhuyin": "ㄕㄚˋ",
      "pinyin": "shàshí",
      "english": "in a split second"
    },
    {
      "character": "珊",
      "zhuyin": "ㄕㄢ",
      "pinyin": "shānhú",
      "english": "coral"
    },
    {
      "character": "瑚",
      "zhuyin": "ㄏㄨˊ",
      "pinyin": "shānhú",
      "english": "coral"
    },
    {
      "character": "麓",
      "zhuyin": "ㄌㄨˋ",
      "pinyin": "shānlù",
      "english": "foothills"
    },
    {
      "character": "巒",
      "zhuyin": "ㄌㄨㄢˊ",
      "pinyin": "shānluán",
      "english": "mountain range, unbroken chain of peaks"
    },
    {
      "character": "榷",
      "zhuyin": "ㄑㄩㄝˋ",
      "pinyin": "shāngquè",
      "english": "to discuss, to bring up various ideas for discussion"
    },
    {
      "character": "昇",
      "zhuyin": "ㄕㄥ",
      "pinyin": "shàngshēng",
      "english": "to rise"
    },
    {
      "character": "尉",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "shàngwèi",
      "english": "captain (military rank)"
    },
    {
      "character": "稷",
      "zhuyin": "ㄐㄧˋ",
      "pinyin": "shèjì",
      "english": "state, country, the Gods of earth and grain"
    },
    {
      "character": "赦",
      "zhuyin": "ㄕㄜˋ",
      "pinyin": "shèmiǎn",
      "english": "to pardon, to absolve, to exempt from punishment"
    },
    {
      "character": "奕",
      "zhuyin": "ㄧˋ",
      "pinyin": "shéncǎiyìyì",
      "english": "in glowing spirits (idiom), bursting with life, radiating health and vigor"
    },
    {
      "character": "祇",
      "zhuyin": "ㄑㄧˊ",
      "pinyin": "shénqí",
      "english": "god, deity"
    },
    {
      "character": "滲",
      "zhuyin": "ㄕㄣˋ",
      "pinyin": "shènrù",
      "english": "to permeate"
    },
    {
      "character": "邃",
      "zhuyin": "ㄙㄨㄟˋ",
      "pinyin": "shēnsuì",
      "english": "deep (valley or night), abstruse, hidden in depth"
    },
    {
      "character": "賢",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "shèngxián",
      "english": "a sage, wise and holy man, virtuous ruler, Buddhist lama, wine"
    },
    {
      "character": "仕",
      "zhuyin": "ㄕˋ",
      "pinyin": "shìtú",
      "english": "official career (formal)"
    },
    {
      "character": "俑",
      "zhuyin": "ㄩㄥˇ",
      "pinyin": "shǐzuòyǒngzhě",
      "english": "lit. the first person to make funerary figurines (idiom), fig. the originator of an evil practice"
    },
    {
      "character": "銬",
      "zhuyin": "ㄎㄠˋ",
      "pinyin": "shǒukào",
      "english": "manacles, handcuffs"
    },
    {
      "character": "狩",
      "zhuyin": "ㄕㄡˋ",
      "pinyin": "shòuliè",
      "english": "to hunt, hunting"
    },
    {
      "character": "抒",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shūfā",
      "english": "to express (an emotion), to give vent"
    },
    {
      "character": "曙",
      "zhuyin": "ㄕㄨˋ",
      "pinyin": "shùguāng",
      "english": "dawn, fig. the dawn of a new era"
    },
    {
      "character": "樞",
      "zhuyin": "ㄕㄨ",
      "pinyin": "shūniǔ",
      "english": "hub (e.g. of traffic network), hinge, pivot, fulcrum"
    },
    {
      "character": "紐",
      "zhuyin": "ㄋㄧㄡˇ",
      "pinyin": "shūniǔ",
      "english": "hub (e.g. of traffic network), hinge, pivot, fulcrum"
    },
    {
      "character": "梢",
      "zhuyin": "ㄕㄠ",
      "pinyin": "shùshāo",
      "english": "the tip of a tree, treetop"
    },
    {
      "character": "壩",
      "zhuyin": "ㄅㄚˋ",
      "pinyin": "shuǐbà",
      "english": "dam, dike"
    },
    {
      "character": "渠",
      "zhuyin": "ㄑㄩˊ",
      "pinyin": "shuǐdàoqúchéng",
      "english": "lit. where water flows, a canal is formed (idiom), fig. when conditions are right, success will foll"
    },
    {
      "character": "忖",
      "zhuyin": "ㄘㄨㄣˇ",
      "pinyin": "sīcǔn",
      "english": "to ponder, to reckon, to turn sth over in one's mind"
    },
    {
      "character": "廝",
      "zhuyin": "ㄙ",
      "pinyin": "sīshā",
      "english": "to fight at close quarters, to fight tooth and nail"
    },
    {
      "character": "塾",
      "zhuyin": "ㄕㄨˊ",
      "pinyin": "sīshú",
      "english": "private school (in former times)"
    },
    {
      "character": "憚",
      "zhuyin": "ㄉㄢˋ",
      "pinyin": "sìwújìdàn",
      "english": "absolutely unrestrained, unbridled, without the slightest scruple"
    },
    {
      "character": "宋",
      "zhuyin": "ㄙㄨㄥˋ",
      "pinyin": "sòngcháo",
      "english": "Song Dynasty (960-1279), also Song of Southern dynasties 南朝宋 (420-479)"
    },
    {
      "character": "穆",
      "zhuyin": "ㄇㄨˋ",
      "pinyin": "sùmù",
      "english": "solemn and respectful, serene"
    },
    {
      "character": "隋",
      "zhuyin": "ㄙㄨㄟˊ",
      "pinyin": "suícháo",
      "english": "Sui dynasty (581-617)"
    },
    {
      "character": "撻",
      "zhuyin": "ㄊㄚˋ",
      "pinyin": "tàfā",
      "english": "conquest"
    },
    {
      "character": "泰",
      "zhuyin": "ㄊㄞˋ",
      "pinyin": "tàiránzìruò",
      "english": "cool and collected (idiom), showing no sign of nerves, perfectly composed"
    },
    {
      "character": "曇",
      "zhuyin": "ㄊㄢˊ",
      "pinyin": "tánhuāyíxiàn",
      "english": "lit. the night-blooming cactus shows once, flash in the pan (idiom), short-lived"
    },
    {
      "character": "簧",
      "zhuyin": "ㄏㄨㄤˊ",
      "pinyin": "tánhuáng",
      "english": "spring"
    },
    {
      "character": "忐",
      "zhuyin": "ㄊㄢˇ",
      "pinyin": "tǎntèbùān",
      "english": "restless, apprehensive"
    },
    {
      "character": "忑",
      "zhuyin": "ㄊㄜˋ",
      "pinyin": "tǎntèbùān",
      "english": "restless, apprehensive"
    },
    {
      "character": "搪",
      "zhuyin": "ㄊㄤˊ",
      "pinyin": "tángsè",
      "english": "to muddle through, to fob sb off, to beat around the bush, to dodge"
    },
    {
      "character": "冶",
      "zhuyin": "ㄧㄝˇ",
      "pinyin": "táoyě",
      "english": "lit. to fire pots and smelt metal, fig. to educate"
    },
    {
      "character": "夭",
      "zhuyin": "ㄧㄠ",
      "pinyin": "táozhīyāoyāo",
      "english": "to escape without trace (idiom), to make one's getaway (from the scene of a crime), to show a clean "
    },
    {
      "character": "藤",
      "zhuyin": "ㄊㄥˊ",
      "pinyin": "téngmàn",
      "english": "vine, also pr. [teng2 wan4]"
    },
    {
      "character": "恤",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "tǐxù",
      "english": "to empathize with, to show solicitude for, (loanword) T-shirt"
    },
    {
      "character": "譚",
      "zhuyin": "ㄊㄢˊ",
      "pinyin": "tiānfāngyètán",
      "english": "fantasy story"
    },
    {
      "character": "墜",
      "zhuyin": "ㄓㄨㄟˋ",
      "pinyin": "tiānhuāluànzhuì",
      "english": "lit. a deluge of heavenly flowers (idiom), fig. extravagant embellishments, hype"
    },
    {
      "character": "蚤",
      "zhuyin": "ㄗㄠˇ",
      "pinyin": "tiàozǎo",
      "english": "flea"
    },
    {
      "character": "鋌",
      "zhuyin": "ㄊㄧㄥˇ",
      "pinyin": "tǐngérzǒuxiǎn",
      "english": "to take a risk out of desperation (idiom)"
    },
    {
      "character": "歇",
      "zhuyin": "ㄒㄧㄝ",
      "pinyin": "tíngxiē",
      "english": "to stop for a rest"
    },
    {
      "character": "瞳",
      "zhuyin": "ㄊㄨㄥˊ",
      "pinyin": "tóngkǒng",
      "english": "pupil (of the eye)"
    },
    {
      "character": "緝",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "tōngqì",
      "english": "to order the arrest of sb as criminal, to list as wanted"
    },
    {
      "character": "御",
      "zhuyin": "ㄩˋ",
      "pinyin": "tǒngyù",
      "english": "(literary) to have control over, to rule"
    },
    {
      "character": "盔",
      "zhuyin": "ㄎㄨㄟ",
      "pinyin": "tóukuī",
      "english": "helmet"
    },
    {
      "character": "顱",
      "zhuyin": "ㄌㄨˊ",
      "pinyin": "tóulú",
      "english": "head, skull"
    },
    {
      "character": "兀",
      "zhuyin": "ㄨˋ",
      "pinyin": "túwù",
      "english": "lofty or towering, sudden or abrupt"
    },
    {
      "character": "湍",
      "zhuyin": "ㄊㄨㄢ",
      "pinyin": "tuānjí",
      "english": "rapid (flow of water)"
    },
    {
      "character": "蛻",
      "zhuyin": "ㄊㄨㄟˋ",
      "pinyin": "tuìbiàn",
      "english": "to transform, to morph, to degenerate, metamorphosis, transmutation, transformation, decay, degenera"
    },
    {
      "character": "頹",
      "zhuyin": "ㄊㄨㄟˊ",
      "pinyin": "tuífèi",
      "english": "decadent, dispirited, depressed, dejected"
    },
    {
      "character": "諉",
      "zhuyin": "ㄨㄟˇ",
      "pinyin": "tuīwěi",
      "english": "to shirk responsibility, to blame others, to pass the buck"
    },
    {
      "character": "囤",
      "zhuyin": "ㄊㄨㄣˊ",
      "pinyin": "túnjī",
      "english": "to stock up, to lay in supplies, to hoard (for speculation), to corner the market in sth"
    },
    {
      "character": "噬",
      "zhuyin": "ㄕˋ",
      "pinyin": "tūnshì",
      "english": "to swallow, to engulf, to gobble up"
    },
    {
      "character": "唾",
      "zhuyin": "ㄊㄨㄛˋ",
      "pinyin": "tuòmò",
      "english": "spittle, saliva"
    },
    {
      "character": "橢",
      "zhuyin": "ㄊㄨㄛˇ",
      "pinyin": "tuǒyuánxíng",
      "english": "oval"
    },
    {
      "character": "豌",
      "zhuyin": "ㄨㄢ",
      "pinyin": "wāndòu",
      "english": "pea (Pisum sativum)"
    },
    {
      "character": "莞",
      "zhuyin": "ㄨㄢˇ",
      "pinyin": "wǎněr",
      "english": "(literary) to smile"
    },
    {
      "character": "婉",
      "zhuyin": "ㄨㄢˇ",
      "pinyin": "wǎnjù",
      "english": "to tactfully decline, to turn down gracefully"
    },
    {
      "character": "汪",
      "zhuyin": "ㄨㄤ",
      "pinyin": "wāngyáng",
      "english": "vast body of water, CL:片[pian4]"
    },
    {
      "character": "巍",
      "zhuyin": "ㄨㄟˊ",
      "pinyin": "wéié",
      "english": "lofty, towering, majestic"
    },
    {
      "character": "峨",
      "zhuyin": "ㄜˊ",
      "pinyin": "wéié",
      "english": "lofty, towering, majestic"
    },
    {
      "character": "剿",
      "zhuyin": "ㄐㄧㄠˇ",
      "pinyin": "wéijiǎo",
      "english": "to encircle and annihilate, refers to repeated campaigns of the Guomindang against the communists fr"
    },
    {
      "character": "蔚",
      "zhuyin": "ㄨㄟˋ",
      "pinyin": "wèilán",
      "english": "azure, sky blue"
    },
    {
      "character": "娓",
      "zhuyin": "ㄨㄟˇ",
      "pinyin": "wěiwěidàolái",
      "english": "to speak continuously without interruption"
    },
    {
      "character": "繆",
      "zhuyin": "ㄇㄡˊ",
      "pinyin": "wèiyǔchóumóu",
      "english": "lit. before it rains, bind around with silk (idiom, from Book of Songs 詩經|诗经), fig. to plan ahead, t"
    },
    {
      "character": "嗚",
      "zhuyin": "ㄨ",
      "pinyin": "wūhū",
      "english": "alas, alack, welladay, wellaway, to die"
    },
    {
      "character": "穢",
      "zhuyin": "ㄏㄨㄟˋ",
      "pinyin": "wūhuì",
      "english": "nasty, sordid, filthy"
    },
    {
      "character": "毋",
      "zhuyin": "ㄨˊ",
      "pinyin": "wúníng",
      "english": "not as good as, would rather"
    },
    {
      "character": "巫",
      "zhuyin": "ㄨ",
      "pinyin": "wūpó",
      "english": "witch, sorceress, female shaman"
    },
    {
      "character": "誣",
      "zhuyin": "ㄨ",
      "pinyin": "wūxiàn",
      "english": "to entrap, to frame, to plant false evidence against sb"
    },
    {
      "character": "簷",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "wūyán",
      "english": "eaves, roof (i.e. home)"
    },
    {
      "character": "弗",
      "zhuyin": "ㄈㄨˊ",
      "pinyin": "wúyuǎnfújiè",
      "english": "to extend all over the globe (idiom), far-reaching"
    },
    {
      "character": "滌",
      "zhuyin": "ㄉㄧˊ",
      "pinyin": "xǐdí",
      "english": "to rinse, to wash, washing"
    },
    {
      "character": "犀",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xīlì",
      "english": "sharp, incisive, penetrating"
    },
    {
      "character": "奚",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xīluò",
      "english": "to taunt, to ridicule, to jeer at, to treat coldly, to abandon"
    },
    {
      "character": "嬉",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xīnào",
      "english": "playful and laughing"
    },
    {
      "character": "蹊",
      "zhuyin": "ㄒㄧ",
      "pinyin": "xīqiāo",
      "english": "odd, queer, strange, fishy, Taiwan pr. [xi1 qiao1]"
    },
    {
      "character": "蹺",
      "zhuyin": "ㄑㄧㄠ",
      "pinyin": "xīqiāo",
      "english": "odd, queer, strange, fishy, Taiwan pr. [xi1 qiao1]"
    },
    {
      "character": "吮",
      "zhuyin": "ㄕㄨㄣˇ",
      "pinyin": "xīshǔn",
      "english": "to suck on (sth), to suck in"
    },
    {
      "character": "挾",
      "zhuyin": "ㄒㄧㄚˊ",
      "pinyin": "xiáchí",
      "english": "to seize"
    },
    {
      "character": "遐",
      "zhuyin": "ㄒㄧㄚˊ",
      "pinyin": "xiáxiǎng",
      "english": "reverie, daydream, to be lost in wild and fanciful thoughts"
    },
    {
      "character": "詔",
      "zhuyin": "ㄓㄠˋ",
      "pinyin": "xiàzhào",
      "english": "to hand down an imperial edict"
    },
    {
      "character": "峻",
      "zhuyin": "ㄐㄩㄣˋ",
      "pinyin": "xiǎnjùn",
      "english": "(of terrain) mountainous, rugged, (of a situation) precarious, daunting"
    },
    {
      "character": "嫻",
      "zhuyin": "ㄒㄧㄢˊ",
      "pinyin": "xiánshóu",
      "english": "adept, skilled"
    },
    {
      "character": "弭",
      "zhuyin": "ㄇㄧˇ",
      "pinyin": "xiāomǐ",
      "english": "(literary) to eliminate, to put an end to"
    },
    {
      "character": "掬",
      "zhuyin": "ㄐㄩˊ",
      "pinyin": "xiàoróngkějú",
      "english": "smiling wholeheartedly (idiom), beaming from ear to ear"
    },
    {
      "character": "褻",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "xièdú",
      "english": "to blaspheme, to profane"
    },
    {
      "character": "瀆",
      "zhuyin": "ㄉㄨˊ",
      "pinyin": "xièdú",
      "english": "to blaspheme, to profane"
    },
    {
      "character": "邂",
      "zhuyin": "ㄒㄧㄝˋ",
      "pinyin": "xièhòu",
      "english": "to meet by chance, to run into sb, chance encounter"
    },
    {
      "character": "逅",
      "zhuyin": "ㄏㄡˋ",
      "pinyin": "xièhòu",
      "english": "to meet by chance, to run into sb, chance encounter"
    },
    {
      "character": "怡",
      "zhuyin": "ㄧˊ",
      "pinyin": "xīnkuàngshényí",
      "english": "lit. heart untroubled, spirit pleased (idiom), carefree and relaxed"
    },
    {
      "character": "瘁",
      "zhuyin": "ㄘㄨㄟˋ",
      "pinyin": "xīnlìjiāocuì",
      "english": "to be both mentally and physically exhausted (idiom)"
    },
    {
      "character": "杏",
      "zhuyin": "ㄒㄧㄥˋ",
      "pinyin": "xìngrén",
      "english": "almond, apricot kernel"
    },
    {
      "character": "惺",
      "zhuyin": "ㄒㄧㄥ",
      "pinyin": "xīngsōng",
      "english": "drowsy-eyed, (literary) wavering, indecisive, (literary) awake, conscious, clearheaded"
    },
    {
      "character": "忪",
      "zhuyin": "ㄙㄨㄥ",
      "pinyin": "xīngsōng",
      "english": "drowsy-eyed, (literary) wavering, indecisive, (literary) awake, conscious, clearheaded"
    },
    {
      "character": "脯",
      "zhuyin": "ㄆㄨˊ",
      "pinyin": "xiōngpú",
      "english": "chest"
    },
    {
      "character": "憩",
      "zhuyin": "ㄑㄧˋ",
      "pinyin": "xiūqì",
      "english": "to rest, to relax, to take a break"
    },
    {
      "character": "旭",
      "zhuyin": "ㄒㄩˋ",
      "pinyin": "xùrì",
      "english": "the rising sun"
    },
    {
      "character": "徐",
      "zhuyin": "ㄒㄩˊ",
      "pinyin": "xúxú",
      "english": "slowly, gently"
    },
    {
      "character": "栩",
      "zhuyin": "ㄒㄩˇ",
      "pinyin": "xǔxǔrúshēng",
      "english": "vivid and lifelike (idiom), true to life, realistic"
    },
    {
      "character": "玄",
      "zhuyin": "ㄒㄩㄢˊ",
      "pinyin": "xuánguān",
      "english": "entrance hall, vestibule"
    },
    {
      "character": "喧",
      "zhuyin": "ㄒㄩㄢ",
      "pinyin": "xuānhuá",
      "english": "hubbub, clamor, to make a racket"
    },
    {
      "character": "嘩",
      "zhuyin": "ㄏㄨㄚˊ",
      "pinyin": "xuānhuá",
      "english": "hubbub, clamor, to make a racket"
    },
    {
      "character": "絢",
      "zhuyin": "ㄒㄩㄢˋ",
      "pinyin": "xuànlàn",
      "english": "splendid, gorgeous, dazzling"
    },
    {
      "character": "渲",
      "zhuyin": "ㄒㄩㄢˋ",
      "pinyin": "xuànrǎn",
      "english": "rendering (computing), to add washes of ink or color to a drawing (Chinese painting), to exaggerate,"
    },
    {
      "character": "軒",
      "zhuyin": "ㄒㄩㄢ",
      "pinyin": "xuānrándàbō",
      "english": "huge waves, (fig.) ruckus, controversy, sensation"
    },
    {
      "character": "馴",
      "zhuyin": "ㄒㄩㄣˊ",
      "pinyin": "xúnfú",
      "english": "to tame, tame, docile"
    },
    {
      "character": "衙",
      "zhuyin": "ㄧㄚˊ",
      "pinyin": "yámén",
      "english": "government office in feudal China, yamen"
    },
    {
      "character": "榨",
      "zhuyin": "ㄓㄚˋ",
      "pinyin": "yāzhà",
      "english": "to press, to squeeze, to extract juice, oil etc by squeezing"
    },
    {
      "character": "囪",
      "zhuyin": "ㄘㄨㄥ",
      "pinyin": "yāncōng",
      "english": "chimney"
    },
    {
      "character": "宕",
      "zhuyin": "ㄉㄤˋ",
      "pinyin": "yándàng",
      "english": "to postpone, to keep putting sth off"
    },
    {
      "character": "撩",
      "zhuyin": "ㄌㄧㄠˊ",
      "pinyin": "yǎnhuāliáoluàn",
      "english": "describes blurry eyes and confusion"
    },
    {
      "character": "儼",
      "zhuyin": "ㄧㄢˇ",
      "pinyin": "yǎnrán",
      "english": "just like, solemn, dignified, neatly laid out"
    },
    {
      "character": "筵",
      "zhuyin": "ㄧㄢˊ",
      "pinyin": "yánxí",
      "english": "banquet, mat for sitting"
    },
    {
      "character": "奄",
      "zhuyin": "ㄧㄢ",
      "pinyin": "yānyānyīxí",
      "english": "dying, at one's last gasp"
    },
    {
      "character": "佯",
      "zhuyin": "ㄧㄤˊ",
      "pinyin": "yángzhuāng",
      "english": "to pretend, to pose as"
    },
    {
      "character": "吆",
      "zhuyin": "ㄧㄠ",
      "pinyin": "yāohè",
      "english": "to shout, to bawl, to yell (to urge on an animal), to hawk (one's wares), to denounce loudly, to sho"
    },
    {
      "character": "曳",
      "zhuyin": "ㄧˋ",
      "pinyin": "yáoyì",
      "english": "to sway gently (as in the wind), (of a flame) to flicker"
    },
    {
      "character": "揶",
      "zhuyin": "ㄧㄝˊ",
      "pinyin": "yéyú",
      "english": "to mock, to ridicule"
    },
    {
      "character": "揄",
      "zhuyin": "ㄩˊ",
      "pinyin": "yéyú",
      "english": "to mock, to ridicule"
    },
    {
      "character": "臆",
      "zhuyin": "ㄧˋ",
      "pinyin": "yìcè",
      "english": "to speculate, to conjecture"
    },
    {
      "character": "鍾",
      "zhuyin": "ㄓㄨㄥ",
      "pinyin": "yíjiànzhōngqíng",
      "english": "to fall in love at first sight (idiom)"
    },
    {
      "character": "蹶",
      "zhuyin": "ㄐㄩㄝˊ",
      "pinyin": "yìjuébúzhèn",
      "english": "one stumble, unable to rise (idiom), a setback leading to total collapse, ruined at a stroke, unable"
    },
    {
      "character": "屹",
      "zhuyin": "ㄧˋ",
      "pinyin": "yìlì",
      "english": "to tower, to stand straight (of person's bearing)"
    },
    {
      "character": "軼",
      "zhuyin": "ㄧˋ",
      "pinyin": "yìshì",
      "english": "anecdote, lost or apocryphal story about famous person"
    },
    {
      "character": "孀",
      "zhuyin": "ㄕㄨㄤ",
      "pinyin": "yíshuāng",
      "english": "widow"
    },
    {
      "character": "偎",
      "zhuyin": "ㄨㄟ",
      "pinyin": "yīwēi",
      "english": "to nestle against, to snuggle up to"
    },
    {
      "character": "隅",
      "zhuyin": "ㄩˊ",
      "pinyin": "yìyú",
      "english": "a corner"
    },
    {
      "character": "霾",
      "zhuyin": "ㄇㄞˊ",
      "pinyin": "yīnmái",
      "english": "haze"
    },
    {
      "character": "殷",
      "zhuyin": "ㄧㄣ",
      "pinyin": "yīnqiè",
      "english": "ardent, eager, earnest"
    },
    {
      "character": "梆",
      "zhuyin": "ㄅㄤ",
      "pinyin": "yìngbāngbāng",
      "english": "very hard"
    },
    {
      "character": "縈",
      "zhuyin": "ㄧㄥˊ",
      "pinyin": "yíngrào",
      "english": "to linger on, to hover, to encircle"
    },
    {
      "character": "鸚",
      "zhuyin": "ㄧㄥ",
      "pinyin": "yīngwǔ",
      "english": "parrot"
    },
    {
      "character": "鵡",
      "zhuyin": "ㄨˇ",
      "pinyin": "yīngwǔ",
      "english": "parrot"
    },
    {
      "character": "慵",
      "zhuyin": "ㄩㄥ",
      "pinyin": "yōnglǎn",
      "english": "languid, indolent"
    },
    {
      "character": "雍",
      "zhuyin": "ㄩㄥ",
      "pinyin": "yōngróng",
      "english": "natural, graceful, and poised"
    },
    {
      "character": "踴",
      "zhuyin": "ㄩㄥˇ",
      "pinyin": "yǒngyuè",
      "english": "to leap, to jump, eager, enthusiastically"
    },
    {
      "character": "攸",
      "zhuyin": "ㄧㄡ",
      "pinyin": "yōuguān",
      "english": "of great concern"
    },
    {
      "character": "艇",
      "zhuyin": "ㄊㄧㄥˇ",
      "pinyin": "yóutǐng",
      "english": "barge, yacht, CL:隻|只[zhi1]"
    },
    {
      "character": "渥",
      "zhuyin": "ㄨㄛˋ",
      "pinyin": "yōuwò",
      "english": "handsome (pay etc), generous, liberal"
    },
    {
      "character": "忡",
      "zhuyin": "ㄔㄨㄥ",
      "pinyin": "yōuxīnchōngchōng",
      "english": "deeply worried and sick at heart (idiom)"
    },
    {
      "character": "筍",
      "zhuyin": "ㄙㄨㄣˇ",
      "pinyin": "yǔhòuchūnsǔn",
      "english": "lit. after rain, the spring bamboo (idiom), fig. rapid new growth, many new things emerge in rapid s"
    },
    {
      "character": "迂",
      "zhuyin": "ㄩ",
      "pinyin": "yūhuí",
      "english": "roundabout route, circuitous, tortuous, to outflank, indirect, roundabout"
    },
    {
      "character": "諭",
      "zhuyin": "ㄩˋ",
      "pinyin": "yùzhǐ",
      "english": "imperial edict"
    },
    {
      "character": "懟",
      "zhuyin": "ㄉㄨㄟˋ",
      "pinyin": "yuànduì",
      "english": "resentment, grudge"
    },
    {
      "character": "鴛",
      "zhuyin": "ㄩㄢ",
      "pinyin": "yuānyāng",
      "english": "(bird species of China) mandarin duck (Aix galericulata), (fig.) affectionate couple, happily marrie"
    },
    {
      "character": "鴦",
      "zhuyin": "ㄧㄤ",
      "pinyin": "yuānyāng",
      "english": "(bird species of China) mandarin duck (Aix galericulata), (fig.) affectionate couple, happily marrie"
    },
    {
      "character": "蘊",
      "zhuyin": "ㄩㄣˋ",
      "pinyin": "yùncáng",
      "english": "to hold in store, to contain (untapped reserves etc)"
    },
    {
      "character": "殃",
      "zhuyin": "ㄧㄤ",
      "pinyin": "zāoyāng",
      "english": "to suffer a calamity"
    },
    {
      "character": "詣",
      "zhuyin": "ㄧˋ",
      "pinyin": "zàoyì",
      "english": "level of mastery (of a skill or area of knowledge), (archaic) to pay a visit to sb"
    },
    {
      "character": "咋",
      "zhuyin": "ㄗㄜˊ",
      "pinyin": "zéshé",
      "english": "to be speechless, also pr. [ze2 she2]"
    },
    {
      "character": "嘖",
      "zhuyin": "ㄗㄜˊ",
      "pinyin": "zézéchēngqí",
      "english": "to click one's tongue in wonder (idiom), to be astonished"
    },
    {
      "character": "蟑",
      "zhuyin": "ㄓㄤ",
      "pinyin": "zhāngláng",
      "english": "cockroach"
    },
    {
      "character": "螂",
      "zhuyin": "ㄌㄤˊ",
      "pinyin": "zhāngláng",
      "english": "cockroach"
    },
    {
      "character": "諦",
      "zhuyin": "ㄉㄧˋ",
      "pinyin": "zhēndì",
      "english": "the real meaning, the true essence"
    },
    {
      "character": "聾",
      "zhuyin": "ㄌㄨㄥˊ",
      "pinyin": "zhèněryùlóng",
      "english": "ear-splitting (idiom), deafening"
    },
    {
      "character": "縝",
      "zhuyin": "ㄓㄣˇ",
      "pinyin": "zhěnmì",
      "english": "meticulous, careful, deliberate, delicate, fine (texture)"
    },
    {
      "character": "懾",
      "zhuyin": "ㄓㄜˊ",
      "pinyin": "zhènzhé",
      "english": "to awe, to intimidate"
    },
    {
      "character": "猙",
      "zhuyin": "ㄓㄥ",
      "pinyin": "zhēngníng",
      "english": "malevolent, fierce, sinister"
    },
    {
      "character": "獰",
      "zhuyin": "ㄋㄧㄥˊ",
      "pinyin": "zhēngníng",
      "english": "malevolent, fierce, sinister"
    },
    {
      "character": "鄭",
      "zhuyin": "ㄓㄥˋ",
      "pinyin": "zhèngzhòng",
      "english": "serious, solemn, earnest, conscientious"
    },
    {
      "character": "拗",
      "zhuyin": "ㄠˋ",
      "pinyin": "zhíào",
      "english": "stubborn, willful, pigheaded, Taiwan pr. [zhi2 ao4]"
    },
    {
      "character": "桎",
      "zhuyin": "ㄓˋ",
      "pinyin": "zhìgù",
      "english": "(literary) shackles"
    },
    {
      "character": "梏",
      "zhuyin": "ㄍㄨˋ",
      "pinyin": "zhìgù",
      "english": "(literary) shackles"
    },
    {
      "character": "睽",
      "zhuyin": "ㄎㄨㄟˊ",
      "pinyin": "zhòngmùkuíkuí",
      "english": "see 萬目睽睽|万目睽睽[wan4 mu4 kui2 kui2]"
    },
    {
      "character": "貞",
      "zhuyin": "ㄓㄣ",
      "pinyin": "zhōngzhēn",
      "english": "loyal and dependable"
    },
    {
      "character": "貯",
      "zhuyin": "ㄓㄨˇ",
      "pinyin": "zhǔcún",
      "english": "to store, to deposit"
    },
    {
      "character": "侯",
      "zhuyin": "ㄏㄡˊ",
      "pinyin": "zhūhóu",
      "english": "dukes or princes who rule a part of the country under the emperor, local rulers"
    },
    {
      "character": "佇",
      "zhuyin": "ㄓㄨˋ",
      "pinyin": "zhùlì",
      "english": "to stand for a long time"
    },
    {
      "character": "誅",
      "zhuyin": "ㄓㄨ",
      "pinyin": "zhūshā",
      "english": "to kill, to murder"
    },
    {
      "character": "蛛",
      "zhuyin": "ㄓㄨ",
      "pinyin": "zhūsīmǎjī",
      "english": "lit. spider's thread and horse track, tiny hints (of a secret), traces, clue"
    },
    {
      "character": "捩",
      "zhuyin": "ㄌㄧㄝˋ",
      "pinyin": "zhuǎnlièdiǎn",
      "english": "turning point"
    },
    {
      "character": "稼",
      "zhuyin": "ㄐㄧㄚˋ",
      "pinyin": "zhuāngjia",
      "english": "farm crop, CL:種|种[zhong3]"
    },
    {
      "character": "諄",
      "zhuyin": "ㄓㄨㄣ",
      "pinyin": "zhūnzhūn",
      "english": "earnest, devoted, tireless, sincere, assiduous"
    },
    {
      "character": "灼",
      "zhuyin": "ㄓㄨㄛˊ",
      "pinyin": "zhuójiàn",
      "english": "to see clearly, deep insight, profound view"
    },
    {
      "character": "嗣",
      "zhuyin": "ㄙˋ",
      "pinyin": "zǐsì",
      "english": "son, heir"
    },
    {
      "character": "恣",
      "zhuyin": "ㄗˋ",
      "pinyin": "zìyì",
      "english": "without restraint, unbridled, reckless"
    },
    {
      "character": "艾",
      "zhuyin": "ㄧˋ",
      "pinyin": "zìyuànzìyì",
      "english": "to be full of remorse, to repent and redress one's errors"
    },
    {
      "character": "孜",
      "zhuyin": "ㄗ",
      "pinyin": "zīzībùjuàn",
      "english": "lit. diligent and never slacking (idiom), continuous concentrated effort, assiduous (in study), to c"
    },
    {
      "character": "摺",
      "zhuyin": "ㄓㄜˊ",
      "pinyin": "zòuzhé",
      "english": "memorial to the emperor (folded in accordion form)"
    },
    {
      "character": "孽",
      "zhuyin": "ㄋㄧㄝˋ",
      "pinyin": "zuìniè",
      "english": "sin, crime, wrongdoing"
    },
    {
      "character": "醺",
      "zhuyin": "ㄒㄩㄣ",
      "pinyin": "zuìxūnxūn",
      "english": "drunk, intoxicated"
    }
  ]
}